webpackJsonp([1],{

/***/ 1311:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(18);

var _node = __webpack_require__(1370);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Measure = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Measure, _Component);

  function Measure(props) {
    (0, _classCallCheck3.default)(this, Measure);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Measure.__proto__ || (0, _getPrototypeOf2.default)(Measure)).call(this, props));

    _this._node = null;
    return _this;
  }

  (0, _createClass3.default)(Measure, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.measure();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.shouldMeasure) {
        this.measure();
      }
    }
  }, {
    key: 'measure',
    value: function measure() {
      if (!this.props.shouldMeasure) {
        return;
      }

      this.props.onMeasure({ width: (0, _node.getWidth)(this._node) });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var children = this.props.children;

      return React.cloneElement(_react.Children.only(children), { ref: function ref(_ref) {
          return _this2._node = _ref;
        } });
    }
  }]);
  return Measure;
}(_react.Component), _class.propTypes = {
  shouldMeasure: _react.PropTypes.bool,
  onMeasure: _react.PropTypes.func,
  children: _react.PropTypes.element
}, _class.defaultProps = {
  shouldMeasure: true,
  onMeasure: _.noop
}, _temp);
exports.default = Measure;

/***/ }),

/***/ 1329:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _wixConnect = __webpack_require__(6);

var _clickable = __webpack_require__(2679);

var _clickable2 = _interopRequireDefault(_clickable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Clickable = (_dec = (0, _wixConnect.WixConnect)(_clickable2.default), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Clickable, _React$Component);

  function Clickable() {
    (0, _classCallCheck3.default)(this, Clickable);
    return (0, _possibleConstructorReturn3.default)(this, (Clickable.__proto__ || (0, _getPrototypeOf2.default)(Clickable)).apply(this, arguments));
  }

  (0, _createClass3.default)(Clickable, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          onClick = _props.onClick,
          children = _props.children;


      var childProps = _.omit(this.props, 'onClick', 'style');

      return React.createElement(
        'div',
        { styleName: 'clickable',
          onClick: onClick,
          style: style },
        React.Children.map(children, function (elem) {
          return React.cloneElement(elem, childProps);
        })
      );
    }
  }]);
  return Clickable;
}(React.Component), _class2.propTypes = {
  children: React.PropTypes.any,
  onClick: React.PropTypes.func,
  style: React.PropTypes.object
}, _temp)) || _class);
exports.default = Clickable;

/***/ }),

/***/ 1353:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(5);

exports.default = (0, _reactIntl.defineMessages)({
  next: {
    id: 'shared.navigation.next-page',
    defaultMessage: 'Next'
  },
  prev: {
    id: 'shared.navigation.previous-page',
    defaultMessage: 'Prev'
  }
});

/***/ }),

/***/ 1370:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWidth = getWidth;

var _attempt = __webpack_require__(175);

function getWidth(node) {
  return (0, _attempt.attempt)(function () {
    return node.getBoundingClientRect().width;
  }, 0);
}

/***/ }),

/***/ 1382:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _reactRedux = __webpack_require__(12);

var _wixConnect = __webpack_require__(6);

var _accountButton = __webpack_require__(740);

var _accountButtonStrip = __webpack_require__(2681);

var _accountButtonStrip2 = _interopRequireDefault(_accountButtonStrip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccountButtonStrip = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    appSettings: state.appSettings,
    currentSiteUser: state.currentSiteUser
  };
}), _dec2 = (0, _wixConnect.WixConnect)(_accountButtonStrip2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_BaseAccountButton) {
  (0, _inherits3.default)(AccountButtonStrip, _BaseAccountButton);

  function AccountButtonStrip() {
    (0, _classCallCheck3.default)(this, AccountButtonStrip);
    return (0, _possibleConstructorReturn3.default)(this, (AccountButtonStrip.__proto__ || (0, _getPrototypeOf2.default)(AccountButtonStrip)).apply(this, arguments));
  }

  return AccountButtonStrip;
}(_accountButton.BaseAccountButton), _class2.displayName = 'AccountButtonStrip', _temp)) || _class) || _class);
exports.default = AccountButtonStrip;

/***/ }),

/***/ 1384:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(5);

exports.default = (0, _reactIntl.defineMessages)({
  allVideos: {
    id: 'widget.categories.all-videos',
    defaultMessage: 'All Categories'
  }
});

/***/ }),

/***/ 1386:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(5);

exports.default = (0, _reactIntl.defineMessages)({
  subscribe: {
    id: 'widget.channel-actions.subscribe',
    defaultMessage: 'Subscribe {price}/month'
  }
});

/***/ }),

/***/ 1387:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = __webpack_require__(10);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _autobind = __webpack_require__(11);

var _autobind2 = _interopRequireDefault(_autobind);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _wixConnect = __webpack_require__(6);

var _icon = __webpack_require__(20);

var _icon2 = _interopRequireDefault(_icon);

var _buttons = __webpack_require__(2690);

var _buttons2 = _interopRequireDefault(_buttons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var CarouselButton = (_dec = (0, _wixConnect.WixConnect)(_buttons2.default), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  (0, _inherits3.default)(CarouselButton, _React$Component);

  function CarouselButton() {
    (0, _classCallCheck3.default)(this, CarouselButton);
    return (0, _possibleConstructorReturn3.default)(this, (CarouselButton.__proto__ || (0, _getPrototypeOf2.default)(CarouselButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(CarouselButton, [{
    key: 'handleClick',
    value: function handleClick(event) {
      event.preventDefault();
      this.props.onClick(event);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          direction = _props.direction,
          isActive = _props.isActive;


      var styleNames = (0, _classnames2.default)('button-container', direction, {
        inactive: isActive === false
      });

      return React.createElement(
        'div',
        { styleName: styleNames,
          onClick: this.handleClick },
        React.createElement(
          'div',
          { styleName: 'button' },
          React.createElement(_icon2.default, { styleName: 'triangle-' + direction,
            name: 'triangle-right' })
        )
      );
    }
  }]);
  return CarouselButton;
}(React.Component), _class3.propTypes = {
  direction: React.PropTypes.string,
  isActive: React.PropTypes.bool,
  onClick: React.PropTypes.func.isRequired
}, _class3.defaultProps = {
  direction: 'left',
  isActive: true
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'handleClick', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleClick'), _class2.prototype)), _class2)) || _class);
exports.default = CarouselButton;

/***/ }),

/***/ 1388:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSlideWidth = getSlideWidth;
exports.getWidth = getWidth;
exports.getTrackLeft = getTrackLeft;
function getSlideWidth(carouselElem, slidesToShow) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$slidesPreviewWid = _ref.slidesPreviewWidth,
      slidesPreviewWidth = _ref$slidesPreviewWid === undefined ? 0 : _ref$slidesPreviewWid;

  return (getWidth(carouselElem) - 2 * slidesPreviewWidth) / slidesToShow;
}

function getWidth(elem) {
  return elem ? elem.getBoundingClientRect().width || elem.offsetWidth : 0;
}

function getTrackLeft(slidesCount, slidesPerPage, slideIndex, slideWidth, slidesPreviewWidth) {
  if (slideIndex === 0) {
    return 0;
  }

  if (slideIndex >= slidesCount - slidesPerPage) {
    return slideIndex * slideWidth * -1 + 2 * slidesPreviewWidth;
  }

  return slideIndex * slideWidth * -1 + slidesPreviewWidth;
}

/***/ }),

/***/ 1389:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _wixConnect = __webpack_require__(6);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _track = __webpack_require__(2692);

var _track2 = _interopRequireDefault(_track);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSlideClasses = function getSlideClasses(spec) {

  var index = void 0;
  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }

  var centerOffset = void 0;
  var slickActive = void 0;
  var slickCenter = void 0;
  var slickCloned = index < 0 || index >= spec.slideCount;
  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }
  return (0, _classnames2.default)({
    'slick-slide': true,
    'slick-active': slickActive,
    'slick-center': slickCenter,
    'slick-cloned': slickCloned
  });
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {
    width: spec.slideWidth,
    flexShrink: 0
  };

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return (
    // key could be a zero
    child.key === null || _.isUndefined(child.key) ? fallbackKey : child.key
  );
};

var renderSlides = function renderSlides(spec) {
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];

  React.Children.forEach(spec.children, function (child, index) {
    var childStyle = getSlideStyle(_.assign({}, spec, { index: index }));
    var slickClasses = getSlideClasses(_.assign({ index: index }, spec));

    var cssClasses = void 0;
    if (child.props.className) {
      cssClasses = (0, _classnames2.default)(slickClasses, child.props.className);
    } else {
      cssClasses = slickClasses;
    }

    slides.push(React.cloneElement(child, {
      key: 'original' + getKey(child, index),
      'data-index': index,
      className: cssClasses,
      style: _.assign({}, child.props.style || {}, childStyle)
    }));
  });

  return preCloneSlides.concat(slides, postCloneSlides);
};

var Track = (_dec = (0, _wixConnect.VODCSSModules)(_track2.default), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Track, _React$Component);

  function Track() {
    (0, _classCallCheck3.default)(this, Track);
    return (0, _possibleConstructorReturn3.default)(this, (Track.__proto__ || (0, _getPrototypeOf2.default)(Track)).apply(this, arguments));
  }

  (0, _createClass3.default)(Track, [{
    key: 'render',
    value: function render() {
      var slides = renderSlides(this.props);
      var _props = this.props,
          trackStyle = _props.trackStyle,
          getRef = _props.getRef,
          className = _props.className;


      return React.createElement(
        'div',
        { ref: getRef,
          styleName: 'slick-track',
          className: className,
          style: trackStyle },
        slides
      );
    }
  }]);
  return Track;
}(React.Component), _class2.propTypes = {
  trackStyle: React.PropTypes.object,
  getRef: React.PropTypes.func,
  className: React.PropTypes.string
}, _class2.defaultProps = {
  getRef: _.noop
}, _temp)) || _class);
exports.default = Track;

/***/ }),

/***/ 1390:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.visibleInViewPort = undefined;

var _getOwnPropertyDescriptor = __webpack_require__(10);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _wixSdk = __webpack_require__(21);

var _wixSdk2 = _interopRequireDefault(_wixSdk);

var _debounce = __webpack_require__(98);

var _debounce2 = _interopRequireDefault(_debounce);

var _autobind = __webpack_require__(11);

var _autobind2 = _interopRequireDefault(_autobind);

var _widget = __webpack_require__(1481);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var visibleInViewPort = exports.visibleInViewPort = function visibleInViewPort(WrappedComponent) {
  var _dec, _desc, _value, _class;

  var VisibleInViewPort = (_dec = (0, _debounce2.default)(400), (_class = function (_React$Component) {
    (0, _inherits3.default)(VisibleInViewPort, _React$Component);

    function VisibleInViewPort() {
      var _ref;

      var _temp, _this, _ret;

      (0, _classCallCheck3.default)(this, VisibleInViewPort);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = VisibleInViewPort.__proto__ || (0, _getPrototypeOf2.default)(VisibleInViewPort)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        isVisible: false
      }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(VisibleInViewPort, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        this.check();
        _wixSdk2.default.addEventListener(_wixSdk2.default.Events.SCROLL, this.check);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        _wixSdk2.default.removeEventListener(_wixSdk2.default.Events.SCROLL, this.check);
      }
    }, {
      key: 'check',
      value: function check() {
        (0, _widget.isMobileWidgetVisibleInViewPort)().then(this.updateVisibility);
      }
    }, {
      key: 'updateVisibility',
      value: function updateVisibility(newIsVisible) {
        if (newIsVisible !== this.state.isVisible) {
          this.setState({
            isVisible: newIsVisible
          });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return React.createElement(WrappedComponent, (0, _extends3.default)({}, this.props, {
          isVisibleInViewport: this.state.isVisible }));
      }
    }]);
    return VisibleInViewPort;
  }(React.Component), (_applyDecoratedDescriptor(_class.prototype, 'check', [_autobind2.default, _dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'check'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateVisibility', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateVisibility'), _class.prototype)), _class));


  VisibleInViewPort.WixWrappedComponent = WrappedComponent;

  return VisibleInViewPort;
};

/***/ }),

/***/ 1393:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPlayerCoverUrl = undefined;

var _reselect = __webpack_require__(105);

var _overlayButtonsUtils = __webpack_require__(222);

var _channels = __webpack_require__(29);

var getVideo = function getVideo(state, props) {
  return props.videoItem;
};
var getUseChannelCoverIfPossible = function getUseChannelCoverIfPossible(state, props) {
  return props.useChannelCoverIfPossible;
};
var getSettings = function getSettings(state) {
  return state.appSettings;
};

var getPlayerCoverUrl = exports.getPlayerCoverUrl = (0, _reselect.createSelector)([getSettings, _channels.getChannelForWidget, getVideo, getUseChannelCoverIfPossible], function (settings, channel, video, useChannelCoverIfPossible) {
  var customCoverUrl = video.customCoverUrl,
      coverUrl = video.coverUrl;


  var url = customCoverUrl || coverUrl;

  if ((0, _overlayButtonsUtils.shouldShowChannelCover)(settings, useChannelCoverIfPossible)) {
    url = channel.customCoverUrl || channel.coverUrl || url;
  }

  return url;
});

/***/ }),

/***/ 1394:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlayerCover = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _reactRedux = __webpack_require__(12);

var _resizedImage = __webpack_require__(47);

var _resizedImage2 = _interopRequireDefault(_resizedImage);

var _playerCoverSelector = __webpack_require__(1393);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlayerCover = exports.PlayerCover = (_dec = (0, _reactRedux.connect)(function (state, props) {
  return {
    coverUrl: (0, _playerCoverSelector.getPlayerCoverUrl)(state, props)
  };
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(PlayerCover, _React$Component);

  function PlayerCover() {
    (0, _classCallCheck3.default)(this, PlayerCover);
    return (0, _possibleConstructorReturn3.default)(this, (PlayerCover.__proto__ || (0, _getPrototypeOf2.default)(PlayerCover)).apply(this, arguments));
  }

  (0, _createClass3.default)(PlayerCover, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          coverUrl = _props.coverUrl,
          children = _props.children,
          coverWidth = _props.coverWidth,
          coverHeight = _props.coverHeight;


      if (!coverUrl) {
        return null;
      }

      return React.createElement(
        _resizedImage2.default,
        { className: className,
          src: coverUrl,
          width: coverWidth,
          height: coverHeight },
        children
      );
    }
  }]);
  return PlayerCover;
}(React.Component), _class2.propTypes = {
  coverUrl: React.PropTypes.string,
  useChannelCoverIfPossible: React.PropTypes.bool,
  coverWidth: React.PropTypes.number,
  coverHeight: React.PropTypes.number,
  className: React.PropTypes.string,
  children: React.PropTypes.any
}, _temp)) || _class);

/***/ }),

/***/ 1395:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _reactRedux = __webpack_require__(12);

var _wixConnect = __webpack_require__(6);

var _appSettings = __webpack_require__(48);

var _subscribeShownBiOverlay = __webpack_require__(338);

var _subscribeShownBiOverlay2 = _interopRequireDefault(_subscribeShownBiOverlay);

var _button = __webpack_require__(91);

var _button2 = _interopRequireDefault(_button);

var _icon = __webpack_require__(20);

var _icon2 = _interopRequireDefault(_icon);

var _classic = __webpack_require__(2698);

var _classic2 = _interopRequireDefault(_classic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OverlayClassicCenter = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    canShowMainItemTitle: (0, _appSettings.canShowMainItemTitle)(state),
    canShowMainItemPublisher: (0, _appSettings.canShowMainItemPublisher)(state)
  };
}), _dec2 = (0, _wixConnect.WixConnect)(_classic2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_SubscribeShownBIOver) {
  (0, _inherits3.default)(OverlayClassicCenter, _SubscribeShownBIOver);

  function OverlayClassicCenter() {
    (0, _classCallCheck3.default)(this, OverlayClassicCenter);
    return (0, _possibleConstructorReturn3.default)(this, (OverlayClassicCenter.__proto__ || (0, _getPrototypeOf2.default)(OverlayClassicCenter)).apply(this, arguments));
  }

  (0, _createClass3.default)(OverlayClassicCenter, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          beenPlayed = _props.beenPlayed,
          ended = _props.ended,
          className = _props.className;


      var onOverlayClick = beenPlayed || ended ? this.playSelectedVideo : _.noop;
      var styles = this.getOpacityStyles();

      return React.createElement(
        'div',
        { style: styles,
          styleName: 'overlay',
          className: 'qa-player-overlay ' + className,
          onClick: onOverlayClick },
        this.title,
        this.publisher,
        this.buttons
      );
    }
  }, {
    key: 'playButton',
    get: function get() {
      var playButtonText = this.playButtonText;

      if (!playButtonText) {
        return null;
      }

      return React.createElement(
        _button2.default,
        { className: 'qa-widget-overlay-play-button',
          styleName: 'button',
          onClick: this.playSelectedVideo },
        React.createElement(_icon2.default, { styleName: 'play-icon',
          name: 'arrow-right-filled' }),
        React.createElement(
          'span',
          null,
          playButtonText
        )
      );
    }
  }, {
    key: 'playNextButton',
    get: function get() {
      var playNextButtonText = this.playNextButtonText;

      if (!playNextButtonText) {
        return null;
      }

      return React.createElement(
        _button2.default,
        { styleName: 'button',
          onClick: this.playNextVideo },
        playNextButtonText,
        React.createElement(_icon2.default, { styleName: 'next-icon',
          name: 'arrow-right' })
      );
    }
  }, {
    key: 'subscribeButton',
    get: function get() {
      var subscribeButtonText = this.subscribeButtonText;

      if (!subscribeButtonText) {
        return null;
      }

      return React.createElement(
        _button2.default,
        { styleName: 'button',
          className: 'qa-widget-overlay-subscribe-button',
          onClick: this.openSubscription },
        subscribeButtonText
      );
    }
  }, {
    key: 'purchaseButton',
    get: function get() {
      var purchaseButtonText = this.purchaseButtonText;

      if (!purchaseButtonText) {
        return null;
      }

      return React.createElement(
        _button2.default,
        { className: 'qa-widget-overlay-buy-from-button',
          styleName: 'button',
          onClick: this.openPurchase },
        purchaseButtonText
      );
    }
  }, {
    key: 'buttons',
    get: function get() {
      if (!this.props.videoItem) {
        return null;
      }

      return React.createElement(
        'div',
        { styleName: 'buttons' },
        this.playButton,
        this.subscribeButton || this.purchaseButton,
        this.playNextButton
      );
    }
  }]);
  return OverlayClassicCenter;
}(_subscribeShownBiOverlay2.default), _class2.displayName = 'OverlayClassicCenter', _temp)) || _class) || _class);
exports.default = OverlayClassicCenter;

/***/ }),

/***/ 1396:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _reactRedux = __webpack_require__(12);

var _wixConnect = __webpack_require__(6);

var _appSettings = __webpack_require__(48);

var _baseMemberOnlyOverlay = __webpack_require__(754);

var _baseMemberOnlyOverlay2 = _interopRequireDefault(_baseMemberOnlyOverlay);

var _memberOnly = __webpack_require__(2699);

var _memberOnly2 = _interopRequireDefault(_memberOnly);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OverlayMemberOnly = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    canShowMainItemTitle: (0, _appSettings.canShowMainItemTitle)(state),
    canShowMainItemPublisher: (0, _appSettings.canShowMainItemPublisher)(state)
  };
}), _dec2 = (0, _wixConnect.WixConnect)(_memberOnly2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_OverlayMemberOnlyBas) {
  (0, _inherits3.default)(OverlayMemberOnly, _OverlayMemberOnlyBas);

  function OverlayMemberOnly() {
    (0, _classCallCheck3.default)(this, OverlayMemberOnly);
    return (0, _possibleConstructorReturn3.default)(this, (OverlayMemberOnly.__proto__ || (0, _getPrototypeOf2.default)(OverlayMemberOnly)).apply(this, arguments));
  }

  return OverlayMemberOnly;
}(_baseMemberOnlyOverlay2.default), _class2.displayName = 'OverlayMemberOnly', _temp)) || _class) || _class);
exports.default = OverlayMemberOnly;

/***/ }),

/***/ 1397:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscribeBottomButton = exports.BottomButton = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _class, _temp;

var _wixConnect = __webpack_require__(6);

var _reactIntl = __webpack_require__(5);

var _bottomButtons = __webpack_require__(2701);

var _bottomButtons2 = _interopRequireDefault(_bottomButtons);

var _translations = __webpack_require__(757);

var _translations2 = _interopRequireDefault(_translations);

var _button = __webpack_require__(19);

var _elementSwitcher = __webpack_require__(694);

var _elementSwitcher2 = _interopRequireDefault(_elementSwitcher);

var _icon = __webpack_require__(20);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BottomButton = exports.BottomButton = (0, _wixConnect.VODCSSModules)(_bottomButtons2.default)(function (props) {
  return React.createElement(_button.GenericButton, (0, _extends3.default)({}, props, {
    styleName: 'bottom-button' }));
});

var SubscribeBottomButton = exports.SubscribeBottomButton = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(SubscribeBottomButton, _React$Component);

  function SubscribeBottomButton() {
    (0, _classCallCheck3.default)(this, SubscribeBottomButton);
    return (0, _possibleConstructorReturn3.default)(this, (SubscribeBottomButton.__proto__ || (0, _getPrototypeOf2.default)(SubscribeBottomButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(SubscribeBottomButton, [{
    key: 'render',
    value: function render() {

      var buttonProps = _.omit(this.props, 'maxWidth', 'dispatch', 'forceShortText');

      return React.createElement(
        BottomButton,
        buttonProps,
        this.content
      );
    }
  }, {
    key: 'icon',
    get: function get() {
      return React.createElement(_icon2.default, { name: 'paid',
        className: _bottomButtons2.default['paid-icon'] });
    }
  }, {
    key: 'shortLabel',
    get: function get() {
      return React.createElement(
        _elementSwitcher2.default,
        { maxWidth: this.props.maxWidth },
        React.createElement(
          'span',
          null,
          this.icon,
          React.createElement(_reactIntl.FormattedMessage, _translations2.default.subscribeShortText)
        ),
        this.icon
      );
    }
  }, {
    key: 'content',
    get: function get() {
      var _props = this.props,
          maxWidth = _props.maxWidth,
          children = _props.children,
          forceShortText = _props.forceShortText;

      if (forceShortText) {
        return this.shortLabel;
      }

      return React.createElement(
        _elementSwitcher2.default,
        { maxWidth: maxWidth },
        children,
        this.shortLabel
      );
    }
  }]);
  return SubscribeBottomButton;
}(React.Component), _class.propTypes = {
  maxWidth: React.PropTypes.number,
  forceShortText: React.PropTypes.bool,
  children: React.PropTypes.any
}, _temp);

/***/ }),

/***/ 1398:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PurchaseButton = exports.PlayButton = undefined;

var _wixConnect = __webpack_require__(6);

var _middleButtons = __webpack_require__(2702);

var _middleButtons2 = _interopRequireDefault(_middleButtons);

var _button = __webpack_require__(19);

var _icon = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlayButton = exports.PlayButton = (0, _wixConnect.VODCSSModules)(_middleButtons2.default)(function (_ref) {
  var onClick = _ref.onClick,
      children = _ref.children;
  return React.createElement(
    _button.GenericButton,
    { renderAsLink: true,
      styleName: 'play',
      onClick: onClick,
      className: 'qa-widget-overlay-play-button' },
    React.createElement(_icon.RoundedIcon, { styleName: 'icon play-icon',
      name: 'arrow-right-filled' }),
    React.createElement(
      'span',
      { styleName: 'text' },
      children
    )
  );
});

var PurchaseButton = exports.PurchaseButton = (0, _wixConnect.VODCSSModules)(_middleButtons2.default)(function (_ref2) {
  var onClick = _ref2.onClick,
      children = _ref2.children;
  return React.createElement(
    _button.GenericButton,
    { renderAsLink: true,
      styleName: 'purchase',
      onClick: onClick,
      className: 'qa-widget-overlay-play-button' },
    React.createElement(
      'span',
      { styleName: 'text' },
      children
    )
  );
});

/***/ }),

/***/ 1399:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _reactRedux = __webpack_require__(12);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntl = __webpack_require__(5);

var _playerWidget = __webpack_require__(25);

var _wixConnect = __webpack_require__(6);

var _videoList = __webpack_require__(509);

var _layoutHelpers = __webpack_require__(67);

var _overlayButtonsUtils = __webpack_require__(222);

var _loginFromMobileWidget = __webpack_require__(788);

var _paymentPagesActions = __webpack_require__(789);

var _mainOpenners = __webpack_require__(347);

var _channels = __webpack_require__(29);

var _currentSiteUser = __webpack_require__(794);

var _appSettings = __webpack_require__(48);

var _subscribeShownBiOverlay = __webpack_require__(338);

var _subscribeShownBiOverlay2 = _interopRequireDefault(_subscribeShownBiOverlay);

var _middleButtons = __webpack_require__(1398);

var _bottomButtons = __webpack_require__(1397);

var _baseOverlay = __webpack_require__(337);

var _baseOverlay2 = _interopRequireDefault(_baseOverlay);

var _playButtonText = __webpack_require__(490);

var _playButtonText2 = _interopRequireDefault(_playButtonText);

var _signInToWatchButtonText = __webpack_require__(491);

var _signInToWatchButtonText2 = _interopRequireDefault(_signInToWatchButtonText);

var _playButtonText3 = __webpack_require__(749);

var _playButtonText4 = _interopRequireDefault(_playButtonText3);

var _signInToWatchButtonText3 = __webpack_require__(750);

var _signInToWatchButtonText4 = _interopRequireDefault(_signInToWatchButtonText3);

var _openVideoWithoutPreviewButtonText = __webpack_require__(748);

var _openVideoWithoutPreviewButtonText2 = _interopRequireDefault(_openVideoWithoutPreviewButtonText);

var _purchaseButtonText = __webpack_require__(489);

var _purchaseButtonText2 = _interopRequireDefault(_purchaseButtonText);

var _subscribeButtonText = __webpack_require__(488);

var _subscribeButtonText2 = _interopRequireDefault(_subscribeButtonText);

var _clampText = __webpack_require__(693);

var _clampText2 = _interopRequireDefault(_clampText);

var _threeRowsWidget = __webpack_require__(2703);

var _threeRowsWidget2 = _interopRequireDefault(_threeRowsWidget);

var _translations = __webpack_require__(757);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WIDGET_PADDING = 30;
var MARGIN_BETWEEN_BOTTOM_BUTTONS = 20;
var BOTTOM_BUTTON_PADDING = 16;
var MAX_SINGLE_BUTTON_CONTENT_WIDTH = window.innerWidth - 2 * WIDGET_PADDING - 2 * BOTTOM_BUTTON_PADDING;
var MAX_TWO_BUTTONS_CONTENT_WIDTH = MAX_SINGLE_BUTTON_CONTENT_WIDTH - MARGIN_BETWEEN_BOTTOM_BUTTONS;

var ThreeRowsWidgetOverlay = (_dec = (0, _reactRedux.connect)(function (state, props) {
  return {
    channelData: (0, _channels.getChannelForWidget)(state),
    isChannelCover: (0, _overlayButtonsUtils.mainItemIsChannelCover)(state.appSettings),
    isSignInVisible: (0, _layoutHelpers.isSignInVisible)(state.appSettings),
    isVideoListHidden: (0, _appSettings.getChannelLayout)(state) === _playerWidget.channelLayoutValues.STRIP && (0, _videoList.isNeverShow)(state.appSettings.numbers.videoListVisibility),
    canShowMainItemTitle: (0, _appSettings.canShowMainItemTitle)(state),
    isSingleVideoAtChannel: props.channelData.videosCount === 1,
    currentSiteUser: (0, _currentSiteUser.getCurrentSiteUser)(state),
    isRounded: (0, _appSettings.areElementsRounded)(state)
  };
}, {
  onSignInClick: _loginFromMobileWidget.login,
  onVisitChannelClick: _mainOpenners.visitChannel,
  onSubscribeClick: _paymentPagesActions.openSubscribeOverlay
}), _dec2 = (0, _wixConnect.WixConnect)(_threeRowsWidget2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_SubscribeShownBIOver) {
  (0, _inherits3.default)(ThreeRowsWidgetOverlay, _SubscribeShownBIOver);

  function ThreeRowsWidgetOverlay() {
    (0, _classCallCheck3.default)(this, ThreeRowsWidgetOverlay);
    return (0, _possibleConstructorReturn3.default)(this, (ThreeRowsWidgetOverlay.__proto__ || (0, _getPrototypeOf2.default)(ThreeRowsWidgetOverlay)).apply(this, arguments));
  }

  (0, _createClass3.default)(ThreeRowsWidgetOverlay, [{
    key: 'renderSubscribeButton',
    value: function renderSubscribeButton() {
      var hasButtonBeside = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var text = (0, _subscribeButtonText2.default)(this.buttonTextProps);

      if (!text) {
        return null;
      }

      var styleName = (0, _classnames2.default)('bottom-button');
      var maxWidth = hasButtonBeside ? MAX_TWO_BUTTONS_CONTENT_WIDTH : MAX_SINGLE_BUTTON_CONTENT_WIDTH;

      return React.createElement(
        _bottomButtons.SubscribeBottomButton,
        { styleName: styleName,
          key: 'subscribe-button',
          forceShortText: hasButtonBeside,
          maxWidth: maxWidth,
          onClick: this.props.onSubscribeClick },
        text
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var className = this.props.className;


      return React.createElement(
        'div',
        { styleName: 'overlay',
          className: className },
        React.createElement(
          'div',
          { styleName: 'main' },
          React.createElement(
            'div',
            { styleName: 'title' },
            this.title
          ),
          React.createElement(
            'div',
            { styleName: 'play-container' },
            this.playButton || this.signInToWatchButton || this.openVideoButton || this.purchaseButton
          )
        ),
        this.bottomButtonsBlock
      );
    }
  }, {
    key: 'canOpenChannelPage',
    get: function get() {
      var isSingleVideoAtChannel = this.props.isSingleVideoAtChannel;


      return this.isChannelCoverView && !isSingleVideoAtChannel;
    }
  }, {
    key: 'title',
    get: function get() {
      var _props = this.props,
          onOpenVideoClick = _props.onOpenVideoClick,
          onVisitChannelClick = _props.onVisitChannelClick,
          canShowMainItemTitle = _props.canShowMainItemTitle;


      if (!canShowMainItemTitle) {
        return null;
      }

      var titleText = this.titleText;

      if (!titleText) {
        return null;
      }

      return React.createElement(
        'span',
        { onClick: this.canOpenChannelPage ? onVisitChannelClick : onOpenVideoClick,
          styleName: 'title-text' },
        React.createElement(
          _clampText2.default,
          { lineClamp: 2 },
          titleText
        )
      );
    }
  }, {
    key: 'playButton',
    get: function get() {
      var text = this.isChannelCoverView ? (0, _playButtonText4.default)(this.buttonTextProps) : (0, _playButtonText2.default)(this.buttonTextProps);

      if (!text) {
        return null;
      }

      return React.createElement(
        _middleButtons.PlayButton,
        { onClick: this.props.onPlayClick },
        text
      );
    }
  }, {
    key: 'signInToWatchButton',
    get: function get() {
      var text = this.isChannelCoverView ? (0, _signInToWatchButtonText4.default)(this.buttonTextProps) : (0, _signInToWatchButtonText2.default)(this.buttonTextProps);

      if (!text) {
        return null;
      }

      return React.createElement(
        _middleButtons.PlayButton,
        { onClick: this.props.onPlayClick },
        text
      );
    }
  }, {
    key: 'openVideoButton',
    get: function get() {
      if (!this.isChannelCoverView) {
        return null;
      }

      var text = (0, _openVideoWithoutPreviewButtonText2.default)(this.buttonTextProps);

      if (!text) {
        return null;
      }

      return React.createElement(
        _middleButtons.PlayButton,
        { onClick: this.props.onOpenVideoClick },
        text
      );
    }
  }, {
    key: 'purchaseButton',
    get: function get() {
      var text = (0, _purchaseButtonText2.default)(this.buttonTextProps);

      if (!text) {
        return null;
      }

      return React.createElement(
        _middleButtons.PurchaseButton,
        { onClick: this.props.onBuyVideoClick },
        text
      );
    }
  }, {
    key: 'signInButton',
    get: function get() {
      var _props2 = this.props,
          isSignInVisible = _props2.isSignInVisible,
          currentSiteUser = _props2.currentSiteUser,
          onSignInClick = _props2.onSignInClick;


      if (!isSignInVisible || currentSiteUser) {
        return null;
      }

      return React.createElement(
        _bottomButtons.BottomButton,
        { styleName: 'bottom-button',
          key: 'sign-in-button',
          onClick: onSignInClick },
        React.createElement(_reactIntl.FormattedMessage, _translations2.default.signIn)
      );
    }
  }, {
    key: 'visitChannelButton',
    get: function get() {
      return React.createElement(
        _bottomButtons.BottomButton,
        { styleName: 'bottom-button',
          key: 'visit-channel-button',
          onClick: this.props.onVisitChannelClick },
        React.createElement(_reactIntl.FormattedMessage, _translations2.default.viewChannel)
      );
    }
  }, {
    key: 'bottomButtons',
    get: function get() {
      var _isChannelSubscribeButtonVisible = (0, _subscribeButtonText.isVisible)(this.buttonTextProps);
      var _props3 = this.props,
          isVideoListHidden = _props3.isVideoListHidden,
          isSingleVideoAtChannel = _props3.isSingleVideoAtChannel;


      if (isVideoListHidden || isSingleVideoAtChannel) {
        var signInButton = this.signInButton;

        if (!signInButton && !_isChannelSubscribeButtonVisible) {
          return [];
        }

        return _.compact([signInButton, this.renderSubscribeButton(Boolean(signInButton))]);
      }

      var visitChannelButton = this.visitChannelButton;

      if (!visitChannelButton && !_isChannelSubscribeButtonVisible) {
        return [];
      }

      return _.compact([visitChannelButton, this.renderSubscribeButton(Boolean(visitChannelButton))]);
    }
  }, {
    key: 'bottomButtonsBlock',
    get: function get() {
      var bottomButtons = this.bottomButtons;

      if (_.isEmpty(bottomButtons)) {
        return null;
      }

      var isRounded = this.props.isRounded;


      var styleNames = (0, _classnames2.default)('buttons', {
        single: bottomButtons.length === 1,
        rounded: isRounded
      });

      return React.createElement(
        'div',
        { styleName: styleNames },
        bottomButtons
      );
    }
  }]);
  return ThreeRowsWidgetOverlay;
}(_subscribeShownBiOverlay2.default), _class2.displayName = 'ThreeRowsWidgetOverlay', _class2.propTypes = (0, _extends3.default)({}, _baseOverlay2.default.propTypes, {
  onSubscribeClick: React.PropTypes.func,
  onVisitChannelClick: React.PropTypes.func,
  onBuyVideoClick: React.PropTypes.func,
  onPlayClick: React.PropTypes.func,
  onOpenVideoClick: React.PropTypes.func,
  onSignInClick: React.PropTypes.func,
  bottomButtons: React.PropTypes.array,
  middleButton: React.PropTypes.object,

  isChannelCover: React.PropTypes.bool,
  isSignInVisible: React.PropTypes.bool,
  isVideoListHidden: React.PropTypes.bool,
  canShowMainItemTitle: React.PropTypes.bool,
  isSingleVideoAtChannel: React.PropTypes.bool,
  isRounded: React.PropTypes.bool
}), _class2.defaultProps = {
  onSubscribeClick: _.noop,
  onVisitChannelClick: _.noop,
  onSignInClick: _.noop
}, _temp)) || _class) || _class);
exports.default = ThreeRowsWidgetOverlay;

/***/ }),

/***/ 1401:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getOwnPropertyDescriptor = __webpack_require__(10);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(13);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _autobind = __webpack_require__(11);

var _autobind2 = _interopRequireDefault(_autobind);

var _runOnce = __webpack_require__(738);

var _runOnce2 = _interopRequireDefault(_runOnce);

var _visibleOnScreen = __webpack_require__(1390);

var _firstTimeTrackAnimation = __webpack_require__(2705);

var _firstTimeTrackAnimation2 = _interopRequireDefault(_firstTimeTrackAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var firstTimeTrackAnimation = function firstTimeTrackAnimation(WrappedComponent) {
  var _class, _desc, _value, _class2, _class3, _temp2;

  var FirstTimeTrackAnimation = (0, _visibleOnScreen.visibleInViewPort)(_class = (_class2 = (_temp2 = _class3 = function (_React$Component) {
    (0, _inherits3.default)(FirstTimeTrackAnimation, _React$Component);

    function FirstTimeTrackAnimation() {
      var _ref;

      var _temp, _this, _ret;

      (0, _classCallCheck3.default)(this, FirstTimeTrackAnimation);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FirstTimeTrackAnimation.__proto__ || (0, _getPrototypeOf2.default)(FirstTimeTrackAnimation)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        isTrackStarted: false
      }, _this._alreadyWasShown = false, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(FirstTimeTrackAnimation, [{
      key: 'updateTrackStarted',
      value: function updateTrackStarted() {
        this.setState({
          isTrackStarted: true
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            trackClassName = _props.trackClassName,
            isVisibleInViewport = _props.isVisibleInViewport;
        var isTrackStarted = this.state.isTrackStarted;

        // If track was already started than don't add track class name because it lead to a bug on iOS
        // https://trello.com/c/wGyLqjFd

        var shouldApplyAnimationClassName = !isTrackStarted && (this._alreadyWasShown || isVisibleInViewport);

        var mergedTrackClassName = (0, _classnames3.default)(trackClassName, (0, _defineProperty3.default)({}, _firstTimeTrackAnimation2.default['start-animation'], shouldApplyAnimationClassName));

        if (shouldApplyAnimationClassName) {
          this._alreadyWasShown = true;
        }

        return React.createElement(WrappedComponent, (0, _extends3.default)({}, this.props, {
          onUserStartedTracking: this.updateTrackStarted,
          trackClassName: mergedTrackClassName }));
      }
    }]);
    return FirstTimeTrackAnimation;
  }(React.Component), _class3.propTypes = {
    isVisibleInViewport: React.PropTypes.bool,
    trackClassName: React.PropTypes.string
  }, _class3.defaultProps = {
    isVisibleInViewport: false
  }, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'updateTrackStarted', [_autobind2.default, _runOnce2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateTrackStarted'), _class2.prototype)), _class2)) || _class;

  FirstTimeTrackAnimation.WixWrappedComponent = WrappedComponent;

  return FirstTimeTrackAnimation;
};

exports.default = firstTimeTrackAnimation;

/***/ }),

/***/ 1402:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = __webpack_require__(10);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _reactRedux = __webpack_require__(12);

var _autobind = __webpack_require__(11);

var _autobind2 = _interopRequireDefault(_autobind);

var _memoizedPartial = __webpack_require__(68);

var _memoizedPartial2 = _interopRequireDefault(_memoizedPartial);

var _videos = __webpack_require__(26);

var _mainOpenners = __webpack_require__(347);

var _mobileCarousel = __webpack_require__(747);

var _mobileCarousel2 = _interopRequireDefault(_mobileCarousel);

var _fakePlayer = __webpack_require__(761);

var _fakePlayer2 = _interopRequireDefault(_fakePlayer);

var _firstTimeTrackAnimation = __webpack_require__(1401);

var _firstTimeTrackAnimation2 = _interopRequireDefault(_firstTimeTrackAnimation);

var _playersListSlidable = __webpack_require__(971);

var _playersListSlidable2 = _interopRequireDefault(_playersListSlidable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/*
 This component is performance dependable. PLease avoid @ui because it leads to extra render while swiping
 */
var PlayersListSlidable = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    videoIds: state.lazyVideoLists.mobileWidget.videoIds,
    videoByIds: (0, _videos.getVideosGroupedByIds)(state)
  };
}, {
  onEnded: _mainOpenners.openVideoPage
}), _dec(_class = (0, _firstTimeTrackAnimation2.default)(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  (0, _inherits3.default)(PlayersListSlidable, _React$Component);

  function PlayersListSlidable() {
    (0, _classCallCheck3.default)(this, PlayersListSlidable);
    return (0, _possibleConstructorReturn3.default)(this, (PlayersListSlidable.__proto__ || (0, _getPrototypeOf2.default)(PlayersListSlidable)).apply(this, arguments));
  }

  (0, _createClass3.default)(PlayersListSlidable, [{
    key: 'afterChange',
    value: function afterChange(leftVisibleSlideIndex) {
      var _props = this.props,
          loadMore = _props.loadMore,
          onCurrentSlideChanged = _props.onCurrentSlideChanged;

      var slidesShown = leftVisibleSlideIndex + 3;

      loadMore(slidesShown);
      onCurrentSlideChanged(leftVisibleSlideIndex);
    }
  }, {
    key: 'setPaused',
    value: function setPaused(index) {
      if (this.selectedIndex === index) {
        this.props.onPaused();
      }
    }
  }, {
    key: 'renderItem',
    value: function renderItem(videoItem, index) {
      var _props2 = this.props,
          onPlayStart = _props2.onPlayStart,
          onPlayClick = _props2.onPlayClick,
          canShowChannelCover = _props2.canShowChannelCover,
          itemWidth = _props2.itemWidth,
          itemHeight = _props2.itemHeight,
          paused = _props2.paused,
          onMemberSignUp = _props2.onMemberSignUp;


      var isCurrentVideo = this.selectedIndex === index;
      var useChannelCoverIfPossible = canShowChannelCover && isCurrentVideo;
      var pausedForThisVideo = isCurrentVideo ? paused : true;

      return React.createElement(_fakePlayer2.default, { videoItem: videoItem,
        className: _playersListSlidable2.default['overlay-item-topmost'],
        useChannelCoverIfPossible: useChannelCoverIfPossible,
        onPause: (0, _memoizedPartial2.default)(this.setPaused, index),
        paused: pausedForThisVideo,
        itemWidth: itemWidth,
        itemHeight: itemHeight,
        onPlayClick: onPlayClick,
        onPlayStart: onPlayStart,
        onMemberSignUp: onMemberSignUp });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          videoIds = _props3.videoIds,
          videoByIds = _props3.videoByIds,
          className = _props3.className,
          itemHeight = _props3.itemHeight,
          trackClassName = _props3.trackClassName,
          onUserStartedTracking = _props3.onUserStartedTracking;


      var partialList = _.map(videoIds, function (videoId, index) {
        return React.createElement(
          'div',
          { key: videoId },
          _this2.renderItem(videoByIds[videoId], index)
        );
      });

      return React.createElement(
        _mobileCarousel2.default,
        { afterChange: this.afterChange,
          getHeight: _.constant(itemHeight),
          showButtons: false,
          onUserStartedTracking: onUserStartedTracking,
          slidesToShow: 1,
          trackClassName: trackClassName,
          className: className,
          initialSlide: this.selectedIndex },
        partialList
      );
    }
  }, {
    key: 'selectedIndex',
    get: function get() {
      var _props4 = this.props,
          videoIds = _props4.videoIds,
          selectedVideoId = _props4.selectedVideoId;


      var selectedVideoIndex = _.indexOf(videoIds, selectedVideoId);
      return selectedVideoIndex < 0 ? 0 : selectedVideoIndex;
    }
  }]);
  return PlayersListSlidable;
}(React.Component), _class3.propTypes = {
  videoIds: React.PropTypes.array,
  videoByIds: React.PropTypes.object,
  onEnded: React.PropTypes.func,
  onUserStartedTracking: React.PropTypes.func,
  className: React.PropTypes.string,
  trackClassName: React.PropTypes.string,

  loadMore: React.PropTypes.func,
  onPaused: React.PropTypes.func,
  paused: React.PropTypes.bool,
  itemWidth: React.PropTypes.number,
  itemHeight: React.PropTypes.number,
  canShowChannelCover: React.PropTypes.bool,
  onCurrentSlideChanged: React.PropTypes.func,
  onPlayClick: React.PropTypes.func,
  onPlayStart: React.PropTypes.func,
  onMemberSignUp: React.PropTypes.func,
  selectedVideoId: React.PropTypes.string
}, _class3.defaultProps = {
  onPlayClick: _.noop,
  onPlayStart: _.noop,
  onMemberSignUp: _.noop,
  onCurrentSlideChanged: _.noop,
  onEnded: _.noop,
  onPaused: _.noop
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'afterChange', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'afterChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setPaused', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setPaused'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = PlayersListSlidable;

/***/ }),

/***/ 1403:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _reactRedux = __webpack_require__(12);

var _desktopPlayer = __webpack_require__(495);

var _desktopPlayer2 = _interopRequireDefault(_desktopPlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullScreenModalPlayer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    currentSiteUser: state.currentSiteUser
  };
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(FullScreenModalPlayer, _React$Component);

  function FullScreenModalPlayer() {
    (0, _classCallCheck3.default)(this, FullScreenModalPlayer);
    return (0, _possibleConstructorReturn3.default)(this, (FullScreenModalPlayer.__proto__ || (0, _getPrototypeOf2.default)(FullScreenModalPlayer)).apply(this, arguments));
  }

  (0, _createClass3.default)(FullScreenModalPlayer, [{
    key: 'render',
    value: function render() {
      var props = _.omit(this.props, 'mobileMode', // can't do this
      'playAtFullScreen', // can't do this
      'showInitialOverlay', // can't do this
      'showControls', // can't do this
      'showPoster', // can't do this
      'currentTime', // can't do this
      'paused', // can't do this
      'muted');

      // For now there is no sense in DesktopPlayer but probably will be needed when implementing video background
      return React.createElement(_desktopPlayer2.default, (0, _extends3.default)({}, props, {
        playAtFullScreen: false,
        showInitialOverlay: true,
        showControls: true,
        showPoster: true,
        paused: true }));
    }
  }]);
  return FullScreenModalPlayer;
}(React.Component), _class2.propTypes = (0, _extends3.default)({}, _.omit(_desktopPlayer2.default.propTypes, ['playAtFullScreen', 'showInitialOverlay', 'showControls', 'showPoster', 'paused', 'muted', 'currentTime', 'onFullScreenChanged']), {
  currentSiteUser: React.PropTypes.object
}), _temp)) || _class);
exports.default = FullScreenModalPlayer;

/***/ }),

/***/ 1405:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(5);

exports.default = (0, _reactIntl.defineMessages)({
  searchVideo: {
    id: 'widget.search-bar.search-video',
    defaultMessage: 'Search video...'
  }
});

/***/ }),

/***/ 1408:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActiveMobileThumbnail = exports.DurationInfo = exports.ActiveFrame = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _dec2, _class3, _class4, _temp2, _dec3, _class5, _class6, _temp3;

var _wixConnect = __webpack_require__(6);

var _simple = __webpack_require__(271);

var _mobileThumb = __webpack_require__(2713);

var _mobileThumb2 = _interopRequireDefault(_mobileThumb);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActiveFrame = exports.ActiveFrame = (_dec = (0, _wixConnect.WixConnect)(_mobileThumb2.default), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(ActiveFrame, _React$Component);

  function ActiveFrame() {
    (0, _classCallCheck3.default)(this, ActiveFrame);
    return (0, _possibleConstructorReturn3.default)(this, (ActiveFrame.__proto__ || (0, _getPrototypeOf2.default)(ActiveFrame)).apply(this, arguments));
  }

  (0, _createClass3.default)(ActiveFrame, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { styleName: 'frame' },
        React.createElement(
          'div',
          { styleName: 'content' },
          this.props.children
        ),
        React.createElement('div', { styleName: 'border' })
      );
    }
  }]);
  return ActiveFrame;
}(React.Component), _class2.propTypes = {
  children: React.PropTypes.any
}, _temp)) || _class);
var DurationInfo = exports.DurationInfo = (_dec2 = (0, _wixConnect.WixConnect)(_mobileThumb2.default), _dec2(_class3 = (_temp2 = _class4 = function (_React$Component2) {
  (0, _inherits3.default)(DurationInfo, _React$Component2);

  function DurationInfo() {
    (0, _classCallCheck3.default)(this, DurationInfo);
    return (0, _possibleConstructorReturn3.default)(this, (DurationInfo.__proto__ || (0, _getPrototypeOf2.default)(DurationInfo)).apply(this, arguments));
  }

  (0, _createClass3.default)(DurationInfo, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { styleName: 'duration' },
        React.createElement(
          'span',
          null,
          this.props.durationStr
        )
      );
    }
  }]);
  return DurationInfo;
}(React.Component), _class4.propTypes = {
  durationStr: React.PropTypes.string
}, _temp2)) || _class3);
var ActiveMobileThumbnail = exports.ActiveMobileThumbnail = (_dec3 = (0, _wixConnect.WixConnect)(_mobileThumb2.default), _dec3(_class5 = (_temp3 = _class6 = function (_React$Component3) {
  (0, _inherits3.default)(ActiveMobileThumbnail, _React$Component3);

  function ActiveMobileThumbnail() {
    (0, _classCallCheck3.default)(this, ActiveMobileThumbnail);
    return (0, _possibleConstructorReturn3.default)(this, (ActiveMobileThumbnail.__proto__ || (0, _getPrototypeOf2.default)(ActiveMobileThumbnail)).apply(this, arguments));
  }

  (0, _createClass3.default)(ActiveMobileThumbnail, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          video = _props.video,
          durationStr = _props.video.durationStr,
          width = _props.width,
          height = _props.height;


      return React.createElement(
        ActiveFrame,
        null,
        React.createElement(_simple.SimpleVideoThumbnail, { video: video,
          width: width,
          height: height }),
        React.createElement(DurationInfo, { durationStr: durationStr })
      );
    }
  }]);
  return ActiveMobileThumbnail;
}(React.Component), _class6.propTypes = {
  video: React.PropTypes.object,
  width: React.PropTypes.number,
  height: React.PropTypes.number
}, _temp3)) || _class5);

/***/ }),

/***/ 1409:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClickableThumbnail = exports.default = undefined;

var _getOwnPropertyDescriptor = __webpack_require__(10);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp, _dec3, _class3, _desc, _value, _class4, _class5, _temp2;

var _autobind = __webpack_require__(11);

var _autobind2 = _interopRequireDefault(_autobind);

var _reactRedux = __webpack_require__(12);

var _reactIntl = __webpack_require__(5);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _textOverflowClamp = __webpack_require__(164);

var _textOverflowClamp2 = _interopRequireDefault(_textOverflowClamp);

var _playerWidget = __webpack_require__(25);

var _wixConnect = __webpack_require__(6);

var _appSettings = __webpack_require__(48);

var _icon = __webpack_require__(20);

var _icon2 = _interopRequireDefault(_icon);

var _simple = __webpack_require__(271);

var _thumbnail = __webpack_require__(2714);

var _thumbnail2 = _interopRequireDefault(_thumbnail);

var _translations = __webpack_require__(1410);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var _propTypes = {
  videoItem: React.PropTypes.object.isRequired,
  isSelected: React.PropTypes.bool,
  nowPlaying: React.PropTypes.bool,
  watched: React.PropTypes.bool,
  width: React.PropTypes.number,
  height: React.PropTypes.number,
  intl: _reactIntl.intlShape,
  className: React.PropTypes.string,
  isTitleVisible: React.PropTypes.bool,
  isPublisherVisible: React.PropTypes.bool,
  isPreviewHover: React.PropTypes.bool,
  isDescriptionVisibleOnHoverOnly: React.PropTypes.bool,
  isDescriptionOnVideo: React.PropTypes.bool
};

var _defaultProps = {
  current: false,
  watched: false,
  width: 160,
  height: 104
};

var Thumbnail = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    isTitleVisible: (0, _appSettings.canShowVideoListItemTitle)(state),
    isPublisherVisible: (0, _appSettings.canShowVideoListItemPublisher)(state),
    isPreviewHover: (0, _appSettings.isPreviewHover)(state),
    isDescriptionVisibleOnHoverOnly: (0, _appSettings.getInfoActionVisibility)(state) === _playerWidget.showInfoValues.ON_MOUSE_OVER,
    isDescriptionOnVideo: (0, _appSettings.getVideoInfoPosition)(state) === _playerWidget.infoPositionValues.ON_VIDEOS
  };
}), _dec2 = (0, _wixConnect.WixConnect)(_thumbnail2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Thumbnail, _React$Component);

  function Thumbnail() {
    (0, _classCallCheck3.default)(this, Thumbnail);
    return (0, _possibleConstructorReturn3.default)(this, (Thumbnail.__proto__ || (0, _getPrototypeOf2.default)(Thumbnail)).apply(this, arguments));
  }

  (0, _createClass3.default)(Thumbnail, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.clamp();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.clamp();
    }
  }, {
    key: 'clamp',
    value: function clamp() {
      // description bellow thumbnail with dynamic height is not supported by classic size calculation
      if (this.props.isDescriptionOnVideo) {
        (0, _textOverflowClamp2.default)(this.titleNode, { lineClamp: 2 });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          videoItem = _props.videoItem,
          isSelected = _props.isSelected,
          nowPlaying = _props.nowPlaying,
          width = _props.width,
          height = _props.height,
          intl = _props.intl,
          className = _props.className,
          isDescriptionVisibleOnHoverOnly = _props.isDescriptionVisibleOnHoverOnly,
          isDescriptionOnVideo = _props.isDescriptionOnVideo,
          isPreviewHover = _props.isPreviewHover;
      var title = videoItem.title,
          durationStr = videoItem.durationStr;
      var formatMessage = intl.formatMessage;


      var wrapperStyleNames = (0, _classnames2.default)('wrapper', {
        selected: isSelected,
        'now-playing': nowPlaying,
        'description-on-video': isDescriptionOnVideo,
        'description-on-hover': isDescriptionVisibleOnHoverOnly,
        'preview-hover': isPreviewHover
      });

      return React.createElement(
        'span',
        { styleName: wrapperStyleNames,
          style: { width: width },
          className: className },
        React.createElement(
          'span',
          { styleName: 'thumbnail',
            title: title,
            'data-duration': durationStr,
            'data-now-playing': formatMessage(_translations2.default.nowPlaying) },
          React.createElement(_simple.SimpleVideoThumbnail, { video: videoItem,
            width: width,
            height: height }),
          this.purchaseIcon,
          this.watchedIcon,
          isDescriptionOnVideo && this.description
        ),
        !isDescriptionOnVideo && this.description
      );
    }
  }, {
    key: 'title',
    get: function get() {
      var _this2 = this;

      var _props2 = this.props,
          videoItem = _props2.videoItem,
          isTitleVisible = _props2.isTitleVisible;
      var title = videoItem.title;

      if (!isTitleVisible) {
        return null;
      }

      return React.createElement(
        'span',
        { ref: function ref(node) {
            return _this2.titleNode = node;
          },
          styleName: 'title',
          title: title },
        title
      );
    }
  }, {
    key: 'publisher',
    get: function get() {
      var _props3 = this.props,
          videoItem = _props3.videoItem,
          isPublisherVisible = _props3.isPublisherVisible;
      var publisher = videoItem.publisher;


      if (!isPublisherVisible) {
        return null;
      }

      return React.createElement(
        'span',
        { styleName: 'publisher',
          title: publisher },
        publisher
      );
    }
  }, {
    key: 'description',
    get: function get() {
      var title = this.title;
      var publisher = this.publisher;
      if (!title && !publisher) {
        return null;
      }

      return React.createElement(
        'span',
        { styleName: 'description' },
        title,
        publisher
      );
    }
  }, {
    key: 'purchaseIcon',
    get: function get() {
      var minVideoPrice = _playerWidget.dealInfoHelpers.getMinPriceInfo(this.props.videoItem.dealInfo);
      if (!minVideoPrice || this.props.watched) {
        return null;
      }

      return React.createElement(
        'span',
        { styleName: 'purchase-icon' },
        React.createElement(_icon2.default, { name: 'paid' })
      );
    }
  }, {
    key: 'watchedIcon',
    get: function get() {
      if (!this.props.watched) {
        return null;
      }

      return React.createElement(
        'span',
        { styleName: 'watched-icon' },
        React.createElement(_icon2.default, { name: 'eye' })
      );
    }
  }]);
  return Thumbnail;
}(React.Component), _class2.propTypes = _propTypes, _class2.defaultProps = _defaultProps, _temp)) || _class) || _class);
exports.default = Thumbnail;
var ClickableThumbnail = exports.ClickableThumbnail = (_dec3 = (0, _wixConnect.WixConnect)(_thumbnail2.default), _dec3(_class3 = (_class4 = (_temp2 = _class5 = function (_React$Component2) {
  (0, _inherits3.default)(ClickableThumbnail, _React$Component2);

  function ClickableThumbnail() {
    (0, _classCallCheck3.default)(this, ClickableThumbnail);
    return (0, _possibleConstructorReturn3.default)(this, (ClickableThumbnail.__proto__ || (0, _getPrototypeOf2.default)(ClickableThumbnail)).apply(this, arguments));
  }

  (0, _createClass3.default)(ClickableThumbnail, [{
    key: 'handleClick',
    value: function handleClick(event) {
      event.preventDefault();

      var _props4 = this.props,
          onClick = _props4.onClick,
          videoItem = _props4.videoItem;

      onClick(videoItem);
    }
  }, {
    key: 'render',
    value: function render() {
      var props = _.pick(this.props, _.keys(_propTypes));
      var _props5 = props,
          className = _props5.className;

      props = _.omit(props, 'className', 'styles');

      return React.createElement(
        'a',
        { href: '',
          styleName: 'clickable',
          className: className,
          onClick: this.handleClick },
        React.createElement(Thumbnail, props)
      );
    }
  }]);
  return ClickableThumbnail;
}(React.Component), _class5.propTypes = (0, _extends3.default)({}, _propTypes, {
  videoItem: React.PropTypes.object.isRequired,
  onClick: React.PropTypes.func.isRequired
}), _class5.defaultProps = _defaultProps, _temp2), (_applyDecoratedDescriptor(_class4.prototype, 'handleClick', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class4.prototype, 'handleClick'), _class4.prototype)), _class4)) || _class3);

/***/ }),

/***/ 1410:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(5);

exports.default = (0, _reactIntl.defineMessages)({
  nowPlaying: {
    id: 'thumbnail.now-playing',
    defaultMessage: 'Now Playing'
  }
});

/***/ }),

/***/ 1411:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = __webpack_require__(10);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp2;

var _reactRedux = __webpack_require__(12);

var _autobind = __webpack_require__(11);

var _autobind2 = _interopRequireDefault(_autobind);

var _decorate = __webpack_require__(348);

var _decorate2 = _interopRequireDefault(_decorate);

var _wixConnect = __webpack_require__(6);

var _videos = __webpack_require__(26);

var _selectVideo = __webpack_require__(179);

var _mobileCarousel = __webpack_require__(747);

var _mobileCarousel2 = _interopRequireDefault(_mobileCarousel);

var _simple = __webpack_require__(271);

var _mobileThumb = __webpack_require__(1408);

var _clickable = __webpack_require__(1329);

var _clickable2 = _interopRequireDefault(_clickable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var SLIDES_PREVIEW_WIDTH = 20;

var VideosListMobile = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    videoIds: state.lazyVideoLists.mobileWidget.videoIds,
    videoByIds: (0, _videos.getVideosGroupedByIds)(state),
    appSettings: state.appSettings
  };
}, {
  selectVideo: _selectVideo.selectVideo
}), _dec2 = (0, _wixConnect.WixConnect)(), _dec3 = (0, _decorate2.default)(_.memoize), _dec(_class = _dec2(_class = (_class2 = (_temp2 = _class3 = function (_React$Component) {
  (0, _inherits3.default)(VideosListMobile, _React$Component);

  function VideosListMobile() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, VideosListMobile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = VideosListMobile.__proto__ || (0, _getPrototypeOf2.default)(VideosListMobile)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedVideoId: null
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(VideosListMobile, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        appSettings: this.props.appSettings
      };
    }
  }, {
    key: 'setCurrentVideo',
    value: function setCurrentVideo(videoId) {
      this.props.selectVideo(videoId);
    }
  }, {
    key: 'handleThumbnailClick',
    value: function handleThumbnailClick(id) {
      var _this2 = this;

      return function () {
        _this2.props.onVideoItemClicked(id);
        _this2.setCurrentVideo(id);
      };
    }

    // TODO extract into component

  }, {
    key: 'renderVideoThumb',
    value: function renderVideoThumb(videoData) {
      var selectedVideoId = this.props.selectedVideoId;
      var id = videoData.id;


      var Thumbnail = id === selectedVideoId ? _mobileThumb.ActiveMobileThumbnail : _simple.SimpleVideoThumbnail;

      return React.createElement(
        _clickable2.default,
        { key: id,
          onClick: this.handleThumbnailClick(id) },
        React.createElement(Thumbnail, { video: videoData })
      );
    }
  }, {
    key: 'getHeight',
    value: function getHeight(elem, width) {
      return width * 9 / 16;
    }
  }, {
    key: 'afterChange',
    value: function afterChange(leftVisibleSlideIndex) {
      var videosInRow = this.props.appSettings.numbers.videosInRow;
      var loadMore = this.props.loadMore;

      var slidesShown = leftVisibleSlideIndex + videosInRow;
      loadMore(slidesShown);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          videoIds = _props.videoIds,
          videoByIds = _props.videoByIds,
          className = _props.className;
      var videosInRow = this.props.appSettings.numbers.videosInRow;

      var shouldPreviewSlides = _.size(videoIds) > videosInRow;

      return React.createElement(
        _mobileCarousel2.default,
        { afterChange: this.afterChange,
          getHeight: this.getHeight,
          slidesToShow: videosInRow,
          slidesPreviewWidth: shouldPreviewSlides ? SLIDES_PREVIEW_WIDTH : 0,
          className: className },
        _(videoIds).map(function (vid) {
          return videoByIds[vid];
        }).map(this.renderVideoThumb).value()
      );
    }
  }]);
  return VideosListMobile;
}(React.Component), _class3.propTypes = {
  videoIds: React.PropTypes.array,
  videoByIds: React.PropTypes.object,
  appSettings: React.PropTypes.object,
  loadMore: React.PropTypes.func,
  selectVideo: React.PropTypes.func,
  currentChannelId: React.PropTypes.string,
  selectedVideoId: React.PropTypes.string,
  onVideoItemClicked: React.PropTypes.func,
  className: React.PropTypes.string
}, _class3.defaultProps = {
  onVideoItemClicked: _.noop
}, _class3.childContextTypes = {
  appSettings: React.PropTypes.object
}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'setCurrentVideo', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setCurrentVideo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleThumbnailClick', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleThumbnailClick'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'renderVideoThumb', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'renderVideoThumb'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'afterChange', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'afterChange'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = VideosListMobile;

/***/ }),

/***/ 1412:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = __webpack_require__(10);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _autobind = __webpack_require__(11);

var _autobind2 = _interopRequireDefault(_autobind);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(12);

var _thumbnail = __webpack_require__(1409);

var _wixConnect = __webpack_require__(6);

var _videos = __webpack_require__(26);

var _appSettings = __webpack_require__(48);

var _navButton = __webpack_require__(1413);

var _base = __webpack_require__(769);

var _base2 = _interopRequireDefault(_base);

var _classic = __webpack_require__(2715);

var _classic2 = _interopRequireDefault(_classic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var ClassicVideosList = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    channelVideoIds: ownProps.paginatedChannelVideos.ids,
    prevPageIds: ownProps.paginatedChannelVideos.prevPageIds,
    nextPageIds: ownProps.paginatedChannelVideos.nextPageIds,
    goBack: ownProps.paginatedChannelVideos.goBack,
    goForward: ownProps.paginatedChannelVideos.goForward,
    videoByIds: (0, _videos.getVideosGroupedByIds)(state),
    locale: state.locale,
    videosInRow: (0, _appSettings.getVideosInRowCount)(state)
  };
}), _dec2 = (0, _wixConnect.WixConnect)(_classic2.default), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_BaseVideosList) {
  (0, _inherits3.default)(ClassicVideosList, _BaseVideosList);

  function ClassicVideosList() {
    (0, _classCallCheck3.default)(this, ClassicVideosList);
    return (0, _possibleConstructorReturn3.default)(this, (ClassicVideosList.__proto__ || (0, _getPrototypeOf2.default)(ClassicVideosList)).apply(this, arguments));
  }

  (0, _createClass3.default)(ClassicVideosList, [{
    key: 'toVideoThumbnail',
    value: function toVideoThumbnail(videoId) {
      var _props = this.props,
          videoByIds = _props.videoByIds,
          onThumbnailClick = _props.onThumbnailClick,
          thumbnailSize = _props.thumbnailSize,
          isVideoPaused = _props.isVideoPaused,
          selectedVideoId = _props.selectedVideoId,
          locale = _props.locale,
          isSelectedVideoIndicationDisabled = _props.isSelectedVideoIndicationDisabled;
      var width = thumbnailSize.width,
          height = thumbnailSize.height;

      var isVideoSelected = selectedVideoId === videoId && !isSelectedVideoIndicationDisabled;
      return React.createElement(_thumbnail.ClickableThumbnail, { key: videoId,
        styleName: 'thumbnail',
        videoItem: videoByIds[videoId],
        nowPlaying: isVideoSelected && !isVideoPaused,
        onClick: onThumbnailClick,
        isSelected: isVideoSelected,
        locale: locale,
        width: width,
        height: height });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          prevPageIds = _props2.prevPageIds,
          nextPageIds = _props2.nextPageIds,
          className = _props2.className;

      var styleNames = (0, _classnames2.default)('container', {
        'with-paging': prevPageIds.length || nextPageIds.length
      });

      return React.createElement(
        'section',
        { className: className + ' qa-widget-video-list',
          styleName: styleNames },
        this.list,
        this.pageButtons
      );
    }
  }, {
    key: 'pageButtons',
    get: function get() {
      var _props3 = this.props,
          prevPageIds = _props3.prevPageIds,
          nextPageIds = _props3.nextPageIds;


      if (!prevPageIds.length && !nextPageIds.length) {
        return null;
      }

      return React.createElement(
        'div',
        { styleName: 'buttons' },
        React.createElement(_navButton.PrevButton, { disabled: !prevPageIds.length,
          onClick: this.toPrevPage }),
        React.createElement(_navButton.NextButton, { disabled: !nextPageIds.length,
          onClick: this.toNextPage })
      );
    }
  }]);
  return ClassicVideosList;
}(_base2.default), _class3.displayName = 'ClassicVideosList', _class3.propTypes = (0, _extends3.default)({}, _base2.default.propTypes, {
  isSelectedVideoIndicationDisabled: React.PropTypes.bool,
  isVideoPaused: React.PropTypes.bool,
  selectedVideoId: React.PropTypes.string,
  onThumbnailClick: React.PropTypes.func,
  locale: React.PropTypes.string
}), _temp), (_applyDecoratedDescriptor(_class2.prototype, 'toVideoThumbnail', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'toVideoThumbnail'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = ClassicVideosList;

/***/ }),

/***/ 1413:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getOwnPropertyDescriptor = __webpack_require__(10);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

exports.PrevButton = PrevButton;
exports.NextButton = NextButton;

var _autobind = __webpack_require__(11);

var _autobind2 = _interopRequireDefault(_autobind);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntl = __webpack_require__(5);

var _wixConnect = __webpack_require__(6);

var _prev = __webpack_require__(1523);

var _prev2 = _interopRequireDefault(_prev);

var _navButton = __webpack_require__(2716);

var _navButton2 = _interopRequireDefault(_navButton);

var _navigation = __webpack_require__(1353);

var _navigation2 = _interopRequireDefault(_navigation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var GenericNavButton = (_dec = (0, _wixConnect.WixConnect)(_navButton2.default), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  (0, _inherits3.default)(GenericNavButton, _React$Component);

  function GenericNavButton() {
    (0, _classCallCheck3.default)(this, GenericNavButton);
    return (0, _possibleConstructorReturn3.default)(this, (GenericNavButton.__proto__ || (0, _getPrototypeOf2.default)(GenericNavButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(GenericNavButton, [{
    key: 'handleClick',
    value: function handleClick() {
      var _props = this.props,
          disabled = _props.disabled,
          onClick = _props.onClick;

      if (!disabled) {
        return onClick();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          name = _props2.name,
          disabled = _props2.disabled;


      var styleNames = (0, _classnames2.default)('nav-button', name, {
        disabled: disabled
      });

      return React.createElement(
        'button',
        { onClick: this.handleClick,
          styleName: styleNames },
        React.createElement(_prev2.default, { styleName: 'nav-arrow' }),
        React.createElement(
          'div',
          { styleName: 'nav-text' },
          React.createElement(_reactIntl.FormattedMessage, _navigation2.default[name])
        )
      );
    }
  }]);
  return GenericNavButton;
}(React.Component), _class3.propTypes = {
  name: React.PropTypes.string.isRequired,
  onClick: React.PropTypes.func,
  disabled: React.PropTypes.bool
}, _class3.defaultProps = {
  rounded: false
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'handleClick', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleClick'), _class2.prototype)), _class2)) || _class);
function PrevButton(props) {
  return React.createElement(GenericNavButton, (0, _extends3.default)({}, props, {
    name: 'prev' }));
}

function NextButton(props) {
  return React.createElement(GenericNavButton, (0, _extends3.default)({}, props, {
    name: 'next' }));
}

/***/ }),

/***/ 1414:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = __webpack_require__(10);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _autobind = __webpack_require__(11);

var _autobind2 = _interopRequireDefault(_autobind);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(12);

var _wixConnect = __webpack_require__(6);

var _videos = __webpack_require__(26);

var _appSettings = __webpack_require__(48);

var _icon = __webpack_require__(20);

var _icon2 = _interopRequireDefault(_icon);

var _button = __webpack_require__(19);

var _base = __webpack_require__(769);

var _base2 = _interopRequireDefault(_base);

var _thumbnailOverlay = __webpack_require__(1415);

var _thumbnailOverlay2 = _interopRequireDefault(_thumbnailOverlay);

var _simple = __webpack_require__(271);

var _strip = __webpack_require__(2717);

var _strip2 = _interopRequireDefault(_strip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var StripVideosList = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    channelVideoIds: ownProps.paginatedChannelVideos.ids,
    prevPageIds: ownProps.paginatedChannelVideos.prevPageIds,
    nextPageIds: ownProps.paginatedChannelVideos.nextPageIds,
    goBack: ownProps.paginatedChannelVideos.goBack,
    goForward: ownProps.paginatedChannelVideos.goForward,
    videoByIds: (0, _videos.getVideosGroupedByIds)(state),
    appSettings: state.appSettings,
    numberOfRows: (0, _appSettings.getNumberOfRows)(state),
    videosInRow: (0, _appSettings.getVideosInRowCount)(state)
  };
}), _dec2 = (0, _wixConnect.WixConnect)(_strip2.default), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_BaseVideosList) {
  (0, _inherits3.default)(StripVideosList, _BaseVideosList);

  function StripVideosList() {
    (0, _classCallCheck3.default)(this, StripVideosList);
    return (0, _possibleConstructorReturn3.default)(this, (StripVideosList.__proto__ || (0, _getPrototypeOf2.default)(StripVideosList)).apply(this, arguments));
  }

  (0, _createClass3.default)(StripVideosList, [{
    key: 'getContainerHeightStyles',
    value: function getContainerHeightStyles() {
      var _props = this.props,
          thumbnailSize = _props.thumbnailSize,
          prevPageIds = _props.prevPageIds,
          channelVideoIds = _props.channelVideoIds,
          videosInRow = _props.videosInRow,
          numberOfRows = _props.numberOfRows;


      if (!thumbnailSize) {
        return null;
      }

      var containerHeight = 0;
      if (!prevPageIds.length && channelVideoIds.length < videosInRow * numberOfRows) {
        containerHeight = thumbnailSize.height * Math.ceil(channelVideoIds.length / videosInRow);
      } else {
        containerHeight = thumbnailSize.height * numberOfRows;
      }

      return {
        height: containerHeight
      };
    }
  }, {
    key: 'toVideoThumbnail',
    value: function toVideoThumbnail(videoId) {
      var _props2 = this.props,
          videoByIds = _props2.videoByIds,
          onThumbnailClick = _props2.onThumbnailClick,
          thumbnailSize = _props2.thumbnailSize,
          appSettings = _props2.appSettings,
          playVideo = _props2.playVideo,
          channelData = _props2.channelData;
      var width = thumbnailSize.width,
          height = thumbnailSize.height;


      var video = videoByIds[videoId];

      // TODO: get rid of toVideoThumbnail, replace with component
      // see src/widget/components/videos-list/_base.js
      var handleClick = function handleClick() {
        return onThumbnailClick(video);
      };
      var handlePlay = function handlePlay() {
        return playVideo(video);
      };

      return React.createElement(
        'div',
        { styleName: 'thumbnail-wrapper',
          key: videoId,
          onClick: handleClick,
          style: { height: height } },
        React.createElement(_simple.SimpleVideoThumbnail, { video: video,
          width: width,
          height: height }),
        React.createElement(_thumbnailOverlay2.default, { styleName: 'overlay',
          channelData: channelData,
          videoItem: video,
          width: width,
          appSettings: appSettings,
          playSelectedVideo: handlePlay })
      );
    }
  }, {
    key: 'navButton',
    value: function navButton(styleName, isDisabled, onClick) {
      var styles = (0, _classnames2.default)('nav-button', styleName, {
        disabled: isDisabled
      });

      return React.createElement(
        _button.GenericButton,
        { styleName: styles,
          onClick: onClick },
        React.createElement(_icon2.default, { name: 'arrow-strip',
          styleName: 'icon' })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          className = _props3.className,
          appSettings = _props3.appSettings,
          prevPageIds = _props3.prevPageIds,
          nextPageIds = _props3.nextPageIds;

      var styles = this.getContainerHeightStyles();

      if (!appSettings) {
        return null;
      }

      return React.createElement(
        'section',
        { className: 'qa-widget-video-list ' + className,
          styleName: 'container',
          style: styles },
        this.list,
        this.navButton('prev-button', !prevPageIds.length, this.toPrevPage),
        this.navButton('next-button', !nextPageIds.length, this.toNextPage)
      );
    }
  }]);
  return StripVideosList;
}(_base2.default), _class3.displayName = 'StripVideosList', _class3.propTypes = (0, _extends3.default)({}, _base2.default.propTypes, {
  onThumbnailClick: React.PropTypes.func,
  playVideo: React.PropTypes.func,
  channelData: React.PropTypes.object
}), _temp), (_applyDecoratedDescriptor(_class2.prototype, 'toVideoThumbnail', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'toVideoThumbnail'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = StripVideosList;

/***/ }),

/***/ 1415:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _reactRedux = __webpack_require__(12);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _playerWidget = __webpack_require__(25);

var _wixConnect = __webpack_require__(6);

var _appSettings = __webpack_require__(48);

var _stripBase = __webpack_require__(494);

var _stripBase2 = _interopRequireDefault(_stripBase);

var _elementSwitcher = __webpack_require__(694);

var _elementSwitcher2 = _interopRequireDefault(_elementSwitcher);

var _icon = __webpack_require__(20);

var _button = __webpack_require__(19);

var _thumbnailOverlay = __webpack_require__(2718);

var _thumbnailOverlay2 = _interopRequireDefault(_thumbnailOverlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var THUMB_PADDING = 24;

var ThumbnailOverlayStrip = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    isPreviewHover: (0, _appSettings.isPreviewHover)(state),
    isTitleAlwaysShown: (0, _appSettings.getInfoActionVisibility)(state) === _playerWidget.showInfoValues.ALWAYS,
    isTitleNeverShown: (0, _appSettings.getInfoActionVisibility)(state) === _playerWidget.showInfoValues.NEVER
  };
}), _dec2 = (0, _wixConnect.WixConnect)(_thumbnailOverlay2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_OverlayStripBase) {
  (0, _inherits3.default)(ThumbnailOverlayStrip, _OverlayStripBase);

  function ThumbnailOverlayStrip(props) {
    (0, _classCallCheck3.default)(this, ThumbnailOverlayStrip);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ThumbnailOverlayStrip.__proto__ || (0, _getPrototypeOf2.default)(ThumbnailOverlayStrip)).call(this, props));

    var durationStr = _this.props.videoItem.durationStr;


    _this.clampOptions = (0, _extends3.default)({}, _this.clampOptions, {
      truncateText: ' / ' + durationStr,
      textAlign: 'center'
    });
    return _this;
  }

  (0, _createClass3.default)(ThumbnailOverlayStrip, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          channelData = _props.channelData,
          videoItem = _props.videoItem,
          className = _props.className,
          width = _props.width,
          isPreviewHover = _props.isPreviewHover,
          isTitleAlwaysShown = _props.isTitleAlwaysShown,
          isTitleNeverShown = _props.isTitleNeverShown;


      if (!channelData || !videoItem) {
        return null;
      }

      var styleNames = (0, _classnames2.default)('overlay-wrapper', {
        hovered: isPreviewHover,
        visible: isTitleAlwaysShown || isTitleNeverShown
      });

      return React.createElement(
        'div',
        { styleName: styleNames,
          className: className },
        React.createElement('div', { styleName: 'background' }),
        React.createElement(
          'div',
          { styleName: 'content' },
          React.createElement(
            'div',
            { styleName: 'top-content',
              dir: 'ltr' },
            this.titleBlock,
            React.createElement(
              _elementSwitcher2.default,
              { maxWidth: width - 2 * THUMB_PADDING },
              this.normalButtons,
              this.smallButtons
            )
          )
        )
      );
    }
  }, {
    key: 'titleText',
    get: function get() {
      return this.props.videoItem.title;
    }
  }, {
    key: 'shouldShowTitle',
    get: function get() {
      return true;
    }
  }, {
    key: 'titleBlock',
    get: function get() {
      if (this.props.isTitleNeverShown) {
        return null;
      }

      return React.createElement(
        'div',
        { styleName: 'title-block' },
        this.title
      );
    }
  }, {
    key: 'smallPlayButton',
    get: function get() {
      if (!this.playButtonText) {
        return null;
      }

      return React.createElement(
        _button.GenericButton,
        { styleName: 'button play-button',
          onClick: this.playSelectedVideo },
        React.createElement(_icon.RoundedIcon, { styleName: 'icon play-icon',
          name: 'arrow-right-filled' })
      );
    }
  }, {
    key: 'smallSubscribeButton',
    get: function get() {
      if (!this.subscribeButtonText) {
        return null;
      }

      return React.createElement(
        _button.GenericButton,
        { styleName: 'button small-subscribe-button',
          onClick: this.openSubscription },
        React.createElement(_icon.RoundedIcon, { styleName: 'icon paid-icon',
          name: 'paid' })
      );
    }
  }, {
    key: 'smallPurchaseButton',
    get: function get() {
      if (!this.purchaseButtonText) {
        return null;
      }

      return React.createElement(
        _button.GenericButton,
        { styleName: 'button small-buy-button',
          onClick: this.openPurchase },
        React.createElement(_icon.RoundedIcon, { styleName: 'icon paid-icon',
          name: 'paid' })
      );
    }
  }, {
    key: 'normalButtons',
    get: function get() {
      var play = this.playButton;
      var subscribe = this.subscribeButton;
      var purchase = this.purchaseButton;

      var key = '' + (play ? '1' : '') + (subscribe ? '2' : '') + (purchase ? '3' : '');

      return React.createElement(
        'div',
        { styleName: 'buttons-wrapper',
          key: key },
        play,
        subscribe || purchase
      );
    }
  }, {
    key: 'smallButtons',
    get: function get() {
      return React.createElement(
        'section',
        { styleName: 'buttons-wrapper' },
        this.smallPlayButton,
        this.smallSubscribeButton || this.smallPurchaseButton
      );
    }
  }]);
  return ThumbnailOverlayStrip;
}(_stripBase2.default), _class2.displayName = 'ThumbnailOverlayStrip', _class2.propTypes = {
  isPreviewHover: React.PropTypes.bool,
  isTitleAlwaysShown: React.PropTypes.bool,
  isTitleNeverShown: React.PropTypes.bool
}, _temp)) || _class) || _class);
exports.default = ThumbnailOverlayStrip;

/***/ }),

/***/ 1416:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  EDITOR: 'editor',
  PREVIEW: 'preview',
  SITE: 'site',
  STANDALONE: 'standalone'
};

/***/ }),

/***/ 1419:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _reactRedux = __webpack_require__(12);

var _playerWidget = __webpack_require__(25);

var _reduxUi = __webpack_require__(40);

var _reduxUi2 = _interopRequireDefault(_reduxUi);

var _getQueryParams = __webpack_require__(480);

var _getQueryParams2 = _interopRequireDefault(_getQueryParams);

var _videosSizes = __webpack_require__(132);

var _biUnhandledErrorLogger = __webpack_require__(255);

var _biUnhandledErrorLogger2 = _interopRequireDefault(_biUnhandledErrorLogger);

var _searchQueryFields = __webpack_require__(708);

var _searchQueryFields2 = _interopRequireDefault(_searchQueryFields);

var _channels = __webpack_require__(29);

var _appSettings = __webpack_require__(48);

var _tooltipPopout = __webpack_require__(110);

var _tooltipPopout2 = _interopRequireDefault(_tooltipPopout);

var _modal = __webpack_require__(36);

var _modal2 = _interopRequireDefault(_modal);

var _experiments = __webpack_require__(211);

var _experiments2 = _interopRequireDefault(_experiments);

var _appSettings2 = __webpack_require__(340);

var _appSettings3 = _interopRequireDefault(_appSettings2);

var _updateChannelPublishedState = __webpack_require__(498);

var _updateChannelPublishedState2 = _interopRequireDefault(_updateChannelPublishedState);

var _channel = __webpack_require__(341);

var _channel2 = _interopRequireDefault(_channel);

var _paymentInfo = __webpack_require__(273);

var _paymentInfo2 = _interopRequireDefault(_paymentInfo);

var _channelVideo = __webpack_require__(217);

var _channelVideo2 = _interopRequireDefault(_channelVideo);

var _paginatedChannelVideos = __webpack_require__(219);

var _paginatedChannelVideos2 = _interopRequireDefault(_paginatedChannelVideos);

var _nextChannelVideos = __webpack_require__(497);

var _nextChannelVideos2 = _interopRequireDefault(_nextChannelVideos);

var _currentSiteUser = __webpack_require__(272);

var _currentSiteUser2 = _interopRequireDefault(_currentSiteUser);

var _reloadChannelPaymentDataOnPayment = __webpack_require__(343);

var _reloadChannelPaymentDataOnPayment2 = _interopRequireDefault(_reloadChannelPaymentDataOnPayment);

var _clearVideoUrlsCacheOnPayment = __webpack_require__(342);

var _clearVideoUrlsCacheOnPayment2 = _interopRequireDefault(_clearVideoUrlsCacheOnPayment);

var _proxy = __webpack_require__(323);

var _proxy2 = _interopRequireDefault(_proxy);

__webpack_require__(242);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DesktopLayout = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    appSettings: state.appSettings,
    selectedVideoId: state.selectedVideoId,
    channelData: (0, _channels.getChannelForWidget)(state),
    currentChannelId: state.currentChannelId,
    firstVideoId: _.get(state.lazyVideoLists[_paginatedChannelVideos.DATA_KEY], 'idChunks[0][0]'),
    numberOfRows: (0, _appSettings.getNumberOfRows)(state)
  };
}), _dec2 = (0, _reduxUi2.default)({
  state: {
    searchQuery: '',
    searchQueryField: _searchQueryFields2.default.QUERY
  }
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(DesktopLayout, _React$Component);

  function DesktopLayout() {
    (0, _classCallCheck3.default)(this, DesktopLayout);
    return (0, _possibleConstructorReturn3.default)(this, (DesktopLayout.__proto__ || (0, _getPrototypeOf2.default)(DesktopLayout)).apply(this, arguments));
  }

  (0, _createClass3.default)(DesktopLayout, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          currentChannelId = _props.currentChannelId,
          appSettings = _props.appSettings;


      return React.createElement(
        'div',
        null,
        React.createElement(
          _experiments2.default,
          null,
          React.createElement(_biUnhandledErrorLogger2.default, null),
          React.createElement(_appSettings3.default, null),
          React.createElement(_updateChannelPublishedState2.default, { channelId: currentChannelId }),
          this.content,
          React.createElement(_modal2.default, { settings: appSettings }),
          React.createElement(_tooltipPopout2.default, null)
        )
      );
    }
  }, {
    key: 'videosPerPage',


    // Todo: move to loader or reducer
    get: function get() {
      var _props2 = this.props,
          appSettings = _props2.appSettings,
          numberOfRows = _props2.numberOfRows,
          channelData = _props2.channelData;

      var videosInRow = appSettings.numbers.videosInRow;
      if (appSettings.numbers.channelLayout === _playerWidget.channelLayoutValues.STRIP) {
        return videosInRow * numberOfRows;
      }

      var allVideosCount = channelData && channelData.videosCount;

      return (0, _videosSizes.videosPerPage)(appSettings.requestedWidgetSize, videosInRow, allVideosCount, appSettings, channelData || {});
    }
  }, {
    key: 'content',
    get: function get() {
      var _props3 = this.props,
          children = _props3.children,
          appSettings = _props3.appSettings,
          firstVideoId = _props3.firstVideoId,
          currentChannelId = _props3.currentChannelId,
          channelData = _props3.channelData,
          selectedVideoId = _props3.selectedVideoId,
          _props3$ui = _props3.ui,
          searchQuery = _props3$ui.searchQuery,
          searchQueryField = _props3$ui.searchQueryField;


      if (!appSettings || !currentChannelId) {
        return null;
      }

      var compId = appSettings.compId,
          siteUrl = appSettings.siteUrl;

      var featuredItemId = channelData && channelData.featuredItem;
      var queryParams = (0, _getQueryParams2.default)(siteUrl);

      var videoIdFromUrl = null;
      if (compId === queryParams['wix-vod-comp-id']) {
        videoIdFromUrl = queryParams['wix-vod-video-id'];
      }

      var nextChannelVideosVideoId = selectedVideoId || videoIdFromUrl || featuredItemId || firstVideoId;

      return React.createElement(
        _channel2.default,
        { channelId: currentChannelId },
        React.createElement(
          _paginatedChannelVideos2.default,
          { channelId: currentChannelId,
            videosPerUIPage: this.videosPerPage,
            searchQuery: searchQuery,
            searchQueryField: searchQueryField,
            as: _paginatedChannelVideos.DATA_KEY },
          React.createElement(
            _channelVideo2.default,
            { channelId: currentChannelId,
              videoId: videoIdFromUrl },
            React.createElement(
              _nextChannelVideos2.default,
              { channelId: currentChannelId,
                currentVideoId: nextChannelVideosVideoId },
              React.createElement(
                _currentSiteUser2.default,
                null,
                React.createElement(
                  _paymentInfo2.default,
                  { channelId: currentChannelId },
                  children,
                  React.createElement(_proxy2.default, null),
                  React.createElement(_reloadChannelPaymentDataOnPayment2.default, null),
                  React.createElement(_clearVideoUrlsCacheOnPayment2.default, null)
                )
              )
            )
          )
        )
      );
    }
  }]);
  return DesktopLayout;
}(React.Component), _class2.propTypes = {
  selectedVideoId: React.PropTypes.string,
  children: React.PropTypes.element,
  currentChannelId: React.PropTypes.string,
  firstVideoId: React.PropTypes.string,
  channelData: React.PropTypes.object,
  appSettings: React.PropTypes.object,
  ui: React.PropTypes.object,
  numberOfRows: React.PropTypes.number
}, _temp)) || _class) || _class);
exports.default = DesktopLayout;

/***/ }),

/***/ 1420:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _reactRedux = __webpack_require__(12);

var _wixConnect = __webpack_require__(6);

var _getQueryParams = __webpack_require__(480);

var _getQueryParams2 = _interopRequireDefault(_getQueryParams);

var _tooltipPopout = __webpack_require__(110);

var _tooltipPopout2 = _interopRequireDefault(_tooltipPopout);

var _modal = __webpack_require__(36);

var _biUnhandledErrorLogger = __webpack_require__(255);

var _biUnhandledErrorLogger2 = _interopRequireDefault(_biUnhandledErrorLogger);

var _mobileSpinnerOverlay = __webpack_require__(486);

var _mobileSpinnerOverlay2 = _interopRequireDefault(_mobileSpinnerOverlay);

var _experiments = __webpack_require__(211);

var _experiments2 = _interopRequireDefault(_experiments);

var _appSettings = __webpack_require__(340);

var _appSettings2 = _interopRequireDefault(_appSettings);

var _updateChannelPublishedState = __webpack_require__(498);

var _updateChannelPublishedState2 = _interopRequireDefault(_updateChannelPublishedState);

var _updateWidgetSize = __webpack_require__(274);

var _updateWidgetSize2 = _interopRequireDefault(_updateWidgetSize);

var _channel = __webpack_require__(341);

var _channel2 = _interopRequireDefault(_channel);

var _paymentInfo = __webpack_require__(273);

var _paymentInfo2 = _interopRequireDefault(_paymentInfo);

var _channelVideo = __webpack_require__(217);

var _channelVideo2 = _interopRequireDefault(_channelVideo);

var _lazyChannelVideos = __webpack_require__(218);

var _lazyChannelVideos2 = _interopRequireDefault(_lazyChannelVideos);

var _currentSiteUser = __webpack_require__(272);

var _currentSiteUser2 = _interopRequireDefault(_currentSiteUser);

var _reloadChannelPaymentDataOnPayment = __webpack_require__(343);

var _reloadChannelPaymentDataOnPayment2 = _interopRequireDefault(_reloadChannelPaymentDataOnPayment);

var _clearVideoUrlsCacheOnPayment = __webpack_require__(342);

var _clearVideoUrlsCacheOnPayment2 = _interopRequireDefault(_clearVideoUrlsCacheOnPayment);

var _proxy = __webpack_require__(323);

var _proxy2 = _interopRequireDefault(_proxy);

var _appSettings3 = __webpack_require__(48);

var _widgetHeightByContentSync = __webpack_require__(1421);

var _widgetHeightByContentSync2 = _interopRequireDefault(_widgetHeightByContentSync);

__webpack_require__(242);

var _mobile = __webpack_require__(2719);

var _mobile2 = _interopRequireDefault(_mobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MobileLayout = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    appSettings: state.appSettings,
    currentChannelId: state.currentChannelId,
    layout: (0, _appSettings3.getChannelLayout)(state)
  };
}), _dec2 = (0, _wixConnect.WixConnect)(_mobile2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(MobileLayout, _React$Component);

  function MobileLayout() {
    (0, _classCallCheck3.default)(this, MobileLayout);
    return (0, _possibleConstructorReturn3.default)(this, (MobileLayout.__proto__ || (0, _getPrototypeOf2.default)(MobileLayout)).apply(this, arguments));
  }

  (0, _createClass3.default)(MobileLayout, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          currentChannelId = _props.currentChannelId,
          appSettings = _props.appSettings,
          layout = _props.layout;


      return React.createElement(
        'div',
        { styleName: 'container',
          'data-layout': layout },
        React.createElement(
          _experiments2.default,
          null,
          React.createElement(_biUnhandledErrorLogger2.default, null),
          React.createElement(_appSettings2.default, null),
          React.createElement(_updateChannelPublishedState2.default, { channelId: currentChannelId }),
          React.createElement(_updateWidgetSize2.default, null),
          this.content,
          React.createElement(_modal.MobileModal, { settings: appSettings }),
          React.createElement(_tooltipPopout2.default, null)
        )
      );
    }
  }, {
    key: 'content',
    get: function get() {
      var _props2 = this.props,
          children = _props2.children,
          appSettings = _props2.appSettings,
          currentChannelId = _props2.currentChannelId;


      if (!appSettings || !currentChannelId) {
        return React.createElement(_mobileSpinnerOverlay2.default, null);
      }

      var compId = appSettings.compId,
          siteUrl = appSettings.siteUrl,
          videosInRow = appSettings.numbers.videosInRow;


      var queryParams = (0, _getQueryParams2.default)(siteUrl);

      var videoIdFromUrl = null;
      if (compId === queryParams['wix-vod-comp-id']) {
        videoIdFromUrl = queryParams['wix-vod-video-id'];
      }

      return React.createElement(
        _widgetHeightByContentSync2.default,
        null,
        React.createElement(
          _channel2.default,
          { channelId: currentChannelId },
          React.createElement(
            _lazyChannelVideos2.default,
            { channelId: currentChannelId,
              as: _lazyChannelVideos.MOBILE_WIDGET_DATA_KEY,
              numberToLoadMore: videosInRow * 3 },
            React.createElement(
              _channelVideo2.default,
              { channelId: currentChannelId,
                videoId: videoIdFromUrl },
              React.createElement(
                _currentSiteUser2.default,
                null,
                React.createElement(
                  _paymentInfo2.default,
                  { channelId: currentChannelId },
                  children,
                  React.createElement(_proxy2.default, null),
                  React.createElement(_reloadChannelPaymentDataOnPayment2.default, null),
                  React.createElement(_clearVideoUrlsCacheOnPayment2.default, null)
                )
              )
            )
          )
        )
      );
    }
  }]);
  return MobileLayout;
}(React.Component), _class2.propTypes = {
  children: React.PropTypes.element,
  currentChannelId: React.PropTypes.string,
  appSettings: React.PropTypes.object,
  layout: React.PropTypes.number
}, _temp)) || _class) || _class);
exports.default = MobileLayout;

/***/ }),

/***/ 1421:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = __webpack_require__(10);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _reactRedux = __webpack_require__(12);

var _autobind = __webpack_require__(11);

var _autobind2 = _interopRequireDefault(_autobind);

var _debounce = __webpack_require__(98);

var _debounce2 = _interopRequireDefault(_debounce);

var _wixSdk = __webpack_require__(21);

var _wixSdk2 = _interopRequireDefault(_wixSdk);

var _viewModes = __webpack_require__(81);

var _viewModes2 = _interopRequireDefault(_viewModes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var WidgetHeightByContentSync = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    // lazyVideoLists is needed to trigger height calculations
    lazyVideoLists: state.lazyVideoLists,
    appSettings: state.appSettings
  };
}), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  (0, _inherits3.default)(WidgetHeightByContentSync, _React$Component);

  function WidgetHeightByContentSync() {
    (0, _classCallCheck3.default)(this, WidgetHeightByContentSync);
    return (0, _possibleConstructorReturn3.default)(this, (WidgetHeightByContentSync.__proto__ || (0, _getPrototypeOf2.default)(WidgetHeightByContentSync)).apply(this, arguments));
  }

  (0, _createClass3.default)(WidgetHeightByContentSync, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateTPAParentIfNeeded();
      window.addEventListener('resize', this.updateTPAParentIfNeeded);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.updateTPAParentIfNeeded();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateTPAParentIfNeeded);
    }
  }, {
    key: 'updateTPAParentIfNeeded',
    value: function updateTPAParentIfNeeded() {
      if (!this.container) {
        return;
      }

      var newHeight = Math.ceil(this.container.scrollHeight);

      // Width is not checked, only height
      if (newHeight === 0) {
        return;
      }

      // Getting real bounding rect for our component
      _wixSdk2.default.getBoundingRectAndOffsets().then(function (data) {
        var rect = data.rect;


        if (rect.height !== newHeight) {
          if (_wixSdk2.default.Utils.getViewMode() === _viewModes2.default.EDITOR) {
            // this is for editor
            _wixSdk2.default.resizeComponent({ height: newHeight });

            // fix TPA bug. TODO remove
            _wixSdk2.default.setHeight(newHeight);
          } else {
            // this is for viewer
            _wixSdk2.default.setHeight(newHeight);
          }
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          appSettings = _props.appSettings,
          children = _props.children;

      var widgetWidth = _.get(appSettings, 'requestedWidgetSize.width');

      if (!widgetWidth) {
        return null;
      }

      return React.createElement(
        'div',
        { ref: function ref(node) {
            return _this2.container = node;
          },
          style: { width: widgetWidth } },
        children
      );
    }
  }]);
  return WidgetHeightByContentSync;
}(React.Component), _class3.propTypes = {
  appSettings: React.PropTypes.object,
  children: React.PropTypes.any
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'updateTPAParentIfNeeded', [_autobind2.default, _debounce2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateTPAParentIfNeeded'), _class2.prototype)), _class2)) || _class);
exports.default = WidgetHeightByContentSync;

/***/ }),

/***/ 1478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRouter = __webpack_require__(27);

var _wixSdk = __webpack_require__(21);

var _wixSdk2 = _interopRequireDefault(_wixSdk);

var _deviceTypes = __webpack_require__(326);

var _deviceTypes2 = _interopRequireDefault(_deviceTypes);

var _notFoundView = __webpack_require__(268);

var _notFoundView2 = _interopRequireDefault(_notFoundView);

var _desktop = __webpack_require__(1419);

var _desktop2 = _interopRequireDefault(_desktop);

var _mobile = __webpack_require__(1420);

var _mobile2 = _interopRequireDefault(_mobile);

var _desktopViewsSwitcher = __webpack_require__(1487);

var _desktopViewsSwitcher2 = _interopRequireDefault(_desktopViewsSwitcher);

var _mobile3 = __webpack_require__(1490);

var _mobile4 = _interopRequireDefault(_mobile3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MOBILE_ROUTE_PREFIX = '/mobile';

function getUrlDeviceType(location) {
  return _.startsWith(location.pathname, MOBILE_ROUTE_PREFIX) ? _deviceTypes2.default.MOBILE : _deviceTypes2.default.DESKTOP;
}

function requireRedirectToMobile(nextState, replace) {
  if (_wixSdk2.default.Utils.getDeviceType() === _deviceTypes2.default.MOBILE && getUrlDeviceType(nextState.location) !== _deviceTypes2.default.MOBILE) {
    replace('/mobile');
  }
}

function onEnterMobile() {
  // TODO: set full width
}

exports.default = React.createElement(
  _reactRouter.Route,
  { path: '/' },
  React.createElement(
    _reactRouter.Route,
    { onEnter: requireRedirectToMobile,
      component: _desktop2.default },
    React.createElement(_reactRouter.IndexRoute, { component: _desktopViewsSwitcher2.default })
  ),
  React.createElement(
    _reactRouter.Route,
    { path: MOBILE_ROUTE_PREFIX,
      onEnter: onEnterMobile,
      component: _mobile2.default },
    React.createElement(_reactRouter.IndexRoute, { component: _mobile4.default })
  ),
  React.createElement(_reactRouter.Route, { path: '/404',
    component: _notFoundView2.default }),
  React.createElement(_reactRouter.Redirect, { from: '*',
    to: '/404' })
);

/***/ }),

/***/ 1481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMobileWidgetVisibleInViewPort = isMobileWidgetVisibleInViewPort;

var _wixSdk = __webpack_require__(21);

var _wixSdk2 = _interopRequireDefault(_wixSdk);

var _screen = __webpack_require__(266);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isMobileWidgetVisibleInViewPort() {
  return _wixSdk2.default.getBoundingRectAndOffsets().then(function (data) {
    var _data$rect = data.rect,
        top = _data$rect.top,
        bottom = _data$rect.bottom;

    var _getScreenSizeByUserA = (0, _screen.getScreenSizeByUserAgent)(),
        width = _getScreenSizeByUserA.width,
        height = _getScreenSizeByUserA.height;

    var screenHeight = (0, _screen.isLandscape)() ? width : height;

    return top <= 0 && bottom >= screenHeight || top >= 0 && bottom <= screenHeight;
  });
}

/***/ }),

/***/ 1482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = __webpack_require__(10);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(511);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntl = __webpack_require__(5);

var _autobind = __webpack_require__(11);

var _autobind2 = _interopRequireDefault(_autobind);

var _debounce = __webpack_require__(98);

var _debounce2 = _interopRequireDefault(_debounce);

var _reactRedux = __webpack_require__(12);

var _reduxUi = __webpack_require__(40);

var _reduxUi2 = _interopRequireDefault(_reduxUi);

var _layoutHelpers = __webpack_require__(67);

var _wixConnect = __webpack_require__(6);

var _wixSdk = __webpack_require__(21);

var _wixSdk2 = _interopRequireDefault(_wixSdk);

var _newRelic = __webpack_require__(120);

var _videoOverlayEventsParams = __webpack_require__(264);

var _reload = __webpack_require__(131);

var _payments = __webpack_require__(145);

var _payments2 = _interopRequireDefault(_payments);

var _screen = __webpack_require__(266);

var _selectVideo = __webpack_require__(179);

var _changePlaybackStatus = __webpack_require__(130);

var _openOverlay = __webpack_require__(128);

var _selectedVideoId = __webpack_require__(277);

var _paginatedChannelVideos = __webpack_require__(219);

var _videosSizes = __webpack_require__(132);

var _videoPlaybackStatus = __webpack_require__(180);

var _viewModes = __webpack_require__(81);

var _viewModes2 = _interopRequireDefault(_viewModes);

var _base = __webpack_require__(278);

var _base2 = _interopRequireDefault(_base);

var _desktopPlayer = __webpack_require__(495);

var _desktopPlayer2 = _interopRequireDefault(_desktopPlayer);

var _mobilePlayer = __webpack_require__(269);

var _mobilePlayer2 = _interopRequireDefault(_mobilePlayer);

var _previewPrompt = __webpack_require__(177);

var _shareChannel = __webpack_require__(764);

var _shareChannel2 = _interopRequireDefault(_shareChannel);

var _accountButton = __webpack_require__(740);

var _accountButton2 = _interopRequireDefault(_accountButton);

var _channelInfoButton = __webpack_require__(743);

var _channelInfoButton2 = _interopRequireDefault(_channelInfoButton);

var _channelSubscriptionButton = __webpack_require__(744);

var _channelSubscriptionButton2 = _interopRequireDefault(_channelSubscriptionButton);

var _categories = __webpack_require__(742);

var _categories2 = _interopRequireDefault(_categories);

var _tags = __webpack_require__(339);

var _tags2 = _interopRequireDefault(_tags);

var _searchBar = __webpack_require__(763);

var _classic = __webpack_require__(1412);

var _classic2 = _interopRequireDefault(_classic);

var _center = __webpack_require__(1395);

var _center2 = _interopRequireDefault(_center);

var _memberOnly = __webpack_require__(1396);

var _memberOnly2 = _interopRequireDefault(_memberOnly);

var _scrollbarWrapper = __webpack_require__(109);

var _updateWidgetSize = __webpack_require__(274);

var _updateWidgetSize2 = _interopRequireDefault(_updateWidgetSize);

var _paymentEvents = __webpack_require__(121);

var _paymentEvents2 = _interopRequireDefault(_paymentEvents);

var _emptySearchResults = __webpack_require__(745);

var _emptySearchResults2 = _interopRequireDefault(_emptySearchResults);

var _reloadStorage = __webpack_require__(270);

var _reloadStorage2 = _interopRequireDefault(_reloadStorage);

var _classic3 = __webpack_require__(2741);

var _classic4 = _interopRequireDefault(_classic3);

var _translations = __webpack_require__(276);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var DEFAULT_STATE = {
  canShowChannelCover: true,
  isInFullScreen: false,
  isTagFocused: false,
  isSearchInputFocused: false,
  searchLayout: false,
  currentCategory: null
};

var ClassicView = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    mainVideoId: (0, _selectedVideoId.getMainVideoId)(state, ownProps, _paginatedChannelVideos.DATA_KEY),
    isVideoPlaying: (0, _videoPlaybackStatus.isVideoPlaying)(state),
    isVideoPaused: (0, _videoPlaybackStatus.isVideoPaused)(state),
    currentChannelId: state.currentChannelId,
    appSettings: state.appSettings,
    firstChannelVideoId: state.firstChannelVideoId,
    prevVideoId: ownProps.nextChannelVideos.prevId,
    nextVideoId: ownProps.nextChannelVideos.nextId,
    isSearchBarVisible: (0, _layoutHelpers.isClassicLayoutSearchBarVisible)(state.appSettings, ownProps.channelData),
    isSearchInputVisible: (0, _layoutHelpers.isSearchInputVisible)(state.appSettings, ownProps.channelData),
    isCategoriesDropdownVisible: (0, _layoutHelpers.isCategoriesDropdownVisible)(state.appSettings, ownProps.channelData)
  };
}, {
  selectVideo: _selectVideo.selectVideo,
  playVideo: _changePlaybackStatus.playVideo,
  pauseVideo: _changePlaybackStatus.pauseVideo
}), _dec2 = (0, _reduxUi2.default)(), _dec3 = (0, _wixConnect.WixConnect)(_classic4.default), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_BaseView) {
  (0, _inherits3.default)(ClassicView, _BaseView);

  function ClassicView(props) {
    (0, _classCallCheck3.default)(this, ClassicView);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ClassicView.__proto__ || (0, _getPrototypeOf2.default)(ClassicView)).call(this, props));

    _this.state = (0, _extends3.default)({}, DEFAULT_STATE, {
      searchBarValue: props.ui.searchQuery
    });

    (0, _newRelic.getNewRelic)().setCustomAttribute('layout', 'classic');
    return _this;
  }

  (0, _createClass3.default)(ClassicView, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _get3.default)(ClassicView.prototype.__proto__ || (0, _getPrototypeOf2.default)(ClassicView.prototype), 'componentDidMount', this).call(this);
      this.setUtmostWidgetSize();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      (0, _get3.default)(ClassicView.prototype.__proto__ || (0, _getPrototypeOf2.default)(ClassicView.prototype), 'componentDidUpdate', this).call(this, prevProps);

      var _props = this.props,
          appSettings = _props.appSettings,
          channelData = _props.channelData;


      if (appSettings.numbers.videosInRow !== prevProps.appSettings.numbers.videosInRow || appSettings.numbers.videoInfoPosition !== prevProps.appSettings.numbers.videoInfoPosition || !_.isEqual(appSettings.booleans, prevProps.appSettings.booleans) || channelData !== prevProps.channelData || !_.isEqual(appSettings.requestedWidgetSize, prevProps.appSettings.requestedWidgetSize)) {
        this.setUtmostWidgetSize();
      }
    }
  }, {
    key: 'setUtmostWidgetSize',
    value: function setUtmostWidgetSize() {
      var _props2 = this.props,
          appSettings = _props2.appSettings,
          channelData = _props2.channelData;


      if (!appSettings || !channelData) {
        return;
      }

      var videosInRow = appSettings.numbers.videosInRow;
      var initialWidth = window.innerWidth;
      var initialHeight = window.innerHeight;
      var width = Math.min(Math.max(initialWidth, _videosSizes.MIN_WIDGET_WIDTH), _videosSizes.MAX_WIDGET_WIDTH);
      var height = initialHeight;

      var allVideosCount = channelData.videosCount;

      // what videos rows need to be displayed
      var perPage = (0, _videosSizes.videosPerPage)({
        width: width,
        height: height
      }, videosInRow, allVideosCount, appSettings, channelData);
      var rowsCount = Math.ceil(Math.min(perPage, allVideosCount) / videosInRow);

      if (rowsCount <= 0) {
        rowsCount = 1;
      }

      // widget height for this rows count
      height = Math.ceil((0, _videosSizes.classicLayoutWidgetHeight)(width, videosInRow, allVideosCount, rowsCount, appSettings, channelData));

      if (width !== initialWidth || height !== initialHeight) {
        if (_wixSdk2.default.Utils.getViewMode() === _viewModes2.default.EDITOR) {
          // editor
          _wixSdk2.default.resizeComponent({ width: width, height: height });
        } else {
          // viewer
          _wixSdk2.default.resizeWindow(width, height);
        }
        // fix TPA bug. TODO remove
        _wixSdk2.default.setHeight(height);
      }
    }
  }, {
    key: 'reset',
    value: function reset() {
      (0, _get3.default)(ClassicView.prototype.__proto__ || (0, _getPrototypeOf2.default)(ClassicView.prototype), 'reset', this).call(this);

      this.setState((0, _extends3.default)({}, DEFAULT_STATE, {
        searchBarValue: ''
      }));
    }
  }, {
    key: 'processSubscriptionCancel',
    value: function processSubscriptionCancel() {
      var _props3 = this.props,
          _props3$appSettings = _props3.appSettings,
          siteUrl = _props3$appSettings.siteUrl,
          instance = _props3$appSettings.instance,
          currentChannelId = _props3.currentChannelId;


      _payments2.default.cancelSubscription(currentChannelId, siteUrl, instance);
    }
  }, {
    key: 'handleThumbnailClick',
    value: function handleThumbnailClick(videoItem) {
      this.scrollToWidgetTop();
      this.selectVideo(videoItem);
      this.sendVidSelectedBiEvent(videoItem);
    }
  }, {
    key: 'scrollToWidgetTop',
    value: function scrollToWidgetTop() {
      var compId = this.props.appSettings.compId;

      _wixSdk2.default.navigateToComponent(compId);
    }
  }, {
    key: 'showChannelInfo',
    value: function showChannelInfo(event) {
      event.preventDefault();
      (0, _openOverlay.openFullScreenOverlay)('#/channel/' + this.props.channelData.id + '/info');
    }
  }, {
    key: 'openSubscription',
    value: function openSubscription() {
      var _this2 = this;

      if ((0, _previewPrompt.isPreviewMode)()) {
        (0, _previewPrompt.openPreviewPrompt)();
        return;
      }

      (0, _openOverlay.openFullScreenSubscribeOverlay)(this.props.channelData.id, function () {
        _this2.props.biEvent('widget.subscriptionPopUp.Completed', { result: 'canceled', errorMsg: '' });
      });
    }
  }, {
    key: 'openMemberOnly',
    value: function openMemberOnly(id) {
      (0, _openOverlay.openFullScreenMemberOnlyOverlay)(this.props.channelData.id, id);
    }
  }, {
    key: 'storeDataForReload',
    value: function storeDataForReload() {
      (0, _reload.storeForReload)({
        mainVideoId: this.props.mainVideoId
      });
    }
  }, {
    key: 'processDataFromStorage',
    value: function processDataFromStorage(_ref) {
      var selectedVideoId = _ref.selectedVideoId,
          autoplay = _ref.autoplay;

      if (autoplay) {
        this.playVideo({ id: selectedVideoId });
      } else {
        this.selectVideo({ id: selectedVideoId });
      }
    }
  }, {
    key: 'setFullScreenState',
    value: function setFullScreenState(isInFullScreen) {
      // in full screen in mobile the innerWidth becomes bigger that is should be, so exit.
      // Seems like this is viewer issue because site itself becomes wider than 320px.
      this.setState({ isInFullScreen: isInFullScreen });
    }
  }, {
    key: 'renderPlayerForCurrentDevice',
    value: function renderPlayerForCurrentDevice(videoItem) {
      var _props4 = this.props,
          channelData = _props4.channelData,
          isVideoPlaying = _props4.isVideoPlaying;

      var commonProps = (0, _extends3.default)({
        styleName: 'player',
        className: 'qa-widget-player',
        videoItem: videoItem,
        channelData: channelData
      }, this.playerSize, {
        paused: !isVideoPlaying,
        canShowChannelCover: this.canShowChannelCover,
        onPurchaseClick: this.openPurchase,
        onSubscribeClick: this.openSubscription,
        openPreviewPrompt: _previewPrompt.openPreviewPrompt,
        onMemberSignUp: this.openMemberOnly,
        memberOnlyOverlay: React.createElement(_memberOnly2.default, null),
        children: this.playerOverlay,
        onFullScreenChanged: this.setFullScreenState
      });

      var PlayerComponent = (0, _screen.isMobile)() || (0, _screen.isTablet)() ? _mobilePlayer2.default : _desktopPlayer2.default;

      return React.createElement(PlayerComponent, commonProps);
    }
  }, {
    key: 'sendVidSelectedBiEvent',
    value: function sendVidSelectedBiEvent(_ref2) {
      var id = _ref2.id;
      var _props5 = this.props,
          appSettings = _props5.appSettings,
          channelData = _props5.channelData,
          videoByIds = _props5.videoByIds;

      this.props.biEvent('widget.VidSelected.displayed', (0, _videoOverlayEventsParams.getVideoSelectedEventParams)(appSettings, channelData, videoByIds[id], this.canShowChannelCover));
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.isUIBlockingDataLoaded || !this.isVideosLoaded) {
        return this.spinner;
      }

      var appSettings = this.props.appSettings;

      var widgetSize = _.get(appSettings, 'requestedWidgetSize');
      var styleNames = (0, _classnames2.default)('container', 'view-mode-' + appSettings.editMode);

      return React.createElement(
        'section',
        { styleName: styleNames,
          style: widgetSize,
          'data-channel-layout': 'classic' },
        React.createElement(_updateWidgetSize2.default, { disabled: this.state.isInFullScreen }),
        React.createElement(_reloadStorage2.default, { onReload: this.processDataFromStorage }),
        this.header,
        this.player,
        this.content,
        React.createElement(_paymentEvents2.default, { onRent: this.setCurrentVideoFromPayment,
          onSale: this.setCurrentVideoFromPayment,
          onSubscription: this.reset,
          onSubscriptionCancel: this.reset })
      );
    }
  }, {
    key: 'listThumbnailSize',
    get: function get() {
      var appSettings = this.props.appSettings;

      var widgetWidth = appSettings.requestedWidgetSize.width;
      var videosInRow = appSettings.numbers.videosInRow;
      return (0, _videosSizes.listThumbnailSize)(widgetWidth, videosInRow);
    }

    // TODO: move to data component

  }, {
    key: 'tagList',
    get: function get() {
      return _.get(this.props, 'channelData.statsInfo.tags') || [];
    }
  }, {
    key: 'categoriesList',
    get: function get() {
      var categoriesStats = _.get(this.props, 'channelData.statsInfo.categories') || [];
      return _.map(categoriesStats, 'value');
    }
  }, {
    key: 'tags',
    get: function get() {
      var _state = this.state,
          searchLayout = _state.searchLayout,
          searchBarValue = _state.searchBarValue;

      var tags = this.tagList;

      if (!tags.length || !searchLayout || searchBarValue) {
        return null;
      }

      return React.createElement(
        'div',
        { styleName: 'tags-wrapper' },
        React.createElement(
          _scrollbarWrapper.WidgetScrollbarWrapper,
          null,
          React.createElement(_tags2.default, { styleName: 'tags',
            onTagFocus: this.handleTagsFocus,
            onTagBlur: this.handleTagsBlur,
            onTagClick: this.searchByTag,
            tags: tags })
        )
      );
    }
  }, {
    key: 'noSearchResults',
    get: function get() {
      var _state2 = this.state,
          searchBarValue = _state2.searchBarValue,
          searchLayout = _state2.searchLayout;


      if (!this.hasNoSearchResults || searchLayout && !searchBarValue) {
        return null;
      }

      return React.createElement(_emptySearchResults2.default, null);
    }
  }, {
    key: 'videosList',
    get: function get() {
      var _props6 = this.props,
          paginatedChannelVideos = _props6.paginatedChannelVideos,
          channelData = _props6.channelData,
          searchQuery = _props6.ui.searchQuery,
          mainVideoId = _props6.mainVideoId,
          isVideoPlaying = _props6.isVideoPlaying;
      var searchLayout = this.state.searchLayout;

      var searchBlockShown = searchLayout && !searchQuery && this.tagList.length;

      var noVideos = !paginatedChannelVideos.ids.length;
      if (!this.isFetching && channelData.videosCount === 0) {
        return React.createElement(
          'div',
          { styleName: 'coming-soon' },
          React.createElement(_reactIntl.FormattedMessage, _translations2.default.thisChannelIsComingSoon)
        );
      }

      if (this.isFetching || noVideos || !this.mainVideo || searchBlockShown) {
        return null;
      }

      return React.createElement(_classic2.default, { onThumbnailClick: this.handleThumbnailClick,
        thumbnailSize: this.listThumbnailSize,
        paginatedChannelVideos: paginatedChannelVideos,
        isSelectedVideoIndicationDisabled: this.isChannelCoverShown,
        isVideoPaused: !isVideoPlaying,
        selectedVideoId: mainVideoId,
        styleName: 'videos' });
    }
  }, {
    key: 'search',
    get: function get() {
      var _props7 = this.props,
          isSearchInputVisible = _props7.isSearchInputVisible,
          searchQuery = _props7.ui.searchQuery;


      if (!isSearchInputVisible) {
        return null;
      }

      var value = this.isCategorySelected ? '' : searchQuery;

      return React.createElement(_searchBar.ClassicSearchBar, { value: value,
        onFocus: this.handleSearchInputFocus,
        onBlur: this.handleSearchInputBlur,
        onChange: this.setSearchBarValue,
        onSearch: this.searchByQuery,
        onClose: this.clearSearch,
        styleName: 'search' });
    }
  }, {
    key: 'categories',
    get: function get() {
      var _props8 = this.props,
          isCategoriesDropdownVisible = _props8.isCategoriesDropdownVisible,
          ui = _props8.ui;


      if (!isCategoriesDropdownVisible) {
        return null;
      }

      var _state3 = this.state,
          searchLayout = _state3.searchLayout,
          currentCategory = _state3.currentCategory,
          searchBarValue = _state3.searchBarValue;


      if (searchLayout || !this.isCategorySelected && (searchBarValue || ui.searchQuery)) {
        return null;
      }

      return React.createElement(_categories2.default, { styleName: 'categories',
        list: this.categoriesList,
        onCategorySelect: this.searchByCategory,
        selectedCategory: currentCategory });
    }
  }, {
    key: 'content',
    get: function get() {
      var styleNames = (0, _classnames2.default)('content', {
        'no-search-bar': !this.props.isSearchBarVisible
      });

      return React.createElement(
        'section',
        { styleName: styleNames,
          className: 'qa-widget-content' },
        React.createElement(
          'div',
          { styleName: 'search-line',
            className: 'qa-widget-search-line' },
          this.search,
          this.categories
        ),
        this.tags,
        this.videosList,
        this.noSearchResults
      );
    }
  }, {
    key: 'channelTitle',
    get: function get() {
      var _props9 = this.props,
          channelData = _props9.channelData,
          appSettings = _props9.appSettings;

      return appSettings.booleans.showChannelTitle ? channelData.title : null;
    }
  }, {
    key: 'header',
    get: function get() {
      var _props10 = this.props,
          appSettings = _props10.appSettings,
          channelData = _props10.channelData;

      var styleNames = (0, _classnames2.default)('header', {
        'empty-header': !(0, _layoutHelpers.isClassicLayoutHeaderVisible)(appSettings, channelData)
      });
      var channelTitle = this.channelTitle;

      return React.createElement(
        'section',
        { styleName: styleNames,
          className: 'qa-widget-header' },
        React.createElement(
          'div',
          { styleName: 'channel-name',
            title: channelTitle },
          channelTitle
        ),
        React.createElement(_shareChannel2.default, { styleName: 'action',
          channelData: channelData }),
        React.createElement(_channelInfoButton2.default, { styleName: 'action',
          channelData: channelData,
          onClick: this.showChannelInfo }),
        React.createElement(_channelSubscriptionButton2.default, { styleName: 'action',
          channelData: channelData,
          onClick: this.openSubscription }),
        React.createElement(_accountButton2.default, { styleName: 'action',
          channelData: channelData,
          onUserLogin: this.storeDataForReload,
          onUserLogout: this.storeDataForReload,
          onSubscribeClick: this.openSubscription,
          onSubscriptionCancelClick: this.processSubscriptionCancel })
      );
    }
  }, {
    key: 'player',
    get: function get() {
      var videoItem = this.mainVideo;

      if (videoItem) {
        return this.renderPlayerForCurrentDevice(videoItem);
      }
      return this.noVideosPlayerContent;
    }
  }, {
    key: 'playerOverlay',
    get: function get() {
      var _props11 = this.props,
          appSettings = _props11.appSettings,
          channelData = _props11.channelData;


      var props = {
        appSettings: appSettings,
        channelData: channelData,
        showChannelCover: this.canShowChannelCover,
        videoItem: this.mainVideo,
        nextVideoId: this.props.nextVideoId,
        playSelectedVideo: this.playSelectedVideo,
        playNextVideo: this.playNextVideo
      };

      return React.createElement(_center2.default, props);
    }
  }, {
    key: 'isVideosLoaded',
    get: function get() {
      var _props12 = this.props,
          videoByIds = _props12.videoByIds,
          paginatedChannelVideos = _props12.paginatedChannelVideos;

      return !paginatedChannelVideos.isFetching || !_.isEmpty(videoByIds);
    }
  }]);
  return ClassicView;
}(_base2.default), _class3.displayName = 'ClassicView', _class3.propTypes = {
  isSearchBarVisible: React.PropTypes.bool,
  isSearchInputVisible: React.PropTypes.bool,
  isCategoriesDropdownVisible: React.PropTypes.bool
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'setUtmostWidgetSize', [_autobind2.default, _debounce2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setUtmostWidgetSize'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'reset', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'reset'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'processSubscriptionCancel', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'processSubscriptionCancel'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleThumbnailClick', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleThumbnailClick'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'scrollToWidgetTop', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'scrollToWidgetTop'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showChannelInfo', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'showChannelInfo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'openSubscription', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'openSubscription'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'openMemberOnly', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'openMemberOnly'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'storeDataForReload', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'storeDataForReload'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'processDataFromStorage', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'processDataFromStorage'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setFullScreenState', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setFullScreenState'), _class2.prototype)), _class2)) || _class) || _class) || _class);
exports.default = ClassicView;

/***/ }),

/***/ 1483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _reactRedux = __webpack_require__(12);

var _wixConnect = __webpack_require__(6);

var _newRelic = __webpack_require__(120);

var _selectedVideoId = __webpack_require__(277);

var _paginatedChannelVideos = __webpack_require__(219);

var _base = __webpack_require__(278);

var _base2 = _interopRequireDefault(_base);

var _updateWidgetSize = __webpack_require__(274);

var _updateWidgetSize2 = _interopRequireDefault(_updateWidgetSize);

var _paymentEvents = __webpack_require__(121);

var _paymentEvents2 = _interopRequireDefault(_paymentEvents);

var _reloadStorage = __webpack_require__(270);

var _reloadStorage2 = _interopRequireDefault(_reloadStorage);

var _channelActions = __webpack_require__(1484);

var _channelActions2 = _interopRequireDefault(_channelActions);

var _player = __webpack_require__(1485);

var _player2 = _interopRequireDefault(_player);

var _videos = __webpack_require__(1486);

var _videos2 = _interopRequireDefault(_videos);

var _compact = __webpack_require__(2742);

var _compact2 = _interopRequireDefault(_compact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_STATE = {
  canShowChannelCover: true,
  areAllVideosVisible: false
};

var CompactView = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    mainVideoId: (0, _selectedVideoId.getMainVideoId)(state, ownProps, _paginatedChannelVideos.DATA_KEY),
    // Provide selectors here for paginatedChannelVideos
    ids: [],
    prevPageIds: [],
    nextPageIds: []
  };
}), _dec2 = (0, _wixConnect.VODCSSModules)(_compact2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_BaseView) {
  (0, _inherits3.default)(CompactView, _BaseView);

  function CompactView(props) {
    (0, _classCallCheck3.default)(this, CompactView);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CompactView.__proto__ || (0, _getPrototypeOf2.default)(CompactView)).call(this, props));

    _this.state = DEFAULT_STATE;
    (0, _newRelic.getNewRelic)().setCustomAttribute('layout', 'compact');
    return _this;
  }

  (0, _createClass3.default)(CompactView, [{
    key: 'showAllVideos',
    value: function showAllVideos() {
      this.setState({
        areAllVideosVisible: true
      });
    }
  }, {
    key: 'hideAllVideos',
    value: function hideAllVideos() {
      this.setState({
        areAllVideosVisible: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.isUIBlockingDataLoaded || !this.isVideosLoaded) {
        return this.spinner;
      }

      var areAllVideosVisible = this.props.areAllVideosVisible;

      return React.createElement(
        'section',
        { styleName: 'container',
          ref: this.setContainerEl,
          className: 'qa-widget-container' },
        React.createElement(_updateWidgetSize2.default, null),
        React.createElement(_reloadStorage2.default, { onReload: this.processDataFromStorage }),
        React.createElement(
          'div',
          { className: 'content',
            style: this.playerSize },
          areAllVideosVisible ? this.videos : this.player
        ),
        areAllVideosVisible ? this.actions : this.showVideosButton,
        React.createElement(_paymentEvents2.default, { onRent: this.setCurrentVideoFromPayment,
          onSale: this.setCurrentVideoFromPayment,
          onSubscription: this.reset,
          onSubscriptionCancel: this.reset })
      );
    }
  }, {
    key: 'player',
    get: function get() {
      var mainVideo = this.mainVideo;

      if (!mainVideo) {
        // TODO Move to component
        // each initial state need to be a single component
        return this.noVideosPlayerContent;
      }

      // TODO wrap with container to provide playback actions like onPlayRequested
      // wrapper, not pure actions needed because of different logic for views
      // Also can be done as view specific actions (need to discuss)
      return React.createElement(_player2.default, { video: mainVideo });
    }
  }, {
    key: 'videos',
    get: function get() {
      var _props = this.props,
          ids = _props.ids,
          prevPageIds = _props.prevPageIds,
          nextPageIds = _props.nextPageIds;
      // TODO wrap with container to provide playback actions like onNextPage
      // wrapper, not pure actions needed because of different logic for views
      // Also can be done as view specific actions (need to discuss)

      return React.createElement(_videos2.default, { ids: ids,
        prevPageIds: prevPageIds,
        nextPageIds: nextPageIds });
    }
  }, {
    key: 'showVideosButton',
    get: function get() {
      return React.createElement(
        'button',
        { styleName: 'show-all-videos',
          onClick: this.showAllVideos },
        'TODO: add icon at css'
      );
    }
  }, {
    key: 'actions',
    get: function get() {
      return (
        // TODO wrap with container to provide playback actions like onShareRequested
        // wrapper, not pure actions needed because of different logic for views
        // Also can be done as view specific actions (need to discuss)
        React.createElement(_channelActions2.default, { onClose: this.hideAllVideos })
      );
    }
  }, {
    key: 'isVideosLoaded',
    get: function get() {
      var _props2 = this.props,
          videoByIds = _props2.videoByIds,
          paginatedChannelVideos = _props2.paginatedChannelVideos;

      return !paginatedChannelVideos.isFetching || !_.isEmpty(videoByIds);
    }
  }]);
  return CompactView;
}(_base2.default), _class2.displayName = 'CompactView', _class2.propTypes = {
  mainVideoId: React.PropTypes.string,
  ids: React.PropTypes.arrayOf(React.PropTypes.string),
  prevPageIds: React.PropTypes.arrayOf(React.PropTypes.string),
  nextPageIds: React.PropTypes.arrayOf(React.PropTypes.string)
}, _temp)) || _class) || _class);
exports.default = CompactView;

/***/ }),

/***/ 1484:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _wixConnect = __webpack_require__(6);

var _channelActions = __webpack_require__(2743);

var _channelActions2 = _interopRequireDefault(_channelActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChannelActions = (_dec = (0, _wixConnect.VODCSSModules)(_channelActions2.default), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(ChannelActions, _React$Component);

  function ChannelActions() {
    (0, _classCallCheck3.default)(this, ChannelActions);
    return (0, _possibleConstructorReturn3.default)(this, (ChannelActions.__proto__ || (0, _getPrototypeOf2.default)(ChannelActions)).apply(this, arguments));
  }

  (0, _createClass3.default)(ChannelActions, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { styleName: 'container' },
        React.createElement(
          'div',
          null,
          'TODO Actions'
        ),
        React.createElement(
          'button',
          { onClick: this.toggleVisibilityAllVideos },
          'TODO Close'
        )
      );
    }
  }]);
  return ChannelActions;
}(React.Component)) || _class);
exports.default = ChannelActions;

/***/ }),

/***/ 1485:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _wixConnect = __webpack_require__(6);

var _player = __webpack_require__(2744);

var _player2 = _interopRequireDefault(_player);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Player = (_dec = (0, _wixConnect.VODCSSModules)(_player2.default), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(Player, _React$Component);

  function Player() {
    (0, _classCallCheck3.default)(this, Player);
    return (0, _possibleConstructorReturn3.default)(this, (Player.__proto__ || (0, _getPrototypeOf2.default)(Player)).apply(this, arguments));
  }

  (0, _createClass3.default)(Player, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { styleName: 'container' },
        'TODO: Play',
        React.createElement('br', null),
        'Full-screen modal, Inline play or inline for mobile'
      );
    }
  }]);
  return Player;
}(React.Component)) || _class);
exports.default = Player;

/***/ }),

/***/ 1486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _wixConnect = __webpack_require__(6);

var _videos = __webpack_require__(2745);

var _videos2 = _interopRequireDefault(_videos);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Videos = (_dec = (0, _wixConnect.VODCSSModules)(_videos2.default), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(Videos, _React$Component);

  function Videos() {
    (0, _classCallCheck3.default)(this, Videos);
    return (0, _possibleConstructorReturn3.default)(this, (Videos.__proto__ || (0, _getPrototypeOf2.default)(Videos)).apply(this, arguments));
  }

  (0, _createClass3.default)(Videos, [{
    key: 'render',
    value: function render() {
      // TODO wrap each video with container to provide playback actions like onPlayRequested
      // wrapper, not pure actions needed because of different logic for views
      // Also can be done as view specific actions (need to discuss)
      return React.createElement(
        'div',
        { styleName: 'container' },
        'TODO 4 videos'
      );
    }
  }]);
  return Videos;
}(React.Component)) || _class);
exports.default = Videos;

/***/ }),

/***/ 1487:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defineProperty2 = __webpack_require__(13);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _VIEWS_BY_LAYOUT_TYPE, _dec, _class, _class2, _temp;

var _reactRedux = __webpack_require__(12);

var _playerWidget = __webpack_require__(25);

var _appSettings = __webpack_require__(48);

var _classic = __webpack_require__(1482);

var _classic2 = _interopRequireDefault(_classic);

var _strip = __webpack_require__(1488);

var _strip2 = _interopRequireDefault(_strip);

var _compact = __webpack_require__(1483);

var _compact2 = _interopRequireDefault(_compact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VIEWS_BY_LAYOUT_TYPES = (_VIEWS_BY_LAYOUT_TYPE = {}, (0, _defineProperty3.default)(_VIEWS_BY_LAYOUT_TYPE, _playerWidget.channelLayoutValues.STRIP, _strip2.default), (0, _defineProperty3.default)(_VIEWS_BY_LAYOUT_TYPE, _playerWidget.channelLayoutValues.CLASSIC, _classic2.default), (0, _defineProperty3.default)(_VIEWS_BY_LAYOUT_TYPE, _playerWidget.channelLayoutValues.COMPACT, _compact2.default), _VIEWS_BY_LAYOUT_TYPE);

var DesktopViewsSwitcher = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    layout: (0, _appSettings.getChannelLayout)(state)
  };
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(DesktopViewsSwitcher, _React$Component);

  function DesktopViewsSwitcher() {
    (0, _classCallCheck3.default)(this, DesktopViewsSwitcher);
    return (0, _possibleConstructorReturn3.default)(this, (DesktopViewsSwitcher.__proto__ || (0, _getPrototypeOf2.default)(DesktopViewsSwitcher)).apply(this, arguments));
  }

  (0, _createClass3.default)(DesktopViewsSwitcher, [{
    key: 'render',
    value: function render() {
      var layout = this.props.layout;


      if (!layout) {
        return null;
      }

      // TODO: remove if don`t needed
      if (_.isEmpty(this.props.channelData)) {
        return null;
      }

      var View = VIEWS_BY_LAYOUT_TYPES[layout] || _classic2.default;
      return React.createElement(View, this.props);
    }
  }]);
  return DesktopViewsSwitcher;
}(React.Component), _class2.propTypes = {
  layout: React.PropTypes.number,
  channelData: React.PropTypes.object
}, _temp)) || _class);
exports.default = DesktopViewsSwitcher;

/***/ }),

/***/ 1488:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = __webpack_require__(10);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = __webpack_require__(13);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(511);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _class, _desc, _value, _class2, _class3, _temp;

var _reactIntl = __webpack_require__(5);

var _classnames3 = __webpack_require__(14);

var _classnames4 = _interopRequireDefault(_classnames3);

var _autobind = __webpack_require__(11);

var _autobind2 = _interopRequireDefault(_autobind);

var _reactRedux = __webpack_require__(12);

var _playerWidget = __webpack_require__(25);

var _reduxUi = __webpack_require__(40);

var _reduxUi2 = _interopRequireDefault(_reduxUi);

var _wixConnect = __webpack_require__(6);

var _newRelic = __webpack_require__(120);

var _wixSdk = __webpack_require__(21);

var _wixSdk2 = _interopRequireDefault(_wixSdk);

var _screen = __webpack_require__(266);

var _videoOverlayEventsParams = __webpack_require__(264);

var _videoPlaybackStatus = __webpack_require__(180);

var _openOverlay = __webpack_require__(128);

var _payments = __webpack_require__(145);

var _payments2 = _interopRequireDefault(_payments);

var _videosSizes = __webpack_require__(132);

var _videoList = __webpack_require__(509);

var _layoutHelpers = __webpack_require__(67);

var _popout = __webpack_require__(31);

var _editModes = __webpack_require__(1416);

var _editModes2 = _interopRequireDefault(_editModes);

var _selectVideo = __webpack_require__(179);

var _changePlaybackStatus = __webpack_require__(130);

var _selectedVideoId = __webpack_require__(277);

var _paginatedChannelVideos = __webpack_require__(219);

var _base = __webpack_require__(278);

var _base2 = _interopRequireDefault(_base);

var _icon = __webpack_require__(20);

var _icon2 = _interopRequireDefault(_icon);

var _button = __webpack_require__(19);

var _dropdown = __webpack_require__(72);

var _updateWidgetSize = __webpack_require__(274);

var _updateWidgetSize2 = _interopRequireDefault(_updateWidgetSize);

var _accountButtonStrip = __webpack_require__(1382);

var _accountButtonStrip2 = _interopRequireDefault(_accountButtonStrip);

var _channelInfoButton = __webpack_require__(743);

var _channelInfoButton2 = _interopRequireDefault(_channelInfoButton);

var _channelSubscriptionButton = __webpack_require__(744);

var _channelSubscriptionButton2 = _interopRequireDefault(_channelSubscriptionButton);

var _shareChannel = __webpack_require__(764);

var _shareChannel2 = _interopRequireDefault(_shareChannel);

var _fsModalPlayer = __webpack_require__(1403);

var _fsModalPlayer2 = _interopRequireDefault(_fsModalPlayer);

var _mobilePlayer = __webpack_require__(269);

var _mobilePlayer2 = _interopRequireDefault(_mobilePlayer);

var _fsBuyExtensions = __webpack_require__(796);

var _fsBuyExtensions2 = _interopRequireDefault(_fsBuyExtensions);

var _categories = __webpack_require__(742);

var _categories2 = _interopRequireDefault(_categories);

var _tags = __webpack_require__(339);

var _tags2 = _interopRequireDefault(_tags);

var _searchBar = __webpack_require__(763);

var _strip = __webpack_require__(1414);

var _strip2 = _interopRequireDefault(_strip);

var _strip3 = __webpack_require__(759);

var _strip4 = _interopRequireDefault(_strip3);

var _memberOnly = __webpack_require__(758);

var _memberOnly2 = _interopRequireDefault(_memberOnly);

var _paymentEvents = __webpack_require__(121);

var _paymentEvents2 = _interopRequireDefault(_paymentEvents);

var _emptySearchResults = __webpack_require__(745);

var _emptySearchResults2 = _interopRequireDefault(_emptySearchResults);

var _button2 = __webpack_require__(91);

var _button3 = _interopRequireDefault(_button2);

var _viewModes = __webpack_require__(81);

var _viewModes2 = _interopRequireDefault(_viewModes);

var _reloadStorage = __webpack_require__(270);

var _reloadStorage2 = _interopRequireDefault(_reloadStorage);

var _reload = __webpack_require__(131);

var _strip5 = __webpack_require__(2746);

var _strip6 = _interopRequireDefault(_strip5);

var _translations = __webpack_require__(1489);

var _translations2 = _interopRequireDefault(_translations);

var _translations3 = __webpack_require__(276);

var _translations4 = _interopRequireDefault(_translations3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var MIN_WIDGET_HEIGHT = 480;
var SEARCH_LINE_HEIGHT = 42;
var FIXED_NO_SEARCH_RESULT_MIN_HEIGHT = 350;
var IS_MOBILE_DEVICE = (0, _screen.isMobile)() || (0, _screen.isTablet)();
var DEFAULT_STATE = {
  canShowChannelCover: true,
  isTagFocused: false,
  isSearchInputFocused: false,
  searchLayout: false,
  currentCategory: null,
  areAllVideosVisible: false
};

var StripPlayer = (0, _fsBuyExtensions2.default)(_fsModalPlayer2.default);

var StripView = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    mainVideoId: (0, _selectedVideoId.getMainVideoId)(state, ownProps, _paginatedChannelVideos.DATA_KEY),
    isVideoPlaying: (0, _videoPlaybackStatus.isVideoPlaying)(state),
    currentChannelId: state.currentChannelId,
    appSettings: state.appSettings,
    firstChannelVideoId: state.firstChannelVideoId,
    prevVideoId: ownProps.nextChannelVideos.prevId,
    nextVideoId: ownProps.nextChannelVideos.nextId,
    isSearchInputVisible: (0, _layoutHelpers.isSearchInputVisible)(state.appSettings, ownProps.channelData),
    isCategoriesDropdownVisible: (0, _layoutHelpers.isCategoriesDropdownVisible)(state.appSettings, ownProps.channelData)
  };
}, {
  selectVideo: _selectVideo.selectVideo,
  playVideo: _changePlaybackStatus.playVideo,
  pauseVideo: _changePlaybackStatus.pauseVideo
}), _dec2 = (0, _reduxUi2.default)(), _dec3 = (0, _wixConnect.WixConnect)(_strip6.default), _dec4 = (0, _autobind2.default)(), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_BaseView) {
  (0, _inherits3.default)(StripView, _BaseView);

  function StripView(props) {
    (0, _classCallCheck3.default)(this, StripView);

    var _this = (0, _possibleConstructorReturn3.default)(this, (StripView.__proto__ || (0, _getPrototypeOf2.default)(StripView)).call(this, props));

    _this.containerEl = null;
    _this.resizeByContentInterval = null;
    _this.currentContentHeight = 0;
    _this.initialWidgetHeight = 0;


    _this.state = (0, _extends3.default)({
      searchBarValue: props.ui.searchQuery
    }, DEFAULT_STATE, _this.getDefaultPlayerConfig(props));

    (0, _newRelic.getNewRelic)().setCustomAttribute('layout', 'strip');
    return _this;
  }

  (0, _createClass3.default)(StripView, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _get3.default)(StripView.prototype.__proto__ || (0, _getPrototypeOf2.default)(StripView.prototype), 'componentDidMount', this).call(this);
      this.resizeByContentInterval = setInterval(this.resizeByContent, 300);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      (0, _get3.default)(StripView.prototype.__proto__ || (0, _getPrototypeOf2.default)(StripView.prototype), 'componentWillReceiveProps', this).call(this, nextProps);
      if (_wixSdk2.default.Utils.getViewMode() === _viewModes2.default.EDITOR && this.hasPreviewBecameActive(nextProps)) {
        this.reset(nextProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _get3.default)(StripView.prototype.__proto__ || (0, _getPrototypeOf2.default)(StripView.prototype), 'componentWillUnmount', this).call(this);
      clearInterval(this.resizeByContentInterval);
    }
  }, {
    key: 'isVideoPreviewMode',
    value: function isVideoPreviewMode() {
      // TODO: clean up video preview
      return false;
    }
  }, {
    key: 'getDefaultPlayerConfig',
    value: function getDefaultPlayerConfig() {
      return {
        // TODO: move to selector or method. Probably will be used with isWidgetTouched (old canShowChannelCover)
        isVideoPreview: false
      };
    }
  }, {
    key: 'onThumbnailClicked',
    value: function onThumbnailClicked(video) {
      if (video.id !== this.props.mainVideoId || this.canShowChannelCover) {
        this.sendVidSelectedBiEvent(video);
      }

      this.selectVideo(video);
    }
  }, {
    key: 'selectNextVideo',
    value: function selectNextVideo() {
      this.selectVideo({
        id: this.props.nextVideoId
      });
    }
  }, {
    key: 'selectPrevVideo',
    value: function selectPrevVideo() {
      this.selectVideo({
        id: this.props.prevVideoId
      });
    }
  }, {
    key: 'reset',
    value: function reset() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      (0, _get3.default)(StripView.prototype.__proto__ || (0, _getPrototypeOf2.default)(StripView.prototype), 'reset', this).call(this);

      this.setState((0, _extends3.default)({
        searchBarValue: ''
      }, DEFAULT_STATE, this.getDefaultPlayerConfig(props)));
    }
  }, {
    key: 'processSubscriptionCancel',
    value: function processSubscriptionCancel() {
      var _props = this.props,
          _props$appSettings = _props.appSettings,
          siteUrl = _props$appSettings.siteUrl,
          instance = _props$appSettings.instance,
          currentChannelId = _props.currentChannelId;

      _payments2.default.cancelSubscription(currentChannelId, siteUrl, instance);
    }
  }, {
    key: 'setContainerEl',
    value: function setContainerEl(el) {
      this.containerEl = el;
    }
  }, {
    key: 'resizeByContent',
    value: function resizeByContent() {
      var height = Math.ceil(this.contentHeight);
      if (!height || height === this.currentContentHeight) {
        return;
      }

      this.currentContentHeight = height;
      _wixSdk2.default.setHeight(height, { overflow: false });
    }
  }, {
    key: 'saveInitialHeight',
    value: function saveInitialHeight() {
      this.initialWidgetHeight = this.widgetHeight;
    }
  }, {
    key: 'restoreInitialHeight',
    value: function restoreInitialHeight() {
      var height = this.initialWidgetHeight;
      // true only is allowed at editor
      _wixSdk2.default.setHeight(height, { overflow: false });
    }
  }, {
    key: 'resizeToMinHeight',
    value: function resizeToMinHeight() {
      if (this.widgetHeight < MIN_WIDGET_HEIGHT) {
        // true only is allowed at editor
        _wixSdk2.default.setHeight(MIN_WIDGET_HEIGHT, { overflow: false });
      }
    }
  }, {
    key: 'hasPreviewBecameActive',
    value: function hasPreviewBecameActive(nextProps) {
      // TODO: rename to videoAsBackground
      return !this.state.isVideoPreview && this.isVideoPreviewMode(nextProps);
    }
  }, {
    key: 'storeDataForReload',
    value: function storeDataForReload() {
      (0, _reload.storeForReload)({
        selectedVideoId: this.props.mainVideoId
      });
    }
  }, {
    key: 'showChannelInfo',
    value: function showChannelInfo(event) {
      event.preventDefault();

      (0, _openOverlay.openFullScreenOverlay)('#/channel/' + this.props.channelData.id + '/info');
    }
  }, {
    key: 'openMembership',
    value: function openMembership() {
      (0, _openOverlay.openFullScreenMemberOnlyOverlay)(this.props.channelData.id, this.mainVideo.id);
    }
  }, {
    key: 'processDataFromStorage',
    value: function processDataFromStorage(data) {
      var selectedVideoId = data.selectedVideoId,
          openOverlay = data.openOverlay,
          autoplay = data.autoplay;
      var selectVideo = this.props.selectVideo;

      selectVideo(selectedVideoId);

      if (selectedVideoId) {
        this.disableChannelCover();
        this.toggleVisibilityAllVideos();
        if (openOverlay) {
          (0, _openOverlay.openFullScreenOverlay)('#/channel/' + this.props.channelData.id + '/video/' + selectedVideoId + '/' + (autoplay ? 'play' : ''));
        }
      }
    }
  }, {
    key: 'playVideo',
    value: function playVideo(videoData) {
      var _props2 = this.props,
          currentSiteUser = _props2.currentSiteUser,
          channelData = _props2.channelData,
          mainVideoId = _props2.mainVideoId;
      var id = videoData.id,
          memberOnly = videoData.memberOnly;


      if (IS_MOBILE_DEVICE) {
        // we can`t start playing for not rendered player because of browser restriction
        if (id === mainVideoId) {
          return (0, _get3.default)(StripView.prototype.__proto__ || (0, _getPrototypeOf2.default)(StripView.prototype), 'playVideo', this).call(this, videoData);
        }
        return this.onThumbnailClicked(videoData);
      }

      if (!memberOnly || memberOnly && currentSiteUser.data) {
        (0, _openOverlay.openFullScreenOverlay)('#/channel/' + channelData.id + '/video/' + id + '/play');
      } else {
        (0, _openOverlay.openFullScreenMemberOnlyOverlay)(channelData.id, id);
      }
    }
  }, {
    key: 'getPlayerOverlay',
    value: function getPlayerOverlay(videoItem) {
      var _props3 = this.props,
          appSettings = _props3.appSettings,
          channelData = _props3.channelData,
          prevVideoId = _props3.prevVideoId,
          nextVideoId = _props3.nextVideoId;


      var hasBottomContent = this.hasBottomContent;

      var buttonsWrapperClassName = (0, _classnames4.default)((0, _defineProperty3.default)({}, _strip6.default['buttons-wrapper-no-margin'], !hasBottomContent));

      return React.createElement(_strip4.default, { styleName: 'player-overlay',
        buttonsWrapperClassName: buttonsWrapperClassName,
        channelData: channelData,
        appSettings: appSettings,
        videoItem: videoItem,
        showChannelCover: this.canShowChannelCover,
        playSelectedVideo: this.playVideo,
        nextVideoId: nextVideoId,
        prevVideoId: prevVideoId,
        playNextVideo: this.playNextVideo,
        selectNextVideo: this.selectNextVideo,
        selectPrevVideo: this.selectPrevVideo,
        areAllVideosVisible: this.shouldRenderVideos,
        toggleVisibilityAllVideos: this.toggleVisibilityAllVideos,
        showChannelInfo: this.showChannelInfo });
    }
  }, {
    key: 'toggleVisibilityAllVideos',
    value: function toggleVisibilityAllVideos() {
      this.setState({
        areAllVideosVisible: !this.state.areAllVideosVisible
      });
    }
  }, {
    key: 'sendVidSelectedBiEvent',
    value: function sendVidSelectedBiEvent(_ref) {
      var id = _ref.id;
      var _props4 = this.props,
          appSettings = _props4.appSettings,
          channelData = _props4.channelData,
          videoByIds = _props4.videoByIds;

      this.props.biEvent('widget.VidSelected.displayed', (0, _videoOverlayEventsParams.getVideoSelectedEventParams)(appSettings, channelData, videoByIds[id], this.canShowChannelCover));
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.isUIBlockingDataLoaded || !this.isVideosLoaded) {
        return this.spinner;
      }

      var appSettings = this.props.appSettings;

      var styleNames = (0, _classnames4.default)('container', 'view-mode-' + appSettings.editMode);

      return React.createElement(
        'section',
        { styleName: styleNames,
          ref: this.setContainerEl,
          className: 'qa-widget-container' },
        React.createElement(_updateWidgetSize2.default, null),
        React.createElement(_reloadStorage2.default, { onReload: this.processDataFromStorage }),
        this.playerContainer,
        this.videos,
        React.createElement(_paymentEvents2.default, { onRent: this.setCurrentVideoFromPayment,
          onSale: this.setCurrentVideoFromPayment,
          onSubscription: this.reset,
          onSubscriptionCancel: this.reset })
      );
    }
  }, {
    key: 'shouldRenderVideos',
    get: function get() {
      var appSettings = this.props.appSettings;


      return (0, _videoList.isExpandOnClick)(appSettings.numbers.videoListVisibility) ? this.state.areAllVideosVisible : (0, _videoList.isAlwaysShow)(appSettings.numbers.videoListVisibility);
    }
  }, {
    key: 'shouldRenderAllVideosButton',
    get: function get() {
      var appSettings = this.props.appSettings;

      return (0, _videoList.isExpandOnClick)(appSettings.numbers.videoListVisibility) && !this.state.areAllVideosVisible;
    }
  }, {
    key: 'listThumbnailSize',
    get: function get() {
      var widgetWidth = window.innerWidth;
      var videosInRow = this.props.appSettings.numbers.videosInRow;

      return (0, _videosSizes.stripLayoutThumbnailSize)(widgetWidth, videosInRow);
    }
  }, {
    key: 'videosListHeight',
    get: function get() {
      var _props5 = this.props,
          appSettings = _props5.appSettings,
          channelData = _props5.channelData;
      var _appSettings$numbers = appSettings.numbers,
          videosInRow = _appSettings$numbers.videosInRow,
          numberOfRows = _appSettings$numbers.numberOfRows;

      var videosCount = Math.min(channelData.videosCount, videosInRow * numberOfRows);

      return this.listThumbnailSize.height * Math.ceil(videosCount / videosInRow);
    }
  }, {
    key: 'isInEditor',
    get: function get() {
      return _.get(this.props.appSettings, 'editMode') === _editModes2.default.EDITOR;
    }
  }, {
    key: 'contentHeight',
    get: function get() {
      if (!this.containerEl) {
        return 0;
      }
      return this.containerEl.clientHeight;
    }
  }, {
    key: 'widgetHeight',
    get: function get() {
      return _.get(this.props, 'appSettings.requestedWidgetSize.height');
    }
  }, {
    key: 'tagList',
    get: function get() {
      return _.get(this.props, 'channelData.statsInfo.tags') || [];
    }
  }, {
    key: 'categoriesList',
    get: function get() {
      var categoriesStats = _.get(this.props, 'channelData.statsInfo.categories') || [];
      return _.map(categoriesStats, 'value');
    }
  }, {
    key: 'tags',
    get: function get() {
      var _state = this.state,
          searchLayout = _state.searchLayout,
          searchBarValue = _state.searchBarValue;


      var tags = this.tagList;

      if (!tags.length || !searchLayout && !searchBarValue || this.props.ui.searchQuery) {
        return null;
      }

      return React.createElement(_tags2.default, { styleName: 'tags',
        onTagFocus: this.handleTagsFocus,
        onTagBlur: this.handleTagsBlur,
        onTagClick: this.searchByTag,
        tags: tags });
    }
  }, {
    key: 'noSearchResults',
    get: function get() {
      if (!this.hasNoSearchResults) {
        return null;
      }

      var styleNames = (0, _classnames4.default)('no-search-results', {
        stretched: this.videosListHeight < FIXED_NO_SEARCH_RESULT_MIN_HEIGHT
      });

      return React.createElement(_emptySearchResults2.default, { styleName: styleNames });
    }
  }, {
    key: 'videosList',
    get: function get() {
      var _props6 = this.props,
          paginatedChannelVideos = _props6.paginatedChannelVideos,
          channelData = _props6.channelData,
          mainVideoId = _props6.mainVideoId;

      var noVideos = !paginatedChannelVideos.ids.length;

      if (this.isFetching || noVideos || !this.mainVideo) {
        return null;
      }

      return React.createElement(_strip2.default, { channelData: channelData,
        paginatedChannelVideos: paginatedChannelVideos,
        playVideo: this.playVideo,
        onThumbnailClick: this.onThumbnailClicked,
        thumbnailSize: this.listThumbnailSize,
        selectedVideoId: mainVideoId,
        styleName: 'videos' });
    }
  }, {
    key: 'closeVideosButton',
    get: function get() {
      var appSettings = this.props.appSettings;
      var _appSettings$booleans = appSettings.booleans,
          showChannelShare = _appSettings$booleans.showChannelShare,
          showChannelInfo = _appSettings$booleans.showChannelInfo,
          showSignIn = _appSettings$booleans.showSignIn;

      var isAllActionsDisabled = !showChannelShare && !showChannelInfo && !this.canSubscribe && !showSignIn;

      if (!this.shouldRenderVideos || (0, _videoList.isAlwaysShow)(appSettings.numbers.videoListVisibility)) {
        return null;
      }

      var extendedCloseButton = React.createElement(
        'span',
        null,
        React.createElement(_reactIntl.FormattedMessage, _translations2.default.close),
        React.createElement(_icon2.default, { styleName: 'small-close-icon',
          name: 'add' })
      );

      return React.createElement(
        _button.LinkButton,
        { styleName: 'action',
          onClick: this.toggleVisibilityAllVideos },
        isAllActionsDisabled ? extendedCloseButton : React.createElement(_icon2.default, { styleName: 'normal-close-icon',
          name: 'add' })
      );
    }
  }, {
    key: 'categories',
    get: function get() {
      var _props7 = this.props,
          isCategoriesDropdownVisible = _props7.isCategoriesDropdownVisible,
          appSettings = _props7.appSettings,
          searchQuery = _props7.ui.searchQuery;


      if (!isCategoriesDropdownVisible) {
        return null;
      }

      var _state2 = this.state,
          searchLayout = _state2.searchLayout,
          currentCategory = _state2.currentCategory,
          searchBarValue = _state2.searchBarValue;
      var videoListVisibility = appSettings.numbers.videoListVisibility;
      var showChannelCategories = appSettings.booleans.showChannelCategories;


      if ((0, _videoList.isNeverShow)(videoListVisibility) || searchLayout || !this.isCategorySelected && (searchQuery || searchBarValue) || !showChannelCategories) {
        return null;
      }

      return React.createElement(_categories2.default, { styleName: 'categories',
        DropdownClass: _dropdown.StripWidgetDropdown,
        height: SEARCH_LINE_HEIGHT,
        list: this.categoriesList,
        onCategorySelect: this.searchByCategory,
        selectedCategory: currentCategory });
    }
  }, {
    key: 'shareChannel',
    get: function get() {
      return React.createElement(_shareChannel2.default, { channelData: this.props.channelData,
        buttonsClassName: _strip6.default['share-buttons'],
        styleName: 'share-channel action' });
    }
  }, {
    key: 'canSubscribe',
    get: function get() {
      var channelData = this.props.channelData;

      var subscriptionPriceInfo = _playerWidget.dealInfoHelpers.getSubscriptionPriceInfo(channelData.dealInfo);

      return !_.get(channelData, 'dgsInfo.subscription') && subscriptionPriceInfo;
    }
  }, {
    key: 'channelActions',
    get: function get() {
      var _props8 = this.props,
          channelData = _props8.channelData,
          searchQuery = _props8.ui.searchQuery,
          appSettings = _props8.appSettings;
      var _state3 = this.state,
          searchLayout = _state3.searchLayout,
          searchBarValue = _state3.searchBarValue;


      var value = this.isCategorySelected ? '' : searchQuery;

      if (searchLayout || value || searchBarValue) {
        return null;
      }

      var closeVideoButton = this.closeVideosButton;

      if (!(0, _layoutHelpers.isChannelShareVisible)(appSettings) && !(0, _layoutHelpers.isChannelInfoVisible)(appSettings) && !(0, _layoutHelpers.isSubscriptionButtonVisible)(channelData) && !(0, _layoutHelpers.isSignInVisible)(appSettings) && !closeVideoButton) {
        return null;
      }

      return React.createElement(
        'div',
        { styleName: 'channel-actions',
          className: 'qa-widget-channel-actions' },
        this.shareChannel,
        React.createElement(_channelInfoButton2.default, { styleName: 'action',
          className: 'qa-widget-channel-info',
          channelData: channelData,
          onClick: this.showChannelInfo }),
        React.createElement(_channelSubscriptionButton2.default, { styleName: 'action',
          className: 'qa-widget-overlay-subscribe-button',
          channelData: channelData,
          onClick: this.openSubscription }),
        React.createElement(_accountButtonStrip2.default, { styleName: 'action',
          className: 'qa-widget-channel-account',
          channelData: channelData,
          popoutSide: _popout.sides.TOP,
          onUserLogin: this.storeDataForReload,
          onUserLogout: this.storeDataForReload,
          onSubscribeClick: this.openSubscription,
          onSubscriptionCancelClick: this.processSubscriptionCancel }),
        closeVideoButton
      );
    }
  }, {
    key: 'searchBar',
    get: function get() {
      var _props9 = this.props,
          isSearchInputVisible = _props9.isSearchInputVisible,
          appSettings = _props9.appSettings,
          searchQuery = _props9.ui.searchQuery;


      if (!isSearchInputVisible) {
        return null;
      }

      var _state4 = this.state,
          searchLayout = _state4.searchLayout,
          searchBarValue = _state4.searchBarValue;

      var value = this.isCategorySelected ? '' : searchQuery;
      var isExpanded = searchLayout || value || searchBarValue;
      var booleans = appSettings.booleans,
          numbers = appSettings.numbers;
      var videoListVisibility = numbers.videoListVisibility;
      var showSearch = booleans.showSearch;


      if ((0, _videoList.isNeverShow)(videoListVisibility) || !showSearch) {
        return null;
      }

      return React.createElement(_searchBar.StripSearchBar, { styleName: (0, _classnames4.default)('search', { expanded: isExpanded }),
        className: 'qa-widget-searchbar',
        value: value,
        onFocus: this.handleSearchInputFocus,
        onBlur: this.handleSearchInputBlur,
        onChange: this.setSearchBarValue,
        onClose: this.clearSearch,
        onSearch: this.searchByQuery });
    }
  }, {
    key: 'searchLine',
    get: function get() {
      var searchBar = this.searchBar;
      var categories = this.categories;
      var channelActions = this.channelActions;
      var _props10 = this.props,
          appSettings = _props10.appSettings,
          isVideoPlaying = _props10.isVideoPlaying;


      if (!this.shouldRenderVideos && !(0, _videoList.isNeverShow)(appSettings.numbers.videoListVisibility) || IS_MOBILE_DEVICE && isVideoPlaying || !searchBar && !categories && !channelActions) {
        return null;
      }

      return React.createElement(
        'div',
        { styleName: 'search-line',
          className: 'qa-widget-search-line' },
        channelActions,
        searchBar,
        categories
      );
    }
  }, {
    key: 'allVideosButton',
    get: function get() {
      var isVideoPlaying = this.props.isVideoPlaying;

      if (!this.shouldRenderAllVideosButton || IS_MOBILE_DEVICE && isVideoPlaying) {
        return null;
      }

      return React.createElement(
        'div',
        { styleName: 'all-videos' },
        React.createElement(
          _button3.default,
          { styleName: 'button',
            disableTheme: true,
            className: 'qa-widget-overlay-all-videos-button',
            onClick: this.toggleVisibilityAllVideos },
          React.createElement(_reactIntl.FormattedMessage, _translations2.default.allVideos),
          React.createElement(_icon2.default, { name: 'add',
            styleName: 'icon' })
        )
      );
    }
  }, {
    key: 'videos',
    get: function get() {
      var channelData = this.props.channelData;


      if (!channelData || !this.shouldRenderVideos) {
        return null;
      }

      if (!channelData.videosCount) {
        return React.createElement(
          'div',
          { styleName: 'coming-soon',
            style: { minHeight: this.listThumbnailSize.height } },
          React.createElement(_reactIntl.FormattedMessage, _translations4.default.thisChannelIsComingSoon)
        );
      }

      return React.createElement(
        'div',
        { styleName: 'videos-container',
          style: { height: this.videosListHeight } },
        this.videosList,
        this.noSearchResults
      );
    }
  }, {
    key: 'playerSize',
    get: function get() {
      return {
        width: window.innerWidth,
        height: Math.round(window.innerWidth / 2.39)
      };
    }
  }, {
    key: 'hasBottomContent',
    get: function get() {
      // TODO move hasBottomContent to selector|method
      var allVideosButton = this.allVideosButton;
      var searchLine = this.searchLine;
      return Boolean(allVideosButton || searchLine);
    }
  }, {
    key: 'memberOnlyOverlay',
    get: function get() {
      var _props11 = this.props,
          prevVideoId = _props11.prevVideoId,
          nextVideoId = _props11.nextVideoId;


      var hasBottomContent = this.hasBottomContent;

      var buttonsWrapperClassName = (0, _classnames4.default)((0, _defineProperty3.default)({}, _strip6.default['buttons-wrapper-no-margin'], !hasBottomContent));

      return React.createElement(_memberOnly2.default, { className: _strip6.default['player-overlay'],
        buttonsWrapperClassName: buttonsWrapperClassName,
        nextVideoId: nextVideoId,
        prevVideoId: prevVideoId,
        selectNextVideo: this.selectNextVideo,
        selectPrevVideo: this.selectPrevVideo });
    }

    // used as no videos overlay
    // TODO: remove after move noVideosPlayerContent to component

  }, {
    key: 'playerOverlay',
    get: function get() {
      return this.getPlayerOverlay(null);
    }
  }, {
    key: 'player',
    get: function get() {
      var mainVideo = this.mainVideo;
      var _playerSize = this.playerSize,
          width = _playerSize.width,
          height = _playerSize.height;
      var _props12 = this.props,
          channelData = _props12.channelData,
          isVideoPlaying = _props12.isVideoPlaying;


      var playerProps = {
        videoItem: mainVideo,
        key: mainVideo.id,
        channelData: channelData,
        width: width, height: height,
        canShowChannelCover: this.canShowChannelCover,
        styleName: 'player',
        className: 'qa-widget-player',
        memberOnlyOverlay: this.memberOnlyOverlay,
        onMemberSignUp: this.openMembership
      };

      if (IS_MOBILE_DEVICE) {
        return React.createElement(
          _mobilePlayer2.default,
          (0, _extends3.default)({}, playerProps, {
            paused: !isVideoPlaying }),
          this.getPlayerOverlay(mainVideo)
        );
      }

      return React.createElement(
        StripPlayer,
        (0, _extends3.default)({}, playerProps, {
          onMemberSignUp: this.openMembership }),
        this.getPlayerOverlay(mainVideo)
      );
    }
  }, {
    key: 'playerContainer',
    get: function get() {
      var mainVideo = this.mainVideo;

      if (!mainVideo) {
        return React.createElement(
          'div',
          { styleName: 'player-container' },
          this.noVideosPlayerContent,
          this.allVideosButton,
          this.searchLine
        );
      }

      var hasBottomContent = this.hasBottomContent;

      return React.createElement(
        'div',
        { styleName: (0, _classnames4.default)('player-container', { 'with-bottom-padding': hasBottomContent }),
          'data-channel-layout': 'strip' },
        this.player,
        this.allVideosButton,
        this.searchLine
      );
    }
  }, {
    key: 'isVideosLoaded',
    get: function get() {
      var _props13 = this.props,
          videoByIds = _props13.videoByIds,
          paginatedChannelVideos = _props13.paginatedChannelVideos;

      return !paginatedChannelVideos.isFetching || !_.isEmpty(videoByIds);
    }
  }]);
  return StripView;
}(_base2.default), _class3.displayName = 'StripView', _class3.propTypes = {
  updateUI: React.PropTypes.func,
  isSearchInputVisible: React.PropTypes.bool,
  isCategoriesDropdownVisible: React.PropTypes.bool
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onThumbnailClicked', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onThumbnailClicked'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'selectNextVideo', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'selectNextVideo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'selectPrevVideo', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'selectPrevVideo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'reset', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'reset'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'processSubscriptionCancel', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'processSubscriptionCancel'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setContainerEl', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setContainerEl'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resizeByContent', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resizeByContent'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'storeDataForReload', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'storeDataForReload'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showChannelInfo', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'showChannelInfo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'openMembership', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'openMembership'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'processDataFromStorage', [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'processDataFromStorage'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'playVideo', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'playVideo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toggleVisibilityAllVideos', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'toggleVisibilityAllVideos'), _class2.prototype)), _class2)) || _class) || _class) || _class);
exports.default = StripView;

/***/ }),

/***/ 1489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(5);

exports.default = (0, _reactIntl.defineMessages)({
  allVideos: {
    id: 'widget.strip-view.all-videos',
    defaultMessage: 'All Videos'
  },
  close: {
    id: 'widget.strip-view.close',
    defaultMessage: 'Close'
  }
});

/***/ }),

/***/ 1490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = __webpack_require__(10);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(12);

var _autobind = __webpack_require__(11);

var _autobind2 = _interopRequireDefault(_autobind);

var _reduxUi = __webpack_require__(40);

var _reduxUi2 = _interopRequireDefault(_reduxUi);

var _reactIntl = __webpack_require__(5);

var _wixConnect = __webpack_require__(6);

var _memoizedPartial = __webpack_require__(68);

var _memoizedPartial2 = _interopRequireDefault(_memoizedPartial);

var _newRelic = __webpack_require__(120);

var _base = __webpack_require__(278);

var _base2 = _interopRequireDefault(_base);

var _mobilePlayer = __webpack_require__(269);

var _mobilePlayer2 = _interopRequireDefault(_mobilePlayer);

var _mainVideo = __webpack_require__(755);

var _mainVideo2 = _interopRequireDefault(_mainVideo);

var _playersListSlidable = __webpack_require__(1402);

var _playersListSlidable2 = _interopRequireDefault(_playersListSlidable);

var _videoAccess = __webpack_require__(92);

var _openOverlay = __webpack_require__(128);

var _mainOpenners = __webpack_require__(347);

var _initiators = __webpack_require__(481);

var _videosSizes = __webpack_require__(132);

var _videos = __webpack_require__(26);

var _selectedVideoId = __webpack_require__(277);

var _videoPlaybackStatus = __webpack_require__(180);

var _selectVideo = __webpack_require__(179);

var _changePlaybackStatus = __webpack_require__(130);

var _videoOverlayEventsParams = __webpack_require__(264);

var _lazyChannelVideos = __webpack_require__(218);

var _button = __webpack_require__(19);

var _icon = __webpack_require__(20);

var _icon2 = _interopRequireDefault(_icon);

var _resizedImage = __webpack_require__(47);

var _resizedImage2 = _interopRequireDefault(_resizedImage);

var _headerMobile = __webpack_require__(746);

var _headerMobile2 = _interopRequireDefault(_headerMobile);

var _videosListMobile = __webpack_require__(1411);

var _videosListMobile2 = _interopRequireDefault(_videosListMobile);

var _paymentEvents = __webpack_require__(121);

var _paymentEvents2 = _interopRequireDefault(_paymentEvents);

var _reloadStorage = __webpack_require__(270);

var _reloadStorage2 = _interopRequireDefault(_reloadStorage);

var _reload = __webpack_require__(131);

var _fakePlayer = __webpack_require__(761);

var _fakePlayer2 = _interopRequireDefault(_fakePlayer);

var _mobile = __webpack_require__(2747);

var _mobile2 = _interopRequireDefault(_mobile);

var _translations = __webpack_require__(1491);

var _translations2 = _interopRequireDefault(_translations);

var _translations3 = __webpack_require__(276);

var _translations4 = _interopRequireDefault(_translations3);

var _payments = __webpack_require__(145);

var _payments2 = _interopRequireDefault(_payments);

var _experiments = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var MobileView = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    isVideoPlaying: (0, _videoPlaybackStatus.isVideoPlaying)(state),
    currentChannelId: state.currentChannelId,
    appSettings: state.appSettings,
    videoByIds: (0, _videos.getVideosGroupedByIds)(state),
    firstChannelVideoId: state.firstChannelVideoId,
    newMobileUXIsEnabled: (0, _experiments.isNewMobileUXEnabled)(state),
    videoIds: state.lazyVideoLists.mobileWidget.videoIds,
    mainVideoId: (0, _selectedVideoId.getMainVideoId)(state, ownProps, _lazyChannelVideos.MOBILE_WIDGET_DATA_KEY)
  };
}, {
  openVideoPage: _mainOpenners.openVideoPage,
  selectVideo: _selectVideo.selectVideo,
  playVideo: _changePlaybackStatus.playVideo,
  pauseVideo: _changePlaybackStatus.pauseVideo,
  resetPlaybackStatus: _changePlaybackStatus.resetPlaybackStatus
}), _dec2 = (0, _reduxUi2.default)(), _dec3 = (0, _wixConnect.WixConnect)(_mobile2.default), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_BaseView) {
  (0, _inherits3.default)(MobileView, _BaseView);

  function MobileView(props) {
    (0, _classCallCheck3.default)(this, MobileView);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MobileView.__proto__ || (0, _getPrototypeOf2.default)(MobileView)).call(this, props));

    (0, _newRelic.getNewRelic)().setCustomAttribute('layout', 'mobile');
    return _this;
  }

  (0, _createClass3.default)(MobileView, [{
    key: 'processSubscriptionCancel',
    value: function processSubscriptionCancel() {
      var _props = this.props,
          _props$appSettings = _props.appSettings,
          siteUrl = _props$appSettings.siteUrl,
          instance = _props$appSettings.instance,
          currentChannelId = _props.currentChannelId;


      _payments2.default.cancelSubscription(currentChannelId, siteUrl, instance);
    }
  }, {
    key: 'openPaymentPage',
    value: function openPaymentPage(path) {
      path += '?' + (0, _initiators.makeInitiatorQueryString)(_initiators.INITIATORS.WIDGET);
      (0, _openOverlay.openMobileOverlay)(path);
    }
  }, {
    key: 'openMemberOnlyPage',
    value: function openMemberOnlyPage(id) {
      this.openPaymentPage('#/membership/' + id);
    }
  }, {
    key: 'handlePlayStart',
    value: function handlePlayStart() {
      this.disableChannelCover();
    }
  }, {
    key: 'processDataFromStorage',
    value: function processDataFromStorage(_ref) {
      var selectedVideoId = _ref.selectedVideoId;

      if (selectedVideoId) {
        this.selectVideo({ id: selectedVideoId });
      }
    }
  }, {
    key: 'storeDataForReload',
    value: function storeDataForReload() {
      (0, _reload.storeForReload)({
        selectedVideoId: this.props.mainVideoId
      });
    }
  }, {
    key: 'playSelectedVideo',
    value: function playSelectedVideo() {
      this.disableChannelCover();
      var _props2 = this.props,
          channelData = _props2.channelData,
          currentSiteUser = _props2.currentSiteUser,
          selectVideo = _props2.selectVideo,
          playVideo = _props2.playVideo;


      var videoItem = this.mainVideo;
      var isPlayAllowed = (0, _videoAccess.canPlayFullOrPreview)(channelData, videoItem, currentSiteUser.data);

      if (isPlayAllowed) {
        playVideo(videoItem.id);
      } else {
        selectVideo(videoItem.id);
      }
    }
  }, {
    key: 'onCurrentSlideChanged',
    value: function onCurrentSlideChanged(newIndex) {
      var videoIds = this.props.videoIds;

      this.selectVideo({ id: videoIds[newIndex] });
    }
  }, {
    key: 'clearStoredDataForMobileOverlay',
    value: function clearStoredDataForMobileOverlay() {
      (0, _reload.storeForReload)({
        selectedVideoId: null
      });
    }
  }, {
    key: 'handleExploreChannelClick',
    value: function handleExploreChannelClick() {
      this.sendExploreThisChannelEvent();
      this.clearStoredDataForMobileOverlay();
      (0, _openOverlay.openMobileOverlay)();
    }
  }, {
    key: 'sendExploreThisChannelEvent',
    value: function sendExploreThisChannelEvent() {
      this.props.biEvent('widget.exploreThisChannel.clicked');
    }
  }, {
    key: 'onVideoItemClicked',
    value: function onVideoItemClicked(videoItemId) {
      this.disableChannelCover();
      this.sendVidSelectedBiEvent(videoItemId);
      this.props.resetPlaybackStatus();
    }
  }, {
    key: 'sendVidSelectedBiEvent',
    value: function sendVidSelectedBiEvent(newVideoId) {
      var _props3 = this.props,
          appSettings = _props3.appSettings,
          channelData = _props3.channelData,
          videoByIds = _props3.videoByIds;

      this.props.biEvent('widget.VidSelected.displayed', (0, _videoOverlayEventsParams.getVideoSelectedEventParams)(appSettings, channelData, videoByIds[newVideoId], this.canShowChannelCover));
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.isUIBlockingDataLoaded || !this.isVideosLoaded) {
        return this.spinner;
      }

      var _props4 = this.props,
          appSettings = _props4.appSettings,
          newMobileUXIsEnabled = _props4.newMobileUXIsEnabled;


      var styleNames = (0, _classnames2.default)('container', 'view-mode-' + appSettings.editMode);

      return React.createElement(
        'section',
        { styleName: styleNames },
        React.createElement(_reloadStorage2.default, { onReload: this.processDataFromStorage }),
        React.createElement(_paymentEvents2.default, { onSubscription: this.reset,
          onSubscriptionCancel: this.reset }),
        newMobileUXIsEnabled ? this.newMobileUI : this.mainUI
      );
    }
  }, {
    key: 'mainVideoList',
    get: function get() {
      return this.props.lazyChannelVideos;
    }
  }, {
    key: 'playerSize',
    get: function get() {
      var _props5 = this.props,
          newMobileUXIsEnabled = _props5.newMobileUXIsEnabled,
          appSettings = _props5.appSettings;

      var widgetWidth = appSettings.requestedWidgetSize.width;

      return newMobileUXIsEnabled ? (0, _videosSizes.playerSizeMobileMainItemForNewUX)(widgetWidth) : (0, _videosSizes.playerSizeMobile)(widgetWidth);
    }
  }, {
    key: 'isFetching',
    get: function get() {
      var mainVideoList = this.mainVideoList;
      var channel = this.props.channel;

      return channel.isFetching || mainVideoList.isFetching && !_.get(mainVideoList, 'ids.length');
    }
  }, {
    key: 'player',
    get: function get() {
      var videoItem = this.mainVideo;
      var playerOverlay = this.playerOverlay;
      var _playerSize = this.playerSize,
          width = _playerSize.width,
          height = _playerSize.height;
      var _props6 = this.props,
          appSettings = _props6.appSettings,
          channelData = _props6.channelData;


      if (videoItem) {
        return React.createElement(
          _mobilePlayer2.default,
          { styleName: 'player',
            videoItem: videoItem,
            channel: channelData,
            width: width,
            height: height,
            canShowChannelCover: this.canShowChannelCover,
            onPurchaseClick: this.openPurchase,
            onSubscribeClick: this.openSubscription,
            onPlayStart: this.handlePlayStart,
            onMemberSignUp: (0, _memoizedPartial2.default)(this.openMemberOnlyPage, videoItem.id) },
          playerOverlay
        );
      }

      var coverUrl = channelData.customCoverUrl || channelData.coverUrl;

      if (!coverUrl) {
        return React.createElement(
          'div',
          { styleName: 'no-player',
            style: { width: width, height: height } },
          React.createElement(_icon2.default, { styleName: 'no-player-play',
            name: 'arrow-right-filled' })
        );
      }

      return React.createElement(
        _resizedImage2.default,
        { styleName: 'overlay-only',
          src: coverUrl,
          width: width,
          height: height,
          params: { lg: 1 } },
        React.cloneElement(playerOverlay, {
          showChannelCover: true,
          channelData: channelData,
          appSettings: appSettings
        })
      );
    }
  }, {
    key: 'playerOverlay',
    get: function get() {
      var videoItem = this.mainVideo || {};
      var openVideoPurchasePage = (0, _memoizedPartial2.default)(this.openPaymentPage, '#/video/purchase/' + videoItem.id);
      var openSubscriptionPage = (0, _memoizedPartial2.default)(this.openPaymentPage, '#/channel/subscribe');

      return React.createElement(_mainVideo2.default, { onPlayClick: this.playSelectedVideo,
        onPurchaseClick: openVideoPurchasePage,
        onSubscribeClick: openSubscriptionPage,
        onTitleClick: _openOverlay.openMobileOverlay });
    }
  }, {
    key: 'footer',
    get: function get() {
      if (this.props.channelData.videosCount === 0) {
        return React.createElement(
          'div',
          { styleName: 'footer coming-soon',
            key: 'footer' },
          React.createElement(_reactIntl.FormattedMessage, _translations4.default.thisChannelIsComingSoon)
        );
      }

      return React.createElement(
        'div',
        { styleName: 'footer',
          key: 'footer' },
        React.createElement(
          _button.LinkButton,
          { styleName: 'explore-channel',
            onClick: this.handleExploreChannelClick },
          React.createElement(_reactIntl.FormattedMessage, _translations2.default.exploreThisChannel),
          React.createElement(_icon2.default, { styleName: 'search-icon',
            name: 'permit-search' })
        )
      );
    }
  }, {
    key: 'carousel',
    get: function get() {
      var _props7 = this.props,
          mainVideoId = _props7.mainVideoId,
          currentChannelId = _props7.currentChannelId;
      var loadMore = this.mainVideoList.loadMore;


      if (this.isFetching || !this.mainVideo) {
        return null;
      }

      return React.createElement(_videosListMobile2.default, { key: 'carousel',
        styleName: 'videos-carousel',
        currentChannelId: currentChannelId,
        selectedVideoId: mainVideoId,
        onVideoItemClicked: this.onVideoItemClicked,
        loadMore: loadMore });
    }
  }, {
    key: 'newMobileUI',
    get: function get() {
      var _playerSize2 = this.playerSize,
          width = _playerSize2.width,
          height = _playerSize2.height;
      var loadMore = this.mainVideoList.loadMore;
      var _props8 = this.props,
          videoIds = _props8.videoIds,
          openVideoPage = _props8.openVideoPage,
          isVideoPlaying = _props8.isVideoPlaying;

      var videoItem = this.mainVideo;

      if (_.size(videoIds) === 1) {
        return React.createElement(_fakePlayer2.default, { videoItem: videoItem,
          useChannelCoverIfPossible: this.canShowChannelCover,
          paused: !isVideoPlaying,
          itemWidth: width,
          itemHeight: height,
          onPlayClick: (0, _memoizedPartial2.default)(openVideoPage, videoItem.id),
          onPlayStart: this.handlePlayStart,
          onMemberSignUp: (0, _memoizedPartial2.default)(this.openMemberOnlyPage, videoItem.id) });
      }

      return React.createElement(_playersListSlidable2.default, { loadMore: loadMore,
        paused: !isVideoPlaying,
        itemWidth: width,
        itemHeight: height,
        canShowChannelCover: this.canShowChannelCover,
        onCurrentSlideChanged: this.onCurrentSlideChanged,
        onPlayClick: (0, _memoizedPartial2.default)(openVideoPage, videoItem.id),
        onPlayStart: this.handlePlayStart,
        onMemberSignUp: (0, _memoizedPartial2.default)(this.openMemberOnlyPage, videoItem.id),
        selectedVideoId: videoItem && videoItem.id });
    }
  }, {
    key: 'mainUI',
    get: function get() {
      return [React.createElement(_headerMobile2.default, { styleName: 'header',
        key: 'header',
        channel: this.props.channelData,
        onUserLogin: this.storeDataForReload,
        onUserLogout: this.storeDataForReload,
        onSubscribeClick: (0, _memoizedPartial2.default)(this.openPaymentPage, '#/channel/subscribe'),
        onSubscriptionCancelClick: this.processSubscriptionCancel }), React.createElement(
        'div',
        { styleName: 'player-wrapper',
          key: 'wrapper' },
        this.player
      ), this.carousel, this.footer];
    }
  }, {
    key: 'isVideosLoaded',
    get: function get() {
      var _props9 = this.props,
          videoIds = _props9.videoIds,
          lazyChannelVideos = _props9.lazyChannelVideos;

      return !lazyChannelVideos.isFetching || !_.isEmpty(videoIds);
    }
  }]);
  return MobileView;
}(_base2.default), _class3.displayName = 'MobileView', _class3.propTypes = {
  resetPlaybackStatus: React.PropTypes.func,
  lazyChannelVideos: React.PropTypes.object,
  newMobileUXIsEnabled: React.PropTypes.bool,
  openVideoPage: React.PropTypes.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'processSubscriptionCancel', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'processSubscriptionCancel'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'openPaymentPage', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'openPaymentPage'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'openMemberOnlyPage', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'openMemberOnlyPage'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handlePlayStart', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handlePlayStart'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'processDataFromStorage', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'processDataFromStorage'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'storeDataForReload', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'storeDataForReload'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'playSelectedVideo', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'playSelectedVideo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onCurrentSlideChanged', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onCurrentSlideChanged'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleExploreChannelClick', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleExploreChannelClick'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onVideoItemClicked', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onVideoItemClicked'), _class2.prototype)), _class2)) || _class) || _class) || _class);
exports.default = MobileView;

/***/ }),

/***/ 1491:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(5);

exports.default = (0, _reactIntl.defineMessages)({
  exploreThisChannel: {
    id: 'widget.home-view-mobile.explore-this-channel',
    defaultMessage: 'Explore this channel'
  }
});

/***/ }),

/***/ 1522:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(18);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SVG = function (_React$Component) {
  (0, _inherits3.default)(SVG, _React$Component);

  function SVG() {
    (0, _classCallCheck3.default)(this, SVG);
    return (0, _possibleConstructorReturn3.default)(this, (SVG.__proto__ || (0, _getPrototypeOf2.default)(SVG)).apply(this, arguments));
  }

  (0, _createClass3.default)(SVG, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "svg",
        (0, _extends3.default)({ xmlns: "http://www.w3.org/2000/svg", width: "36", height: "37", viewBox: "0 0 36 37" }, this.props),
        _react2.default.createElement("path", { className: "cls-1", d: "M16.47 33.13a16.575 16.575 0 1 1 16.47-16.57 16.538 16.538 0 0 1-16.47 16.57zm0-31.75a15.18 15.18 0 1 0 15.09 15.18A15.144 15.144 0 0 0 16.47 1.38zm18.51 35.61l-8.61-9.48 1.02-.94L36 36.04z" })
      );
    }
  }]);
  return SVG;
}(_react2.default.Component);

exports.default = SVG;

/***/ }),

/***/ 1523:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(18);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SVG = function (_React$Component) {
  (0, _inherits3.default)(SVG, _React$Component);

  function SVG() {
    (0, _classCallCheck3.default)(this, SVG);
    return (0, _possibleConstructorReturn3.default)(this, (SVG.__proto__ || (0, _getPrototypeOf2.default)(SVG)).apply(this, arguments));
  }

  (0, _createClass3.default)(SVG, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "svg",
        (0, _extends3.default)({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 30 9" }, this.props),
        _react2.default.createElement("path", { d: "M24 0v4H0v1h24v4l6-4.5z" })
      );
    }
  }]);
  return SVG;
}(_react2.default.Component);

exports.default = SVG;

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = React;

/***/ }),

/***/ 1951:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, ".clickable__clickable__1fD9z{display:-ms-flexbox;display:flex}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/shared/containers/clickable/src/shared/containers/clickable/clickable.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/shared/containers/clickable/clickable.styl"],"names":[],"mappings":"AAEA,6BACE,oBAAA,YAAA,CCDD","file":"clickable.styl","sourcesContent":["@require '~shared/styles/mixins'\n\n.clickable\n  display flex\n",".clickable {\n  display: flex;\n}\n/*# sourceMappingURL=src/shared/containers/clickable/clickable.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"clickable": "clickable__clickable__1fD9z"
};

/***/ }),

/***/ 1954:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, ".account-button-strip__account-button__3zfYt{-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;height:20px;line-height:20px;border-radius:0;color:-wix-colors-buttonsAndLinksColor-80;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;font-size:14px}.account-button-strip__account-button__3zfYt:hover{color:-wix-colors-buttonsAndLinksColor-100}.account-button-strip__account-preview-button-wrapper__dcE0Y{-ms-flex-positive:0;flex-grow:0;height:20px;line-height:20px;margin-right:10px;border-radius:0}.account-button-strip__account-preview-button__D7EVi{font-size:28px;background:none;color:-wix-colors-buttonsAndLinksColor-80}.account-button-strip__account-preview-button__D7EVi:hover{background:none;color:-wix-colors-buttonsAndLinksColor}.account-button-strip__popout__2NeZk{width:325px}.account-button-strip__popout-inner__2bzGm{padding:0}.account-button-strip__popout-inner__2bzGm,.account-button-strip__popout-triangle__3iUO6{background-color:-wix-colors-backgroundColor-100}.account-button-strip__user-email__2aY7h{padding:30px 20px 10px}.account-button-strip__channel-subscription__2vG3B,.account-button-strip__user-email__2aY7h{border-bottom:1px solid -wix-colors-dividersAndArrowsColor;color:-wix-colors-textColor}.account-button-strip__channel-subscription__2vG3B{padding:30px 20px}.account-button-strip__logout-wrapper__2rls9{display:-ms-flexbox;display:flex;-ms-flex-pack:end;justify-content:flex-end;padding:20px;line-height:14px}.account-button-strip__logout__D9D6D{color:-wix-colors-buttonsAndLinksColor}.account-button-strip__account-button__3zfYt,.account-button-strip__account-preview-button__D7EVi{color:#fff}.account-button-strip__account-button__3zfYt:hover,.account-button-strip__account-preview-button__D7EVi:hover{color:hsla(0,0%,100%,.7)}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/account/src/widget/components/account/account-button.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/account/account-button-strip.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/account/src/widget/components/account/account-button-strip.styl"],"names":[],"mappings":"AAGA,6CACE,oBAAA,YAAA,oBACA,cAAA,YACA,iBACA,gBACA,0CACA,uCACA,qCACA,uCACA,+CACA,cACA,CAEA,mDACE,0CAAA,CAEJ,6DACE,oBAAA,YAAA,YACA,iBACA,kBACA,eACA,CAEF,qDACE,eAAA,gBACA,yCACA,CAEA,2DACE,gBAAA,sCACA,CAEJ,qCACE,WAAA,CAEF,2CACE,SAAA,CAGF,yFAFE,gDAAA,CAKF,yCACE,sBAAA,CAIF,4FAHE,2DAAA,2BACA,CAEF,mDACE,iBAAA,CAIF,6CACE,oBAAA,aAAA,kBACA,yBAAA,aACA,gBACA,CAEF,qCACE,sCAAA,CCFD,kGCvDC,UAAA,CD2DD,8GCxDG,wBAAA,CD4DH","file":"account-button-strip.styl","sourcesContent":["@require '~shared/styles/mixins'\n\n\n.account-button\n  flex-grow 0\n  flex-shrink 0\n  height 20px\n  line-height 20px\n  border-radius 0\n  color -wix-colors-buttonsAndLinksColor-80\n  font-weight -wix-fonts-textFont-weight\n  font-style -wix-fonts-textFont-style\n  font-family -wix-fonts-textFont-family\n  text-decoration -wix-fonts-textFont-decoration\n  font-size 14px\n\n  &:hover\n    color -wix-colors-buttonsAndLinksColor-100\n\n.account-preview-button-wrapper\n  flex-grow 0\n  height 20px\n  line-height 20px\n  margin-right 10px\n  border-radius 0\n\n.account-preview-button\n  font-size 28px\n  background none\n  color -wix-colors-buttonsAndLinksColor-80\n\n  &:hover\n    background none\n    color -wix-colors-buttonsAndLinksColor\n\n.popout\n  width 325px\n\n.popout-inner\n  padding 0\n  background-color -wix-colors-backgroundColor-100\n\n.popout-triangle\n  background-color -wix-colors-backgroundColor-100\n\n.user-email\n  padding 30px 20px 10px\n  border-bottom 1px solid -wix-colors-dividersAndArrowsColor\n  color -wix-colors-textColor\n\n.channel-subscription\n  padding 30px 20px\n  border-bottom 1px solid -wix-colors-dividersAndArrowsColor\n  color -wix-colors-textColor\n\n.logout-wrapper\n  display flex\n  justify-content flex-end\n  padding 20px\n  line-height 14px\n\n.logout\n  color -wix-colors-buttonsAndLinksColor\n",".account-button {\n  flex-grow: 0;\n  flex-shrink: 0;\n  height: 20px;\n  line-height: 20px;\n  border-radius: 0;\n  color: -wix-colors-buttonsAndLinksColor-80;\n  font-weight: -wix-fonts-textFont-weight;\n  font-style: -wix-fonts-textFont-style;\n  font-family: -wix-fonts-textFont-family;\n  text-decoration: -wix-fonts-textFont-decoration;\n  font-size: 14px;\n}\n.account-button:hover {\n  color: -wix-colors-buttonsAndLinksColor-100;\n}\n.account-preview-button-wrapper {\n  flex-grow: 0;\n  height: 20px;\n  line-height: 20px;\n  margin-right: 10px;\n  border-radius: 0;\n}\n.account-preview-button {\n  font-size: 28px;\n  background: none;\n  color: -wix-colors-buttonsAndLinksColor-80;\n}\n.account-preview-button:hover {\n  background: none;\n  color: -wix-colors-buttonsAndLinksColor;\n}\n.popout {\n  width: 325px;\n}\n.popout-inner {\n  padding: 0;\n  background-color: -wix-colors-backgroundColor-100;\n}\n.popout-triangle {\n  background-color: -wix-colors-backgroundColor-100;\n}\n.user-email {\n  padding: 30px 20px 10px;\n  border-bottom: 1px solid -wix-colors-dividersAndArrowsColor;\n  color: -wix-colors-textColor;\n}\n.channel-subscription {\n  padding: 30px 20px;\n  border-bottom: 1px solid -wix-colors-dividersAndArrowsColor;\n  color: -wix-colors-textColor;\n}\n.logout-wrapper {\n  display: flex;\n  justify-content: flex-end;\n  padding: 20px;\n  line-height: 14px;\n}\n.logout {\n  color: -wix-colors-buttonsAndLinksColor;\n}\n.account-button,\n.account-preview-button {\n  color: #fff;\n}\n.account-button:hover,\n.account-preview-button:hover {\n  color: rgba(255,255,255,0.7);\n}\n/*# sourceMappingURL=src/widget/components/account/account-button-strip.css.map */","@require './account-button'\n\n\n.account-button\n.account-preview-button\n  color #fff\n\n  &:hover\n    color rgba(255, 255, 255, 0.7)\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"account-button": "account-button-strip__account-button__3zfYt",
	"accountButton": "account-button-strip__account-button__3zfYt",
	"account-preview-button-wrapper": "account-button-strip__account-preview-button-wrapper__dcE0Y",
	"accountPreviewButtonWrapper": "account-button-strip__account-preview-button-wrapper__dcE0Y",
	"account-preview-button": "account-button-strip__account-preview-button__D7EVi",
	"accountPreviewButton": "account-button-strip__account-preview-button__D7EVi",
	"popout": "account-button-strip__popout__2NeZk",
	"popout-inner": "account-button-strip__popout-inner__2bzGm",
	"popoutInner": "account-button-strip__popout-inner__2bzGm",
	"popout-triangle": "account-button-strip__popout-triangle__3iUO6",
	"popoutTriangle": "account-button-strip__popout-triangle__3iUO6",
	"user-email": "account-button-strip__user-email__2aY7h",
	"userEmail": "account-button-strip__user-email__2aY7h",
	"channel-subscription": "account-button-strip__channel-subscription__2vG3B",
	"channelSubscription": "account-button-strip__channel-subscription__2vG3B",
	"logout-wrapper": "account-button-strip__logout-wrapper__2rls9",
	"logoutWrapper": "account-button-strip__logout-wrapper__2rls9",
	"logout": "account-button-strip__logout__D9D6D"
};

/***/ }),

/***/ 1955:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, ".account-button__account-button__cP2fq{-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;height:20px;line-height:20px;border-radius:0;color:-wix-colors-buttonsAndLinksColor-80;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;font-size:14px}.account-button__account-button__cP2fq:hover{color:-wix-colors-buttonsAndLinksColor-100}.account-button__account-preview-button-wrapper__2jGCT{-ms-flex-positive:0;flex-grow:0;height:20px;line-height:20px;margin-right:10px;border-radius:0}.account-button__account-preview-button__y5o_i{font-size:28px;background:none;color:-wix-colors-buttonsAndLinksColor-80}.account-button__account-preview-button__y5o_i:hover{background:none;color:-wix-colors-buttonsAndLinksColor}.account-button__popout__3BhI9{width:325px}.account-button__popout-inner__34y6t{padding:0}.account-button__popout-inner__34y6t,.account-button__popout-triangle__blaQl{background-color:-wix-colors-backgroundColor-100}.account-button__user-email__2m7rH{padding:30px 20px 10px}.account-button__channel-subscription__2CZbF,.account-button__user-email__2m7rH{border-bottom:1px solid -wix-colors-dividersAndArrowsColor;color:-wix-colors-textColor}.account-button__channel-subscription__2CZbF{padding:30px 20px}.account-button__logout-wrapper__1177A{display:-ms-flexbox;display:flex;-ms-flex-pack:end;justify-content:flex-end;padding:20px;line-height:14px}.account-button__logout__oE0Zv{color:-wix-colors-buttonsAndLinksColor}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/account/src/widget/components/account/account-button.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/account/account-button.styl"],"names":[],"mappings":"AAGA,uCACE,oBAAA,YAAA,oBACA,cAAA,YACA,iBACA,gBACA,0CACA,uCACA,qCACA,uCACA,+CACA,cACA,CAEA,6CACE,0CAAA,CAEJ,uDACE,oBAAA,YAAA,YACA,iBACA,kBACA,eACA,CAEF,+CACE,eAAA,gBACA,yCACA,CAEA,qDACE,gBAAA,sCACA,CAEJ,+BACE,WAAA,CAEF,qCACE,SAAA,CAGF,6EAFE,gDAAA,CAKF,mCACE,sBAAA,CAIF,gFAHE,2DAAA,2BACA,CAEF,6CACE,iBAAA,CAIF,uCACE,oBAAA,aAAA,kBACA,yBAAA,aACA,gBACA,CAEF,+BACE,sCAAA,CCFD","file":"account-button.styl","sourcesContent":["@require '~shared/styles/mixins'\n\n\n.account-button\n  flex-grow 0\n  flex-shrink 0\n  height 20px\n  line-height 20px\n  border-radius 0\n  color -wix-colors-buttonsAndLinksColor-80\n  font-weight -wix-fonts-textFont-weight\n  font-style -wix-fonts-textFont-style\n  font-family -wix-fonts-textFont-family\n  text-decoration -wix-fonts-textFont-decoration\n  font-size 14px\n\n  &:hover\n    color -wix-colors-buttonsAndLinksColor-100\n\n.account-preview-button-wrapper\n  flex-grow 0\n  height 20px\n  line-height 20px\n  margin-right 10px\n  border-radius 0\n\n.account-preview-button\n  font-size 28px\n  background none\n  color -wix-colors-buttonsAndLinksColor-80\n\n  &:hover\n    background none\n    color -wix-colors-buttonsAndLinksColor\n\n.popout\n  width 325px\n\n.popout-inner\n  padding 0\n  background-color -wix-colors-backgroundColor-100\n\n.popout-triangle\n  background-color -wix-colors-backgroundColor-100\n\n.user-email\n  padding 30px 20px 10px\n  border-bottom 1px solid -wix-colors-dividersAndArrowsColor\n  color -wix-colors-textColor\n\n.channel-subscription\n  padding 30px 20px\n  border-bottom 1px solid -wix-colors-dividersAndArrowsColor\n  color -wix-colors-textColor\n\n.logout-wrapper\n  display flex\n  justify-content flex-end\n  padding 20px\n  line-height 14px\n\n.logout\n  color -wix-colors-buttonsAndLinksColor\n",".account-button {\n  flex-grow: 0;\n  flex-shrink: 0;\n  height: 20px;\n  line-height: 20px;\n  border-radius: 0;\n  color: -wix-colors-buttonsAndLinksColor-80;\n  font-weight: -wix-fonts-textFont-weight;\n  font-style: -wix-fonts-textFont-style;\n  font-family: -wix-fonts-textFont-family;\n  text-decoration: -wix-fonts-textFont-decoration;\n  font-size: 14px;\n}\n.account-button:hover {\n  color: -wix-colors-buttonsAndLinksColor-100;\n}\n.account-preview-button-wrapper {\n  flex-grow: 0;\n  height: 20px;\n  line-height: 20px;\n  margin-right: 10px;\n  border-radius: 0;\n}\n.account-preview-button {\n  font-size: 28px;\n  background: none;\n  color: -wix-colors-buttonsAndLinksColor-80;\n}\n.account-preview-button:hover {\n  background: none;\n  color: -wix-colors-buttonsAndLinksColor;\n}\n.popout {\n  width: 325px;\n}\n.popout-inner {\n  padding: 0;\n  background-color: -wix-colors-backgroundColor-100;\n}\n.popout-triangle {\n  background-color: -wix-colors-backgroundColor-100;\n}\n.user-email {\n  padding: 30px 20px 10px;\n  border-bottom: 1px solid -wix-colors-dividersAndArrowsColor;\n  color: -wix-colors-textColor;\n}\n.channel-subscription {\n  padding: 30px 20px;\n  border-bottom: 1px solid -wix-colors-dividersAndArrowsColor;\n  color: -wix-colors-textColor;\n}\n.logout-wrapper {\n  display: flex;\n  justify-content: flex-end;\n  padding: 20px;\n  line-height: 14px;\n}\n.logout {\n  color: -wix-colors-buttonsAndLinksColor;\n}\n/*# sourceMappingURL=src/widget/components/account/account-button.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"account-button": "account-button__account-button__cP2fq",
	"accountButton": "account-button__account-button__cP2fq",
	"account-preview-button-wrapper": "account-button__account-preview-button-wrapper__2jGCT",
	"accountPreviewButtonWrapper": "account-button__account-preview-button-wrapper__2jGCT",
	"account-preview-button": "account-button__account-preview-button__y5o_i",
	"accountPreviewButton": "account-button__account-preview-button__y5o_i",
	"popout": "account-button__popout__3BhI9",
	"popout-inner": "account-button__popout-inner__34y6t",
	"popoutInner": "account-button__popout-inner__34y6t",
	"popout-triangle": "account-button__popout-triangle__blaQl",
	"popoutTriangle": "account-button__popout-triangle__blaQl",
	"user-email": "account-button__user-email__2m7rH",
	"userEmail": "account-button__user-email__2m7rH",
	"channel-subscription": "account-button__channel-subscription__2CZbF",
	"channelSubscription": "account-button__channel-subscription__2CZbF",
	"logout-wrapper": "account-button__logout-wrapper__1177A",
	"logoutWrapper": "account-button__logout-wrapper__1177A",
	"logout": "account-button__logout__oE0Zv"
};

/***/ }),

/***/ 1959:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, ".categories__option__2GZ1t,.categories__options__35IOB{width:100%}.categories__option__2GZ1t{display:block;overflow:hidden;text-overflow:ellipsis}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/categories/src/widget/components/categories/categories.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/categories/categories.styl"],"names":[],"mappings":"AAGA,uDAFE,UAAA,CAEF,2BACE,cAAA,gBAEA,sBACA,CCCD","file":"categories.styl","sourcesContent":[".options\n  width 100%\n\n.option\n  display block\n  width 100%\n  overflow hidden\n  text-overflow ellipsis\n",".options {\n  width: 100%;\n}\n.option {\n  display: block;\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n/*# sourceMappingURL=src/widget/components/categories/categories.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"option": "categories__option__2GZ1t",
	"options": "categories__options__35IOB"
};

/***/ }),

/***/ 1960:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, ".channel-actions__action__3ss81{-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;height:20px;line-height:20px;border-radius:0;color:-wix-colors-buttonsAndLinksColor-80;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;font-size:14px}.channel-actions__action__3ss81.channel-actions__info__1tBNe:hover .channel-actions__icon__3FzAR,.channel-actions__action__3ss81:hover{color:-wix-colors-buttonsAndLinksColor-100}.channel-actions__action__3ss81.channel-actions__info__1tBNe .channel-actions__icon__3FzAR{color:-wix-colors-buttonsAndLinksColor-80;font-size:15px}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/channel-actions/src/widget/components/channel-actions/channel-actions.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/channel-actions/channel-actions.styl"],"names":[],"mappings":"AAAA,gCACE,oBAAA,YAAA,oBACA,cAAA,YACA,iBACA,gBACA,0CACA,uCACA,qCACA,uCACA,+CACA,cACA,CAME,uIACE,0CAAA,CAEF,2FACE,0CAAA,cACA,CCAL","file":"channel-actions.styl","sourcesContent":[".action\n  flex-grow 0\n  flex-shrink 0\n  height 20px\n  line-height 20px\n  border-radius 0\n  color -wix-colors-buttonsAndLinksColor-80\n  font-weight -wix-fonts-textFont-weight\n  font-style -wix-fonts-textFont-style\n  font-family -wix-fonts-textFont-family\n  text-decoration -wix-fonts-textFont-decoration\n  font-size 14px\n\n  &:hover\n    color -wix-colors-buttonsAndLinksColor-100\n\n  &.info\n    &:hover .icon\n      color -wix-colors-buttonsAndLinksColor-100\n\n    .icon\n      color -wix-colors-buttonsAndLinksColor-80\n      font-size 15px\n",".action {\n  flex-grow: 0;\n  flex-shrink: 0;\n  height: 20px;\n  line-height: 20px;\n  border-radius: 0;\n  color: -wix-colors-buttonsAndLinksColor-80;\n  font-weight: -wix-fonts-textFont-weight;\n  font-style: -wix-fonts-textFont-style;\n  font-family: -wix-fonts-textFont-family;\n  text-decoration: -wix-fonts-textFont-decoration;\n  font-size: 14px;\n}\n.action:hover {\n  color: -wix-colors-buttonsAndLinksColor-100;\n}\n.action.info:hover .icon {\n  color: -wix-colors-buttonsAndLinksColor-100;\n}\n.action.info .icon {\n  color: -wix-colors-buttonsAndLinksColor-80;\n  font-size: 15px;\n}\n/*# sourceMappingURL=src/widget/components/channel-actions/channel-actions.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"action": "channel-actions__action__3ss81",
	"info": "channel-actions__info__1tBNe",
	"icon": "channel-actions__icon__3FzAR"
};

/***/ }),

/***/ 1962:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, ".empty-search-results__no-search-wrapper__1vg37{-ms-flex-positive:1;flex-grow:1;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;padding:36px 0 54px;color:-wix-colors-buttonsAndLinksColor;opacity:.5}.empty-search-results__no-search-icon__2AZs7{margin-bottom:15px;heigth:37px;font-size:36px}.empty-search-results__no-search-icon__2AZs7 path{fill:-wix-colors-buttonsAndLinksColor}.empty-search-results__no-search-text__3ofiu{font-size:16px}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/empty-search-results/src/widget/components/empty-search-results/empty-search-results.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/empty-search-results/empty-search-results.styl"],"names":[],"mappings":"AAEA,gDACE,oBAAA,YAAA,oBACA,aAAA,0BACA,sBAAA,qBACA,uBAAA,sBACA,mBAAA,oBACA,uCACA,UACA,CAEF,6CACE,mBAAA,YACA,cACA,CAEA,kDACE,qCAAA,CAEJ,6CACE,cAAA,CCDD","file":"empty-search-results.styl","sourcesContent":["@require '~shared/styles/mixins'\n\n.no-search-wrapper\n  flex-grow 1\n  display flex\n  flex-direction column\n  justify-content center\n  align-items center\n  padding 36px 0 54px 0\n  color -wix-colors-buttonsAndLinksColor\n  opacity 0.5\n\n.no-search-icon\n  margin-bottom 15px\n  heigth 37px\n  font-size 36px\n\n  path\n    fill -wix-colors-buttonsAndLinksColor\n\n.no-search-text\n  font-size 16px\n",".no-search-wrapper {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 36px 0 54px 0;\n  color: -wix-colors-buttonsAndLinksColor;\n  opacity: 0.5;\n}\n.no-search-icon {\n  margin-bottom: 15px;\n  heigth: 37px;\n  font-size: 36px;\n}\n.no-search-icon path {\n  fill: -wix-colors-buttonsAndLinksColor;\n}\n.no-search-text {\n  font-size: 16px;\n}\n/*# sourceMappingURL=src/widget/components/empty-search-results/empty-search-results.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"no-search-wrapper": "empty-search-results__no-search-wrapper__1vg37",
	"noSearchWrapper": "empty-search-results__no-search-wrapper__1vg37",
	"no-search-icon": "empty-search-results__no-search-icon__2AZs7",
	"noSearchIcon": "empty-search-results__no-search-icon__2AZs7",
	"no-search-text": "empty-search-results__no-search-text__3ofiu",
	"noSearchText": "empty-search-results__no-search-text__3ofiu"
};

/***/ }),

/***/ 1964:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, ".buttons__button-container__3uW6n{position:absolute;top:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.buttons__button-container__3uW6n.buttons__inactive__3ngqj{opacity:.3}.buttons__button-container__3uW6n:before{content:\" \";position:absolute;top:0;bottom:0;width:15px}.buttons__button-container__3uW6n.buttons__left__zSv1l{left:0}.buttons__button-container__3uW6n.buttons__left__zSv1l:before{background:linear-gradient(90deg,rgba(0,0,0,.4),hsla(0,0%,100%,0));left:0}.buttons__button-container__3uW6n.buttons__left__zSv1l .buttons__button__2RPO-{transform:scaleX(-1);margin-left:10px}.buttons__button-container__3uW6n.buttons__right__3qYSz{right:0}.buttons__button-container__3uW6n.buttons__right__3qYSz:before{background:linear-gradient(270deg,rgba(0,0,0,.4),hsla(0,0%,100%,0));right:0}.buttons__button-container__3uW6n.buttons__right__3qYSz .buttons__button__2RPO-{margin-right:10px}.buttons__button__2RPO-{color:#fff;font-size:8px}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/mobile-carousel/src/widget/components/mobile-carousel/buttons.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/mobile-carousel/buttons.styl"],"names":[],"mappings":"AAIA,kCACE,kBAAA,MACA,SACA,oBACA,aAAA,sBACA,kBAAA,CAEA,2DACE,UAAA,CAEF,yCACE,YAAA,kBACA,MACA,SACA,UACA,CAEF,uDACE,MAAA,CAEA,8DACE,mEAAA,MACA,CAEF,+EACE,qBAAA,gBACA,CAEJ,wDACE,OAAA,CAEA,+DACE,oEAAA,OACA,CAEF,gFACE,iBAAA,CAEN,wBACE,WAAA,aACA,CCHD","file":"buttons.styl","sourcesContent":["start-color = rgba(0, 0, 0, 0.4)\nend-color = rgba(255, 255, 255, 0)\nbutton-padding = 10px\n\n.button-container\n  position absolute\n  top 0\n  bottom 0\n  display flex\n  align-items center\n\n  &.inactive\n    opacity 0.3\n\n  &::before\n    content ' '\n    position absolute\n    top 0\n    bottom 0\n    width 15px\n\n  &.left\n    left 0\n\n    &::before\n      background linear-gradient(to right, start-color, end-color)\n      left 0\n\n    .button\n      transform: scale(-1, 1);\n      margin-left button-padding\n\n  &.right\n    right 0\n\n    &::before\n      background linear-gradient(to left, start-color, end-color)\n      right 0\n\n    .button\n      margin-right button-padding\n\n.button\n  color: white\n  font-size 8px\n",".button-container {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n}\n.button-container.inactive {\n  opacity: 0.3;\n}\n.button-container::before {\n  content: ' ';\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 15px;\n}\n.button-container.left {\n  left: 0;\n}\n.button-container.left::before {\n  background: linear-gradient(to right, rgba(0,0,0,0.4), rgba(255,255,255,0));\n  left: 0;\n}\n.button-container.left .button {\n  transform: scale(-1, 1);\n  margin-left: 10px;\n}\n.button-container.right {\n  right: 0;\n}\n.button-container.right::before {\n  background: linear-gradient(to left, rgba(0,0,0,0.4), rgba(255,255,255,0));\n  right: 0;\n}\n.button-container.right .button {\n  margin-right: 10px;\n}\n.button {\n  color: #fff;\n  font-size: 8px;\n}\n/*# sourceMappingURL=src/widget/components/mobile-carousel/buttons.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"button-container": "buttons__button-container__3uW6n",
	"buttonContainer": "buttons__button-container__3uW6n",
	"inactive": "buttons__inactive__3ngqj",
	"left": "buttons__left__zSv1l",
	"button": "buttons__button__2RPO-",
	"right": "buttons__right__3qYSz"
};

/***/ }),

/***/ 1965:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, ".mobile-carousel__container__13BgB{position:relative;overflow:hidden;-ms-touch-action:pan-y pinch-zoom;touch-action:pan-y pinch-zoom}.mobile-carousel__slick-track__5QJA1{display:-ms-flexbox;display:flex}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/mobile-carousel/src/widget/components/mobile-carousel/mobile-carousel.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/mobile-carousel/mobile-carousel.styl"],"names":[],"mappings":"AAEA,mCACE,kBAAA,gBACA,kCACA,6BAAA,CAEF,qCACE,oBAAA,YAAA,CCDD","file":"mobile-carousel.styl","sourcesContent":["@require '~shared/styles/mixins'\n\n.container\n  position relative\n  overflow hidden\n  touch-action pan-y pinch-zoom\n\n.slick-track\n  display flex\n",".container {\n  position: relative;\n  overflow: hidden;\n  touch-action: pan-y pinch-zoom;\n}\n.slick-track {\n  display: flex;\n}\n/*# sourceMappingURL=src/widget/components/mobile-carousel/mobile-carousel.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "mobile-carousel__container__13BgB",
	"slick-track": "mobile-carousel__slick-track__5QJA1",
	"slickTrack": "mobile-carousel__slick-track__5QJA1"
};

/***/ }),

/***/ 1966:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, ".track__slick-track__2vOSc{display:-ms-flexbox;display:flex}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/mobile-carousel/src/widget/components/mobile-carousel/track.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/mobile-carousel/track.styl"],"names":[],"mappings":"AAEA,2BACE,oBAAA,YAAA,CCDD","file":"track.styl","sourcesContent":["@require '~shared/styles/mixins'\n\n.slick-track\n  display flex\n",".slick-track {\n  display: flex;\n}\n/*# sourceMappingURL=src/widget/components/mobile-carousel/track.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"slick-track": "track__slick-track__2vOSc",
	"slickTrack": "track__slick-track__2vOSc"
};

/***/ }),

/***/ 1972:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, ".classic__overlay__2yQY8,.classic__overlay-bottom__3i5r5{z-index:120;position:absolute;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;color:#fff}.classic__overlay-bottom__3i5r5 .classic__title__31O8o,.classic__overlay__2yQY8 .classic__title__31O8o{width:calc(100% - 180px);margin-left:90px;margin-right:90px;padding:0;font-weight:-wix-fonts-titleFont-weight;font-style:-wix-fonts-titleFont-style;font-family:-wix-fonts-titleFont-family;text-decoration:-wix-fonts-titleFont-decoration;font-size:-wix-fonts-titleFont-size}.classic__overlay-bottom__3i5r5 .classic__title__31O8o+.classic__publisher__3rh6X,.classic__overlay__2yQY8 .classic__title__31O8o+.classic__publisher__3rh6X{margin-top:10px}.classic__overlay-bottom__3i5r5 .classic__title__31O8o .classic__preview-text__2tIBi,.classic__overlay__2yQY8 .classic__title__31O8o .classic__preview-text__2tIBi{font-size:14px;margin-left:10px}.classic__overlay-bottom__3i5r5 .classic__publisher__3rh6X,.classic__overlay__2yQY8 .classic__publisher__3rh6X{width:100%;padding-left:95px;padding-right:95px;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;font-size:18px;line-height:24px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.classic__overlay-bottom__3i5r5 .classic__buttons__3UyyT:not(:first-child),.classic__overlay__2yQY8 .classic__buttons__3UyyT:not(:first-child){margin-top:36px}.classic__overlay-bottom__3i5r5 .classic__buttons__3UyyT .classic__button__3HMCZ,.classic__overlay__2yQY8 .classic__buttons__3UyyT .classic__button__3HMCZ{margin:0 8px 0 7px}.classic__overlay__2yQY8 .classic__title__31O8o .classic__preview-text__2tIBi{display:none}.classic__overlay__2yQY8{top:0;-ms-flex-direction:column;flex-direction:column;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:center;justify-content:center;-ms-flex-align:stretch;align-items:stretch;color:#fff;text-align:center}.classic__overlay-bottom__3i5r5{position:absolute;left:0;right:0;bottom:0;height:183px;display:-ms-flexbox;display:flex;box-sizing:border-box;padding:61px 30px 0;-ms-flex-align:center;align-items:center;background:linear-gradient(0deg,rgba(0,0,0,.5),transparent)}.classic__overlay-bottom__3i5r5 .classic__play-button__2QHTJ{margin-right:30px;padding:0;width:60px;height:60px;border-radius:50%;border:1px solid #fff;text-align:center;background:transparent;outline:none;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#fff;-ms-flex:0 0 auto;flex:0 0 auto}.classic__overlay-bottom__3i5r5 .classic__play-button__2QHTJ .classic__play-icon__2yBDd{font-size:22px;margin-left:5px}.classic__overlay-bottom__3i5r5 .classic__info__k75sW{-ms-flex:1;flex:1;text-align:left;overflow:hidden;margin-right:40px}.classic__overlay-bottom__3i5r5 .classic__info__k75sW .classic__publisher__3rh6X,.classic__overlay-bottom__3i5r5 .classic__info__k75sW .classic__title__31O8o{padding-left:0;padding-right:0;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}@media only screen and (max-width:320px){.classic__overlay-bottom__3i5r5 .classic__buttons__3UyyT,.classic__overlay__2yQY8 .classic__buttons__3UyyT{margin-top:25px}.classic__overlay-bottom__3i5r5 .classic__buttons__3UyyT .classic__button__3HMCZ,.classic__overlay__2yQY8 .classic__buttons__3UyyT .classic__button__3HMCZ{margin:0 5px}}.classic__button__3HMCZ .classic__next-icon__3btb8,.classic__button__3HMCZ .classic__play-icon__2yBDd{font-size:14px}.classic__button__3HMCZ .classic__play-icon__2yBDd{margin-right:11px}.classic__button__3HMCZ .classic__next-icon__3btb8{margin-left:11px}@media only screen and (max-width:320px){.classic__button__3HMCZ .classic__play-icon__2yBDd{font-size:10px}}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/player-overlay/classic/src/widget/components/player-overlay/classic/classic.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/player-overlay/classic/src/shared/styles/mixins/text-overflow.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/player-overlay/classic/classic.styl"],"names":[],"mappings":"AAEA,yDAEE,YAAA,kBACA,OACA,QACA,SACA,oBACA,aAAA,UACA,CAEA,uGACE,yBAAA,iBACA,kBACA,UACA,wCACA,sCACA,wCACA,gDACA,mCACA,CAEA,6JACE,eAAA,CAEF,mKACE,eAAA,gBACA,CAEJ,+GACE,WAAA,kBACA,mBACA,uCACA,qCACA,uCACA,+CACA,eACA,iBACA,uBCtCF,gBAGE,kBACA,CDsCA,+IACE,eAAA,CAEF,2JACE,kBAAA,CAEN,8EACE,YAAA,CAEF,yBACE,MAAA,0BACA,sBAAA,mBACA,eAAA,qBACA,uBAAA,uBACA,oBAAA,WACA,iBACA,CAEF,gCACE,kBAAA,OACA,QACA,SACA,aACA,oBACA,aAAA,sBACA,oBACA,sBACA,mBAAA,2DACA,CAEA,6DACE,kBAAA,UACA,WACA,YACA,kBACA,sBACA,kBACA,uBACA,aACA,8BACA,0BAAA,eACA,yBACA,sBAAA,qBAAA,iBAAA,WACA,kBACA,aAAA,CAEA,wFACE,eAAA,eACA,CAEJ,sDACE,WAAA,OAAA,gBACA,gBACA,iBACA,CAEA,8JAEE,eAAA,gBACA,uBCrGJ,gBAGE,kBACA,CDoGoC,yCAGpC,2GACE,eAAA,CAEA,2JACE,YAAA,CEQL,CFLD,sGAEE,cAAA,CAEF,mDACE,iBAAA,CAEF,mDACE,gBAAA,CAEoC,yCAEpC,mDACE,cAAA,CEOH,CACF","file":"classic.styl","sourcesContent":["@require '~shared/styles/mixins'\n\n.overlay\n.overlay-bottom\n  z-index 120\n  position absolute\n  left 0\n  right 0\n  bottom 0\n  display flex\n  color white\n\n  .title\n    width calc(100% - 180px)\n    margin-left 90px\n    margin-right 90px\n    padding 0\n    font-weight -wix-fonts-titleFont-weight\n    font-style -wix-fonts-titleFont-style\n    font-family -wix-fonts-titleFont-family\n    text-decoration -wix-fonts-titleFont-decoration\n    font-size -wix-fonts-titleFont-size\n\n    + .publisher\n      margin-top 10px\n\n    .preview-text\n      font-size 14px\n      margin-left 10px\n\n  .publisher\n    width 100%\n    padding-left 95px\n    padding-right 95px\n    font-weight -wix-fonts-textFont-weight\n    font-style -wix-fonts-textFont-style\n    font-family -wix-fonts-textFont-family\n    text-decoration -wix-fonts-textFont-decoration\n    font-size 18px\n    line-height 24px\n    text-overflow()\n\n  .buttons\n    &:not(:first-child)\n      margin-top 36px\n\n    .button\n      margin 0 8px 0 7px\n\n.overlay .title .preview-text\n  display none\n\n.overlay\n  top 0\n  flex-direction column\n  flex-wrap wrap\n  justify-content center\n  align-items stretch\n  color white\n  text-align center\n\n.overlay-bottom\n  position absolute\n  left 0\n  right 0\n  bottom 0\n  height 183px\n  display flex\n  box-sizing border-box\n  padding 61px 30px 0 30px\n  align-items center\n  background linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);\n\n  .play-button\n    margin-right 30px\n    padding 0\n    width 60px\n    height 60px\n    border-radius 50%\n    border 1px solid white\n    text-align center\n    background transparent\n    outline none\n    touch-action manipulation\n    cursor pointer\n    user-select none\n    color white\n    flex 0 0 auto\n\n    .play-icon\n      font-size 22px\n      margin-left 5px\n\n  .info\n    flex 1\n    text-align left\n    overflow hidden\n    margin-right 40px\n\n    .title\n    .publisher\n      padding-left 0\n      padding-right 0\n      text-overflow()\n\n@media only screen and (max-width: 320px)\n  .overlay\n  .overlay-bottom\n    .buttons\n      margin-top 25px\n\n      .button\n        margin 0 5px\n\n.button\n  .play-icon\n  .next-icon\n    font-size 14px\n\n  .play-icon\n    margin-right 11px\n\n  .next-icon\n    margin-left 11px\n\n@media only screen and (max-width: 320px)\n  .button\n    .play-icon\n      font-size 10px\n","text-overflow(type = ellipsis)\n  text-overflow type\n\n  if type == ellipsis\n    overflow hidden\n    white-space nowrap\n",".overlay,\n.overlay-bottom {\n  z-index: 120;\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  color: #fff;\n}\n.overlay .title,\n.overlay-bottom .title {\n  width: calc(100% - 180px);\n  margin-left: 90px;\n  margin-right: 90px;\n  padding: 0;\n  font-weight: -wix-fonts-titleFont-weight;\n  font-style: -wix-fonts-titleFont-style;\n  font-family: -wix-fonts-titleFont-family;\n  text-decoration: -wix-fonts-titleFont-decoration;\n  font-size: -wix-fonts-titleFont-size;\n}\n.overlay .title + .publisher,\n.overlay-bottom .title + .publisher {\n  margin-top: 10px;\n}\n.overlay .title .preview-text,\n.overlay-bottom .title .preview-text {\n  font-size: 14px;\n  margin-left: 10px;\n}\n.overlay .publisher,\n.overlay-bottom .publisher {\n  width: 100%;\n  padding-left: 95px;\n  padding-right: 95px;\n  font-weight: -wix-fonts-textFont-weight;\n  font-style: -wix-fonts-textFont-style;\n  font-family: -wix-fonts-textFont-family;\n  text-decoration: -wix-fonts-textFont-decoration;\n  font-size: 18px;\n  line-height: 24px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.overlay .buttons:not(:first-child),\n.overlay-bottom .buttons:not(:first-child) {\n  margin-top: 36px;\n}\n.overlay .buttons .button,\n.overlay-bottom .buttons .button {\n  margin: 0 8px 0 7px;\n}\n.overlay .title .preview-text {\n  display: none;\n}\n.overlay {\n  top: 0;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: stretch;\n  color: #fff;\n  text-align: center;\n}\n.overlay-bottom {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 183px;\n  display: flex;\n  box-sizing: border-box;\n  padding: 61px 30px 0 30px;\n  align-items: center;\n  background: linear-gradient(0deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0) 100%);\n}\n.overlay-bottom .play-button {\n  margin-right: 30px;\n  padding: 0;\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  border: 1px solid #fff;\n  text-align: center;\n  background: transparent;\n  outline: none;\n  touch-action: manipulation;\n  cursor: pointer;\n  user-select: none;\n  color: #fff;\n  flex: 0 0 auto;\n}\n.overlay-bottom .play-button .play-icon {\n  font-size: 22px;\n  margin-left: 5px;\n}\n.overlay-bottom .info {\n  flex: 1;\n  text-align: left;\n  overflow: hidden;\n  margin-right: 40px;\n}\n.overlay-bottom .info .title,\n.overlay-bottom .info .publisher {\n  padding-left: 0;\n  padding-right: 0;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n@media only screen and (max-width: 320px) {\n  .overlay .buttons,\n  .overlay-bottom .buttons {\n    margin-top: 25px;\n  }\n  .overlay .buttons .button,\n  .overlay-bottom .buttons .button {\n    margin: 0 5px;\n  }\n}\n.button .play-icon,\n.button .next-icon {\n  font-size: 14px;\n}\n.button .play-icon {\n  margin-right: 11px;\n}\n.button .next-icon {\n  margin-left: 11px;\n}\n@media only screen and (max-width: 320px) {\n  .button .play-icon {\n    font-size: 10px;\n  }\n}\n/*# sourceMappingURL=src/widget/components/player-overlay/classic/classic.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"overlay": "classic__overlay__2yQY8",
	"overlay-bottom": "classic__overlay-bottom__3i5r5",
	"overlayBottom": "classic__overlay-bottom__3i5r5",
	"title": "classic__title__31O8o",
	"publisher": "classic__publisher__3rh6X",
	"preview-text": "classic__preview-text__2tIBi",
	"previewText": "classic__preview-text__2tIBi",
	"buttons": "classic__buttons__3UyyT",
	"button": "classic__button__3HMCZ",
	"play-button": "classic__play-button__2QHTJ",
	"playButton": "classic__play-button__2QHTJ",
	"play-icon": "classic__play-icon__2yBDd",
	"playIcon": "classic__play-icon__2yBDd",
	"info": "classic__info__k75sW",
	"next-icon": "classic__next-icon__3btb8",
	"nextIcon": "classic__next-icon__3btb8"
};

/***/ }),

/***/ 1973:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, ".member-only__overlay__LCmbA,.member-only__overlay-bottom__dZ6dm{z-index:120;position:absolute;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;color:#fff}.member-only__overlay-bottom__dZ6dm .member-only__title__1qOy6,.member-only__overlay__LCmbA .member-only__title__1qOy6{width:calc(100% - 180px);margin-left:90px;margin-right:90px;padding:0;font-weight:-wix-fonts-titleFont-weight;font-style:-wix-fonts-titleFont-style;font-family:-wix-fonts-titleFont-family;text-decoration:-wix-fonts-titleFont-decoration;font-size:-wix-fonts-titleFont-size}.member-only__overlay-bottom__dZ6dm .member-only__title__1qOy6+.member-only__publisher___ZYs8,.member-only__overlay__LCmbA .member-only__title__1qOy6+.member-only__publisher___ZYs8{margin-top:10px}.member-only__overlay-bottom__dZ6dm .member-only__title__1qOy6 .member-only__preview-text__1AZgr,.member-only__overlay__LCmbA .member-only__title__1qOy6 .member-only__preview-text__1AZgr{font-size:14px;margin-left:10px}.member-only__overlay-bottom__dZ6dm .member-only__publisher___ZYs8,.member-only__overlay__LCmbA .member-only__publisher___ZYs8{width:100%;padding-left:95px;padding-right:95px;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;font-size:18px;line-height:24px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.member-only__overlay-bottom__dZ6dm .member-only__buttons__3Mwj7:not(:first-child),.member-only__overlay__LCmbA .member-only__buttons__3Mwj7:not(:first-child){margin-top:36px}.member-only__overlay-bottom__dZ6dm .member-only__buttons__3Mwj7 .member-only__button__1CgYY,.member-only__overlay__LCmbA .member-only__buttons__3Mwj7 .member-only__button__1CgYY{margin:0 8px 0 7px}.member-only__overlay__LCmbA .member-only__title__1qOy6 .member-only__preview-text__1AZgr{display:none}.member-only__overlay__LCmbA{top:0;-ms-flex-direction:column;flex-direction:column;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:center;justify-content:center;-ms-flex-align:stretch;align-items:stretch;color:#fff;text-align:center}.member-only__overlay-bottom__dZ6dm{position:absolute;left:0;right:0;bottom:0;height:183px;display:-ms-flexbox;display:flex;box-sizing:border-box;padding:61px 30px 0;-ms-flex-align:center;align-items:center;background:linear-gradient(0deg,rgba(0,0,0,.5),transparent)}.member-only__overlay-bottom__dZ6dm .member-only__play-button__2hhbB{margin-right:30px;padding:0;width:60px;height:60px;border-radius:50%;border:1px solid #fff;text-align:center;background:transparent;outline:none;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#fff;-ms-flex:0 0 auto;flex:0 0 auto}.member-only__overlay-bottom__dZ6dm .member-only__play-button__2hhbB .member-only__play-icon__jvNCn{font-size:22px;margin-left:5px}.member-only__overlay-bottom__dZ6dm .member-only__info__2RYGB{-ms-flex:1;flex:1;text-align:left;overflow:hidden;margin-right:40px}.member-only__overlay-bottom__dZ6dm .member-only__info__2RYGB .member-only__publisher___ZYs8,.member-only__overlay-bottom__dZ6dm .member-only__info__2RYGB .member-only__title__1qOy6{padding-left:0;padding-right:0;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}@media only screen and (max-width:320px){.member-only__overlay-bottom__dZ6dm .member-only__buttons__3Mwj7,.member-only__overlay__LCmbA .member-only__buttons__3Mwj7{margin-top:25px}.member-only__overlay-bottom__dZ6dm .member-only__buttons__3Mwj7 .member-only__button__1CgYY,.member-only__overlay__LCmbA .member-only__buttons__3Mwj7 .member-only__button__1CgYY{margin:0 5px}}.member-only__button__1CgYY .member-only__next-icon__2sNTd,.member-only__button__1CgYY .member-only__play-icon__jvNCn{font-size:14px}.member-only__button__1CgYY .member-only__play-icon__jvNCn{margin-right:11px}.member-only__button__1CgYY .member-only__next-icon__2sNTd{margin-left:11px}@media only screen and (max-width:320px){.member-only__button__1CgYY .member-only__play-icon__jvNCn{font-size:10px}}.member-only__wrapper__2Nx5p{display:-ms-flexbox;display:flex;position:relative;background-color:#000}.member-only__overlay__LCmbA{position:relative;height:100%}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/player-overlay/classic/src/widget/components/player-overlay/classic/classic.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/player-overlay/classic/src/shared/styles/mixins/text-overflow.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/player-overlay/classic/member-only.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/player-overlay/classic/src/widget/components/player-overlay/classic/member-only.styl"],"names":[],"mappings":"AAEA,iEAEE,YAAA,kBACA,OACA,QACA,SACA,oBACA,aAAA,UACA,CAEA,uHACE,yBAAA,iBACA,kBACA,UACA,wCACA,sCACA,wCACA,gDACA,mCACA,CAEA,qLACE,eAAA,CAEF,2LACE,eAAA,gBACA,CAEJ,+HACE,WAAA,kBACA,mBACA,uCACA,qCACA,uCACA,+CACA,eACA,iBACA,uBCtCF,gBAGE,kBACA,CDsCA,+JACE,eAAA,CAEF,mLACE,kBAAA,CAEN,0FACE,YAAA,CAEF,6BACE,MAAA,0BACA,sBAAA,mBACA,eAAA,qBACA,uBAAA,uBACA,oBAAA,WACA,iBACA,CAEF,oCACE,kBAAA,OACA,QACA,SACA,aACA,oBACA,aAAA,sBACA,oBACA,sBACA,mBAAA,2DACA,CAEA,qEACE,kBAAA,UACA,WACA,YACA,kBACA,sBACA,kBACA,uBACA,aACA,8BACA,0BAAA,eACA,yBACA,sBAAA,qBAAA,iBAAA,WACA,kBACA,aAAA,CAEA,oGACE,eAAA,eACA,CAEJ,8DACE,WAAA,OAAA,gBACA,gBACA,iBACA,CAEA,sLAEE,eAAA,gBACA,uBCrGJ,gBAGE,kBACA,CDoGoC,yCAGpC,2HACE,eAAA,CAEA,mLACE,YAAA,CEQL,CFLD,sHAEE,cAAA,CAEF,2DACE,iBAAA,CAEF,2DACE,gBAAA,CAEoC,yCAEpC,2DACE,cAAA,CEOH,CACF,6BCrIC,oBAAA,aAAA,kBACA,qBACA,CDwID,6BCrIC,kBAAA,WACA,CDwID","file":"member-only.styl","sourcesContent":["@require '~shared/styles/mixins'\n\n.overlay\n.overlay-bottom\n  z-index 120\n  position absolute\n  left 0\n  right 0\n  bottom 0\n  display flex\n  color white\n\n  .title\n    width calc(100% - 180px)\n    margin-left 90px\n    margin-right 90px\n    padding 0\n    font-weight -wix-fonts-titleFont-weight\n    font-style -wix-fonts-titleFont-style\n    font-family -wix-fonts-titleFont-family\n    text-decoration -wix-fonts-titleFont-decoration\n    font-size -wix-fonts-titleFont-size\n\n    + .publisher\n      margin-top 10px\n\n    .preview-text\n      font-size 14px\n      margin-left 10px\n\n  .publisher\n    width 100%\n    padding-left 95px\n    padding-right 95px\n    font-weight -wix-fonts-textFont-weight\n    font-style -wix-fonts-textFont-style\n    font-family -wix-fonts-textFont-family\n    text-decoration -wix-fonts-textFont-decoration\n    font-size 18px\n    line-height 24px\n    text-overflow()\n\n  .buttons\n    &:not(:first-child)\n      margin-top 36px\n\n    .button\n      margin 0 8px 0 7px\n\n.overlay .title .preview-text\n  display none\n\n.overlay\n  top 0\n  flex-direction column\n  flex-wrap wrap\n  justify-content center\n  align-items stretch\n  color white\n  text-align center\n\n.overlay-bottom\n  position absolute\n  left 0\n  right 0\n  bottom 0\n  height 183px\n  display flex\n  box-sizing border-box\n  padding 61px 30px 0 30px\n  align-items center\n  background linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);\n\n  .play-button\n    margin-right 30px\n    padding 0\n    width 60px\n    height 60px\n    border-radius 50%\n    border 1px solid white\n    text-align center\n    background transparent\n    outline none\n    touch-action manipulation\n    cursor pointer\n    user-select none\n    color white\n    flex 0 0 auto\n\n    .play-icon\n      font-size 22px\n      margin-left 5px\n\n  .info\n    flex 1\n    text-align left\n    overflow hidden\n    margin-right 40px\n\n    .title\n    .publisher\n      padding-left 0\n      padding-right 0\n      text-overflow()\n\n@media only screen and (max-width: 320px)\n  .overlay\n  .overlay-bottom\n    .buttons\n      margin-top 25px\n\n      .button\n        margin 0 5px\n\n.button\n  .play-icon\n  .next-icon\n    font-size 14px\n\n  .play-icon\n    margin-right 11px\n\n  .next-icon\n    margin-left 11px\n\n@media only screen and (max-width: 320px)\n  .button\n    .play-icon\n      font-size 10px\n","text-overflow(type = ellipsis)\n  text-overflow type\n\n  if type == ellipsis\n    overflow hidden\n    white-space nowrap\n",".overlay,\n.overlay-bottom {\n  z-index: 120;\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  color: #fff;\n}\n.overlay .title,\n.overlay-bottom .title {\n  width: calc(100% - 180px);\n  margin-left: 90px;\n  margin-right: 90px;\n  padding: 0;\n  font-weight: -wix-fonts-titleFont-weight;\n  font-style: -wix-fonts-titleFont-style;\n  font-family: -wix-fonts-titleFont-family;\n  text-decoration: -wix-fonts-titleFont-decoration;\n  font-size: -wix-fonts-titleFont-size;\n}\n.overlay .title + .publisher,\n.overlay-bottom .title + .publisher {\n  margin-top: 10px;\n}\n.overlay .title .preview-text,\n.overlay-bottom .title .preview-text {\n  font-size: 14px;\n  margin-left: 10px;\n}\n.overlay .publisher,\n.overlay-bottom .publisher {\n  width: 100%;\n  padding-left: 95px;\n  padding-right: 95px;\n  font-weight: -wix-fonts-textFont-weight;\n  font-style: -wix-fonts-textFont-style;\n  font-family: -wix-fonts-textFont-family;\n  text-decoration: -wix-fonts-textFont-decoration;\n  font-size: 18px;\n  line-height: 24px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.overlay .buttons:not(:first-child),\n.overlay-bottom .buttons:not(:first-child) {\n  margin-top: 36px;\n}\n.overlay .buttons .button,\n.overlay-bottom .buttons .button {\n  margin: 0 8px 0 7px;\n}\n.overlay .title .preview-text {\n  display: none;\n}\n.overlay {\n  top: 0;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: stretch;\n  color: #fff;\n  text-align: center;\n}\n.overlay-bottom {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 183px;\n  display: flex;\n  box-sizing: border-box;\n  padding: 61px 30px 0 30px;\n  align-items: center;\n  background: linear-gradient(0deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0) 100%);\n}\n.overlay-bottom .play-button {\n  margin-right: 30px;\n  padding: 0;\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  border: 1px solid #fff;\n  text-align: center;\n  background: transparent;\n  outline: none;\n  touch-action: manipulation;\n  cursor: pointer;\n  user-select: none;\n  color: #fff;\n  flex: 0 0 auto;\n}\n.overlay-bottom .play-button .play-icon {\n  font-size: 22px;\n  margin-left: 5px;\n}\n.overlay-bottom .info {\n  flex: 1;\n  text-align: left;\n  overflow: hidden;\n  margin-right: 40px;\n}\n.overlay-bottom .info .title,\n.overlay-bottom .info .publisher {\n  padding-left: 0;\n  padding-right: 0;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n@media only screen and (max-width: 320px) {\n  .overlay .buttons,\n  .overlay-bottom .buttons {\n    margin-top: 25px;\n  }\n  .overlay .buttons .button,\n  .overlay-bottom .buttons .button {\n    margin: 0 5px;\n  }\n}\n.button .play-icon,\n.button .next-icon {\n  font-size: 14px;\n}\n.button .play-icon {\n  margin-right: 11px;\n}\n.button .next-icon {\n  margin-left: 11px;\n}\n@media only screen and (max-width: 320px) {\n  .button .play-icon {\n    font-size: 10px;\n  }\n}\n.wrapper {\n  display: flex;\n  position: relative;\n  background-color: #000;\n}\n.overlay {\n  position: relative;\n  height: 100%;\n}\n/*# sourceMappingURL=src/widget/components/player-overlay/classic/member-only.css.map */","@import '~widget/components/player-overlay/classic/classic.styl'\n\n.wrapper\n  display flex\n  position relative\n  background-color black\n\n.overlay\n  position relative\n  height 100%\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"overlay": "member-only__overlay__LCmbA",
	"overlay-bottom": "member-only__overlay-bottom__dZ6dm",
	"overlayBottom": "member-only__overlay-bottom__dZ6dm",
	"title": "member-only__title__1qOy6",
	"publisher": "member-only__publisher___ZYs8",
	"preview-text": "member-only__preview-text__1AZgr",
	"previewText": "member-only__preview-text__1AZgr",
	"buttons": "member-only__buttons__3Mwj7",
	"button": "member-only__button__1CgYY",
	"play-button": "member-only__play-button__2hhbB",
	"playButton": "member-only__play-button__2hhbB",
	"play-icon": "member-only__play-icon__jvNCn",
	"playIcon": "member-only__play-icon__jvNCn",
	"info": "member-only__info__2RYGB",
	"next-icon": "member-only__next-icon__2sNTd",
	"nextIcon": "member-only__next-icon__2sNTd",
	"wrapper": "member-only__wrapper__2Nx5p"
};

/***/ }),

/***/ 1976:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, ".bottom-buttons__bottom-button__be5nU{background-color:rgba(0,0,0,.2);border:1px solid #fff;border-radius:0;height:38px;font-size:12px;color:#fff}.bottom-buttons__bottom-button__be5nU+.bottom-buttons__bottom-button__be5nU{border-left:none}.bottom-buttons__paid-icon__2LM3h{margin-right:5px;font-size:14px}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/player-overlay/mobile/three-rows-widget/buttons/src/widget/components/player-overlay/mobile/three-rows-widget/buttons/bottom-buttons.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/player-overlay/mobile/three-rows-widget/buttons/bottom-buttons.styl"],"names":[],"mappings":"AAEA,sCACE,gCAAA,sBACA,gBACA,YACA,eACA,UACA,CAEA,4EACE,gBAAA,CAEJ,kCACE,iBAAA,cACA,CCDD","file":"bottom-buttons.styl","sourcesContent":["@require '~shared/styles/mixins'\n\n.bottom-button\n  background-color rgba(0, 0, 0, 0.2)\n  border solid 1px #ffffff\n  border-radius 0\n  height 38px\n  font-size 12px\n  color #ffffff\n\n  & + .bottom-button\n    border-left none\n\n.paid-icon\n  margin-right 5px\n  font-size 14px\n",".bottom-button {\n  background-color: rgba(0,0,0,0.2);\n  border: solid 1px #fff;\n  border-radius: 0;\n  height: 38px;\n  font-size: 12px;\n  color: #fff;\n}\n.bottom-button + .bottom-button {\n  border-left: none;\n}\n.paid-icon {\n  margin-right: 5px;\n  font-size: 14px;\n}\n/*# sourceMappingURL=src/widget/components/player-overlay/mobile/three-rows-widget/buttons/bottom-buttons.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"bottom-button": "bottom-buttons__bottom-button__be5nU",
	"bottomButton": "bottom-buttons__bottom-button__be5nU",
	"paid-icon": "bottom-buttons__paid-icon__2LM3h",
	"paidIcon": "bottom-buttons__paid-icon__2LM3h"
};

/***/ }),

/***/ 1977:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, ".middle-buttons__play__3JrgR,.middle-buttons__purchase__40Ju-{overflow:hidden;height:auto;padding:0;border-radius:0;border:none;font-size:14px;color:#fff}.middle-buttons__icon__3ryEt{width:30px;height:30px;border-width:2px;border-color:#fff;margin-right:7px}.middle-buttons__play-icon__Oo-HK:before{transform:scale(.8);left:2px;position:relative}.middle-buttons__text__3QiaB{width:100%;border-bottom:1px solid #fff;line-height:normal;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.middle-buttons__purchase__40Ju- .middle-buttons__text__3QiaB{display:inline-block}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/player-overlay/mobile/three-rows-widget/buttons/src/widget/components/player-overlay/mobile/three-rows-widget/buttons/middle-buttons.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/player-overlay/mobile/three-rows-widget/buttons/src/shared/styles/mixins/text-overflow.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/player-overlay/mobile/three-rows-widget/buttons/middle-buttons.styl"],"names":[],"mappings":"AAEA,8DAEE,gBAAA,YACA,UACA,gBACA,YACA,eACA,UACA,CAEF,6BACE,WAAA,YACA,iBACA,kBACA,gBACA,CAGA,yCACE,oBAAA,SACA,iBACA,CAEJ,6BACE,WAAA,6BACA,mBACA,uBC3BA,gBAGE,kBACA,CD0BJ,8DACE,oBAAA,CEAD","file":"middle-buttons.styl","sourcesContent":["@require '~shared/styles/mixins'\n\n.play\n.purchase\n  overflow hidden\n  height auto\n  padding 0\n  border-radius 0\n  border none\n  font-size 14px\n  color white\n\n.icon\n  width 30px\n  height 30px\n  border-width 2px\n  border-color white\n  margin-right 7px\n\n.play-icon\n  &:before\n    transform scale(0.8)\n    left 2px\n    position relative\n\n.text\n  width 100%\n  border-bottom 1px solid white\n  line-height normal\n  text-overflow()\n\n.purchase .text\n  display inline-block\n","text-overflow(type = ellipsis)\n  text-overflow type\n\n  if type == ellipsis\n    overflow hidden\n    white-space nowrap\n",".play,\n.purchase {\n  overflow: hidden;\n  height: auto;\n  padding: 0;\n  border-radius: 0;\n  border: none;\n  font-size: 14px;\n  color: #fff;\n}\n.icon {\n  width: 30px;\n  height: 30px;\n  border-width: 2px;\n  border-color: #fff;\n  margin-right: 7px;\n}\n.play-icon:before {\n  transform: scale(0.8);\n  left: 2px;\n  position: relative;\n}\n.text {\n  width: 100%;\n  border-bottom: 1px solid #fff;\n  line-height: normal;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.purchase .text {\n  display: inline-block;\n}\n/*# sourceMappingURL=src/widget/components/player-overlay/mobile/three-rows-widget/buttons/middle-buttons.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"play": "middle-buttons__play__3JrgR",
	"purchase": "middle-buttons__purchase__40Ju-",
	"icon": "middle-buttons__icon__3ryEt",
	"play-icon": "middle-buttons__play-icon__Oo-HK",
	"playIcon": "middle-buttons__play-icon__Oo-HK",
	"text": "middle-buttons__text__3QiaB"
};

/***/ }),

/***/ 1978:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, ".three-rows-widget__overlay__znYzv{-ms-flex-pack:justify;justify-content:space-between;padding:0 20px;background-color:rgba(0,0,0,.4)}.three-rows-widget__main__2_JJ_,.three-rows-widget__overlay__znYzv{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center}.three-rows-widget__main__2_JJ_{width:100%;-ms-flex-positive:1;flex-grow:1;-ms-flex-pack:center;justify-content:center}.three-rows-widget__play-container__1avGK{width:100%;text-align:center;overflow:hidden}.three-rows-widget__title__pAPcg+.three-rows-widget__play-container__1avGK{margin-top:10px}.three-rows-widget__title__pAPcg{text-align:center;width:100%}.three-rows-widget__title-text__4WcOj{width:150px;font-size:22px;color:#fff;white-space:normal}.three-rows-widget__buttons__1A-PL{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;width:100%;margin-bottom:25px}.three-rows-widget__bottom-button__2EZIk{-ms-flex:1 1 100%;flex:1 1 100%;max-width:50%}.three-rows-widget__single__1gMwO .three-rows-widget__bottom-button__2EZIk{-ms-flex:0 1 auto;flex:0 1 auto;max-width:100%;min-width:calc(50% + 20px)}.three-rows-widget__rounded__2OqRg .three-rows-widget__bottom-button__2EZIk:first-child{border-top-left-radius:6px;border-bottom-left-radius:6px}.three-rows-widget__rounded__2OqRg .three-rows-widget__bottom-button__2EZIk:last-child{border-top-right-radius:6px;border-bottom-right-radius:6px}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/player-overlay/mobile/three-rows-widget/src/widget/components/player-overlay/mobile/three-rows-widget/three-rows-widget.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/player-overlay/mobile/three-rows-widget/three-rows-widget.styl"],"names":[],"mappings":"AAEA,mCAIE,sBAAA,8BAAA,eACA,+BACA,CAEF,mEAPE,oBAAA,aAAA,0BACA,sBAAA,sBACA,kBAAA,CAKF,gCACE,WAAA,oBAEA,YAAA,qBAEA,sBAAA,CAGF,0CACE,WAAA,kBACA,eACA,CAEF,2EACE,eAAA,CAEF,iCACE,kBAAA,UACA,CAEF,sCACE,YAAA,eACA,WACA,kBACA,CAEF,mCACE,oBAAA,aAAA,qBACA,uBAAA,WACA,kBACA,CAEF,yCACE,kBAAA,cAAA,aACA,CAGA,2EACE,kBAAA,cAAA,eACA,0BACA,CAMA,wFACE,2BAAA,6BACA,CAEF,uFACE,4BAAA,8BACA,CCNL","file":"three-rows-widget.styl","sourcesContent":["@require '~shared/styles/mixins'\n\n.overlay\n  display flex\n  flex-direction column\n  align-items center\n  justify-content space-between\n  padding 0 20px\n  background-color rgba(0, 0, 0, 0.4)\n\n.main\n  width 100%\n  display flex\n  flex-grow 1\n  flex-direction column\n  justify-content center\n  align-items center\n\n.play-container\n  width 100%\n  text-align center\n  overflow hidden\n\n.title + .play-container\n  margin-top 10px\n\n.title\n  text-align center\n  width 100%\n\n.title-text\n  width 150px\n  font-size 22px\n  color white\n  white-space normal\n\n.buttons\n  display flex\n  justify-content center\n  width 100%\n  margin-bottom 25px\n\n.bottom-button\n  flex 1 1 100%\n  max-width 50%\n\n.single\n  .bottom-button\n    flex 0 1 auto\n    max-width 100%\n    min-width calc(50% + 20px)\n\n.rounded\n  border-radius = 6px\n\n  .bottom-button\n    &:first-child\n      border-top-left-radius border-radius\n      border-bottom-left-radius border-radius\n\n    &:last-child\n      border-top-right-radius border-radius\n      border-bottom-right-radius border-radius\n",".overlay {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 20px;\n  background-color: rgba(0,0,0,0.4);\n}\n.main {\n  width: 100%;\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.play-container {\n  width: 100%;\n  text-align: center;\n  overflow: hidden;\n}\n.title + .play-container {\n  margin-top: 10px;\n}\n.title {\n  text-align: center;\n  width: 100%;\n}\n.title-text {\n  width: 150px;\n  font-size: 22px;\n  color: #fff;\n  white-space: normal;\n}\n.buttons {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  margin-bottom: 25px;\n}\n.bottom-button {\n  flex: 1 1 100%;\n  max-width: 50%;\n}\n.single .bottom-button {\n  flex: 0 1 auto;\n  max-width: 100%;\n  min-width: calc(50% + 20px);\n}\n.rounded .bottom-button:first-child {\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n.rounded .bottom-button:last-child {\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n/*# sourceMappingURL=src/widget/components/player-overlay/mobile/three-rows-widget/three-rows-widget.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"overlay": "three-rows-widget__overlay__znYzv",
	"main": "three-rows-widget__main__2_JJ_",
	"play-container": "three-rows-widget__play-container__1avGK",
	"playContainer": "three-rows-widget__play-container__1avGK",
	"title": "three-rows-widget__title__pAPcg",
	"title-text": "three-rows-widget__title-text__4WcOj",
	"titleText": "three-rows-widget__title-text__4WcOj",
	"buttons": "three-rows-widget__buttons__1A-PL",
	"bottom-button": "three-rows-widget__bottom-button__2EZIk",
	"bottomButton": "three-rows-widget__bottom-button__2EZIk",
	"single": "three-rows-widget__single__1gMwO",
	"rounded": "three-rows-widget__rounded__2OqRg"
};

/***/ }),

/***/ 1981:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, ".first-time-track-animation__start-animation__25iS1{position:relative;animation:first-time-track-animation__reveal-swipe-option__24hd1 1.3s}@keyframes first-time-track-animation__reveal-swipe-option__24hd1{0%,to{animation-timing-function:ease-out;left:0}85%{animation-timing-function:linear;left:-60px}}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/players-list-slidable/src/widget/components/players-list-slidable/first-time-track-animation.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/players-list-slidable/first-time-track-animation.styl"],"names":[],"mappings":"AAQA,oDACE,kBAAA,qEACA,CAVS,kEACT,MACE,mCAAA,MACA,CACF,IACE,iCAAA,UACA,CCoCD,CACF","file":"first-time-track-animation.styl","sourcesContent":["@keyframes reveal-swipe-option\n  0%, 100%\n    animation-timing-function ease-out\n    left 0\n  85%\n    animation-timing-function linear\n    left -60px\n\n.start-animation\n  position relative\n  animation reveal-swipe-option 1.3s\n",".start-animation {\n  position: relative;\n  animation: reveal-swipe-option 1.3s;\n}\n@-moz-keyframes reveal-swipe-option {\n  0%, 100% {\n    animation-timing-function: ease-out;\n    left: 0;\n  }\n  85% {\n    animation-timing-function: linear;\n    left: -60px;\n  }\n}\n@-webkit-keyframes reveal-swipe-option {\n  0%, 100% {\n    animation-timing-function: ease-out;\n    left: 0;\n  }\n  85% {\n    animation-timing-function: linear;\n    left: -60px;\n  }\n}\n@-o-keyframes reveal-swipe-option {\n  0%, 100% {\n    animation-timing-function: ease-out;\n    left: 0;\n  }\n  85% {\n    animation-timing-function: linear;\n    left: -60px;\n  }\n}\n@keyframes reveal-swipe-option {\n  0%, 100% {\n    animation-timing-function: ease-out;\n    left: 0;\n  }\n  85% {\n    animation-timing-function: linear;\n    left: -60px;\n  }\n}\n/*# sourceMappingURL=src/widget/components/players-list-slidable/first-time-track-animation.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"start-animation": "first-time-track-animation__start-animation__25iS1",
	"startAnimation": "first-time-track-animation__start-animation__25iS1",
	"reveal-swipe-option": "first-time-track-animation__reveal-swipe-option__24hd1",
	"revealSwipeOption": "first-time-track-animation__reveal-swipe-option__24hd1"
};

/***/ }),

/***/ 1982:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, ".players-list-slidable__slidable-overlay__1saH_{z-index:130}.players-list-slidable__slidable-overlay__1saH_,.players-list-slidable__video-overlay__b6hl6{position:absolute;top:0;left:0;right:0;bottom:0}.players-list-slidable__overlay-item-topmost__1kGpT{-ms-flex-negative:0;flex-shrink:0;position:relative}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/players-list-slidable/src/widget/components/players-list-slidable/players-list-slidable.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/players-list-slidable/src/shared/styles/mixins/position-zeros.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/players-list-slidable/players-list-slidable.styl"],"names":[],"mappings":"AAEA,gDAEE,WAAA,CAEF,6FCLE,kBAAA,MACA,OACA,QACA,QACA,CDIF,oDACE,oBAAA,cAAA,iBACA,CEOD","file":"players-list-slidable.styl","sourcesContent":["@require '~shared/styles/mixins'\n\n.slidable-overlay\n  position-zeros()\n  z-index 130\n\n.video-overlay\n  position-zeros()\n\n.overlay-item-topmost\n  flex-shrink 0\n  position relative\n","position-zeros(position = absolute)\n  position position\n  top 0\n  left 0\n  right 0\n  bottom 0\n",".slidable-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 130;\n}\n.video-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n.overlay-item-topmost {\n  flex-shrink: 0;\n  position: relative;\n}\n/*# sourceMappingURL=src/widget/components/players-list-slidable/players-list-slidable.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"slidable-overlay": "players-list-slidable__slidable-overlay__1saH_",
	"slidableOverlay": "players-list-slidable__slidable-overlay__1saH_",
	"video-overlay": "players-list-slidable__video-overlay__b6hl6",
	"videoOverlay": "players-list-slidable__video-overlay__b6hl6",
	"overlay-item-topmost": "players-list-slidable__overlay-item-topmost__1kGpT",
	"overlayItemTopmost": "players-list-slidable__overlay-item-topmost__1kGpT"
};

/***/ }),

/***/ 1984:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, ".classic-search-bar__container__3k3EG{position:relative;transition:width .2s}.classic-search-bar__container__3k3EG.classic-search-bar__focused__3Y_-G .classic-search-bar__input__1Waxq,.classic-search-bar__container__3k3EG.classic-search-bar__focused__3Y_-G .classic-search-bar__input__1Waxq:hover,.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__input__1Waxq,.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__input__1Waxq:hover{outline:none;box-shadow:none;background-color:-wix-colors-textColor-10;padding:0 38px}.classic-search-bar__container__3k3EG.classic-search-bar__focused__3Y_-G .classic-search-bar__input__1Waxq::-webkit-input-placeholder,.classic-search-bar__container__3k3EG.classic-search-bar__focused__3Y_-G .classic-search-bar__input__1Waxq:hover::-webkit-input-placeholder,.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__input__1Waxq::-webkit-input-placeholder,.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__input__1Waxq:hover::-webkit-input-placeholder{color:-wix-colors-textColor-70}.classic-search-bar__container__3k3EG.classic-search-bar__focused__3Y_-G .classic-search-bar__input__1Waxq:-ms-input-placeholder,.classic-search-bar__container__3k3EG.classic-search-bar__focused__3Y_-G .classic-search-bar__input__1Waxq:hover:-ms-input-placeholder,.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__input__1Waxq:-ms-input-placeholder,.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__input__1Waxq:hover:-ms-input-placeholder{color:-wix-colors-textColor-70}.classic-search-bar__container__3k3EG.classic-search-bar__focused__3Y_-G .classic-search-bar__input__1Waxq::placeholder,.classic-search-bar__container__3k3EG.classic-search-bar__focused__3Y_-G .classic-search-bar__input__1Waxq:hover::placeholder,.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__input__1Waxq::placeholder,.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__input__1Waxq:hover::placeholder{color:-wix-colors-textColor-70}.classic-search-bar__container__3k3EG.classic-search-bar__focused__3Y_-G .classic-search-bar__input__1Waxq::-moz-selection,.classic-search-bar__container__3k3EG.classic-search-bar__focused__3Y_-G .classic-search-bar__input__1Waxq:hover::-moz-selection,.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__input__1Waxq::-moz-selection,.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__input__1Waxq:hover::-moz-selection{background-color:-wix-colors-textColor-20}.classic-search-bar__container__3k3EG.classic-search-bar__focused__3Y_-G .classic-search-bar__input__1Waxq::selection,.classic-search-bar__container__3k3EG.classic-search-bar__focused__3Y_-G .classic-search-bar__input__1Waxq:hover::selection,.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__input__1Waxq::selection,.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__input__1Waxq:hover::selection{background-color:-wix-colors-textColor-20}.classic-search-bar__container__3k3EG.classic-search-bar__focused__3Y_-G .classic-search-bar__search-icon__2PWlq,.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__search-icon__2PWlq{left:12px}.classic-search-bar__container__3k3EG.classic-search-bar__focused__3Y_-G .classic-search-bar__close-search__2Mxjh,.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__close-search__2Mxjh{display:block}.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__input__1Waxq,.classic-search-bar__container__3k3EG.classic-search-bar__has-value__unZ14 .classic-search-bar__input__1Waxq{background-color:-wix-colors-textColor-10;padding:0 38px}.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__close-search__2Mxjh,.classic-search-bar__container__3k3EG.classic-search-bar__has-value__unZ14 .classic-search-bar__close-search__2Mxjh{display:block}.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__search-icon__2PWlq,.classic-search-bar__container__3k3EG.classic-search-bar__has-value__unZ14 .classic-search-bar__search-icon__2PWlq{left:12px}.classic-search-bar__container__3k3EG.classic-search-bar__changed__1qUCi .classic-search-bar__close-search__2Mxjh{display:none}.classic-search-bar__container__3k3EG.classic-search-bar__changed__1qUCi .classic-search-bar__permit-search__2ZoGw,.classic-search-bar__container__3k3EG.classic-search-bar__changed__1qUCi:not(.classic-search-bar__has-value__unZ14) .classic-search-bar__close-search__2Mxjh{display:block}.classic-search-bar__container__3k3EG.classic-search-bar__changed__1qUCi:not(.classic-search-bar__has-value__unZ14) .classic-search-bar__permit-search__2ZoGw{display:none}.classic-search-bar__container__3k3EG .classic-search-bar__close-search__2Mxjh,.classic-search-bar__container__3k3EG .classic-search-bar__permit-search__2ZoGw,.classic-search-bar__container__3k3EG .classic-search-bar__search-icon__2PWlq{position:absolute;top:0;line-height:42px;font-size:15px;color:-wix-colors-textColor}.classic-search-bar__container__3k3EG .classic-search-bar__search-icon__2PWlq{left:0;transition:left .2s}.classic-search-bar__container__3k3EG .classic-search-bar__close-search__2Mxjh,.classic-search-bar__container__3k3EG .classic-search-bar__permit-search__2ZoGw{display:none;right:14px;cursor:pointer}.classic-search-bar__container__3k3EG .classic-search-bar__background-text__3exoc,.classic-search-bar__container__3k3EG .classic-search-bar__input__1Waxq{border:none;background:transparent;outline:none;color:-wix-colors-textColor;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;width:100%;margin:0;line-height:42px;height:42px;padding:0 26px;box-sizing:border-box}.classic-search-bar__container__3k3EG .classic-search-bar__background-text__3exoc{white-space:nowrap;visibility:hidden}.classic-search-bar__container__3k3EG .classic-search-bar__input__1Waxq{top:0;left:0;right:0;bottom:0;position:absolute;transition:padding .2s,background .2s}.classic-search-bar__container__3k3EG .classic-search-bar__input__1Waxq:hover::-webkit-input-placeholder{color:-wix-colors-textColor}.classic-search-bar__container__3k3EG .classic-search-bar__input__1Waxq:hover:-ms-input-placeholder{color:-wix-colors-textColor}.classic-search-bar__container__3k3EG .classic-search-bar__input__1Waxq:hover::placeholder{color:-wix-colors-textColor}.classic-search-bar__container__3k3EG .classic-search-bar__input__1Waxq::-webkit-input-placeholder{color:-wix-colors-textColor-70;transition:color .2s}.classic-search-bar__container__3k3EG .classic-search-bar__input__1Waxq:-ms-input-placeholder{color:-wix-colors-textColor-70;transition:color .2s}.classic-search-bar__container__3k3EG .classic-search-bar__input__1Waxq::placeholder{color:-wix-colors-textColor-70;transition:color .2s}.classic-search-bar__container__3k3EG .classic-search-bar__input__1Waxq::-moz-selection{background-color:-wix-colors-textColor-10}.classic-search-bar__container__3k3EG .classic-search-bar__input__1Waxq::selection{background-color:-wix-colors-textColor-10}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/search-bar/src/widget/components/search-bar/classic-search-bar.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/search-bar/src/shared/styles/mixins/position-zeros.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/search-bar/classic-search-bar.styl"],"names":[],"mappings":"AAEA,sCACE,kBAAA,oBACA,CAIE,gdAEE,aAAA,gBACA,0CACA,cACA,CAEA,4jBACE,8BAAA,CADF,wiBACE,8BAAA,CADF,ogBACE,8BAAA,CAEF,ghBACE,yCAAA,CADF,4fACE,yCAAA,CAEJ,8OACE,SAAA,CAEF,gPACE,aAAA,CAIF,oOACE,0CAAA,cACA,CAEF,kPACE,aAAA,CAEF,gPACE,SAAA,CAGF,kHACE,YAAA,CAMF,gRACE,aAAA,CAEF,8JACE,YAAA,CAEJ,6OAGE,kBAAA,MACA,iBACA,eACA,2BACA,CAEF,8EACE,OAAA,mBACA,CAEF,+JAEE,aAAA,WACA,cACA,CAEF,0JAEE,YAAA,uBACA,aACA,4BACA,uCACA,qCACA,uCACA,+CACA,WACA,SACA,iBACA,YACA,eACA,qBACA,CAEF,kFACE,mBAAA,iBACA,CAEF,wEC3FA,MAAA,OACA,QACA,SD2FE,kBAAA,qCACA,CAEA,yGACE,2BAAA,CADF,oGACE,2BAAA,CADF,2FACE,2BAAA,CAEF,mGACE,+BAAA,oBACA,CAFF,8FACE,+BAAA,oBACA,CAFF,qFACE,+BAAA,oBACA,CAEF,wFACE,yCAAA,CADF,mFACE,yCAAA,CEUL","file":"classic-search-bar.styl","sourcesContent":["@require '~shared/styles/mixins'\n\n.container\n  position relative\n  transition width 0.2s\n\n  &.has-submitted-value\n  &.focused\n    .input\n    .input:hover\n      outline none\n      box-shadow none\n      background-color -wix-colors-textColor-10\n      padding 0 38px\n\n      &::placeholder\n        color -wix-colors-textColor-70\n\n      &::selection\n        background-color -wix-colors-textColor-20\n\n    .search-icon\n      left 12px\n\n    .close-search\n      display block\n\n  &.has-submitted-value\n  &.has-value\n    .input\n      background-color -wix-colors-textColor-10\n      padding 0 38px\n\n    .close-search\n      display block\n\n    .search-icon\n      left 12px\n\n  &.changed\n    .close-search\n      display none\n\n    .permit-search\n      display block\n\n  &.changed:not(.has-value)\n    .close-search\n      display block\n\n    .permit-search\n      display none\n\n  .close-search\n  .permit-search\n  .search-icon\n    position absolute\n    top 0\n    line-height 42px\n    font-size 15px\n    color -wix-colors-textColor\n\n  .search-icon\n    left 0\n    transition left 0.2s\n\n  .close-search\n  .permit-search\n    display none\n    right 14px\n    cursor pointer\n\n  .background-text\n  .input\n    border none\n    background transparent\n    outline none\n    color -wix-colors-textColor\n    font-weight -wix-fonts-textFont-weight\n    font-style -wix-fonts-textFont-style\n    font-family -wix-fonts-textFont-family\n    text-decoration -wix-fonts-textFont-decoration\n    width 100%\n    margin 0\n    line-height 42px\n    height 42px\n    padding 0 26px\n    box-sizing border-box\n\n  .background-text\n    white-space nowrap\n    visibility hidden\n\n  .input\n    position-zeros()\n    position absolute\n    transition padding 0.2s, background 0.2s\n\n    &:hover::placeholder\n      color -wix-colors-textColor\n\n    &::placeholder\n      color -wix-colors-textColor-70\n      transition color 0.2s\n\n    &::selection\n      background-color -wix-colors-textColor-10\n","position-zeros(position = absolute)\n  position position\n  top 0\n  left 0\n  right 0\n  bottom 0\n",".container {\n  position: relative;\n  transition: width 0.2s;\n}\n.container.has-submitted-value .input,\n.container.focused .input,\n.container.has-submitted-value .input:hover,\n.container.focused .input:hover {\n  outline: none;\n  box-shadow: none;\n  background-color: -wix-colors-textColor-10;\n  padding: 0 38px;\n}\n.container.has-submitted-value .input::placeholder,\n.container.focused .input::placeholder,\n.container.has-submitted-value .input:hover::placeholder,\n.container.focused .input:hover::placeholder {\n  color: -wix-colors-textColor-70;\n}\n.container.has-submitted-value .input::selection,\n.container.focused .input::selection,\n.container.has-submitted-value .input:hover::selection,\n.container.focused .input:hover::selection {\n  background-color: -wix-colors-textColor-20;\n}\n.container.has-submitted-value .search-icon,\n.container.focused .search-icon {\n  left: 12px;\n}\n.container.has-submitted-value .close-search,\n.container.focused .close-search {\n  display: block;\n}\n.container.has-submitted-value .input,\n.container.has-value .input {\n  background-color: -wix-colors-textColor-10;\n  padding: 0 38px;\n}\n.container.has-submitted-value .close-search,\n.container.has-value .close-search {\n  display: block;\n}\n.container.has-submitted-value .search-icon,\n.container.has-value .search-icon {\n  left: 12px;\n}\n.container.changed .close-search {\n  display: none;\n}\n.container.changed .permit-search {\n  display: block;\n}\n.container.changed:not(.has-value) .close-search {\n  display: block;\n}\n.container.changed:not(.has-value) .permit-search {\n  display: none;\n}\n.container .close-search,\n.container .permit-search,\n.container .search-icon {\n  position: absolute;\n  top: 0;\n  line-height: 42px;\n  font-size: 15px;\n  color: -wix-colors-textColor;\n}\n.container .search-icon {\n  left: 0;\n  transition: left 0.2s;\n}\n.container .close-search,\n.container .permit-search {\n  display: none;\n  right: 14px;\n  cursor: pointer;\n}\n.container .background-text,\n.container .input {\n  border: none;\n  background: transparent;\n  outline: none;\n  color: -wix-colors-textColor;\n  font-weight: -wix-fonts-textFont-weight;\n  font-style: -wix-fonts-textFont-style;\n  font-family: -wix-fonts-textFont-family;\n  text-decoration: -wix-fonts-textFont-decoration;\n  width: 100%;\n  margin: 0;\n  line-height: 42px;\n  height: 42px;\n  padding: 0 26px;\n  box-sizing: border-box;\n}\n.container .background-text {\n  white-space: nowrap;\n  visibility: hidden;\n}\n.container .input {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  position: absolute;\n  transition: padding 0.2s, background 0.2s;\n}\n.container .input:hover::placeholder {\n  color: -wix-colors-textColor;\n}\n.container .input::placeholder {\n  color: -wix-colors-textColor-70;\n  transition: color 0.2s;\n}\n.container .input::selection {\n  background-color: -wix-colors-textColor-10;\n}\n/*# sourceMappingURL=src/widget/components/search-bar/classic-search-bar.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "classic-search-bar__container__3k3EG",
	"focused": "classic-search-bar__focused__3Y_-G",
	"input": "classic-search-bar__input__1Waxq",
	"has-submitted-value": "classic-search-bar__has-submitted-value__qm3Os",
	"hasSubmittedValue": "classic-search-bar__has-submitted-value__qm3Os",
	"search-icon": "classic-search-bar__search-icon__2PWlq",
	"searchIcon": "classic-search-bar__search-icon__2PWlq",
	"close-search": "classic-search-bar__close-search__2Mxjh",
	"closeSearch": "classic-search-bar__close-search__2Mxjh",
	"has-value": "classic-search-bar__has-value__unZ14",
	"hasValue": "classic-search-bar__has-value__unZ14",
	"changed": "classic-search-bar__changed__1qUCi",
	"permit-search": "classic-search-bar__permit-search__2ZoGw",
	"permitSearch": "classic-search-bar__permit-search__2ZoGw",
	"background-text": "classic-search-bar__background-text__3exoc",
	"backgroundText": "classic-search-bar__background-text__3exoc"
};

/***/ }),

/***/ 1985:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, ".strip-search-bar__container__2Bs8y{position:relative;transition:width .2s}.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei,.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei:hover,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei:hover{outline:none;box-shadow:none;background-color:-wix-colors-textColor-10;padding:0 38px}.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei::-webkit-input-placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei:hover::-webkit-input-placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei::-webkit-input-placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei:hover::-webkit-input-placeholder{color:-wix-colors-textColor-70}.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei:-ms-input-placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei:hover:-ms-input-placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei:-ms-input-placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei:hover:-ms-input-placeholder{color:-wix-colors-textColor-70}.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei::placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei:hover::placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei::placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei:hover::placeholder{color:-wix-colors-textColor-70}.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei::-moz-selection,.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei:hover::-moz-selection,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei::-moz-selection,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei:hover::-moz-selection{background-color:-wix-colors-textColor-20}.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei::selection,.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei:hover::selection,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei::selection,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei:hover::selection{background-color:-wix-colors-textColor-20}.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__search-icon__CEJsT,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__search-icon__CEJsT{left:12px}.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__close-search__2xqmR,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__close-search__2xqmR{display:block}.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei,.strip-search-bar__container__2Bs8y.strip-search-bar__has-value__1u8v3 .strip-search-bar__input__23fei{background-color:-wix-colors-textColor-10;padding:0 38px}.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__close-search__2xqmR,.strip-search-bar__container__2Bs8y.strip-search-bar__has-value__1u8v3 .strip-search-bar__close-search__2xqmR{display:block}.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__search-icon__CEJsT,.strip-search-bar__container__2Bs8y.strip-search-bar__has-value__1u8v3 .strip-search-bar__search-icon__CEJsT{left:12px}.strip-search-bar__container__2Bs8y.strip-search-bar__changed__12eU2 .strip-search-bar__close-search__2xqmR{display:none}.strip-search-bar__container__2Bs8y.strip-search-bar__changed__12eU2 .strip-search-bar__permit-search__Wb-Ni,.strip-search-bar__container__2Bs8y.strip-search-bar__changed__12eU2:not(.strip-search-bar__has-value__1u8v3) .strip-search-bar__close-search__2xqmR{display:block}.strip-search-bar__container__2Bs8y.strip-search-bar__changed__12eU2:not(.strip-search-bar__has-value__1u8v3) .strip-search-bar__permit-search__Wb-Ni{display:none}.strip-search-bar__container__2Bs8y .strip-search-bar__close-search__2xqmR,.strip-search-bar__container__2Bs8y .strip-search-bar__permit-search__Wb-Ni,.strip-search-bar__container__2Bs8y .strip-search-bar__search-icon__CEJsT{position:absolute;top:0;line-height:42px;font-size:15px;color:-wix-colors-textColor}.strip-search-bar__container__2Bs8y .strip-search-bar__search-icon__CEJsT{left:0;transition:left .2s}.strip-search-bar__container__2Bs8y .strip-search-bar__close-search__2xqmR,.strip-search-bar__container__2Bs8y .strip-search-bar__permit-search__Wb-Ni{display:none;right:14px;cursor:pointer}.strip-search-bar__container__2Bs8y .strip-search-bar__background-text__3YC9i,.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei{border:none;background:transparent;outline:none;color:-wix-colors-textColor;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;width:100%;margin:0;line-height:42px;height:42px;padding:0 26px;box-sizing:border-box}.strip-search-bar__container__2Bs8y .strip-search-bar__background-text__3YC9i{white-space:nowrap;visibility:hidden}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei{top:0;left:0;right:0;bottom:0;position:absolute;transition:padding .2s,background .2s}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei:hover::-webkit-input-placeholder{color:-wix-colors-textColor}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei:hover:-ms-input-placeholder{color:-wix-colors-textColor}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei:hover::placeholder{color:-wix-colors-textColor}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei::-webkit-input-placeholder{color:-wix-colors-textColor-70}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei:-ms-input-placeholder{color:-wix-colors-textColor-70}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei::placeholder{color:-wix-colors-textColor-70}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei::-moz-selection{background-color:-wix-colors-textColor-10}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei::selection{background-color:-wix-colors-textColor-10}.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei,.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei:hover,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei:hover{background-color:transparent;border-bottom-color:#fff}.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei::-webkit-input-placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei:hover::-webkit-input-placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei::-webkit-input-placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei:hover::-webkit-input-placeholder{color:hsla(0,0%,100%,.7)}.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei:-ms-input-placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei:hover:-ms-input-placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei:-ms-input-placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei:hover:-ms-input-placeholder{color:hsla(0,0%,100%,.7)}.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei::placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei:hover::placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei::placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei:hover::placeholder{color:hsla(0,0%,100%,.7)}.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei::-moz-selection,.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei:hover::-moz-selection,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei::-moz-selection,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei:hover::-moz-selection{background-color:hsla(0,0%,100%,.2)}.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei::selection,.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei:hover::selection,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei::selection,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei:hover::selection{background-color:hsla(0,0%,100%,.2)}.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei,.strip-search-bar__container__2Bs8y.strip-search-bar__has-value__1u8v3 .strip-search-bar__input__23fei{background-color:transparent;border-bottom-color:#fff}.strip-search-bar__container__2Bs8y .strip-search-bar__close-search__2xqmR,.strip-search-bar__container__2Bs8y .strip-search-bar__permit-search__Wb-Ni,.strip-search-bar__container__2Bs8y .strip-search-bar__search-icon__CEJsT{color:#fff}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei{color:#fff;background-color:transparent;border-bottom:1px solid hsla(0,0%,100%,.7)}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei:hover::-webkit-input-placeholder{color:hsla(0,0%,100%,.7)}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei:hover:-ms-input-placeholder{color:hsla(0,0%,100%,.7)}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei:hover::placeholder{color:hsla(0,0%,100%,.7)}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei::-webkit-input-placeholder{color:#fff;transition:color .2s}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei:-ms-input-placeholder{color:#fff;transition:color .2s}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei::placeholder{color:#fff;transition:color .2s}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei::-moz-selection{background-color:hsla(0,0%,100%,.1)}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei::selection{background-color:hsla(0,0%,100%,.1)}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/search-bar/src/widget/components/search-bar/classic-search-bar.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/search-bar/src/shared/styles/mixins/position-zeros.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/search-bar/strip-search-bar.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/search-bar/src/widget/components/search-bar/strip-search-bar.styl"],"names":[],"mappings":"AAEA,oCACE,kBAAA,oBACA,CAIE,wbAEE,aAAA,gBACA,0CACA,cACA,CAEA,oiBACE,8BAAA,CADF,ghBACE,8BAAA,CADF,4eACE,8BAAA,CAEF,wfACE,yCAAA,CADF,oeACE,yCAAA,CAEJ,kOACE,SAAA,CAEF,oOACE,aAAA,CAIF,wNACE,0CAAA,cACA,CAEF,sOACE,aAAA,CAEF,oOACE,SAAA,CAGF,4GACE,YAAA,CAMF,kQACE,aAAA,CAEF,sJACE,YAAA,CAEJ,iOAGE,kBAAA,MACA,iBACA,eACA,2BACA,CAEF,0EACE,OAAA,mBACA,CAEF,uJAEE,aAAA,WACA,cACA,CAEF,kJAEE,YAAA,uBACA,aACA,4BACA,uCACA,qCACA,uCACA,+CACA,WACA,SACA,iBACA,YACA,eACA,qBACA,CAEF,8EACE,mBAAA,iBACA,CAEF,oEC3FA,MAAA,OACA,QACA,SD2FE,kBAAA,qCACA,CAEA,qGACE,2BAAA,CADF,gGACE,2BAAA,CADF,uFACE,2BAAA,CAEF,+FACE,8BAAA,CADF,0FACE,8BAAA,CADF,iFACE,8BAAA,CAGF,oFACE,yCAAA,CADF,+EACE,yCAAA,CEUL,wbC7GK,6BAAA,wBACA,CDmHL,oiBChHO,wBAAA,CDsHP,ghBCtHO,wBAAA,CDsHP,4eCtHO,wBAAA,CDsHP,wfCnHO,mCAAA,CDyHP,oeCzHO,mCAAA,CDyHP,wNCpHK,6BAAA,wBACA,CDwHL,iOCnHG,UAAA,CDwHH,oECrHG,WAAA,6BACA,0CACA,CDwHH,qGCrHK,wBAAA,CDwHL,gGCxHK,wBAAA,CDwHL,uFCxHK,wBAAA,CDwHL,+FCrHK,WAAA,oBACA,CDwHL,0FCzHK,WAAA,oBACA,CDwHL,iFCzHK,WAAA,oBACA,CDwHL,oFCrHK,mCAAA,CDwHL,+ECxHK,mCAAA,CDwHL","file":"strip-search-bar.styl","sourcesContent":["@require '~shared/styles/mixins'\n\n.container\n  position relative\n  transition width 0.2s\n\n  &.has-submitted-value\n  &.focused\n    .input\n    .input:hover\n      outline none\n      box-shadow none\n      background-color -wix-colors-textColor-10\n      padding 0 38px\n\n      &::placeholder\n        color -wix-colors-textColor-70\n\n      &::selection\n        background-color -wix-colors-textColor-20\n\n    .search-icon\n      left 12px\n\n    .close-search\n      display block\n\n  &.has-submitted-value\n  &.has-value\n    .input\n      background-color -wix-colors-textColor-10\n      padding 0 38px\n\n    .close-search\n      display block\n\n    .search-icon\n      left 12px\n\n  &.changed\n    .close-search\n      display none\n\n    .permit-search\n      display block\n\n  &.changed:not(.has-value)\n    .close-search\n      display block\n\n    .permit-search\n      display none\n\n  .close-search\n  .permit-search\n  .search-icon\n    position absolute\n    top 0\n    line-height 42px\n    font-size 15px\n    color -wix-colors-textColor\n\n  .search-icon\n    left 0\n    transition left 0.2s\n\n  .close-search\n  .permit-search\n    display none\n    right 14px\n    cursor pointer\n\n  .background-text\n  .input\n    border none\n    background transparent\n    outline none\n    color -wix-colors-textColor\n    font-weight -wix-fonts-textFont-weight\n    font-style -wix-fonts-textFont-style\n    font-family -wix-fonts-textFont-family\n    text-decoration -wix-fonts-textFont-decoration\n    width 100%\n    margin 0\n    line-height 42px\n    height 42px\n    padding 0 26px\n    box-sizing border-box\n\n  .background-text\n    white-space nowrap\n    visibility hidden\n\n  .input\n    position-zeros()\n    position absolute\n    transition padding 0.2s, background 0.2s\n\n    &:hover::placeholder\n      color -wix-colors-textColor\n\n    &::placeholder\n      color -wix-colors-textColor-70\n      transition color 0.2s\n\n    &::selection\n      background-color -wix-colors-textColor-10\n","position-zeros(position = absolute)\n  position position\n  top 0\n  left 0\n  right 0\n  bottom 0\n",".container {\n  position: relative;\n  transition: width 0.2s;\n}\n.container.has-submitted-value .input,\n.container.focused .input,\n.container.has-submitted-value .input:hover,\n.container.focused .input:hover {\n  outline: none;\n  box-shadow: none;\n  background-color: -wix-colors-textColor-10;\n  padding: 0 38px;\n}\n.container.has-submitted-value .input::placeholder,\n.container.focused .input::placeholder,\n.container.has-submitted-value .input:hover::placeholder,\n.container.focused .input:hover::placeholder {\n  color: -wix-colors-textColor-70;\n}\n.container.has-submitted-value .input::selection,\n.container.focused .input::selection,\n.container.has-submitted-value .input:hover::selection,\n.container.focused .input:hover::selection {\n  background-color: -wix-colors-textColor-20;\n}\n.container.has-submitted-value .search-icon,\n.container.focused .search-icon {\n  left: 12px;\n}\n.container.has-submitted-value .close-search,\n.container.focused .close-search {\n  display: block;\n}\n.container.has-submitted-value .input,\n.container.has-value .input {\n  background-color: -wix-colors-textColor-10;\n  padding: 0 38px;\n}\n.container.has-submitted-value .close-search,\n.container.has-value .close-search {\n  display: block;\n}\n.container.has-submitted-value .search-icon,\n.container.has-value .search-icon {\n  left: 12px;\n}\n.container.changed .close-search {\n  display: none;\n}\n.container.changed .permit-search {\n  display: block;\n}\n.container.changed:not(.has-value) .close-search {\n  display: block;\n}\n.container.changed:not(.has-value) .permit-search {\n  display: none;\n}\n.container .close-search,\n.container .permit-search,\n.container .search-icon {\n  position: absolute;\n  top: 0;\n  line-height: 42px;\n  font-size: 15px;\n  color: -wix-colors-textColor;\n}\n.container .search-icon {\n  left: 0;\n  transition: left 0.2s;\n}\n.container .close-search,\n.container .permit-search {\n  display: none;\n  right: 14px;\n  cursor: pointer;\n}\n.container .background-text,\n.container .input {\n  border: none;\n  background: transparent;\n  outline: none;\n  color: -wix-colors-textColor;\n  font-weight: -wix-fonts-textFont-weight;\n  font-style: -wix-fonts-textFont-style;\n  font-family: -wix-fonts-textFont-family;\n  text-decoration: -wix-fonts-textFont-decoration;\n  width: 100%;\n  margin: 0;\n  line-height: 42px;\n  height: 42px;\n  padding: 0 26px;\n  box-sizing: border-box;\n}\n.container .background-text {\n  white-space: nowrap;\n  visibility: hidden;\n}\n.container .input {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  position: absolute;\n  transition: padding 0.2s, background 0.2s;\n}\n.container .input:hover::placeholder {\n  color: -wix-colors-textColor;\n}\n.container .input::placeholder {\n  color: -wix-colors-textColor-70;\n  transition: color 0.2s;\n}\n.container .input::selection {\n  background-color: -wix-colors-textColor-10;\n}\n.container.has-submitted-value .input,\n.container.focused .input,\n.container.has-submitted-value .input:hover,\n.container.focused .input:hover {\n  background-color: transparent;\n  border-bottom-color: #fff;\n}\n.container.has-submitted-value .input::placeholder,\n.container.focused .input::placeholder,\n.container.has-submitted-value .input:hover::placeholder,\n.container.focused .input:hover::placeholder {\n  color: rgba(255,255,255,0.7);\n}\n.container.has-submitted-value .input::selection,\n.container.focused .input::selection,\n.container.has-submitted-value .input:hover::selection,\n.container.focused .input:hover::selection {\n  background-color: rgba(255,255,255,0.2);\n}\n.container.has-submitted-value .input,\n.container.has-value .input {\n  background-color: transparent;\n  border-bottom-color: #fff;\n}\n.container .close-search,\n.container .permit-search,\n.container .search-icon {\n  color: #fff;\n}\n.container .input {\n  color: #fff;\n  background-color: transparent;\n  border-bottom: 1px solid rgba(255,255,255,0.7);\n}\n.container .input:hover::placeholder {\n  color: rgba(255,255,255,0.7);\n}\n.container .input::placeholder {\n  color: #fff;\n  transition: color 0.2s;\n}\n.container .input::selection {\n  background-color: rgba(255,255,255,0.1);\n}\n/*# sourceMappingURL=src/widget/components/search-bar/strip-search-bar.css.map */","@require './classic-search-bar'\n\n.container\n  &.has-submitted-value\n  &.focused\n    .input\n    .input:hover\n      background-color transparent\n      border-bottom-color #fff\n\n      &::placeholder\n        color rgba(255, 255, 255, 0.7)\n\n      &::selection\n        background-color rgba(255, 255, 255, 0.2)\n\n  &.has-submitted-value\n  &.has-value\n    .input\n      background-color transparent\n      border-bottom-color #fff\n\n  .close-search\n  .permit-search\n  .search-icon\n    color #fff\n\n  .input\n    color #fff\n    background-color transparent\n    border-bottom 1px solid rgba(255, 255, 255, 0.7)\n\n    &:hover::placeholder\n      color rgba(255, 255, 255, 0.7)\n\n    &::placeholder\n      color #fff\n      transition color 0.2s\n\n    &::selection\n      background-color rgba(255, 255, 255, 0.1)\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "strip-search-bar__container__2Bs8y",
	"focused": "strip-search-bar__focused__17qlH",
	"input": "strip-search-bar__input__23fei",
	"has-submitted-value": "strip-search-bar__has-submitted-value__39_c-",
	"hasSubmittedValue": "strip-search-bar__has-submitted-value__39_c-",
	"search-icon": "strip-search-bar__search-icon__CEJsT",
	"searchIcon": "strip-search-bar__search-icon__CEJsT",
	"close-search": "strip-search-bar__close-search__2xqmR",
	"closeSearch": "strip-search-bar__close-search__2xqmR",
	"has-value": "strip-search-bar__has-value__1u8v3",
	"hasValue": "strip-search-bar__has-value__1u8v3",
	"changed": "strip-search-bar__changed__12eU2",
	"permit-search": "strip-search-bar__permit-search__Wb-Ni",
	"permitSearch": "strip-search-bar__permit-search__Wb-Ni",
	"background-text": "strip-search-bar__background-text__3YC9i",
	"backgroundText": "strip-search-bar__background-text__3YC9i"
};

/***/ }),

/***/ 1986:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, ".share-channel__share-container__2vZmS{display:-ms-flexbox;display:flex;position:relative;color:-wix-colors-buttonsAndLinksColor-80}.share-channel__share-container__2vZmS:hover{color:-wix-colors-buttonsAndLinksColor-100}.share-channel__share-container__2vZmS:hover .share-channel__share-buttons__bMm5z{transition:opacity .3s ease .15s,margin .3s;opacity:1;margin-left:0}.share-channel__share-container__2vZmS:hover .share-channel__share__2UXlw{opacity:.5}.share-channel__share__2UXlw{cursor:pointer;font-size:13px;height:13px}.share-channel__share-buttons__bMm5z{color:-wix-colors-buttonsAndLinksColor-100;display:-ms-flexbox;display:flex;-ms-flex-line-pack:justify;align-content:space-between;width:110px;height:13px;padding-right:18px;margin-left:-110px;opacity:0;transition-property:opacity,margin;transition-duration:.3s;transition-delay:.5s}.share-channel__share-button__2oGPJ{cursor:pointer;font-size:13px}.share-channel__facebook__-WkQU:hover{color:#3b5999}.share-channel__twitter__N9wMI:hover{color:#55acee}.share-channel__pinterest__31poE:hover{color:#bd081c}.share-channel__tumblr__1iIpB:hover{color:#34465d}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/share-channel/src/widget/components/share-channel/share-channel.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/share-channel/share-channel.styl"],"names":[],"mappings":"AAKA,uCACE,oBAAA,aAAA,kBACA,yCACA,CAEA,6CACE,0CAAA,CAEA,kFACE,4CAAA,UACA,aACA,CAEF,0EACE,UAAA,CAEN,6BACE,eAAA,eACA,WACA,CAEF,qCACE,2CAAA,oBACA,aAAA,2BACA,4BAAA,YACA,YACA,mBACA,mBACA,UACA,mCACA,wBACA,oBACA,CAEF,oCACE,eAAA,cACA,CAEF,sCACE,aAAA,CAEF,qCACE,aAAA,CAEF,uCACE,aAAA,CAEF,oCACE,aAAA,CCJD","file":"share-channel.styl","sourcesContent":["@require '~shared/styles/mixins'\n\nicon-size = 13px\nwidth = 110px\n\n.share-container\n  display flex\n  position relative\n  color -wix-colors-buttonsAndLinksColor-80\n\n  &:hover\n    color -wix-colors-buttonsAndLinksColor-100\n\n    .share-buttons\n      transition opacity 300ms ease 150ms, margin 300ms\n      opacity 1\n      margin-left 0\n\n    .share\n      opacity 0.5\n\n.share\n  cursor pointer\n  font-size icon-size\n  height icon-size\n\n.share-buttons\n  color -wix-colors-buttonsAndLinksColor-100\n  display flex\n  align-content space-between\n  width width\n  height icon-size\n  padding-right 18px\n  margin-left - width\n  opacity 0\n  transition-property opacity, margin\n  transition-duration 300ms\n  transition-delay 500ms\n\n.share-button\n  cursor pointer\n  font-size icon-size\n\n.facebook:hover\n  color #3b5999\n\n.twitter:hover\n  color #55acee\n\n.pinterest:hover\n  color #bd081c\n\n.tumblr:hover\n  color #34465d\n",".share-container {\n  display: flex;\n  position: relative;\n  color: -wix-colors-buttonsAndLinksColor-80;\n}\n.share-container:hover {\n  color: -wix-colors-buttonsAndLinksColor-100;\n}\n.share-container:hover .share-buttons {\n  transition: opacity 300ms ease 150ms, margin 300ms;\n  opacity: 1;\n  margin-left: 0;\n}\n.share-container:hover .share {\n  opacity: 0.5;\n}\n.share {\n  cursor: pointer;\n  font-size: 13px;\n  height: 13px;\n}\n.share-buttons {\n  color: -wix-colors-buttonsAndLinksColor-100;\n  display: flex;\n  align-content: space-between;\n  width: 110px;\n  height: 13px;\n  padding-right: 18px;\n  margin-left: -110px;\n  opacity: 0;\n  transition-property: opacity, margin;\n  transition-duration: 300ms;\n  transition-delay: 500ms;\n}\n.share-button {\n  cursor: pointer;\n  font-size: 13px;\n}\n.facebook:hover {\n  color: #3b5999;\n}\n.twitter:hover {\n  color: #55acee;\n}\n.pinterest:hover {\n  color: #bd081c;\n}\n.tumblr:hover {\n  color: #34465d;\n}\n/*# sourceMappingURL=src/widget/components/share-channel/share-channel.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"share-container": "share-channel__share-container__2vZmS",
	"shareContainer": "share-channel__share-container__2vZmS",
	"share-buttons": "share-channel__share-buttons__bMm5z",
	"shareButtons": "share-channel__share-buttons__bMm5z",
	"share": "share-channel__share__2UXlw",
	"share-button": "share-channel__share-button__2oGPJ",
	"shareButton": "share-channel__share-button__2oGPJ",
	"facebook": "share-channel__facebook__-WkQU",
	"twitter": "share-channel__twitter__N9wMI",
	"pinterest": "share-channel__pinterest__31poE",
	"tumblr": "share-channel__tumblr__1iIpB"
};

/***/ }),

/***/ 1991:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, ".mobile-thumb__duration__20BnO{position:absolute;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;background-color:rgba(0,0,0,.5);bottom:0;left:0;width:45px;height:20px;color:#fff;font-size:10px;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family}.mobile-thumb__frame__380Dx{position:relative;display:inline-block;box-sizing:border-box}.mobile-thumb__frame__380Dx .mobile-thumb__content__12Sx6{display:-ms-flexbox;display:flex}.mobile-thumb__frame__380Dx .mobile-thumb__border__2AA2A{border:1px solid -wix-colors-buttonsAndLinksColor;position:absolute;top:0;bottom:0;right:0;left:0}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/thumbnail/src/widget/components/thumbnail/mobile-thumb.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/thumbnail/mobile-thumb.styl"],"names":[],"mappings":"AAEA,+BACE,kBAAA,oBACA,aAAA,qBACA,uBAAA,sBACA,mBAAA,gCACA,SACA,OACA,WACA,YACA,WACA,eACA,uCACA,qCACA,sCACA,CAGF,4BACE,kBAAA,qBACA,qBACA,CAEA,0DACE,oBAAA,YAAA,CAEF,yDACE,kDAAA,kBACA,MACA,SACA,QACA,MACA,CCFH","file":"mobile-thumb.styl","sourcesContent":["@require '~shared/styles/mixins'\n\n.duration\n  position absolute\n  display flex\n  justify-content center\n  align-items center\n  background-color rgba(0, 0, 0, 0.5)\n  bottom 0\n  left 0\n  width 45px\n  height 20px\n  color white\n  font-size 10px\n  font-weight -wix-fonts-textFont-weight\n  font-style -wix-fonts-textFont-style\n  font-family -wix-fonts-textFont-family\n\n\n.frame\n  position relative\n  display inline-block\n  box-sizing border-box\n\n  .content\n    display flex\n\n  .border\n    border 1px solid -wix-colors-buttonsAndLinksColor\n    position absolute\n    top 0\n    bottom 0\n    right 0\n    left 0\n",".duration {\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(0,0,0,0.5);\n  bottom: 0;\n  left: 0;\n  width: 45px;\n  height: 20px;\n  color: #fff;\n  font-size: 10px;\n  font-weight: -wix-fonts-textFont-weight;\n  font-style: -wix-fonts-textFont-style;\n  font-family: -wix-fonts-textFont-family;\n}\n.frame {\n  position: relative;\n  display: inline-block;\n  box-sizing: border-box;\n}\n.frame .content {\n  display: flex;\n}\n.frame .border {\n  border: 1px solid -wix-colors-buttonsAndLinksColor;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n}\n/*# sourceMappingURL=src/widget/components/thumbnail/mobile-thumb.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"duration": "mobile-thumb__duration__20BnO",
	"frame": "mobile-thumb__frame__380Dx",
	"content": "mobile-thumb__content__12Sx6",
	"border": "mobile-thumb__border__2AA2A"
};

/***/ }),

/***/ 1992:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, ".thumbnail__wrapper__1Qdhq{-ms-flex-direction:column;flex-direction:column}.thumbnail__thumbnail__3osrE,.thumbnail__wrapper__1Qdhq{display:-ms-inline-flexbox;display:inline-flex}.thumbnail__thumbnail__3osrE{position:relative}.thumbnail__thumbnail__3osrE:hover .thumbnail__purchase-icon__aGsy1,.thumbnail__thumbnail__3osrE:hover .thumbnail__watched-icon__2ddb5,.thumbnail__thumbnail__3osrE:hover:before{opacity:1}.thumbnail__thumbnail__3osrE:before{content:attr(data-duration);display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;z-index:2;box-sizing:border-box;min-width:60px;max-width:calc(100% - 23px);height:23px;padding-left:8px;padding-right:8px;color:#fff;font-size:12px;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;background-color:rgba(0,0,0,.6);transition:width .2s,opacity .2s}.thumbnail__thumbnail__3osrE:after,.thumbnail__thumbnail__3osrE:before{position:absolute;left:0;bottom:0;opacity:0}.thumbnail__thumbnail__3osrE:after{content:\"\";top:0;right:0;border:solid -wix-colors-buttonsAndLinksColor;z-index:3;transition:opacity .2s}.thumbnail__selected__1OxPt .thumbnail__purchase-icon__aGsy1,.thumbnail__selected__1OxPt .thumbnail__watched-icon__2ddb5{right:2px;bottom:2px;width:21px;height:21px;padding-top:2px;padding-left:2px;opacity:1}.thumbnail__selected__1OxPt.thumbnail__description-on-video__2TAN5 .thumbnail__description__1_IJr{left:2px;top:2px;right:2px;bottom:2px;padding:6px}.thumbnail__selected__1OxPt .thumbnail__thumbnail__3osrE:after{opacity:1}.thumbnail__selected__1OxPt .thumbnail__thumbnail__3osrE:before{left:2px;bottom:2px;height:21px;padding-top:2px;min-width:56px;max-width:calc(100% - 25px);display:-ms-inline-flexbox;display:inline-flex;padding-left:6px;padding-right:6px;opacity:1}.thumbnail__now-playing__3hK0E .thumbnail__thumbnail__3osrE:before,.thumbnail__now-playing__3hK0E .thumbnail__thumbnail__3osrE:hover:before{content:attr(data-now-playing);display:-ms-inline-flexbox;display:inline-flex}.thumbnail__purchase-icon__aGsy1,.thumbnail__watched-icon__2ddb5{position:absolute;z-index:2;right:0;bottom:0;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:23px;height:23px;box-sizing:border-box;color:#fff;font-size:13px;background-color:rgba(0,0,0,.6);opacity:0;transition:opacity .2s}.thumbnail__description__1_IJr{margin-top:8px;font-size:14px;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;overflow:hidden}.thumbnail__publisher__2eTEk,.thumbnail__title__xnLPG{display:block;height:18px;line-height:18px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.thumbnail__title__xnLPG{color:-wix-colors-textColor}.thumbnail__publisher__2eTEk{color:-wix-colors-textColor-50}.thumbnail__description-on-video__2TAN5.thumbnail__description-on-hover__1-9dd.thumbnail__preview-hover__3PWbX .thumbnail__description__1_IJr,.thumbnail__description-on-video__2TAN5.thumbnail__description-on-hover__1-9dd:hover .thumbnail__description__1_IJr{opacity:1}.thumbnail__description-on-video__2TAN5.thumbnail__description-on-hover__1-9dd .thumbnail__description__1_IJr{opacity:0;background-color:rgba(0,0,0,.5);transition:opacity .2s}.thumbnail__description-on-video__2TAN5 .thumbnail__description__1_IJr{position:absolute;z-index:1;left:0;right:0;bottom:0;top:0;margin:0;padding:8px;font-size:12px;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;background:linear-gradient(0deg,transparent,rgba(0,0,0,.351)) no-repeat;background-size:100% 40px}.thumbnail__description-on-video__2TAN5 .thumbnail__title__xnLPG{height:auto;max-height:28px;line-height:normal;color:#fff;overflow:visible}.thumbnail__description-on-video__2TAN5 .thumbnail__publisher__2eTEk{display:none}.thumbnail__clickable__1gOu1{display:-ms-inline-flexbox;display:inline-flex;text-decoration:none}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/thumbnail/src/widget/components/thumbnail/thumbnail.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/thumbnail/src/shared/styles/mixins/flex-center.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/thumbnail/src/shared/styles/mixins/text-overflow.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/thumbnail/thumbnail.styl"],"names":[],"mappings":"AAEA,2BAEE,0BAAA,qBAAA,CAEF,wDAHE,2BAAA,mBAAA,CAGF,6BACE,iBAAA,CAIE,iLAGE,SAAA,CAEJ,oCACE,4BAAA,2BAEA,oBAAA,sBACA,mBAAA,qBACA,uBAAA,UACA,sBAGA,eACA,4BACA,YACA,iBACA,kBACA,WACA,eACA,uCACA,qCACA,uCACA,+CACA,gCACA,gCAEA,CAEF,uEAvBE,kBAAA,OAKA,SACA,SAcA,CAGF,mCACE,WAAA,MAGA,QACA,8CAEA,UAEA,sBACA,CAIF,yHAEE,UAAA,WACA,WACA,YACA,gBACA,iBACA,SACA,CAEF,kGACE,SAAA,QACA,UACA,WACA,WACA,CAGA,+DACE,SAAA,CAEF,gEACE,SAAA,WACA,YACA,gBACA,eACA,4BACA,2BACA,oBAAA,iBACA,kBACA,SACA,CAGJ,4IAEE,+BAAA,2BACA,mBAAA,CAEJ,iEAEE,kBAAA,UACA,QACA,SACA,2BClGA,oBAAA,sBACA,mBAAA,qBACA,uBDkGA,WAAA,YACA,sBACA,WACA,eACA,gCACA,UACA,sBACA,CAEF,+BACE,eAAA,eACA,uCACA,qCACA,uCACA,+CACA,eACA,CAEF,sDAEE,cAAA,YACA,iBACA,uBE1HA,gBAGE,kBACA,CFyHJ,yBACE,2BAAA,CAEF,6BACE,8BAAA,CAMI,kQACE,SAAA,CAEJ,8GACE,UAAA,gCACA,sBACA,CAGJ,uEACE,kBAAA,UACA,OACA,QACA,SACA,MACA,SACA,YACA,eACA,uCACA,qCACA,uCACA,+CACA,wEACA,yBACA,CAEF,iEACE,YAAA,gBACA,mBACA,WACA,gBACA,CAEF,qEACE,YAAA,CAEJ,6BACE,2BAAA,oBAAA,oBACA,CGND","file":"thumbnail.styl","sourcesContent":["@require '~shared/styles/mixins'\n\n.wrapper\n  display inline-flex\n  flex-direction column\n\n.thumbnail\n  position relative\n  display inline-flex\n\n  &:hover\n    &::before\n    .purchase-icon\n    .watched-icon\n      opacity 1\n\n  &::before\n    content attr(data-duration)\n    position absolute\n    display inline-flex\n    align-items center\n    justify-content center\n    z-index 2\n    left 0\n    bottom 0\n    box-sizing border-box\n    min-width 60px\n    max-width calc(100% - 23px)\n    height 23px\n    padding-left 8px\n    padding-right 8px\n    color white\n    font-size 12px\n    font-weight -wix-fonts-textFont-weight\n    font-style -wix-fonts-textFont-style\n    font-family -wix-fonts-textFont-family\n    text-decoration -wix-fonts-textFont-decoration\n    background-color rgba(0, 0, 0, 0.6)\n    opacity 0\n    transition width 0.2s, opacity 0.2s\n\n  &::after\n    content ''\n    position absolute\n    left 0\n    top 0\n    right 0\n    bottom 0\n    border $border-size solid -wix-colors-buttonsAndLinksColor\n    opacity 0\n    z-index 3\n    transition opacity 0.2s\n\n.selected\n  $border-size = 2px\n  .purchase-icon\n  .watched-icon\n    right $border-size\n    bottom $border-size\n    width 21px\n    height 21px\n    padding-top 2px\n    padding-left 2px\n    opacity 1\n\n  &.description-on-video .description\n    left $border-size\n    top $border-size\n    right $border-size\n    bottom $border-size\n    padding 6px\n\n  .thumbnail\n    &::after\n      opacity 1\n\n    &::before\n      left $border-size\n      bottom $border-size\n      height 21px\n      padding-top 2px\n      min-width 56px\n      max-width calc(100% - 25px)\n      display inline-flex\n      padding-left 6px\n      padding-right 6px\n      opacity 1\n\n.now-playing\n  .thumbnail::before\n  .thumbnail:hover::before\n    content attr(data-now-playing)\n    display inline-flex\n\n.purchase-icon\n.watched-icon\n  position absolute\n  z-index 2\n  right 0\n  bottom 0\n  flex-center(inline-flex)\n  width 23px\n  height 23px\n  box-sizing border-box\n  color #ffffff\n  font-size 13px\n  background-color rgba(0, 0, 0, 0.6)\n  opacity 0\n  transition opacity 0.2s\n\n.description\n  margin-top 8px\n  font-size 14px\n  font-weight -wix-fonts-textFont-weight\n  font-style -wix-fonts-textFont-style\n  font-family -wix-fonts-textFont-family\n  text-decoration -wix-fonts-textFont-decoration\n  overflow hidden\n\n.title\n.publisher\n  display block\n  height 18px\n  line-height 18px\n  text-overflow()\n\n.title\n  color -wix-colors-textColor\n\n.publisher\n  color -wix-colors-textColor-50\n\n.description-on-video\n  &.description-on-hover\n    &.preview-hover\n    &:hover\n      .description\n        opacity 1\n\n    .description\n      opacity 0\n      background-color rgba(0, 0, 0, 0.5)\n      transition opacity 0.2s\n\n\n  .description\n    position absolute\n    z-index 1\n    left 0\n    right 0\n    bottom 0\n    top 0\n    margin 0\n    padding 8px\n    font-size 12px\n    font-weight -wix-fonts-textFont-weight\n    font-style -wix-fonts-textFont-style\n    font-family -wix-fonts-textFont-family\n    text-decoration -wix-fonts-textFont-decoration\n    background linear-gradient(0deg, transparent, rgba(0, 0, 0, .351)) no-repeat\n    background-size 100% 40px\n\n  .title\n    height auto\n    max-height 28px\n    line-height normal\n    color white\n    overflow visible\n\n  .publisher\n    display none\n\n.clickable\n  display inline-flex\n  text-decoration none\n","flex-center(display = flex)\n  display display\n  align-items center\n  justify-content center\n","text-overflow(type = ellipsis)\n  text-overflow type\n\n  if type == ellipsis\n    overflow hidden\n    white-space nowrap\n",".wrapper {\n  display: inline-flex;\n  flex-direction: column;\n}\n.thumbnail {\n  position: relative;\n  display: inline-flex;\n}\n.thumbnail:hover::before,\n.thumbnail:hover .purchase-icon,\n.thumbnail:hover .watched-icon {\n  opacity: 1;\n}\n.thumbnail::before {\n  content: attr(data-duration);\n  position: absolute;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2;\n  left: 0;\n  bottom: 0;\n  box-sizing: border-box;\n  min-width: 60px;\n  max-width: calc(100% - 23px);\n  height: 23px;\n  padding-left: 8px;\n  padding-right: 8px;\n  color: #fff;\n  font-size: 12px;\n  font-weight: -wix-fonts-textFont-weight;\n  font-style: -wix-fonts-textFont-style;\n  font-family: -wix-fonts-textFont-family;\n  text-decoration: -wix-fonts-textFont-decoration;\n  background-color: rgba(0,0,0,0.6);\n  opacity: 0;\n  transition: width 0.2s, opacity 0.2s;\n}\n.thumbnail::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  border: $border-size solid -wix-colors-buttonsAndLinksColor;\n  opacity: 0;\n  z-index: 3;\n  transition: opacity 0.2s;\n}\n.selected .purchase-icon,\n.selected .watched-icon {\n  right: 2px;\n  bottom: 2px;\n  width: 21px;\n  height: 21px;\n  padding-top: 2px;\n  padding-left: 2px;\n  opacity: 1;\n}\n.selected.description-on-video .description {\n  left: 2px;\n  top: 2px;\n  right: 2px;\n  bottom: 2px;\n  padding: 6px;\n}\n.selected .thumbnail::after {\n  opacity: 1;\n}\n.selected .thumbnail::before {\n  left: 2px;\n  bottom: 2px;\n  height: 21px;\n  padding-top: 2px;\n  min-width: 56px;\n  max-width: calc(100% - 25px);\n  display: inline-flex;\n  padding-left: 6px;\n  padding-right: 6px;\n  opacity: 1;\n}\n.now-playing .thumbnail::before,\n.now-playing .thumbnail:hover::before {\n  content: attr(data-now-playing);\n  display: inline-flex;\n}\n.purchase-icon,\n.watched-icon {\n  position: absolute;\n  z-index: 2;\n  right: 0;\n  bottom: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 23px;\n  height: 23px;\n  box-sizing: border-box;\n  color: #fff;\n  font-size: 13px;\n  background-color: rgba(0,0,0,0.6);\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n.description {\n  margin-top: 8px;\n  font-size: 14px;\n  font-weight: -wix-fonts-textFont-weight;\n  font-style: -wix-fonts-textFont-style;\n  font-family: -wix-fonts-textFont-family;\n  text-decoration: -wix-fonts-textFont-decoration;\n  overflow: hidden;\n}\n.title,\n.publisher {\n  display: block;\n  height: 18px;\n  line-height: 18px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.title {\n  color: -wix-colors-textColor;\n}\n.publisher {\n  color: -wix-colors-textColor-50;\n}\n.description-on-video.description-on-hover.preview-hover .description,\n.description-on-video.description-on-hover:hover .description {\n  opacity: 1;\n}\n.description-on-video.description-on-hover .description {\n  opacity: 0;\n  background-color: rgba(0,0,0,0.5);\n  transition: opacity 0.2s;\n}\n.description-on-video .description {\n  position: absolute;\n  z-index: 1;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  margin: 0;\n  padding: 8px;\n  font-size: 12px;\n  font-weight: -wix-fonts-textFont-weight;\n  font-style: -wix-fonts-textFont-style;\n  font-family: -wix-fonts-textFont-family;\n  text-decoration: -wix-fonts-textFont-decoration;\n  background: linear-gradient(0deg, transparent, rgba(0,0,0,0.351)) no-repeat;\n  background-size: 100% 40px;\n}\n.description-on-video .title {\n  height: auto;\n  max-height: 28px;\n  line-height: normal;\n  color: #fff;\n  overflow: visible;\n}\n.description-on-video .publisher {\n  display: none;\n}\n.clickable {\n  display: inline-flex;\n  text-decoration: none;\n}\n/*# sourceMappingURL=src/widget/components/thumbnail/thumbnail.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"wrapper": "thumbnail__wrapper__1Qdhq",
	"thumbnail": "thumbnail__thumbnail__3osrE",
	"purchase-icon": "thumbnail__purchase-icon__aGsy1",
	"purchaseIcon": "thumbnail__purchase-icon__aGsy1",
	"watched-icon": "thumbnail__watched-icon__2ddb5",
	"watchedIcon": "thumbnail__watched-icon__2ddb5",
	"selected": "thumbnail__selected__1OxPt",
	"description-on-video": "thumbnail__description-on-video__2TAN5",
	"descriptionOnVideo": "thumbnail__description-on-video__2TAN5",
	"description": "thumbnail__description__1_IJr",
	"now-playing": "thumbnail__now-playing__3hK0E",
	"nowPlaying": "thumbnail__now-playing__3hK0E",
	"publisher": "thumbnail__publisher__2eTEk",
	"title": "thumbnail__title__xnLPG",
	"description-on-hover": "thumbnail__description-on-hover__1-9dd",
	"descriptionOnHover": "thumbnail__description-on-hover__1-9dd",
	"preview-hover": "thumbnail__preview-hover__3PWbX",
	"previewHover": "thumbnail__preview-hover__3PWbX",
	"clickable": "thumbnail__clickable__1gOu1"
};

/***/ }),

/***/ 1993:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, ".classic__list-wrapper__2YgDu{overflow:hidden;position:relative}.classic__list-wrapper__2YgDu.classic__scroll-to-prev__1vkxV .classic__list__2EJe-.classic__prev__3m5aU{animation:classic__prev-move-right__2GRQB .5s}.classic__list-wrapper__2YgDu.classic__scroll-to-prev__1vkxV .classic__list__2EJe-.classic__current__1z4dr{animation:classic__current-move-right__VqmDq .5s}.classic__list-wrapper__2YgDu.classic__scroll-to-next__3T0tu .classic__list__2EJe-.classic__next__181Y4{animation:classic__next-move-left__3VSd5 .5s}.classic__list-wrapper__2YgDu.classic__scroll-to-next__3T0tu .classic__list__2EJe-.classic__current__1z4dr{animation:classic__current-move-left__3w0Wp .5s}.classic__list-wrapper__2YgDu .classic__list__2EJe-{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start;-ms-flex-line-pack:start;align-content:flex-start;-ms-flex-wrap:wrap;flex-wrap:wrap;transition:left 1s,right 1s}.classic__list-wrapper__2YgDu .classic__list__2EJe-.classic__current__1z4dr{position:relative}.classic__list-wrapper__2YgDu .classic__list__2EJe-.classic__prev__3m5aU{left:-100%;right:100%}.classic__list-wrapper__2YgDu .classic__list__2EJe-.classic__next__181Y4{right:-100%;left:100%}@keyframes classic__current-move-left__3w0Wp{0%{right:0;left:0}to{right:100%;left:-100%}}@keyframes classic__next-move-left__3VSd5{0%{right:-100%;left:100%}to{left:0;right:0}}@keyframes classic__current-move-right__VqmDq{0%{right:0;left:0}to{right:-100%;left:100%}}@keyframes classic__prev-move-right__2GRQB{0%{left:-100%;right:100%}to{right:0;left:0}}.classic__container__2h2ED{position:relative;overflow:hidden;padding-bottom:10px}.classic__container__2h2ED.classic__with-paging__2fsJa{padding-bottom:0}.classic__container__2h2ED.classic__with-paging__2fsJa .classic__buttons__3sM7N{display:-ms-flexbox;display:flex;-ms-flex:0 0 auto;flex:0 0 auto;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;width:100%;line-height:18px;height:18px;margin-top:14px;margin-bottom:5px}.classic__container__2h2ED .classic__list-wrapper__2YgDu{-ms-flex-direction:row;flex-direction:row;-ms-flex:1;flex:1}.classic__container__2h2ED .classic__list-wrapper__2YgDu.classic__row-2__3fQHe .classic__thumbnail__3hziQ:nth-child(2n),.classic__container__2h2ED .classic__list-wrapper__2YgDu.classic__row-3__2m0Yd .classic__thumbnail__3hziQ:nth-child(3n),.classic__container__2h2ED .classic__list-wrapper__2YgDu.classic__row-4__1mOYq .classic__thumbnail__3hziQ:nth-child(4n){margin-right:0}.classic__container__2h2ED .classic__list-wrapper__2YgDu .classic__list__2EJe-{-ms-flex-line-pack:start;align-content:flex-start}.classic__container__2h2ED .classic__list-wrapper__2YgDu .classic__list__2EJe- .classic__thumbnail__3hziQ{margin:0 10px 10px 0}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/videos-list/classic/src/widget/components/videos-list/_base.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/videos-list/classic/src/shared/styles/mixins/position-zeros.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/videos-list/classic/classic.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/videos-list/classic/src/widget/components/videos-list/classic/classic.styl"],"names":[],"mappings":"AAEA,8BACE,gBAAA,iBACA,CAII,wGACE,6CAAA,CAEF,2GACE,gDAAA,CAIF,wGACE,4CAAA,CAEF,2GACE,+CAAA,CAEN,oDCrBA,kBAAA,MACA,OACA,QACA,SDoBE,oBAAA,aAAA,qBACA,uBAAA,yBACA,yBAAA,mBACA,eAAA,2BACA,CAEA,4EACE,iBAAA,CAEF,yEACE,WAAA,UACA,CAEF,yEACE,YAAA,SACA,CAEK,6CACT,GACE,QAAA,MACA,CAEF,GACE,WAAA,UACA,CE6BD,CF3BQ,0CACT,GACE,YAAA,SACA,CAEF,GACE,OAAA,OACA,CE4DD,CF1DQ,8CACT,GACE,QAAA,MACA,CAEF,GACE,YAAA,SACA,CE2FD,CFzFQ,2CACT,GACE,WAAA,UACA,CAEF,GACE,QAAA,MACA,CE0HD,CACF,2BClMC,kBAAA,gBACA,mBACA,CDqMD,uDClMG,gBAAA,CDqMH,gFClMK,oBAAA,aAAA,kBACA,cAAA,sBACA,mBAAA,sBACA,8BAAA,WACA,iBACA,YACA,gBACA,iBACA,CDqML,yDClMG,uBAAA,mBAAA,WACA,MAAA,CDqMH,wWCjMK,cAAA,CDsML,+ECnMK,yBAAA,wBAAA,CDsML,0GCnMK,oBAAA,CDsML","file":"classic.styl","sourcesContent":["@require '~shared/styles/mixins'\n\n.list-wrapper\n  overflow hidden\n  position relative\n\n  &.scroll-to-prev\n    .list\n      &.prev\n        animation: prev-move-right 0.5s\n\n      &.current\n        animation: current-move-right 0.5s\n\n  &.scroll-to-next\n    .list\n      &.next\n        animation: next-move-left 0.5s\n\n      &.current\n        animation: current-move-left 0.5s\n\n  .list\n    position-zeros()\n    display flex\n    align-items flex-start\n    align-content flex-start\n    flex-wrap wrap\n    transition left 1s, right 1s\n\n    &.current\n      position relative\n\n    &.prev\n      left -100%\n      right 100%\n\n    &.next\n      right -100%\n      left 100%\n\n@keyframes current-move-left\n  0%\n    right 0\n    left 0\n\n  100%\n    right 100%\n    left -100%\n\n@keyframes next-move-left\n  0%\n    right -100%\n    left 100%\n\n  100%\n    left 0\n    right 0\n\n@keyframes current-move-right\n  0%\n    right 0\n    left 0\n\n  100%\n    right -100%\n    left 100%\n\n@keyframes prev-move-right\n  0%\n    left -100%\n    right 100%\n\n  100%\n    right 0\n    left 0\n","position-zeros(position = absolute)\n  position position\n  top 0\n  left 0\n  right 0\n  bottom 0\n",".list-wrapper {\n  overflow: hidden;\n  position: relative;\n}\n.list-wrapper.scroll-to-prev .list.prev {\n  animation: prev-move-right 0.5s;\n}\n.list-wrapper.scroll-to-prev .list.current {\n  animation: current-move-right 0.5s;\n}\n.list-wrapper.scroll-to-next .list.next {\n  animation: next-move-left 0.5s;\n}\n.list-wrapper.scroll-to-next .list.current {\n  animation: current-move-left 0.5s;\n}\n.list-wrapper .list {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: flex-start;\n  align-content: flex-start;\n  flex-wrap: wrap;\n  transition: left 1s, right 1s;\n}\n.list-wrapper .list.current {\n  position: relative;\n}\n.list-wrapper .list.prev {\n  left: -100%;\n  right: 100%;\n}\n.list-wrapper .list.next {\n  right: -100%;\n  left: 100%;\n}\n@-moz-keyframes current-move-left {\n  0% {\n    right: 0;\n    left: 0;\n  }\n  100% {\n    right: 100%;\n    left: -100%;\n  }\n}\n@-webkit-keyframes current-move-left {\n  0% {\n    right: 0;\n    left: 0;\n  }\n  100% {\n    right: 100%;\n    left: -100%;\n  }\n}\n@-o-keyframes current-move-left {\n  0% {\n    right: 0;\n    left: 0;\n  }\n  100% {\n    right: 100%;\n    left: -100%;\n  }\n}\n@keyframes current-move-left {\n  0% {\n    right: 0;\n    left: 0;\n  }\n  100% {\n    right: 100%;\n    left: -100%;\n  }\n}\n@-moz-keyframes next-move-left {\n  0% {\n    right: -100%;\n    left: 100%;\n  }\n  100% {\n    left: 0;\n    right: 0;\n  }\n}\n@-webkit-keyframes next-move-left {\n  0% {\n    right: -100%;\n    left: 100%;\n  }\n  100% {\n    left: 0;\n    right: 0;\n  }\n}\n@-o-keyframes next-move-left {\n  0% {\n    right: -100%;\n    left: 100%;\n  }\n  100% {\n    left: 0;\n    right: 0;\n  }\n}\n@keyframes next-move-left {\n  0% {\n    right: -100%;\n    left: 100%;\n  }\n  100% {\n    left: 0;\n    right: 0;\n  }\n}\n@-moz-keyframes current-move-right {\n  0% {\n    right: 0;\n    left: 0;\n  }\n  100% {\n    right: -100%;\n    left: 100%;\n  }\n}\n@-webkit-keyframes current-move-right {\n  0% {\n    right: 0;\n    left: 0;\n  }\n  100% {\n    right: -100%;\n    left: 100%;\n  }\n}\n@-o-keyframes current-move-right {\n  0% {\n    right: 0;\n    left: 0;\n  }\n  100% {\n    right: -100%;\n    left: 100%;\n  }\n}\n@keyframes current-move-right {\n  0% {\n    right: 0;\n    left: 0;\n  }\n  100% {\n    right: -100%;\n    left: 100%;\n  }\n}\n@-moz-keyframes prev-move-right {\n  0% {\n    left: -100%;\n    right: 100%;\n  }\n  100% {\n    right: 0;\n    left: 0;\n  }\n}\n@-webkit-keyframes prev-move-right {\n  0% {\n    left: -100%;\n    right: 100%;\n  }\n  100% {\n    right: 0;\n    left: 0;\n  }\n}\n@-o-keyframes prev-move-right {\n  0% {\n    left: -100%;\n    right: 100%;\n  }\n  100% {\n    right: 0;\n    left: 0;\n  }\n}\n@keyframes prev-move-right {\n  0% {\n    left: -100%;\n    right: 100%;\n  }\n  100% {\n    right: 0;\n    left: 0;\n  }\n}\n.container {\n  position: relative;\n  overflow: hidden;\n  padding-bottom: 10px;\n}\n.container.with-paging {\n  padding-bottom: 0;\n}\n.container.with-paging .buttons {\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  line-height: 18px;\n  height: 18px;\n  margin-top: 14px;\n  margin-bottom: 5px;\n}\n.container .list-wrapper {\n  flex-direction: row;\n  flex: 1;\n}\n.container .list-wrapper.row-2 .thumbnail:nth-child(2n),\n.container .list-wrapper.row-3 .thumbnail:nth-child(3n),\n.container .list-wrapper.row-4 .thumbnail:nth-child(4n) {\n  margin-right: 0;\n}\n.container .list-wrapper .list {\n  align-content: flex-start;\n}\n.container .list-wrapper .list .thumbnail {\n  margin: 0 10px 10px 0;\n}\n/*# sourceMappingURL=src/widget/components/videos-list/classic/classic.css.map */","@require '~shared/styles/mixins'\n@require '../_base'\n\n.container\n  position relative\n  overflow hidden\n  padding-bottom 10px\n\n  &.with-paging\n    padding-bottom 0\n\n    .buttons\n      display flex\n      flex 0 0 auto\n      align-items center\n      justify-content space-between\n      width 100%\n      line-height 18px\n      height 18px\n      margin-top 14px\n      margin-bottom 5px\n\n  .list-wrapper\n    flex-direction row\n    flex 1\n    &.row-2 .thumbnail:nth-child(2n)\n    &.row-3 .thumbnail:nth-child(3n)\n    &.row-4 .thumbnail:nth-child(4n)\n      margin-right 0\n\n    .list\n      align-content flex-start\n\n    .list .thumbnail\n      margin 0 10px 10px 0\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"list-wrapper": "classic__list-wrapper__2YgDu",
	"listWrapper": "classic__list-wrapper__2YgDu",
	"scroll-to-prev": "classic__scroll-to-prev__1vkxV",
	"scrollToPrev": "classic__scroll-to-prev__1vkxV",
	"list": "classic__list__2EJe-",
	"prev": "classic__prev__3m5aU",
	"prev-move-right": "classic__prev-move-right__2GRQB",
	"prevMoveRight": "classic__prev-move-right__2GRQB",
	"current": "classic__current__1z4dr",
	"current-move-right": "classic__current-move-right__VqmDq",
	"currentMoveRight": "classic__current-move-right__VqmDq",
	"scroll-to-next": "classic__scroll-to-next__3T0tu",
	"scrollToNext": "classic__scroll-to-next__3T0tu",
	"next": "classic__next__181Y4",
	"next-move-left": "classic__next-move-left__3VSd5",
	"nextMoveLeft": "classic__next-move-left__3VSd5",
	"current-move-left": "classic__current-move-left__3w0Wp",
	"currentMoveLeft": "classic__current-move-left__3w0Wp",
	"container": "classic__container__2h2ED",
	"with-paging": "classic__with-paging__2fsJa",
	"withPaging": "classic__with-paging__2fsJa",
	"buttons": "classic__buttons__3sM7N",
	"row-2": "classic__row-2__3fQHe",
	"row2": "classic__row-2__3fQHe",
	"thumbnail": "classic__thumbnail__3hziQ",
	"row-3": "classic__row-3__2m0Yd",
	"row3": "classic__row-3__2m0Yd",
	"row-4": "classic__row-4__1mOYq",
	"row4": "classic__row-4__1mOYq"
};

/***/ }),

/***/ 1994:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, ".nav-button__nav-button__26ZQn{display:inline-block;padding:0;outline:none;border:none;background:none;transition:opacity .2s,visibility .2s}.nav-button__nav-button__26ZQn .nav-button__nav-text__GQz68{display:inline-block;margin:0 13px;color:-wix-colors-textColor;text-decoration:-wix-fonts-textFont-decoration;font-size:14px;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family}.nav-button__nav-button__26ZQn .nav-button__nav-arrow__2Z8JX{width:30px;height:9px;fill:-wix-colors-textColor}.nav-button__nav-button__26ZQn:hover{opacity:.7}.nav-button__nav-button__26ZQn.nav-button__disabled__3wnrx,.nav-button__nav-button__26ZQn.nav-button__disabled__3wnrx:hover{visibility:hidden;opacity:0}.nav-button__nav-button__26ZQn+.nav-button__nav-button__26ZQn{margin-left:10px}.nav-button__nav-button__26ZQn polygon{fill:-wix-colors-textColor}.nav-button__nav-button__26ZQn.nav-button__prev__24p06 .nav-button__nav-arrow__2Z8JX{transform:rotate(180deg)}.nav-button__nav-button__26ZQn.nav-button__next__1rwow{direction:rtl}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/videos-list/nav-button/src/widget/components/videos-list/nav-button/nav-button.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/videos-list/nav-button/nav-button.styl"],"names":[],"mappings":"AAAA,+BACE,qBAAA,UACA,aACA,YACA,gBACA,qCACA,CAEA,4DACE,qBAAA,cACA,4BACA,+CACA,eACA,uCACA,qCACA,sCACA,CAEF,6DACE,WAAA,WACA,0BACA,CAEF,qCACE,UAAA,CAEF,4HAEE,kBAAA,SACA,CAEF,8DACE,gBAAA,CAEF,uCACE,0BAAA,CAGA,qFACE,wBAAA,CAEJ,uDACE,aAAA,CCAH","file":"nav-button.styl","sourcesContent":[".nav-button\n  display inline-block\n  padding 0\n  outline none\n  border none\n  background none\n  transition opacity .2s, visibility .2s\n\n  .nav-text\n    display inline-block\n    margin 0 13px\n    color -wix-colors-textColor\n    text-decoration -wix-fonts-textFont-decoration\n    font-size 14px\n    font-weight -wix-fonts-textFont-weight\n    font-style -wix-fonts-textFont-style\n    font-family -wix-fonts-textFont-family\n\n  .nav-arrow\n    width 30px\n    height 9px\n    fill -wix-colors-textColor\n\n  &:hover\n    opacity 0.7\n\n  &.disabled\n  &.disabled:hover\n    visibility hidden\n    opacity 0\n\n  & + .nav-button\n    margin-left 10px\n\n  polygon\n    fill -wix-colors-textColor\n\n  &.prev\n    .nav-arrow\n      transform rotate(180deg)\n\n  &.next\n    direction rtl\n",".nav-button {\n  display: inline-block;\n  padding: 0;\n  outline: none;\n  border: none;\n  background: none;\n  transition: opacity 0.2s, visibility 0.2s;\n}\n.nav-button .nav-text {\n  display: inline-block;\n  margin: 0 13px;\n  color: -wix-colors-textColor;\n  text-decoration: -wix-fonts-textFont-decoration;\n  font-size: 14px;\n  font-weight: -wix-fonts-textFont-weight;\n  font-style: -wix-fonts-textFont-style;\n  font-family: -wix-fonts-textFont-family;\n}\n.nav-button .nav-arrow {\n  width: 30px;\n  height: 9px;\n  fill: -wix-colors-textColor;\n}\n.nav-button:hover {\n  opacity: 0.7;\n}\n.nav-button.disabled,\n.nav-button.disabled:hover {\n  visibility: hidden;\n  opacity: 0;\n}\n.nav-button + .nav-button {\n  margin-left: 10px;\n}\n.nav-button polygon {\n  fill: -wix-colors-textColor;\n}\n.nav-button.prev .nav-arrow {\n  transform: rotate(180deg);\n}\n.nav-button.next {\n  direction: rtl;\n}\n/*# sourceMappingURL=src/widget/components/videos-list/nav-button/nav-button.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"nav-button": "nav-button__nav-button__26ZQn",
	"navButton": "nav-button__nav-button__26ZQn",
	"nav-text": "nav-button__nav-text__GQz68",
	"navText": "nav-button__nav-text__GQz68",
	"nav-arrow": "nav-button__nav-arrow__2Z8JX",
	"navArrow": "nav-button__nav-arrow__2Z8JX",
	"disabled": "nav-button__disabled__3wnrx",
	"prev": "nav-button__prev__24p06",
	"next": "nav-button__next__1rwow"
};

/***/ }),

/***/ 1995:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, ".strip__list-wrapper__31Mxz{overflow:hidden;position:relative}.strip__list-wrapper__31Mxz.strip__scroll-to-prev__3KNKk .strip__list__3R8cc.strip__prev__197wz{animation:strip__prev-move-right__2WyUN .5s}.strip__list-wrapper__31Mxz.strip__scroll-to-prev__3KNKk .strip__list__3R8cc.strip__current__1KBFG{animation:strip__current-move-right__tMTDG .5s}.strip__list-wrapper__31Mxz.strip__scroll-to-next__3osty .strip__list__3R8cc.strip__next__apskT{animation:strip__next-move-left__2Dez7 .5s}.strip__list-wrapper__31Mxz.strip__scroll-to-next__3osty .strip__list__3R8cc.strip__current__1KBFG{animation:strip__current-move-left__2iuHY .5s}.strip__list-wrapper__31Mxz .strip__list__3R8cc{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start;-ms-flex-line-pack:start;align-content:flex-start;-ms-flex-wrap:wrap;flex-wrap:wrap;transition:left 1s,right 1s}.strip__list-wrapper__31Mxz .strip__list__3R8cc.strip__current__1KBFG{position:relative}.strip__list-wrapper__31Mxz .strip__list__3R8cc.strip__prev__197wz{left:-100%;right:100%}.strip__list-wrapper__31Mxz .strip__list__3R8cc.strip__next__apskT{right:-100%;left:100%}@keyframes strip__current-move-left__2iuHY{0%{right:0;left:0}to{right:100%;left:-100%}}@keyframes strip__next-move-left__2Dez7{0%{right:-100%;left:100%}to{left:0;right:0}}@keyframes strip__current-move-right__tMTDG{0%{right:0;left:0}to{right:-100%;left:100%}}@keyframes strip__prev-move-right__2WyUN{0%{left:-100%;right:100%}to{right:0;left:0}}.strip__container__3C1Jt{position:relative;width:100%}.strip__container__3C1Jt .strip__thumbnail-wrapper__uBLxW{position:relative;overflow:hidden}.strip__container__3C1Jt .strip__thumbnail-wrapper__uBLxW .strip__overlay__15RBr{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex}.strip__container__3C1Jt .strip__next-button__1Qpcr,.strip__container__3C1Jt .strip__prev-button__2wmpE{position:absolute;top:50%;height:66px;width:50px;margin-top:-33px;border-radius:0;background-color:rgba(0,0,0,.8);font-size:23px;color:hsla(0,0%,100%,.5);transition:color .2s,opacity .2s,visibility .2s;opacity:1;z-index:130}.strip__container__3C1Jt .strip__next-button__1Qpcr:hover,.strip__container__3C1Jt .strip__prev-button__2wmpE:hover{color:#fff}.strip__container__3C1Jt .strip__next-button__1Qpcr.strip__disabled__1C79T,.strip__container__3C1Jt .strip__next-button__1Qpcr.strip__disabled__1C79T:hover,.strip__container__3C1Jt .strip__prev-button__2wmpE.strip__disabled__1C79T,.strip__container__3C1Jt .strip__prev-button__2wmpE.strip__disabled__1C79T:hover{visibility:hidden;opacity:0}.strip__container__3C1Jt .strip__prev-button__2wmpE{left:0;transform:rotate(180deg)}.strip__container__3C1Jt .strip__next-button__1Qpcr{right:0}.strip__list-wrapper__31Mxz{height:100%}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/videos-list/strip/src/widget/components/videos-list/_base.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/videos-list/strip/src/shared/styles/mixins/position-zeros.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/videos-list/strip/strip.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/videos-list/strip/src/widget/components/videos-list/strip/strip.styl"],"names":[],"mappings":"AAEA,4BACE,gBAAA,iBACA,CAII,gGACE,2CAAA,CAEF,mGACE,8CAAA,CAIF,gGACE,0CAAA,CAEF,mGACE,6CAAA,CAEN,gDCrBA,kBAAA,MACA,OACA,QACA,SDoBE,oBAAA,aAAA,qBACA,uBAAA,yBACA,yBAAA,mBACA,eAAA,2BACA,CAEA,sEACE,iBAAA,CAEF,mEACE,WAAA,UACA,CAEF,mEACE,YAAA,SACA,CAEK,2CACT,GACE,QAAA,MACA,CAEF,GACE,WAAA,UACA,CE6BD,CF3BQ,wCACT,GACE,YAAA,SACA,CAEF,GACE,OAAA,OACA,CE4DD,CF1DQ,4CACT,GACE,QAAA,MACA,CAEF,GACE,YAAA,SACA,CE2FD,CFzFQ,yCACT,GACE,WAAA,UACA,CAEF,GACE,QAAA,MACA,CE0HD,CACF,yBClMC,kBAAA,UACA,CDqMD,0DClMG,kBAAA,eACA,CDqMH,iFD7MC,kBAAA,MACA,OACA,QACA,SACA,oBEQI,YAAA,CDyML,wGCrMG,kBAAA,QACA,YACA,WACA,iBACA,gBACA,gCACA,eACA,yBACA,gDACA,UACA,WACA,CDyMH,oHCtMK,UAAA,CD0ML,wTCtMK,kBAAA,SACA,CD4ML,oDCzMG,OAAA,wBACA,CD4MH,oDCzMG,OAAA,CD4MH,4BCzMC,WAAA,CD4MD","file":"strip.styl","sourcesContent":["@require '~shared/styles/mixins'\n\n.list-wrapper\n  overflow hidden\n  position relative\n\n  &.scroll-to-prev\n    .list\n      &.prev\n        animation: prev-move-right 0.5s\n\n      &.current\n        animation: current-move-right 0.5s\n\n  &.scroll-to-next\n    .list\n      &.next\n        animation: next-move-left 0.5s\n\n      &.current\n        animation: current-move-left 0.5s\n\n  .list\n    position-zeros()\n    display flex\n    align-items flex-start\n    align-content flex-start\n    flex-wrap wrap\n    transition left 1s, right 1s\n\n    &.current\n      position relative\n\n    &.prev\n      left -100%\n      right 100%\n\n    &.next\n      right -100%\n      left 100%\n\n@keyframes current-move-left\n  0%\n    right 0\n    left 0\n\n  100%\n    right 100%\n    left -100%\n\n@keyframes next-move-left\n  0%\n    right -100%\n    left 100%\n\n  100%\n    left 0\n    right 0\n\n@keyframes current-move-right\n  0%\n    right 0\n    left 0\n\n  100%\n    right -100%\n    left 100%\n\n@keyframes prev-move-right\n  0%\n    left -100%\n    right 100%\n\n  100%\n    right 0\n    left 0\n","position-zeros(position = absolute)\n  position position\n  top 0\n  left 0\n  right 0\n  bottom 0\n",".list-wrapper {\n  overflow: hidden;\n  position: relative;\n}\n.list-wrapper.scroll-to-prev .list.prev {\n  animation: prev-move-right 0.5s;\n}\n.list-wrapper.scroll-to-prev .list.current {\n  animation: current-move-right 0.5s;\n}\n.list-wrapper.scroll-to-next .list.next {\n  animation: next-move-left 0.5s;\n}\n.list-wrapper.scroll-to-next .list.current {\n  animation: current-move-left 0.5s;\n}\n.list-wrapper .list {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: flex-start;\n  align-content: flex-start;\n  flex-wrap: wrap;\n  transition: left 1s, right 1s;\n}\n.list-wrapper .list.current {\n  position: relative;\n}\n.list-wrapper .list.prev {\n  left: -100%;\n  right: 100%;\n}\n.list-wrapper .list.next {\n  right: -100%;\n  left: 100%;\n}\n@-moz-keyframes current-move-left {\n  0% {\n    right: 0;\n    left: 0;\n  }\n  100% {\n    right: 100%;\n    left: -100%;\n  }\n}\n@-webkit-keyframes current-move-left {\n  0% {\n    right: 0;\n    left: 0;\n  }\n  100% {\n    right: 100%;\n    left: -100%;\n  }\n}\n@-o-keyframes current-move-left {\n  0% {\n    right: 0;\n    left: 0;\n  }\n  100% {\n    right: 100%;\n    left: -100%;\n  }\n}\n@keyframes current-move-left {\n  0% {\n    right: 0;\n    left: 0;\n  }\n  100% {\n    right: 100%;\n    left: -100%;\n  }\n}\n@-moz-keyframes next-move-left {\n  0% {\n    right: -100%;\n    left: 100%;\n  }\n  100% {\n    left: 0;\n    right: 0;\n  }\n}\n@-webkit-keyframes next-move-left {\n  0% {\n    right: -100%;\n    left: 100%;\n  }\n  100% {\n    left: 0;\n    right: 0;\n  }\n}\n@-o-keyframes next-move-left {\n  0% {\n    right: -100%;\n    left: 100%;\n  }\n  100% {\n    left: 0;\n    right: 0;\n  }\n}\n@keyframes next-move-left {\n  0% {\n    right: -100%;\n    left: 100%;\n  }\n  100% {\n    left: 0;\n    right: 0;\n  }\n}\n@-moz-keyframes current-move-right {\n  0% {\n    right: 0;\n    left: 0;\n  }\n  100% {\n    right: -100%;\n    left: 100%;\n  }\n}\n@-webkit-keyframes current-move-right {\n  0% {\n    right: 0;\n    left: 0;\n  }\n  100% {\n    right: -100%;\n    left: 100%;\n  }\n}\n@-o-keyframes current-move-right {\n  0% {\n    right: 0;\n    left: 0;\n  }\n  100% {\n    right: -100%;\n    left: 100%;\n  }\n}\n@keyframes current-move-right {\n  0% {\n    right: 0;\n    left: 0;\n  }\n  100% {\n    right: -100%;\n    left: 100%;\n  }\n}\n@-moz-keyframes prev-move-right {\n  0% {\n    left: -100%;\n    right: 100%;\n  }\n  100% {\n    right: 0;\n    left: 0;\n  }\n}\n@-webkit-keyframes prev-move-right {\n  0% {\n    left: -100%;\n    right: 100%;\n  }\n  100% {\n    right: 0;\n    left: 0;\n  }\n}\n@-o-keyframes prev-move-right {\n  0% {\n    left: -100%;\n    right: 100%;\n  }\n  100% {\n    right: 0;\n    left: 0;\n  }\n}\n@keyframes prev-move-right {\n  0% {\n    left: -100%;\n    right: 100%;\n  }\n  100% {\n    right: 0;\n    left: 0;\n  }\n}\n.container {\n  position: relative;\n  width: 100%;\n}\n.container .thumbnail-wrapper {\n  position: relative;\n  overflow: hidden;\n}\n.container .thumbnail-wrapper .overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n}\n.container .prev-button,\n.container .next-button {\n  position: absolute;\n  top: 50%;\n  height: 66px;\n  width: 50px;\n  margin-top: -33px;\n  border-radius: 0;\n  background-color: rgba(0,0,0,0.8);\n  font-size: 23px;\n  color: rgba(255,255,255,0.5);\n  transition: color 0.2s, opacity 0.2s, visibility 0.2s;\n  opacity: 1;\n  z-index: 130;\n}\n.container .prev-button:hover,\n.container .next-button:hover {\n  color: #fff;\n}\n.container .prev-button.disabled,\n.container .next-button.disabled,\n.container .prev-button.disabled:hover,\n.container .next-button.disabled:hover {\n  visibility: hidden;\n  opacity: 0;\n}\n.container .prev-button {\n  left: 0;\n  transform: rotate(180deg);\n}\n.container .next-button {\n  right: 0;\n}\n.list-wrapper {\n  height: 100%;\n}\n/*# sourceMappingURL=src/widget/components/videos-list/strip/strip.css.map */","@require '~shared/styles/mixins'\n@require '../_base'\n\n.container\n  position relative\n  width 100%\n\n  .thumbnail-wrapper\n    position relative\n    overflow hidden\n\n    .overlay\n      position-zeros()\n      display flex\n\n  .prev-button\n  .next-button\n    position absolute\n    top 50%\n    height 66px\n    width 50px\n    margin-top (@height / -2)\n    border-radius 0\n    background-color rgba(0, 0, 0, 0.8)\n    font-size 23px\n    color rgba(255, 255, 255, 0.5)\n    transition color 0.2s, opacity 0.2s, visibility 0.2s\n    opacity 1\n    z-index 130\n\n    &:hover\n      color rgba(255, 255, 255, 1)\n\n    &.disabled\n    &.disabled:hover\n      visibility hidden\n      opacity 0\n\n  .prev-button\n    left 0\n    transform rotate(180deg)\n\n  .next-button\n    right 0\n\n.list-wrapper\n  height 100%\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"list-wrapper": "strip__list-wrapper__31Mxz",
	"listWrapper": "strip__list-wrapper__31Mxz",
	"scroll-to-prev": "strip__scroll-to-prev__3KNKk",
	"scrollToPrev": "strip__scroll-to-prev__3KNKk",
	"list": "strip__list__3R8cc",
	"prev": "strip__prev__197wz",
	"prev-move-right": "strip__prev-move-right__2WyUN",
	"prevMoveRight": "strip__prev-move-right__2WyUN",
	"current": "strip__current__1KBFG",
	"current-move-right": "strip__current-move-right__tMTDG",
	"currentMoveRight": "strip__current-move-right__tMTDG",
	"scroll-to-next": "strip__scroll-to-next__3osty",
	"scrollToNext": "strip__scroll-to-next__3osty",
	"next": "strip__next__apskT",
	"next-move-left": "strip__next-move-left__2Dez7",
	"nextMoveLeft": "strip__next-move-left__2Dez7",
	"current-move-left": "strip__current-move-left__2iuHY",
	"currentMoveLeft": "strip__current-move-left__2iuHY",
	"container": "strip__container__3C1Jt",
	"thumbnail-wrapper": "strip__thumbnail-wrapper__uBLxW",
	"thumbnailWrapper": "strip__thumbnail-wrapper__uBLxW",
	"overlay": "strip__overlay__15RBr",
	"next-button": "strip__next-button__1Qpcr",
	"nextButton": "strip__next-button__1Qpcr",
	"prev-button": "strip__prev-button__2wmpE",
	"prevButton": "strip__prev-button__2wmpE",
	"disabled": "strip__disabled__1C79T"
};

/***/ }),

/***/ 1996:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, ".thumbnail-overlay__overlay__1nyI8{position:absolute;top:0;left:0;right:0;bottom:0;z-index:120;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:stretch;align-items:stretch;color:#fff}.thumbnail-overlay__overlay__1nyI8:hover .thumbnail-overlay__next-button__v63mo,.thumbnail-overlay__overlay__1nyI8:hover .thumbnail-overlay__prev-button__3iVa5{opacity:1;pointer-events:auto}.thumbnail-overlay__content__2MZkG{-ms-flex:1 1 auto;flex:1 1 auto}.thumbnail-overlay__content__2MZkG,.thumbnail-overlay__top-content__3DNWA{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center}.thumbnail-overlay__top-content__3DNWA{-ms-flex-pack:center;justify-content:center;-ms-flex:1 1 auto;flex:1 1 auto;max-width:920px}.thumbnail-overlay__top-content__3DNWA .thumbnail-overlay__title__qAwro{width:100%;margin-bottom:25px;font-weight:-wix-fonts-titleFont-weight;font-style:-wix-fonts-titleFont-style;font-family:-wix-fonts-titleFont-family;text-decoration:-wix-fonts-titleFont-decoration;font-size:-wix-fonts-titleFont-size;line-height:normal;text-align:center}.thumbnail-overlay__top-content__3DNWA .thumbnail-overlay__title__qAwro .thumbnail-overlay__preview-text__4n7ex{margin-left:10px;font-size:14px}.thumbnail-overlay__top-content__3DNWA .thumbnail-overlay__publisher__1-LXl{margin-bottom:30px;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;text-align:center;font-size:18px}.thumbnail-overlay__buttons-wrapper__2mXOL{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;height:40px}.thumbnail-overlay__buttons-wrapper__2mXOL:first-child{margin-top:107px}.thumbnail-overlay__buttons-wrapper__2mXOL .thumbnail-overlay__button__rlddz{font-size:18px;white-space:nowrap;line-height:37px}.thumbnail-overlay__buttons-wrapper__2mXOL .thumbnail-overlay__button__rlddz+.thumbnail-overlay__button__rlddz{margin-left:54px}.thumbnail-overlay__rounded-icon__ppGhV{width:37px;height:37px;padding-left:2px;border-color:#fff;border-width:2px}.thumbnail-overlay__button__rlddz{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;height:40px;padding:0;transition:opacity .2s;color:inherit;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:none;text-decoration:-wix-fonts-textFont-decoration;border-radius:0}.thumbnail-overlay__button__rlddz:hover{opacity:.7}.thumbnail-overlay__button__rlddz.thumbnail-overlay__bordered__3ASn8{border:1px solid #fff;background:transparent}.thumbnail-overlay__button__rlddz .thumbnail-overlay__text__1a-yV{margin-bottom:-4px;border-bottom:2px solid #fff;line-height:normal}.thumbnail-overlay__play-icon__-w10y{}@media only screen and (max-width:320px){.thumbnail-overlay__overlay__1nyI8 .thumbnail-overlay__buttons__2EwyB{margin-top:25px}.thumbnail-overlay__overlay__1nyI8 .thumbnail-overlay__buttons__2EwyB .thumbnail-overlay__button__rlddz{margin:0 5px}}.thumbnail-overlay__button__rlddz .thumbnail-overlay__next-icon__26WPJ,.thumbnail-overlay__button__rlddz .thumbnail-overlay__play-icon__-w10y{font-size:14px}.thumbnail-overlay__button__rlddz .thumbnail-overlay__play-icon__-w10y{margin-right:11px}.thumbnail-overlay__button__rlddz .thumbnail-overlay__next-icon__26WPJ{margin-left:11px}@media only screen and (max-width:320px){.thumbnail-overlay__button__rlddz .thumbnail-overlay__play-icon__-w10y{font-size:10px}}.thumbnail-overlay__next-button__v63mo,.thumbnail-overlay__prev-button__3iVa5{transform:translateY(-50%);position:absolute;top:50%;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;opacity:0;font-size:35px;transition:opacity .5s;pointer-events:none}.thumbnail-overlay__prev-button__3iVa5{left:54px}.thumbnail-overlay__next-button__v63mo{right:54px}.thumbnail-overlay__reverse__3VPA4{transform:rotate(180deg)}.thumbnail-overlay__overlay-wrapper__1O3Ad{position:absolute;top:0;left:0;right:0;bottom:0;z-index:1;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:stretch;align-items:stretch;color:#fff}.thumbnail-overlay__overlay-wrapper__1O3Ad.thumbnail-overlay__hovered__23mPL .thumbnail-overlay__background__2-yEm,.thumbnail-overlay__overlay-wrapper__1O3Ad.thumbnail-overlay__visible__1U0vQ .thumbnail-overlay__background__2-yEm,.thumbnail-overlay__overlay-wrapper__1O3Ad:hover .thumbnail-overlay__background__2-yEm{background-color:rgba(0,0,0,.5)}.thumbnail-overlay__overlay-wrapper__1O3Ad.thumbnail-overlay__hovered__23mPL .thumbnail-overlay__content__2MZkG,.thumbnail-overlay__overlay-wrapper__1O3Ad.thumbnail-overlay__visible__1U0vQ .thumbnail-overlay__content__2MZkG,.thumbnail-overlay__overlay-wrapper__1O3Ad:hover .thumbnail-overlay__content__2MZkG{transform:translateZ(0);opacity:1}.thumbnail-overlay__overlay-wrapper__1O3Ad.thumbnail-overlay__visible__1U0vQ:hover .thumbnail-overlay__button__rlddz,.thumbnail-overlay__overlay-wrapper__1O3Ad.thumbnail-overlay__visible__1U0vQ:hover .thumbnail-overlay__title-block__13rfX{opacity:.7}.thumbnail-overlay__overlay-wrapper__1O3Ad.thumbnail-overlay__visible__1U0vQ:hover .thumbnail-overlay__button__rlddz:active,.thumbnail-overlay__overlay-wrapper__1O3Ad.thumbnail-overlay__visible__1U0vQ:hover .thumbnail-overlay__button__rlddz:focus,.thumbnail-overlay__overlay-wrapper__1O3Ad.thumbnail-overlay__visible__1U0vQ:hover .thumbnail-overlay__button__rlddz:hover{opacity:1}.thumbnail-overlay__background__2-yEm{position:absolute;top:0;left:0;right:0;bottom:0;background-color:transparent;transition:background-color .45s ease-in-out}.thumbnail-overlay__content__2MZkG{padding:0;opacity:0;transform:translate3d(0,30px,0);transition:opacity .45s,transform .65s}.thumbnail-overlay__content__2MZkG,.thumbnail-overlay__top-content__3DNWA{width:100%}.thumbnail-overlay__top-content__3DNWA .thumbnail-overlay__title-block__13rfX{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;width:100%;white-space:nowrap;transition:opacity .2s}.thumbnail-overlay__top-content__3DNWA .thumbnail-overlay__title__qAwro{width:calc(100% - 32px);max-width:100%;height:auto;margin:0 16px 14px;font-weight:-wix-fonts-videoInfoFont-weight;font-style:-wix-fonts-videoInfoFont-style;text-decoration:-wix-fonts-videoInfoFont-decoration;font-size:-wix-fonts-videoInfoFont-size}.thumbnail-overlay__top-content__3DNWA .thumbnail-overlay__title__qAwro .thumbnail-overlay__preview-text__4n7ex{display:none}.thumbnail-overlay__top-content__3DNWA .thumbnail-overlay__publisher__1-LXl{width:100%;font-size:14px;margin-bottom:10px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.thumbnail-overlay__top-content__3DNWA .thumbnail-overlay__buttons-wrapper__2mXOL{height:30px}.thumbnail-overlay__top-content__3DNWA .thumbnail-overlay__buttons-wrapper__2mXOL:first-child{margin-top:0}.thumbnail-overlay__top-content__3DNWA .thumbnail-overlay__buttons-wrapper__2mXOL .thumbnail-overlay__button__rlddz{font-size:14px;font-weight:700;line-height:28px}.thumbnail-overlay__top-content__3DNWA .thumbnail-overlay__buttons-wrapper__2mXOL .thumbnail-overlay__button__rlddz+.thumbnail-overlay__button__rlddz{margin-left:28px}.thumbnail-overlay__top-content__3DNWA .thumbnail-overlay__buttons-wrapper__2mXOL .thumbnail-overlay__button__rlddz.thumbnail-overlay__small-buy-button__Sw8f4{margin-left:4px}.thumbnail-overlay__small-buttons__34VwV{visibility:hidden}.thumbnail-overlay__paid-icon__1wbap{}.thumbnail-overlay__paid-icon__1wbap:before{left:-1px;position:relative}.thumbnail-overlay__play-icon__-w10y:before{transform:scale(.8)}.thumbnail-overlay__button__rlddz{height:30px}.thumbnail-overlay__button__rlddz .thumbnail-overlay__icon__2gzrz{font-size:14px}.thumbnail-overlay__button__rlddz .thumbnail-overlay__paid-icon__1wbap,.thumbnail-overlay__button__rlddz .thumbnail-overlay__play-icon__-w10y{width:28px;height:28px}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/videos-list/strip/thumbnail-overlay/src/widget/components/player-overlay/strip/strip.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/videos-list/strip/thumbnail-overlay/src/shared/styles/mixins/position-zeros.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/videos-list/strip/thumbnail-overlay/src/shared/styles/mixins/flex-center.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/videos-list/strip/thumbnail-overlay/thumbnail-overlay.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/videos-list/strip/thumbnail-overlay/src/widget/components/videos-list/strip/thumbnail-overlay/thumbnail-overlay.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/videos-list/strip/thumbnail-overlay/src/shared/styles/mixins/text-overflow.styl"],"names":[],"mappings":"AAEA,mCCDE,kBAAA,MACA,OACA,QACA,SDAA,YAAA,oBACA,aAAA,qBACA,uBAAA,uBACA,oBAAA,UACA,CAGE,gKAEE,UAAA,mBACA,CAEN,mCAIE,kBAAA,aAAA,CAGF,0EANE,oBAAA,aAAA,0BACA,sBAAA,sBACA,kBAAA,CAIF,uCEpBE,qBAAA,uBFuBA,kBAAA,cAAA,eAEA,CAEA,wEACE,WAAA,mBACA,wCACA,sCACA,wCACA,gDACA,oCACA,mBACA,iBACA,CAEA,gHACE,iBAAA,cACA,CAEJ,4EACE,mBAAA,uCACA,qCACA,uCACA,+CACA,kBACA,cACA,CAEJ,2CACE,oBAAA,aAAA,sBACA,mBAAA,WACA,CAEA,uDACE,gBAAA,CAEF,6EACE,eAAA,mBACA,gBACA,CAEA,+GACE,gBAAA,CAEN,wCACE,WAAA,YACA,iBACA,kBACA,gBACA,CAEF,kCE5EE,oBAAA,aAAA,sBACA,mBAAA,qBACA,uBF4EA,YAAA,UACA,uBACA,cACA,uCACA,qCACA,uCACA,qBACA,+CACA,eACA,CAEA,wCACE,UAAA,CAEF,qEACE,sBAAA,sBACA,CAKF,kEACE,mBAAA,6BACA,kBACA,CAEJ,sCAGwC,yCAEpC,sEACE,eAAA,CAEA,wGACE,YAAA,CGKL,CHFD,8IAEE,cAAA,CAEF,uEACE,iBAAA,CAEF,uEACE,gBAAA,CAEoC,yCAEpC,uEACE,cAAA,CGIH,CHFH,8EAEE,2BAAA,kBACA,QACA,oBEvIA,aAAA,sBACA,mBAAA,qBACA,uBFuIA,UAAA,eACA,uBACA,mBACA,CAEF,uCACE,SAAA,CAEF,uCACE,UAAA,CAEF,mCACE,wBAAA,CGOD,2CF5JC,kBAAA,MACA,OACA,QACA,SACA,UGAA,oBACA,aAAA,qBACA,uBAAA,uBACA,oBAAA,UACA,CDgKD,6TC1JK,+BAAA,CD+JL,oTC5JK,wBAAA,SACA,CDiKL,+OC3JO,UAAA,CD+JP,kXCzJS,SAAA,CD8JT,sCF5LC,kBAAA,MACA,OACA,QACA,SACA,6BG8BA,4CACA,CDkKD,mCC9JC,UAAA,UACA,gCACA,sCACA,CDkKD,0ECtKC,UAAA,CDyKD,8EC/JG,oBAAA,aAAA,qBACA,uBAAA,WACA,mBACA,sBACA,CDkKH,wEC/JG,wBAAA,eACA,YACA,mBACA,4CACA,0CACA,oDACA,uCACA,CDkKH,gHC/JK,YAAA,CDkKL,4EC/JG,WAAA,eACA,mBACA,uBCtEF,gBAGE,kBACA,CFuOH,kFCjKG,WAAA,CDoKH,8FCjKK,YAAA,CDoKL,oHCjKK,eAAA,gBACA,gBACA,CDoKL,sJCjKO,gBAAA,CDoKP,+JCjKO,eAAA,CDoKP,yCCjKC,iBAAA,CDoKD,sCAGA,4CCjKG,UAAA,iBACA,CDoKH,4CChKG,mBAAA,CDmKH,kCChKC,WAAA,CDmKD,kEChKG,cAAA,CDmKH,8IChKG,WAAA,WACA,CDoKH","file":"thumbnail-overlay.styl","sourcesContent":["@require '~shared/styles/mixins'\n\n.overlay\n  position-zeros()\n  z-index 120\n  display flex\n  justify-content center\n  align-items stretch\n  color white\n\n  &:hover\n    .prev-button\n    .next-button\n      opacity 1\n      pointer-events auto\n\n.content\n  display flex\n  flex-direction column\n  align-items center\n  flex 1 1 auto\n  width 100%\n\n.top-content\n  flex-center()\n  flex-direction column\n  flex 1 1 auto\n  width 100%\n  max-width 920px\n\n  .title\n    width 100%\n    margin-bottom 25px\n    font-weight -wix-fonts-titleFont-weight\n    font-style -wix-fonts-titleFont-style\n    font-family -wix-fonts-titleFont-family\n    text-decoration -wix-fonts-titleFont-decoration\n    font-size -wix-fonts-titleFont-size\n    line-height normal\n    text-align center\n\n    .preview-text\n      margin-left 10px\n      font-size 14px\n\n  .publisher\n    margin-bottom 30px\n    font-weight -wix-fonts-textFont-weight\n    font-style -wix-fonts-textFont-style\n    font-family -wix-fonts-textFont-family\n    text-decoration -wix-fonts-textFont-decoration\n    text-align center\n    font-size 18px\n\n.buttons-wrapper\n  display flex\n  align-items center\n  height 40px\n\n  &:first-child\n    margin-top 107px\n\n  .button\n    font-size 18px\n    white-space nowrap\n    line-height 37px\n\n    + .button\n      margin-left 54px\n\n.rounded-icon\n  width 37px\n  height 37px\n  padding-left 2px\n  border-color white\n  border-width 2px\n\n.button\n  flex-center()\n  height 40px\n  padding 0\n  transition opacity 0.2s\n  color inherit\n  font-weight -wix-fonts-textFont-weight\n  font-style -wix-fonts-textFont-style\n  font-family -wix-fonts-textFont-family\n  text-decoration none // default value\n  text-decoration -wix-fonts-textFont-decoration\n  border-radius 0\n\n  &:hover\n    opacity 0.7\n\n  &.bordered\n    border 1px solid white\n    background transparent\n\n  .icon\n    font-size 14px\n\n  .text\n    margin-bottom -4px\n    border-bottom 2px solid white\n    line-height normal\n\n.play-icon\n  composes rounded-icon\n\n@media only screen and (max-width: 320px)\n  .overlay\n    .buttons\n      margin-top 25px\n\n      .button\n        margin 0 5px\n\n.button\n  .play-icon\n  .next-icon\n    font-size 14px\n\n  .play-icon\n    margin-right 11px\n\n  .next-icon\n    margin-left 11px\n\n@media only screen and (max-width: 320px)\n  .button\n    .play-icon\n      font-size 10px\n\n.prev-button\n.next-button\n  transform translateY(-50%)\n  position absolute\n  top 50%\n  flex-center()\n  opacity 0\n  font-size 35px\n  transition opacity 0.5s\n  pointer-events none\n\n.prev-button\n  left 54px\n\n.next-button\n  right 54px\n\n.reverse\n  transform rotate(180deg)\n","position-zeros(position = absolute)\n  position position\n  top 0\n  left 0\n  right 0\n  bottom 0\n","flex-center(display = flex)\n  display display\n  align-items center\n  justify-content center\n",".overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 120;\n  display: flex;\n  justify-content: center;\n  align-items: stretch;\n  color: #fff;\n}\n.overlay:hover .prev-button,\n.overlay:hover .next-button {\n  opacity: 1;\n  pointer-events: auto;\n}\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1 1 auto;\n  width: 100%;\n}\n.top-content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  flex: 1 1 auto;\n  width: 100%;\n  max-width: 920px;\n}\n.top-content .title {\n  width: 100%;\n  margin-bottom: 25px;\n  font-weight: -wix-fonts-titleFont-weight;\n  font-style: -wix-fonts-titleFont-style;\n  font-family: -wix-fonts-titleFont-family;\n  text-decoration: -wix-fonts-titleFont-decoration;\n  font-size: -wix-fonts-titleFont-size;\n  line-height: normal;\n  text-align: center;\n}\n.top-content .title .preview-text {\n  margin-left: 10px;\n  font-size: 14px;\n}\n.top-content .publisher {\n  margin-bottom: 30px;\n  font-weight: -wix-fonts-textFont-weight;\n  font-style: -wix-fonts-textFont-style;\n  font-family: -wix-fonts-textFont-family;\n  text-decoration: -wix-fonts-textFont-decoration;\n  text-align: center;\n  font-size: 18px;\n}\n.buttons-wrapper {\n  display: flex;\n  align-items: center;\n  height: 40px;\n}\n.buttons-wrapper:first-child {\n  margin-top: 107px;\n}\n.buttons-wrapper .button {\n  font-size: 18px;\n  white-space: nowrap;\n  line-height: 37px;\n}\n.buttons-wrapper .button + .button {\n  margin-left: 54px;\n}\n.rounded-icon {\n  width: 37px;\n  height: 37px;\n  padding-left: 2px;\n  border-color: #fff;\n  border-width: 2px;\n}\n.button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n  padding: 0;\n  transition: opacity 0.2s;\n  color: inherit;\n  font-weight: -wix-fonts-textFont-weight;\n  font-style: -wix-fonts-textFont-style;\n  font-family: -wix-fonts-textFont-family;\n  text-decoration: none;\n  text-decoration: -wix-fonts-textFont-decoration;\n  border-radius: 0;\n}\n.button:hover {\n  opacity: 0.7;\n}\n.button.bordered {\n  border: 1px solid #fff;\n  background: transparent;\n}\n.button .icon {\n  font-size: 14px;\n}\n.button .text {\n  margin-bottom: -4px;\n  border-bottom: 2px solid #fff;\n  line-height: normal;\n}\n.play-icon {\n  composes: rounded-icon;\n}\n@media only screen and (max-width: 320px) {\n  .overlay .buttons {\n    margin-top: 25px;\n  }\n  .overlay .buttons .button {\n    margin: 0 5px;\n  }\n}\n.button .play-icon,\n.button .next-icon {\n  font-size: 14px;\n}\n.button .play-icon {\n  margin-right: 11px;\n}\n.button .next-icon {\n  margin-left: 11px;\n}\n@media only screen and (max-width: 320px) {\n  .button .play-icon {\n    font-size: 10px;\n  }\n}\n.prev-button,\n.next-button {\n  transform: translateY(-50%);\n  position: absolute;\n  top: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  font-size: 35px;\n  transition: opacity 0.5s;\n  pointer-events: none;\n}\n.prev-button {\n  left: 54px;\n}\n.next-button {\n  right: 54px;\n}\n.reverse {\n  transform: rotate(180deg);\n}\n.overlay-wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1;\n  display: flex;\n  justify-content: center;\n  align-items: stretch;\n  color: #fff;\n}\n.overlay-wrapper.hovered .background,\n.overlay-wrapper.visible .background,\n.overlay-wrapper:hover .background {\n  background-color: rgba(0,0,0,0.5);\n}\n.overlay-wrapper.hovered .content,\n.overlay-wrapper.visible .content,\n.overlay-wrapper:hover .content {\n  transform: translate3d(0, 0, 0);\n  opacity: 1;\n}\n.overlay-wrapper.visible:hover .title-block,\n.overlay-wrapper.visible:hover .button {\n  opacity: 0.7;\n}\n.overlay-wrapper.visible:hover .button:hover,\n.overlay-wrapper.visible:hover .button:active,\n.overlay-wrapper.visible:hover .button:focus {\n  opacity: 1;\n}\n.background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: transparent;\n  transition: background-color 0.45s ease-in-out;\n}\n.content {\n  width: 100%;\n  padding: 0;\n  opacity: 0;\n  transform: translate3d(0, 30px, 0);\n  transition: opacity 0.45s, transform 0.65s;\n}\n.top-content {\n  width: 100%;\n}\n.top-content .title-block {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  white-space: nowrap;\n  transition: opacity 0.2s;\n}\n.top-content .title {\n  width: calc(100% - 32px);\n  max-width: 100%;\n  height: auto;\n  margin: 0 16px 14px;\n  font-weight: -wix-fonts-videoInfoFont-weight;\n  font-style: -wix-fonts-videoInfoFont-style;\n  text-decoration: -wix-fonts-videoInfoFont-decoration;\n  font-size: -wix-fonts-videoInfoFont-size;\n}\n.top-content .title .preview-text {\n  display: none;\n}\n.top-content .publisher {\n  width: 100%;\n  font-size: 14px;\n  margin-bottom: 10px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.top-content .buttons-wrapper {\n  height: 30px;\n}\n.top-content .buttons-wrapper:first-child {\n  margin-top: 0;\n}\n.top-content .buttons-wrapper .button {\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 28px;\n}\n.top-content .buttons-wrapper .button + .button {\n  margin-left: 28px;\n}\n.top-content .buttons-wrapper .button.small-buy-button {\n  margin-left: 4px;\n}\n.small-buttons {\n  visibility: hidden;\n}\n.paid-icon {\n  composes: rounded-icon;\n}\n.paid-icon:before {\n  left: -1px;\n  position: relative;\n}\n.play-icon:before {\n  transform: scale(0.8);\n}\n.button {\n  height: 30px;\n}\n.button .icon {\n  font-size: 14px;\n}\n.button .play-icon,\n.button .paid-icon {\n  width: 28px;\n  height: 28px;\n}\n/*# sourceMappingURL=src/widget/components/videos-list/strip/thumbnail-overlay/thumbnail-overlay.css.map */","@require '~shared/styles/mixins'\n@require '~widget/components/player-overlay/strip/strip'\n\n.overlay-wrapper\n  position-zeros()\n  z-index 1\n  display flex\n  justify-content center\n  align-items stretch\n  color white\n\n  &.hovered\n  &.visible\n  &:hover\n    .background\n      background-color alpha(black, 0.5)\n\n    .content\n      transform translate3d(0, 0, 0)\n      opacity 1\n\n  &.visible\n    &:hover\n      .title-block\n      .button\n        opacity 0.7\n\n      .button\n        &:hover\n        &:active\n        &:focus\n          opacity 1\n\n.background\n  position-zeros()\n  background-color transparent\n  transition background-color 0.45s ease-in-out;\n\n.content\n  width 100%\n  padding 0\n  opacity 0\n  transform translate3d(0, 30px, 0)\n  transition opacity 0.45s, transform 0.65s\n\n.top-content\n  width 100%\n\n  .title-block\n    display flex\n    justify-content center\n    width 100%\n    white-space nowrap\n    transition opacity 0.2s\n\n  .title\n    width calc(100% - 32px)\n    max-width 100%\n    height auto\n    margin 0 16px 14px\n    font-weight -wix-fonts-videoInfoFont-weight\n    font-style -wix-fonts-videoInfoFont-style\n    text-decoration -wix-fonts-videoInfoFont-decoration\n    font-size -wix-fonts-videoInfoFont-size\n\n    .preview-text\n      display none\n\n  .publisher\n    width 100%\n    font-size 14px\n    margin-bottom 10px\n    text-overflow()\n\n  .buttons-wrapper\n    height 30px\n\n    &:first-child\n      margin-top 0\n\n    .button\n      font-size 14px\n      font-weight bold\n      line-height 28px\n\n      + .button\n        margin-left 28px\n\n      &.small-buy-button\n        margin-left 4px\n\n.small-buttons\n  visibility hidden\n\n.paid-icon\n  composes rounded-icon\n\n  &:before\n    left -1px\n    position relative\n\n.play-icon\n  &:before\n    transform scale(0.8)\n\n.button\n  height 30px\n\n  .icon\n    font-size 14px\n\n  .play-icon, .paid-icon\n    width 28px\n    height 28px\n","text-overflow(type = ellipsis)\n  text-overflow type\n\n  if type == ellipsis\n    overflow hidden\n    white-space nowrap\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"overlay": "thumbnail-overlay__overlay__1nyI8",
	"next-button": "thumbnail-overlay__next-button__v63mo",
	"nextButton": "thumbnail-overlay__next-button__v63mo",
	"prev-button": "thumbnail-overlay__prev-button__3iVa5",
	"prevButton": "thumbnail-overlay__prev-button__3iVa5",
	"content": "thumbnail-overlay__content__2MZkG",
	"top-content": "thumbnail-overlay__top-content__3DNWA",
	"topContent": "thumbnail-overlay__top-content__3DNWA",
	"title": "thumbnail-overlay__title__qAwro",
	"preview-text": "thumbnail-overlay__preview-text__4n7ex",
	"previewText": "thumbnail-overlay__preview-text__4n7ex",
	"publisher": "thumbnail-overlay__publisher__1-LXl",
	"buttons-wrapper": "thumbnail-overlay__buttons-wrapper__2mXOL",
	"buttonsWrapper": "thumbnail-overlay__buttons-wrapper__2mXOL",
	"button": "thumbnail-overlay__button__rlddz",
	"rounded-icon": "thumbnail-overlay__rounded-icon__ppGhV",
	"roundedIcon": "thumbnail-overlay__rounded-icon__ppGhV",
	"bordered": "thumbnail-overlay__bordered__3ASn8",
	"text": "thumbnail-overlay__text__1a-yV",
	"play-icon": "thumbnail-overlay__play-icon__-w10y thumbnail-overlay__rounded-icon__ppGhV",
	"playIcon": "thumbnail-overlay__play-icon__-w10y thumbnail-overlay__rounded-icon__ppGhV",
	"buttons": "thumbnail-overlay__buttons__2EwyB",
	"next-icon": "thumbnail-overlay__next-icon__26WPJ",
	"nextIcon": "thumbnail-overlay__next-icon__26WPJ",
	"reverse": "thumbnail-overlay__reverse__3VPA4",
	"overlay-wrapper": "thumbnail-overlay__overlay-wrapper__1O3Ad",
	"overlayWrapper": "thumbnail-overlay__overlay-wrapper__1O3Ad",
	"hovered": "thumbnail-overlay__hovered__23mPL",
	"background": "thumbnail-overlay__background__2-yEm",
	"visible": "thumbnail-overlay__visible__1U0vQ",
	"title-block": "thumbnail-overlay__title-block__13rfX",
	"titleBlock": "thumbnail-overlay__title-block__13rfX",
	"small-buy-button": "thumbnail-overlay__small-buy-button__Sw8f4",
	"smallBuyButton": "thumbnail-overlay__small-buy-button__Sw8f4",
	"small-buttons": "thumbnail-overlay__small-buttons__34VwV",
	"smallButtons": "thumbnail-overlay__small-buttons__34VwV",
	"paid-icon": "thumbnail-overlay__paid-icon__1wbap thumbnail-overlay__rounded-icon__ppGhV",
	"paidIcon": "thumbnail-overlay__paid-icon__1wbap thumbnail-overlay__rounded-icon__ppGhV",
	"icon": "thumbnail-overlay__icon__2gzrz"
};

/***/ }),

/***/ 1997:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, ".mobile__container__19cXa{background-color:-wix-colors-backgroundColor;box-sizing:border-box}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/layouts/mobile/src/widget/layouts/mobile/mobile.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/layouts/mobile/mobile.styl"],"names":[],"mappings":"AAAA,0BACE,6CAAA,qBACA,CCCD","file":"mobile.styl","sourcesContent":[".container\n  background-color -wix-colors-backgroundColor\n  box-sizing border-box\n",".container {\n  background-color: -wix-colors-backgroundColor;\n  box-sizing: border-box;\n}\n/*# sourceMappingURL=src/widget/layouts/mobile/mobile.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "mobile__container__19cXa"
};

/***/ }),

/***/ 2019:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, ".classic__spinner-container__1Q6ZD{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;background-color:-wix-colors-backgroundColor}.classic__spinner__347tM{color:-wix-colors-buttonsAndLinksColor}.classic__container__1jqwh{-ms-flex-direction:column;flex-direction:column;background-color:-wix-colors-backgroundColor;padding:0 20px 20px;box-sizing:border-box}.classic__container__1jqwh,.classic__header__atND2{display:-ms-flexbox;display:flex}.classic__header__atND2{height:55px;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between}.classic__empty-header__1q6EO{height:20px}.classic__channel-name__6j6Ar{font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;font-size:18px;margin-right:20px;color:-wix-colors-textColor;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:100%;flex-basis:100%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.classic__action__3Pkox{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:0 20px;height:20px;border-right:1px solid -wix-colors-textColor-20}.classic__action__3Pkox:last-child{padding-right:0;border-right:none}.classic__player-wrapper__S5v5r{position:relative}.classic__player__O-T8Z{-ms-flex:0 0 auto;flex:0 0 auto}.classic__content__2PN0E,.classic__player__O-T8Z{display:-ms-flexbox;display:flex}.classic__content__2PN0E{-ms-flex-direction:column;flex-direction:column;margin-top:15px;-ms-flex:1;flex:1}.classic__no-search-bar__2LNDE{margin-top:5px}.classic__search-line__1fzGA{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:end;justify-content:flex-end;font-family:HelveticaNeueW01-55Roma,HelveticaNeueW02-55Roma,HelveticaNeueW10-55Roma,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;font-size:14px;line-height:32px;-ms-flex:0 0 auto;flex:0 0 auto}.classic__search__2CJtk{-ms-flex:1;flex:1}.classic__categories__3wMY9{height:32px;width:162px;margin:5px 0}.classic__tags-wrapper__3ykcY{overflow:hidden;height:100%;padding-top:12px}.classic__tags__3dhpP,.classic__videos__3dhsr{position:relative;-ms-flex:1;flex:1}.classic__videos__3dhsr{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:justify;justify-content:space-between;margin-top:15px}.classic__channel-info-modal__oBZBG{background-color:-wix-colors-backgroundColor-95}.classic__channel-info-window__3vb1H{border-radius:0;max-height:656px;height:100%;width:624px}@media screen and (max-height:738px){.classic__channel-info-window__3vb1H{max-height:calc(100% - 60px)}}.classic__channel-info-modal-content__1icrk{height:100%;padding:0}.classic__coming-soon__8PRei{-ms-flex-align:center;-ms-flex-pack:center;-ms-flex:1;flex:1;color:-wix-colors-textColor;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;font-size:20px}.classic__coming-soon__8PRei,.classic__no-player__2646x{display:-ms-flexbox;display:flex;align-items:center;justify-content:center}.classic__no-player__2646x{-ms-flex-align:center;-ms-flex-pack:center;pointer-events:none}.classic__view-mode-editor__2D6Ry .classic__no-player__2646x{background-color:-wix-colors-emptyPlayerBgEditor}.classic__view-mode-editor__2D6Ry .classic__no-player__2646x .classic__no-player-play__3HXdf{border-color:-wix-colors-emptyPlayIconEditor;color:-wix-colors-emptyPlayIconEditor}.classic__view-mode-preview__1s6lm .classic__no-player__2646x,.classic__view-mode-site__2ktdo .classic__no-player__2646x{background-color:-wix-colors-emptyPlayerBgSite}.classic__view-mode-preview__1s6lm .classic__no-player__2646x .classic__no-player-play__3HXdf,.classic__view-mode-site__2ktdo .classic__no-player__2646x .classic__no-player-play__3HXdf{border-color:-wix-colors-emptyPlayIconSite;color:-wix-colors-emptyPlayIconSite}.classic__no-player__2646x .classic__no-player-play__3HXdf{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:51px;height:51px;border:1px solid transparent;border-radius:50%;font-size:22px}.classic__no-player__2646x .classic__no-player-play__3HXdf:before{transform:translate(3px,1px)}.classic__overlay-only__1Z-_S{display:-ms-flexbox;display:flex;position:relative}.classic__view-mode-editor__2D6Ry .classic__overlay-only__1Z-_S{background-color:-wix-colors-emptyPlayerBgEditor}.classic__view-mode-preview__1s6lm .classic__overlay-only__1Z-_S,.classic__view-mode-site__2ktdo .classic__overlay-only__1Z-_S{background-color:-wix-colors-emptyPlayerBgSite}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/views/desktop/classic/src/widget/views/desktop/classic/classic.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/views/desktop/classic/src/shared/styles/mixins/position-zeros.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/views/desktop/classic/src/shared/styles/mixins/flex-center.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/views/desktop/classic/src/shared/styles/mixins/text-overflow.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/views/desktop/classic/src/shared/styles/mixins/fonts.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/views/desktop/classic/classic.styl"],"names":[],"mappings":"AAEA,mCCDE,kBAAA,MACA,OACA,QACA,SACA,oBCJA,aAAA,sBACA,mBAAA,qBACA,uBFEA,4CAAA,CAEF,yBACE,sCAAA,CAEF,2BAEE,0BAAA,sBAAA,6CACA,oBACA,qBACA,CAEF,mDANE,oBAAA,YAAA,CAMF,wBACE,YAAA,uBAEA,mBAAA,sBACA,mBAAA,sBACA,6BAAA,CAEF,8BACE,WAAA,CAEF,8BACE,uCAAA,qCACA,uCACA,+CACA,eACA,kBACA,4BACA,oBACA,YAAA,6BACA,gBAAA,uBGnCA,gBHqCA,kBAAA,CAEF,wBACE,oBAAA,aAAA,sBACA,mBAAA,eACA,YACA,+CACA,CAEA,mCACE,gBAAA,iBACA,CAEJ,gCACE,iBAAA,CAEF,wBAEE,kBAAA,aAAA,CAEF,iDAHE,oBAAA,YAAA,CAGF,yBAEE,0BAAA,sBAAA,gBACA,WACA,MAAA,CAEF,+BACE,cAAA,CAEF,6BACE,oBAAA,aAAA,uBACA,mBAAA,kBACA,yBAAA,oII9DA,eAGE,iBJ6DF,kBAAA,aAAA,CAEF,wBACE,WAAA,MAAA,CAEF,4BACE,YAAA,YACA,YACA,CAEF,8BACE,gBAAA,YACA,gBACA,CAEF,8CAEE,kBAAA,WACA,MAAA,CAEF,wBACE,oBAAA,aAAA,0BACA,sBAAA,sBACA,8BAAA,eACA,CAEF,oCACE,+CAAA,CAEF,qCACE,gBAAA,iBACA,YACA,WACA,CAEmC,qCAAA,qCACjC,4BAAA,CKUD,CLRH,4CACE,YAAA,SACA,CAEF,6BEhHE,sBAAA,qBFkHA,WAAA,OAAA,4BACA,uCACA,qCACA,uCACA,+CACA,cACA,CAEF,wDE3HE,oBAAA,aAAA,mBACA,sBACA,CFyHF,2BE1HE,sBAAA,qBF4HA,mBAAA,CAEA,6DACE,gDAAA,CAEA,6FACE,6CAAA,qCACA,CAEJ,yHAEE,8CAAA,CAEA,yLACE,2CAAA,mCACA,CAEJ,2DE9IA,oBAAA,aAAA,sBACA,mBAAA,qBACA,uBF8IE,WAAA,YACA,6BACA,kBACA,cACA,CAEA,kEACE,4BAAA,CAEN,8BACE,oBAAA,aAAA,iBACA,CAEA,gEACE,gDAAA,CAEF,+HAEE,8CAAA,CKkBH","file":"classic.styl","sourcesContent":["@require '~shared/styles/mixins'\n\n.spinner-container\n  position-zeros()\n  flex-center()\n  background-color -wix-colors-backgroundColor\n\n.spinner\n  color -wix-colors-buttonsAndLinksColor\n\n.container\n  display flex\n  flex-direction column\n  background-color -wix-colors-backgroundColor\n  padding 0 20px 20px 20px\n  box-sizing border-box\n\n.header\n  height 55px\n  display flex\n  flex-direction row\n  align-items center\n  justify-content space-between\n\n.empty-header\n  height 20px\n\n.channel-name\n  font-weight -wix-fonts-textFont-weight\n  font-style -wix-fonts-textFont-style\n  font-family -wix-fonts-textFont-family\n  text-decoration -wix-fonts-textFont-decoration\n  font-size 18px\n  margin-right 20px\n  color -wix-colors-textColor\n  flex-grow 1\n  flex-basis 100%\n  text-overflow ellipsis\n  white-space nowrap\n\n.action\n  display flex\n  align-items center\n  padding 0 20px\n  height 20px\n  border-right 1px solid -wix-colors-textColor-20\n\n  &:last-child\n    padding-right 0\n    border-right none\n\n.player-wrapper\n  position relative\n\n.player\n  display flex\n  flex 0 0 auto\n\n.content\n  display flex\n  flex-direction column\n  margin-top 15px\n  flex 1\n\n.no-search-bar\n  margin-top 5px\n\n.search-line\n  display flex\n  flex-direction row\n  justify-content flex-end\n  helvetica-55-roma(14px, 32px)\n  flex 0 0 auto\n\n.search\n  flex 1\n\n.categories\n  height 32px\n  width 162px\n  margin 5px 0\n\n.tags-wrapper\n  overflow hidden\n  height 100%\n  padding-top 12px\n\n.videos\n.tags\n  position relative\n  flex 1\n\n.videos\n  display flex\n  flex-direction column\n  justify-content space-between\n  margin-top 15px\n\n.channel-info-modal\n  background-color -wix-colors-backgroundColor-95\n\n.channel-info-window\n  border-radius 0\n  max-height 656px\n  height 100%\n  width 624px\n\n  @media screen and (max-height 738px)\n    max-height calc(100% - 60px)\n\n.channel-info-modal-content\n  height 100%\n  padding 0\n\n.coming-soon\n  flex-center()\n  flex 1\n  color -wix-colors-textColor\n  font-weight -wix-fonts-textFont-weight\n  font-style -wix-fonts-textFont-style\n  font-family -wix-fonts-textFont-family\n  text-decoration -wix-fonts-textFont-decoration\n  font-size 20px\n\n.no-player\n  flex-center()\n  pointer-events none\n\n  .view-mode-editor &\n    background-color -wix-colors-emptyPlayerBgEditor\n\n    .no-player-play\n      border-color -wix-colors-emptyPlayIconEditor\n      color -wix-colors-emptyPlayIconEditor\n\n  .view-mode-preview &\n  .view-mode-site &\n    background-color -wix-colors-emptyPlayerBgSite\n\n    .no-player-play\n      border-color -wix-colors-emptyPlayIconSite\n      color -wix-colors-emptyPlayIconSite\n\n  .no-player-play\n    flex-center()\n    width 51px\n    height 51px\n    border 1px solid transparent\n    border-radius 50%\n    font-size 22px\n\n    &:before\n      transform translate(3px, 1px)\n\n.overlay-only\n  display flex\n  position relative\n\n  .view-mode-editor &\n    background-color -wix-colors-emptyPlayerBgEditor\n\n  .view-mode-preview &\n  .view-mode-site &\n    background-color -wix-colors-emptyPlayerBgSite\n\n","position-zeros(position = absolute)\n  position position\n  top 0\n  left 0\n  right 0\n  bottom 0\n","flex-center(display = flex)\n  display display\n  align-items center\n  justify-content center\n","text-overflow(type = ellipsis)\n  text-overflow type\n\n  if type == ellipsis\n    overflow hidden\n    white-space nowrap\n","font-default = \"Helvetica Neue\", \"ruble\", Helvetica, Arial, sans-serif\nfont-helvetica-35-thin = \"HelveticaNeueW01-Thin\", \"HelveticaNeueW02-Thin\", \"HelveticaNeueW10-35Thin\", font-default\nfont-helvetica-45-ligh = \"HelveticaNeueW01-45Ligh\", \"HelveticaNeueW02-45Ligh\", \"HelveticaNeueW10-45Ligh\", font-default\nfont-helvetica-55-roma = \"HelveticaNeueW01-55Roma\", \"HelveticaNeueW02-55Roma\", \"HelveticaNeueW10-55Roma\", font-default\nfont-helvetica-65-medi = \"HelveticaNeueW01-65Medi\", \"HelveticaNeueW02-65Medi\", \"HelveticaNeueW10-65Medi\", font-default\nfont-helvetica-75-bold = \"HelveticaNeueW01-75Bold\", \"HelveticaNeueW02-75Bold\", \"HelveticaNeueW10-75Bold\", font-default\n\n_helvetica-font(font-family, font-size = null, line-height = null, font-weight = null)\n  font-family font-family\n\n  if font-size != null\n    font-size font-size\n\n  if line-height != null\n    line-height line-height\n\n  if font-weight != null\n    font-weight font-weight\n\nhelvetica-35-thin(font-size = null, line-height = null, font-weight = 100)\n  _helvetica-font(font-helvetica-35-thin, font-size, line-height, font-weight)\n\nhelvetica-45-ligh(font-size = null, line-height = null, font-weight = 300)\n  _helvetica-font(font-helvetica-45-ligh, font-size, line-height, font-weight)\n\nhelvetica-55-roma(font-size = null, line-height = null, font-weight = null)\n  _helvetica-font(font-helvetica-55-roma, font-size, line-height, font-weight)\n\nhelvetica-65-medi(font-size = null, line-height = null, font-weight = 500)\n  _helvetica-font(font-helvetica-65-medi, font-size, line-height, font-weight)\n\nhelvetica-75-bold(font-size = null, line-height = null, font-weight = null)\n  _helvetica-font(font-helvetica-75-bold, font-size, line-height, font-weight)\n",".spinner-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: -wix-colors-backgroundColor;\n}\n.spinner {\n  color: -wix-colors-buttonsAndLinksColor;\n}\n.container {\n  display: flex;\n  flex-direction: column;\n  background-color: -wix-colors-backgroundColor;\n  padding: 0 20px 20px 20px;\n  box-sizing: border-box;\n}\n.header {\n  height: 55px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n.empty-header {\n  height: 20px;\n}\n.channel-name {\n  font-weight: -wix-fonts-textFont-weight;\n  font-style: -wix-fonts-textFont-style;\n  font-family: -wix-fonts-textFont-family;\n  text-decoration: -wix-fonts-textFont-decoration;\n  font-size: 18px;\n  margin-right: 20px;\n  color: -wix-colors-textColor;\n  flex-grow: 1;\n  flex-basis: 100%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  white-space: nowrap;\n}\n.action {\n  display: flex;\n  align-items: center;\n  padding: 0 20px;\n  height: 20px;\n  border-right: 1px solid -wix-colors-textColor-20;\n}\n.action:last-child {\n  padding-right: 0;\n  border-right: none;\n}\n.player-wrapper {\n  position: relative;\n}\n.player {\n  display: flex;\n  flex: 0 0 auto;\n}\n.content {\n  display: flex;\n  flex-direction: column;\n  margin-top: 15px;\n  flex: 1;\n}\n.no-search-bar {\n  margin-top: 5px;\n}\n.search-line {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  font-family: \"HelveticaNeueW01-55Roma\", \"HelveticaNeueW02-55Roma\", \"HelveticaNeueW10-55Roma\", \"Helvetica Neue\", \"ruble\", Helvetica, Arial, sans-serif;\n  font-size: 14px;\n  line-height: 32px;\n  flex: 0 0 auto;\n}\n.search {\n  flex: 1;\n}\n.categories {\n  height: 32px;\n  width: 162px;\n  margin: 5px 0;\n}\n.tags-wrapper {\n  overflow: hidden;\n  height: 100%;\n  padding-top: 12px;\n}\n.videos,\n.tags {\n  position: relative;\n  flex: 1;\n}\n.videos {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  margin-top: 15px;\n}\n.channel-info-modal {\n  background-color: -wix-colors-backgroundColor-95;\n}\n.channel-info-window {\n  border-radius: 0;\n  max-height: 656px;\n  height: 100%;\n  width: 624px;\n}\n@media screen and (max-height: 738px) {\n  .channel-info-window {\n    max-height: calc(100% - 60px);\n  }\n}\n.channel-info-modal-content {\n  height: 100%;\n  padding: 0;\n}\n.coming-soon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  color: -wix-colors-textColor;\n  font-weight: -wix-fonts-textFont-weight;\n  font-style: -wix-fonts-textFont-style;\n  font-family: -wix-fonts-textFont-family;\n  text-decoration: -wix-fonts-textFont-decoration;\n  font-size: 20px;\n}\n.no-player {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n}\n.view-mode-editor .no-player {\n  background-color: -wix-colors-emptyPlayerBgEditor;\n}\n.view-mode-editor .no-player .no-player-play {\n  border-color: -wix-colors-emptyPlayIconEditor;\n  color: -wix-colors-emptyPlayIconEditor;\n}\n.view-mode-preview .no-player,\n.view-mode-site .no-player {\n  background-color: -wix-colors-emptyPlayerBgSite;\n}\n.view-mode-preview .no-player .no-player-play,\n.view-mode-site .no-player .no-player-play {\n  border-color: -wix-colors-emptyPlayIconSite;\n  color: -wix-colors-emptyPlayIconSite;\n}\n.no-player .no-player-play {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 51px;\n  height: 51px;\n  border: 1px solid transparent;\n  border-radius: 50%;\n  font-size: 22px;\n}\n.no-player .no-player-play:before {\n  transform: translate(3px, 1px);\n}\n.overlay-only {\n  display: flex;\n  position: relative;\n}\n.view-mode-editor .overlay-only {\n  background-color: -wix-colors-emptyPlayerBgEditor;\n}\n.view-mode-preview .overlay-only,\n.view-mode-site .overlay-only {\n  background-color: -wix-colors-emptyPlayerBgSite;\n}\n/*# sourceMappingURL=src/widget/views/desktop/classic/classic.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"spinner-container": "classic__spinner-container__1Q6ZD",
	"spinnerContainer": "classic__spinner-container__1Q6ZD",
	"spinner": "classic__spinner__347tM",
	"container": "classic__container__1jqwh",
	"header": "classic__header__atND2",
	"empty-header": "classic__empty-header__1q6EO",
	"emptyHeader": "classic__empty-header__1q6EO",
	"channel-name": "classic__channel-name__6j6Ar",
	"channelName": "classic__channel-name__6j6Ar",
	"action": "classic__action__3Pkox",
	"player-wrapper": "classic__player-wrapper__S5v5r",
	"playerWrapper": "classic__player-wrapper__S5v5r",
	"player": "classic__player__O-T8Z",
	"content": "classic__content__2PN0E",
	"no-search-bar": "classic__no-search-bar__2LNDE",
	"noSearchBar": "classic__no-search-bar__2LNDE",
	"search-line": "classic__search-line__1fzGA",
	"searchLine": "classic__search-line__1fzGA",
	"search": "classic__search__2CJtk",
	"categories": "classic__categories__3wMY9",
	"tags-wrapper": "classic__tags-wrapper__3ykcY",
	"tagsWrapper": "classic__tags-wrapper__3ykcY",
	"tags": "classic__tags__3dhpP",
	"videos": "classic__videos__3dhsr",
	"channel-info-modal": "classic__channel-info-modal__oBZBG",
	"channelInfoModal": "classic__channel-info-modal__oBZBG",
	"channel-info-window": "classic__channel-info-window__3vb1H",
	"channelInfoWindow": "classic__channel-info-window__3vb1H",
	"channel-info-modal-content": "classic__channel-info-modal-content__1icrk",
	"channelInfoModalContent": "classic__channel-info-modal-content__1icrk",
	"coming-soon": "classic__coming-soon__8PRei",
	"comingSoon": "classic__coming-soon__8PRei",
	"no-player": "classic__no-player__2646x",
	"noPlayer": "classic__no-player__2646x",
	"view-mode-editor": "classic__view-mode-editor__2D6Ry",
	"viewModeEditor": "classic__view-mode-editor__2D6Ry",
	"no-player-play": "classic__no-player-play__3HXdf",
	"noPlayerPlay": "classic__no-player-play__3HXdf",
	"view-mode-preview": "classic__view-mode-preview__1s6lm",
	"viewModePreview": "classic__view-mode-preview__1s6lm",
	"view-mode-site": "classic__view-mode-site__2ktdo",
	"viewModeSite": "classic__view-mode-site__2ktdo",
	"overlay-only": "classic__overlay-only__1Z-_S",
	"overlayOnly": "classic__overlay-only__1Z-_S"
};

/***/ }),

/***/ 2020:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, ".compact__spinner-container__3f9bN{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;background-color:-wix-colors-backgroundColor}.compact__spinner__33deO{color:-wix-colors-buttonsAndLinksColor}.compact__container__MSSfa{background-color:-wix-colors-backgroundColor}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/views/desktop/compact/src/widget/views/desktop/compact/compact.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/views/desktop/compact/src/shared/styles/mixins/position-zeros.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/views/desktop/compact/src/shared/styles/mixins/flex-center.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/views/desktop/compact/compact.styl"],"names":[],"mappings":"AAEA,mCCDE,kBAAA,MACA,OACA,QACA,SACA,oBCJA,aAAA,sBACA,mBAAA,qBACA,uBFEA,4CAAA,CAEF,yBACE,sCAAA,CAEF,2BACE,4CAAA,CGKD","file":"compact.styl","sourcesContent":["@require '~shared/styles/mixins'\n\n.spinner-container\n  position-zeros()\n  flex-center()\n  background-color -wix-colors-backgroundColor\n\n.spinner\n  color -wix-colors-buttonsAndLinksColor\n\n.container\n  background-color -wix-colors-backgroundColor\n","position-zeros(position = absolute)\n  position position\n  top 0\n  left 0\n  right 0\n  bottom 0\n","flex-center(display = flex)\n  display display\n  align-items center\n  justify-content center\n",".spinner-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: -wix-colors-backgroundColor;\n}\n.spinner {\n  color: -wix-colors-buttonsAndLinksColor;\n}\n.container {\n  background-color: -wix-colors-backgroundColor;\n}\n/*# sourceMappingURL=src/widget/views/desktop/compact/compact.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"spinner-container": "compact__spinner-container__3f9bN",
	"spinnerContainer": "compact__spinner-container__3f9bN",
	"spinner": "compact__spinner__33deO",
	"container": "compact__container__MSSfa"
};

/***/ }),

/***/ 2021:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"channel-actions.styl","sourceRoot":""}]);

// exports


/***/ }),

/***/ 2022:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"player.styl","sourceRoot":""}]);

// exports


/***/ }),

/***/ 2023:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"videos.styl","sourceRoot":""}]);

// exports


/***/ }),

/***/ 2024:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, ".strip__spinner-container__20e7q{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;background-color:-wix-colors-backgroundColor}.strip__spinner__3-0Ki{color:-wix-colors-buttonsAndLinksColor}.strip__container__1Le9k{background-color:-wix-colors-backgroundColor}.strip__player-container__1RBRo{position:relative}.strip__player-container__1RBRo.strip__with-bottom-padding__WB03Z .strip__player-overlay__3KjSC{padding-bottom:107px}.strip__player-container__1RBRo .strip__player__3Nfpi{display:-ms-flexbox;display:flex}.strip__player-container__1RBRo .strip__all-videos__IR5KO,.strip__player-container__1RBRo .strip__search-line__1WJsh,.strip__player-container__1RBRo .strip__tags__3kzhE{position:absolute;left:54px;right:54px;z-index:130}.strip__player-container__1RBRo .strip__search-line__1WJsh{bottom:63px;height:42px;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:justify;justify-content:space-between;font-family:HelveticaNeueW01-55Roma,HelveticaNeueW02-55Roma,HelveticaNeueW10-55Roma,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;font-size:14px;line-height:32px}.strip__player-container__1RBRo .strip__search-line__1WJsh .strip__categories__1xAHd,.strip__player-container__1RBRo .strip__search-line__1WJsh .strip__search__30zKo{position:absolute;bottom:0}.strip__player-container__1RBRo .strip__search-line__1WJsh .strip__search__30zKo{left:0;min-width:146px}.strip__player-container__1RBRo .strip__search-line__1WJsh .strip__search__30zKo.strip__expanded__pHpgj{width:100%}.strip__player-container__1RBRo .strip__search-line__1WJsh .strip__categories__1xAHd{right:0;min-width:162px}.strip__player-container__1RBRo .strip__search-line__1WJsh .strip__channel-actions__25Qq7{display:-ms-flexbox;display:flex;-ms-flex:1;flex:1;line-height:1;padding:11px 0;-ms-flex-pack:center;justify-content:center}.strip__player-container__1RBRo .strip__tags__3kzhE{bottom:0;overflow:hidden;padding:0 48px;height:63px}.strip__player-container__1RBRo .strip__all-videos__IR5KO{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;bottom:56px}.strip__player-container__1RBRo .strip__all-videos__IR5KO .strip__button__1AiZE{height:51px;padding:0 24px;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;border:1px solid #fff;background:transparent;transition:opacity .2s}.strip__player-container__1RBRo .strip__all-videos__IR5KO .strip__button__1AiZE:hover{opacity:.7}.strip__player-container__1RBRo .strip__all-videos__IR5KO .strip__button__1AiZE .strip__icon__28alZ{margin-left:13px;font-size:14px}.strip__videos-container__35A73{display:-ms-flexbox;display:flex}.strip__videos-container__35A73 .strip__videos__wSAcA{overflow:hidden}.strip__no-search-results__4GHnY{margin:100px auto auto;-ms-flex-positive:0;flex-grow:0}.strip__no-search-results__4GHnY.strip__stretched__2Y01z{margin:auto;-ms-flex-positive:1;flex-grow:1}.strip__action__3Uzm-{padding-right:20px;border-radius:0;color:#fff;transition:color .2s;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family}.strip__action__3Uzm-:hover{color:hsla(0,0%,100%,.7)}.strip__action__3Uzm-+.strip__action__3Uzm-{padding-left:20px;border-left:1px solid #fff}.strip__action__3Uzm-:last-child{padding-right:0}.strip__normal-close-icon__3fTx3{display:inline-block;transform:rotate(45deg)}.strip__small-close-icon__1EPkw{margin-left:5px;display:inline-block;transform:rotate(45deg) scale(.8)}.strip__share-channel__3XzRo{margin-top:1px;line-height:19px}.strip__share-buttons__3yZM2{position:absolute;right:30px;color:#fff}.strip__channel-info-modal__Yanna{background-color:-wix-colors-backgroundColor-95}.strip__channel-info-window__1x5CA{border-radius:0;max-height:678px;height:100%}@media screen and (max-height:738px){.strip__channel-info-window__1x5CA{max-height:calc(100% - 60px)}}.strip__channel-info-modal-content__2kdFr{height:100%}.strip__no-player__3CaQE{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;pointer-events:none}.strip__view-mode-editor__2zi8v .strip__no-player__3CaQE{background-color:-wix-colors-emptyPlayerBgEditor}.strip__view-mode-editor__2zi8v .strip__no-player__3CaQE .strip__no-player-play__3GVbY{border-color:-wix-colors-emptyPlayIconEditor;color:-wix-colors-emptyPlayIconEditor}.strip__view-mode-preview__DKw3B .strip__no-player__3CaQE,.strip__view-mode-site__rCHb3 .strip__no-player__3CaQE{background-color:-wix-colors-emptyPlayerBgSite}.strip__view-mode-preview__DKw3B .strip__no-player__3CaQE .strip__no-player-play__3GVbY,.strip__view-mode-site__rCHb3 .strip__no-player__3CaQE .strip__no-player-play__3GVbY{border-color:-wix-colors-emptyPlayIconSite;color:-wix-colors-emptyPlayIconSite}.strip__no-player__3CaQE .strip__no-player-play__3GVbY{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:51px;height:51px;border:1px solid transparent;border-radius:50%;font-size:22px}.strip__no-player__3CaQE .strip__no-player-play__3GVbY:before{transform:translate(3px,1px)}.strip__overlay-only__1n94U{display:-ms-flexbox;display:flex;position:relative;background-position:50%;background-size:cover}.strip__view-mode-editor__2zi8v .strip__overlay-only__1n94U{background-color:-wix-colors-emptyPlayerBgEditor}.strip__view-mode-preview__DKw3B .strip__overlay-only__1n94U,.strip__view-mode-site__rCHb3 .strip__overlay-only__1n94U{background-color:-wix-colors-emptyPlayerBgSite}.strip__coming-soon__3agPK{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;color:-wix-colors-textColor;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;font-size:20px}.strip__buttons-wrapper-no-margin__2Gf4G:first-child{margin-top:0}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/views/desktop/strip/src/widget/views/desktop/strip/strip.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/views/desktop/strip/src/shared/styles/mixins/position-zeros.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/views/desktop/strip/src/shared/styles/mixins/flex-center.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/views/desktop/strip/src/shared/styles/mixins/fonts.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/views/desktop/strip/strip.styl"],"names":[],"mappings":"AAEA,iCCDE,kBAAA,MACA,OACA,QACA,SACA,oBCJA,aAAA,sBACA,mBAAA,qBACA,uBFEA,4CAAA,CAEF,uBACE,sCAAA,CAEF,yBACE,4CAAA,CAEF,gCACE,iBAAA,CAGE,gGACE,oBAAA,CAEJ,sDACE,oBAAA,YAAA,CAEF,yKAGE,kBAAA,UACA,WACA,WACA,CAEF,2DACE,YAAA,YACA,oBACA,aAAA,uBACA,mBAAA,sBACA,8BAAA,oIG5BF,eAGE,gBAGA,CHyBA,sKAEE,kBAAA,QACA,CAEF,iFACE,OAAA,eACA,CAEA,wGACE,UAAA,CAEJ,qFACE,QAAA,eACA,CAEF,0FACE,oBAAA,aAAA,WACA,OAAA,cACA,eACA,qBACA,sBAAA,CAEJ,oDACE,SAAA,gBACA,eACA,WACA,CAEF,0DEnEA,oBAAA,aAAA,sBACA,mBAAA,qBACA,uBFmEE,WAAA,CAEA,gFACE,YAAA,eACA,uCACA,qCACA,uCACA,+CACA,sBACA,uBACA,sBACA,CAEA,sFACE,UAAA,CAEF,oGACE,iBAAA,cACA,CAER,gCACE,oBAAA,YAAA,CAEA,sDACE,eAAA,CAEJ,iCACE,uBAAA,oBACA,WAAA,CAEA,yDACE,YAAA,oBACA,WAAA,CAEJ,sBACE,mBAAA,gBACA,WACA,qBACA,uCACA,qCACA,sCACA,CAEA,4BACE,wBAAA,CAEF,4CACE,kBAAA,0BACA,CAEF,iCACE,eAAA,CAEJ,iCACE,qBAAA,uBACA,CAEF,gCACE,gBAAA,qBACA,iCAEA,CAEF,6BACE,eAAA,gBACA,CAEF,6BACE,kBAAA,WACA,UACA,CAEF,kCACE,+CAAA,CAEF,mCACE,gBAAA,iBACA,WACA,CAEmC,qCAAA,mCACjC,4BAAA,CIQD,CJNH,0CACE,WAAA,CAEF,yBE3JE,oBAAA,aAAA,sBACA,mBAAA,qBACA,uBF2JA,mBAAA,CAEA,yDACE,gDAAA,CAEA,uFACE,6CAAA,qCACA,CAEJ,iHAEE,8CAAA,CAEA,6KACE,2CAAA,mCACA,CAEJ,uDE9KA,oBAAA,aAAA,sBACA,mBAAA,qBACA,uBF8KE,WAAA,YACA,6BACA,kBACA,cACA,CAEA,8DACE,4BAAA,CAEN,4BACE,oBAAA,aAAA,kBACA,wBACA,qBACA,CAEA,4DACE,gDAAA,CAEF,uHAEE,8CAAA,CAEJ,2BEtME,oBAAA,aAAA,sBACA,mBAAA,qBACA,uBFsMA,4BAAA,uCACA,qCACA,uCACA,+CACA,cACA,CAGA,qDACE,YAAA,CIeH","file":"strip.styl","sourcesContent":["@require '~shared/styles/mixins'\n\n.spinner-container\n  position-zeros()\n  flex-center()\n  background-color -wix-colors-backgroundColor\n\n.spinner\n  color -wix-colors-buttonsAndLinksColor\n\n.container\n  background-color -wix-colors-backgroundColor\n\n.player-container\n  position relative\n\n  &.with-bottom-padding\n    .player-overlay\n      padding-bottom 107px\n\n  .player\n    display flex\n\n  .search-line\n  .tags\n  .all-videos\n    position absolute\n    left 54px\n    right 54px\n    z-index 130\n\n  .search-line\n    bottom 63px\n    height 42px\n    display flex\n    flex-direction row\n    justify-content space-between\n    helvetica-55-roma(14px, 32px)\n\n    .search\n    .categories\n      position absolute\n      bottom 0\n\n    .search\n      left 0\n      min-width 146px\n\n      &.expanded\n        width 100%\n\n    .categories\n      right 0\n      min-width 162px\n\n    .channel-actions\n      display flex\n      flex 1\n      line-height 1\n      padding 11px 0\n      justify-content center\n\n  .tags\n    bottom 0\n    overflow hidden\n    padding 0 48px\n    height 63px\n\n  .all-videos\n    flex-center()\n    bottom 56px\n\n    .button\n      height 51px\n      padding 0 24px\n      font-weight -wix-fonts-textFont-weight\n      font-style -wix-fonts-textFont-style\n      font-family -wix-fonts-textFont-family\n      text-decoration -wix-fonts-textFont-decoration\n      border 1px solid white\n      background transparent\n      transition opacity 0.2s\n\n      &:hover\n        opacity 0.7\n\n      .icon\n        margin-left 13px\n        font-size 14px\n\n.videos-container\n  display flex\n\n  .videos\n    overflow hidden\n\n.no-search-results\n  margin 100px auto auto auto\n  flex-grow 0\n\n  &.stretched\n    margin auto\n    flex-grow 1\n\n.action\n  padding-right 20px\n  border-radius 0\n  color #fff\n  transition color 0.2s\n  font-weight -wix-fonts-textFont-weight\n  font-style -wix-fonts-textFont-style\n  font-family -wix-fonts-textFont-family\n\n  &:hover\n    color rgba(255, 255, 255, 0.7)\n\n  + .action\n    padding-left 20px\n    border-left 1px solid #fff\n\n  &:last-child\n    padding-right 0\n\n.normal-close-icon\n  display inline-block\n  transform rotate(45deg)\n\n.small-close-icon\n  margin-left 5px\n  display inline-block\n  // scale looks better then font size, related to baseline\n  transform rotate(45deg) scale(0.8)\n\n.share-channel\n  margin-top 1px\n  line-height 19px\n\n.share-buttons\n  position absolute\n  right 30px\n  color white\n\n.channel-info-modal\n  background-color -wix-colors-backgroundColor-95\n\n.channel-info-window\n  border-radius 0\n  max-height 678px\n  height 100%\n\n  @media screen and (max-height 738px)\n    max-height calc(100% - 60px)\n\n.channel-info-modal-content\n  height 100%\n\n.no-player\n  flex-center()\n  pointer-events none\n\n  .view-mode-editor &\n    background-color -wix-colors-emptyPlayerBgEditor\n\n    .no-player-play\n      border-color -wix-colors-emptyPlayIconEditor\n      color -wix-colors-emptyPlayIconEditor\n\n  .view-mode-preview &\n  .view-mode-site &\n    background-color -wix-colors-emptyPlayerBgSite\n\n    .no-player-play\n      border-color -wix-colors-emptyPlayIconSite\n      color -wix-colors-emptyPlayIconSite\n\n  .no-player-play\n    flex-center()\n    width 51px\n    height 51px\n    border 1px solid transparent\n    border-radius 50%\n    font-size 22px\n\n    &:before\n      transform translate(3px, 1px)\n\n.overlay-only\n  display flex\n  position relative\n  background-position center center\n  background-size cover\n\n  .view-mode-editor &\n    background-color -wix-colors-emptyPlayerBgEditor\n\n  .view-mode-preview &\n  .view-mode-site &\n    background-color -wix-colors-emptyPlayerBgSite\n\n.coming-soon\n  flex-center()\n  color -wix-colors-textColor\n  font-weight -wix-fonts-textFont-weight\n  font-style -wix-fonts-textFont-style\n  font-family -wix-fonts-textFont-family\n  text-decoration -wix-fonts-textFont-decoration\n  font-size 20px\n\n.buttons-wrapper-no-margin\n  &:first-child\n    margin-top 0\n","position-zeros(position = absolute)\n  position position\n  top 0\n  left 0\n  right 0\n  bottom 0\n","flex-center(display = flex)\n  display display\n  align-items center\n  justify-content center\n","font-default = \"Helvetica Neue\", \"ruble\", Helvetica, Arial, sans-serif\nfont-helvetica-35-thin = \"HelveticaNeueW01-Thin\", \"HelveticaNeueW02-Thin\", \"HelveticaNeueW10-35Thin\", font-default\nfont-helvetica-45-ligh = \"HelveticaNeueW01-45Ligh\", \"HelveticaNeueW02-45Ligh\", \"HelveticaNeueW10-45Ligh\", font-default\nfont-helvetica-55-roma = \"HelveticaNeueW01-55Roma\", \"HelveticaNeueW02-55Roma\", \"HelveticaNeueW10-55Roma\", font-default\nfont-helvetica-65-medi = \"HelveticaNeueW01-65Medi\", \"HelveticaNeueW02-65Medi\", \"HelveticaNeueW10-65Medi\", font-default\nfont-helvetica-75-bold = \"HelveticaNeueW01-75Bold\", \"HelveticaNeueW02-75Bold\", \"HelveticaNeueW10-75Bold\", font-default\n\n_helvetica-font(font-family, font-size = null, line-height = null, font-weight = null)\n  font-family font-family\n\n  if font-size != null\n    font-size font-size\n\n  if line-height != null\n    line-height line-height\n\n  if font-weight != null\n    font-weight font-weight\n\nhelvetica-35-thin(font-size = null, line-height = null, font-weight = 100)\n  _helvetica-font(font-helvetica-35-thin, font-size, line-height, font-weight)\n\nhelvetica-45-ligh(font-size = null, line-height = null, font-weight = 300)\n  _helvetica-font(font-helvetica-45-ligh, font-size, line-height, font-weight)\n\nhelvetica-55-roma(font-size = null, line-height = null, font-weight = null)\n  _helvetica-font(font-helvetica-55-roma, font-size, line-height, font-weight)\n\nhelvetica-65-medi(font-size = null, line-height = null, font-weight = 500)\n  _helvetica-font(font-helvetica-65-medi, font-size, line-height, font-weight)\n\nhelvetica-75-bold(font-size = null, line-height = null, font-weight = null)\n  _helvetica-font(font-helvetica-75-bold, font-size, line-height, font-weight)\n",".spinner-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: -wix-colors-backgroundColor;\n}\n.spinner {\n  color: -wix-colors-buttonsAndLinksColor;\n}\n.container {\n  background-color: -wix-colors-backgroundColor;\n}\n.player-container {\n  position: relative;\n}\n.player-container.with-bottom-padding .player-overlay {\n  padding-bottom: 107px;\n}\n.player-container .player {\n  display: flex;\n}\n.player-container .search-line,\n.player-container .tags,\n.player-container .all-videos {\n  position: absolute;\n  left: 54px;\n  right: 54px;\n  z-index: 130;\n}\n.player-container .search-line {\n  bottom: 63px;\n  height: 42px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  font-family: \"HelveticaNeueW01-55Roma\", \"HelveticaNeueW02-55Roma\", \"HelveticaNeueW10-55Roma\", \"Helvetica Neue\", \"ruble\", Helvetica, Arial, sans-serif;\n  font-size: 14px;\n  line-height: 32px;\n}\n.player-container .search-line .search,\n.player-container .search-line .categories {\n  position: absolute;\n  bottom: 0;\n}\n.player-container .search-line .search {\n  left: 0;\n  min-width: 146px;\n}\n.player-container .search-line .search.expanded {\n  width: 100%;\n}\n.player-container .search-line .categories {\n  right: 0;\n  min-width: 162px;\n}\n.player-container .search-line .channel-actions {\n  display: flex;\n  flex: 1;\n  line-height: 1;\n  padding: 11px 0;\n  justify-content: center;\n}\n.player-container .tags {\n  bottom: 0;\n  overflow: hidden;\n  padding: 0 48px;\n  height: 63px;\n}\n.player-container .all-videos {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  bottom: 56px;\n}\n.player-container .all-videos .button {\n  height: 51px;\n  padding: 0 24px;\n  font-weight: -wix-fonts-textFont-weight;\n  font-style: -wix-fonts-textFont-style;\n  font-family: -wix-fonts-textFont-family;\n  text-decoration: -wix-fonts-textFont-decoration;\n  border: 1px solid #fff;\n  background: transparent;\n  transition: opacity 0.2s;\n}\n.player-container .all-videos .button:hover {\n  opacity: 0.7;\n}\n.player-container .all-videos .button .icon {\n  margin-left: 13px;\n  font-size: 14px;\n}\n.videos-container {\n  display: flex;\n}\n.videos-container .videos {\n  overflow: hidden;\n}\n.no-search-results {\n  margin: 100px auto auto auto;\n  flex-grow: 0;\n}\n.no-search-results.stretched {\n  margin: auto;\n  flex-grow: 1;\n}\n.action {\n  padding-right: 20px;\n  border-radius: 0;\n  color: #fff;\n  transition: color 0.2s;\n  font-weight: -wix-fonts-textFont-weight;\n  font-style: -wix-fonts-textFont-style;\n  font-family: -wix-fonts-textFont-family;\n}\n.action:hover {\n  color: rgba(255,255,255,0.7);\n}\n.action + .action {\n  padding-left: 20px;\n  border-left: 1px solid #fff;\n}\n.action:last-child {\n  padding-right: 0;\n}\n.normal-close-icon {\n  display: inline-block;\n  transform: rotate(45deg);\n}\n.small-close-icon {\n  margin-left: 5px;\n  display: inline-block;\n  transform: rotate(45deg) scale(0.8);\n}\n.share-channel {\n  margin-top: 1px;\n  line-height: 19px;\n}\n.share-buttons {\n  position: absolute;\n  right: 30px;\n  color: #fff;\n}\n.channel-info-modal {\n  background-color: -wix-colors-backgroundColor-95;\n}\n.channel-info-window {\n  border-radius: 0;\n  max-height: 678px;\n  height: 100%;\n}\n@media screen and (max-height: 738px) {\n  .channel-info-window {\n    max-height: calc(100% - 60px);\n  }\n}\n.channel-info-modal-content {\n  height: 100%;\n}\n.no-player {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n}\n.view-mode-editor .no-player {\n  background-color: -wix-colors-emptyPlayerBgEditor;\n}\n.view-mode-editor .no-player .no-player-play {\n  border-color: -wix-colors-emptyPlayIconEditor;\n  color: -wix-colors-emptyPlayIconEditor;\n}\n.view-mode-preview .no-player,\n.view-mode-site .no-player {\n  background-color: -wix-colors-emptyPlayerBgSite;\n}\n.view-mode-preview .no-player .no-player-play,\n.view-mode-site .no-player .no-player-play {\n  border-color: -wix-colors-emptyPlayIconSite;\n  color: -wix-colors-emptyPlayIconSite;\n}\n.no-player .no-player-play {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 51px;\n  height: 51px;\n  border: 1px solid transparent;\n  border-radius: 50%;\n  font-size: 22px;\n}\n.no-player .no-player-play:before {\n  transform: translate(3px, 1px);\n}\n.overlay-only {\n  display: flex;\n  position: relative;\n  background-position: center center;\n  background-size: cover;\n}\n.view-mode-editor .overlay-only {\n  background-color: -wix-colors-emptyPlayerBgEditor;\n}\n.view-mode-preview .overlay-only,\n.view-mode-site .overlay-only {\n  background-color: -wix-colors-emptyPlayerBgSite;\n}\n.coming-soon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: -wix-colors-textColor;\n  font-weight: -wix-fonts-textFont-weight;\n  font-style: -wix-fonts-textFont-style;\n  font-family: -wix-fonts-textFont-family;\n  text-decoration: -wix-fonts-textFont-decoration;\n  font-size: 20px;\n}\n.buttons-wrapper-no-margin:first-child {\n  margin-top: 0;\n}\n/*# sourceMappingURL=src/widget/views/desktop/strip/strip.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"spinner-container": "strip__spinner-container__20e7q",
	"spinnerContainer": "strip__spinner-container__20e7q",
	"spinner": "strip__spinner__3-0Ki",
	"container": "strip__container__1Le9k",
	"player-container": "strip__player-container__1RBRo",
	"playerContainer": "strip__player-container__1RBRo",
	"with-bottom-padding": "strip__with-bottom-padding__WB03Z",
	"withBottomPadding": "strip__with-bottom-padding__WB03Z",
	"player-overlay": "strip__player-overlay__3KjSC",
	"playerOverlay": "strip__player-overlay__3KjSC",
	"player": "strip__player__3Nfpi",
	"all-videos": "strip__all-videos__IR5KO",
	"allVideos": "strip__all-videos__IR5KO",
	"search-line": "strip__search-line__1WJsh",
	"searchLine": "strip__search-line__1WJsh",
	"tags": "strip__tags__3kzhE",
	"categories": "strip__categories__1xAHd",
	"search": "strip__search__30zKo",
	"expanded": "strip__expanded__pHpgj",
	"channel-actions": "strip__channel-actions__25Qq7",
	"channelActions": "strip__channel-actions__25Qq7",
	"button": "strip__button__1AiZE",
	"icon": "strip__icon__28alZ",
	"videos-container": "strip__videos-container__35A73",
	"videosContainer": "strip__videos-container__35A73",
	"videos": "strip__videos__wSAcA",
	"no-search-results": "strip__no-search-results__4GHnY",
	"noSearchResults": "strip__no-search-results__4GHnY",
	"stretched": "strip__stretched__2Y01z",
	"action": "strip__action__3Uzm-",
	"normal-close-icon": "strip__normal-close-icon__3fTx3",
	"normalCloseIcon": "strip__normal-close-icon__3fTx3",
	"small-close-icon": "strip__small-close-icon__1EPkw",
	"smallCloseIcon": "strip__small-close-icon__1EPkw",
	"share-channel": "strip__share-channel__3XzRo",
	"shareChannel": "strip__share-channel__3XzRo",
	"share-buttons": "strip__share-buttons__3yZM2",
	"shareButtons": "strip__share-buttons__3yZM2",
	"channel-info-modal": "strip__channel-info-modal__Yanna",
	"channelInfoModal": "strip__channel-info-modal__Yanna",
	"channel-info-window": "strip__channel-info-window__1x5CA",
	"channelInfoWindow": "strip__channel-info-window__1x5CA",
	"channel-info-modal-content": "strip__channel-info-modal-content__2kdFr",
	"channelInfoModalContent": "strip__channel-info-modal-content__2kdFr",
	"no-player": "strip__no-player__3CaQE",
	"noPlayer": "strip__no-player__3CaQE",
	"view-mode-editor": "strip__view-mode-editor__2zi8v",
	"viewModeEditor": "strip__view-mode-editor__2zi8v",
	"no-player-play": "strip__no-player-play__3GVbY",
	"noPlayerPlay": "strip__no-player-play__3GVbY",
	"view-mode-preview": "strip__view-mode-preview__DKw3B",
	"viewModePreview": "strip__view-mode-preview__DKw3B",
	"view-mode-site": "strip__view-mode-site__rCHb3",
	"viewModeSite": "strip__view-mode-site__rCHb3",
	"overlay-only": "strip__overlay-only__1n94U",
	"overlayOnly": "strip__overlay-only__1n94U",
	"coming-soon": "strip__coming-soon__3agPK",
	"comingSoon": "strip__coming-soon__3agPK",
	"buttons-wrapper-no-margin": "strip__buttons-wrapper-no-margin__2Gf4G",
	"buttonsWrapperNoMargin": "strip__buttons-wrapper-no-margin__2Gf4G"
};

/***/ }),

/***/ 2025:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(true);
// imports


// module
exports.push([module.i, ".mobile__spinner-container__2Edq0{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.mobile__spinner__2Hber{color:-wix-colors-buttonsAndLinksColor}[data-layout=\"2\"][data-experiments*=newMobileUX] .mobile__spinner__2Hber{color:-wix-colors-mobileButtonsBackgroundColor}.mobile__container__K1HRY .mobile__box__3jUP3{display:inline-block;width:70px;height:50px}.mobile__container__K1HRY .mobile__header__18TAh{height:48px;padding:0 15px}.mobile__container__K1HRY .mobile__player-wrapper__28A-w{position:relative}.mobile__container__K1HRY .mobile__player-wrapper__28A-w .mobile__player__14Am3{display:-ms-flexbox;display:flex}.mobile__container__K1HRY .mobile__videos-carousel__175Ms{margin-top:1px}.mobile__container__K1HRY .mobile__footer__ygg8j{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;height:48px}.mobile__container__K1HRY .mobile__footer__ygg8j .mobile__explore-channel__1bd8o{color:-wix-colors-buttonsAndLinksColor-80;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;font-size:14px}.mobile__container__K1HRY .mobile__footer__ygg8j .mobile__search-icon__2UBZF{padding-left:8px;color:-wix-colors-buttonsAndLinksColor-80;font-size:9px;line-height:9px;position:relative;top:-2px}.mobile__no-player__365Ai{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;pointer-events:none}.mobile__view-mode-editor__35bVa .mobile__no-player__365Ai{background-color:-wix-colors-emptyPlayerBgEditor}.mobile__view-mode-editor__35bVa .mobile__no-player__365Ai .mobile__no-player-play__2oIoj{border-color:-wix-colors-emptyPlayIconEditor;color:-wix-colors-emptyPlayIconEditor}.mobile__view-mode-preview__LsJFU .mobile__no-player__365Ai,.mobile__view-mode-site__7IrSu .mobile__no-player__365Ai{background-color:-wix-colors-emptyPlayerBgSite}.mobile__view-mode-preview__LsJFU .mobile__no-player__365Ai .mobile__no-player-play__2oIoj,.mobile__view-mode-site__7IrSu .mobile__no-player__365Ai .mobile__no-player-play__2oIoj{border-color:-wix-colors-emptyPlayIconSite;color:-wix-colors-emptyPlayIconSite}.mobile__no-player__365Ai .mobile__no-player-play__2oIoj{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:51px;height:51px;border:1px solid transparent;border-radius:50%;font-size:22px}.mobile__no-player__365Ai .mobile__no-player-play__2oIoj:before{transform:translate(3px,1px)}.mobile__overlay-only__1R8CQ{display:-ms-flexbox;display:flex;position:relative}.mobile__view-mode-editor__35bVa .mobile__overlay-only__1R8CQ{background-color:-wix-colors-emptyPlayerBgEditor}.mobile__view-mode-preview__LsJFU .mobile__overlay-only__1R8CQ,.mobile__view-mode-site__7IrSu .mobile__overlay-only__1R8CQ{background-color:-wix-colors-emptyPlayerBgSite}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/views/mobile/src/widget/views/mobile/mobile.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/views/mobile/src/shared/styles/mixins/position-zeros.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/views/mobile/src/shared/styles/mixins/flex-center.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/views/mobile/mobile.styl"],"names":[],"mappings":"AAEA,kCCDE,kBAAA,MACA,OACA,QACA,SACA,oBCJA,aAAA,sBACA,mBAAA,qBACA,sBAAA,CFGF,wBACE,sCAAA,CAEC,yEACC,8CAAA,CAIF,8CACE,qBAAA,WACA,WACA,CAEF,iDACE,YAAA,cACA,CAGF,yDACE,iBAAA,CAEA,gFACE,oBAAA,YAAA,CAEJ,0DACE,cAAA,CAEF,iDACE,oBAAA,aAAA,qBACA,uBAAA,sBACA,mBAAA,WACA,CAEA,iFACE,0CAAA,uCACA,qCACA,uCACA,+CACA,cACA,CAEF,6EACE,iBAAA,0CACA,cACA,gBACA,kBACA,QACA,CAEN,0BEtDE,oBAAA,aAAA,sBACA,mBAAA,qBACA,uBFsDA,mBAAA,CAEA,2DACE,gDAAA,CAEA,0FACE,6CAAA,qCACA,CAEJ,qHAEE,8CAAA,CAEA,mLACE,2CAAA,mCACA,CAEJ,yDEzEA,oBAAA,aAAA,sBACA,mBAAA,qBACA,uBFyEE,WAAA,YACA,6BACA,kBACA,cACA,CAEA,gEACE,4BAAA,CAEN,6BACE,oBAAA,aAAA,iBACA,CAEA,8DACE,gDAAA,CAEF,2HAEE,8CAAA,CGOH","file":"mobile.styl","sourcesContent":["@require '~shared/styles/mixins'\n\n.spinner-container\n  position-zeros()\n  flex-center()\n\n.spinner\n  color -wix-colors-buttonsAndLinksColor\n\n  {strip}{newMobileUX} &\n    color -wix-colors-mobileButtonsBackgroundColor\n\n.container\n\n  .box\n    display inline-block\n    width 70px\n    height 50px\n\n  .header\n    height 48px\n    padding 0 15px\n\n\n  .player-wrapper\n    position relative\n\n    .player\n      display flex\n\n  .videos-carousel\n    margin-top 1px\n\n  .footer\n    display flex\n    justify-content center\n    align-items center\n    height 48px\n\n    .explore-channel\n      color -wix-colors-buttonsAndLinksColor-80\n      font-weight -wix-fonts-textFont-weight\n      font-style -wix-fonts-textFont-style\n      font-family -wix-fonts-textFont-family\n      text-decoration -wix-fonts-textFont-decoration\n      font-size 14px\n\n    .search-icon\n      padding-left 8px\n      color -wix-colors-buttonsAndLinksColor-80\n      font-size 9px\n      line-height 9px\n      position relative\n      top -2px\n\n.no-player\n  flex-center()\n  pointer-events none\n\n  .view-mode-editor &\n    background-color -wix-colors-emptyPlayerBgEditor\n\n    .no-player-play\n      border-color -wix-colors-emptyPlayIconEditor\n      color -wix-colors-emptyPlayIconEditor\n\n  .view-mode-preview &\n  .view-mode-site &\n    background-color -wix-colors-emptyPlayerBgSite\n\n    .no-player-play\n      border-color -wix-colors-emptyPlayIconSite\n      color -wix-colors-emptyPlayIconSite\n\n  .no-player-play\n    flex-center()\n    width 51px\n    height 51px\n    border 1px solid transparent\n    border-radius 50%\n    font-size 22px\n\n    &:before\n      transform translate(3px, 1px)\n\n.overlay-only\n  display flex\n  position relative\n\n  .view-mode-editor &\n    background-color -wix-colors-emptyPlayerBgEditor\n\n  .view-mode-preview &\n  .view-mode-site &\n    background-color -wix-colors-emptyPlayerBgSite\n","position-zeros(position = absolute)\n  position position\n  top 0\n  left 0\n  right 0\n  bottom 0\n","flex-center(display = flex)\n  display display\n  align-items center\n  justify-content center\n",".spinner-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.spinner {\n  color: -wix-colors-buttonsAndLinksColor;\n}\n[data-layout=\"2\"][data-experiments*=\"newMobileUX\"] .spinner {\n  color: -wix-colors-mobileButtonsBackgroundColor;\n}\n.container .box {\n  display: inline-block;\n  width: 70px;\n  height: 50px;\n}\n.container .header {\n  height: 48px;\n  padding: 0 15px;\n}\n.container .player-wrapper {\n  position: relative;\n}\n.container .player-wrapper .player {\n  display: flex;\n}\n.container .videos-carousel {\n  margin-top: 1px;\n}\n.container .footer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 48px;\n}\n.container .footer .explore-channel {\n  color: -wix-colors-buttonsAndLinksColor-80;\n  font-weight: -wix-fonts-textFont-weight;\n  font-style: -wix-fonts-textFont-style;\n  font-family: -wix-fonts-textFont-family;\n  text-decoration: -wix-fonts-textFont-decoration;\n  font-size: 14px;\n}\n.container .footer .search-icon {\n  padding-left: 8px;\n  color: -wix-colors-buttonsAndLinksColor-80;\n  font-size: 9px;\n  line-height: 9px;\n  position: relative;\n  top: -2px;\n}\n.no-player {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n}\n.view-mode-editor .no-player {\n  background-color: -wix-colors-emptyPlayerBgEditor;\n}\n.view-mode-editor .no-player .no-player-play {\n  border-color: -wix-colors-emptyPlayIconEditor;\n  color: -wix-colors-emptyPlayIconEditor;\n}\n.view-mode-preview .no-player,\n.view-mode-site .no-player {\n  background-color: -wix-colors-emptyPlayerBgSite;\n}\n.view-mode-preview .no-player .no-player-play,\n.view-mode-site .no-player .no-player-play {\n  border-color: -wix-colors-emptyPlayIconSite;\n  color: -wix-colors-emptyPlayIconSite;\n}\n.no-player .no-player-play {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 51px;\n  height: 51px;\n  border: 1px solid transparent;\n  border-radius: 50%;\n  font-size: 22px;\n}\n.no-player .no-player-play:before {\n  transform: translate(3px, 1px);\n}\n.overlay-only {\n  display: flex;\n  position: relative;\n}\n.view-mode-editor .overlay-only {\n  background-color: -wix-colors-emptyPlayerBgEditor;\n}\n.view-mode-preview .overlay-only,\n.view-mode-site .overlay-only {\n  background-color: -wix-colors-emptyPlayerBgSite;\n}\n/*# sourceMappingURL=src/widget/views/mobile/mobile.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"spinner-container": "mobile__spinner-container__2Edq0",
	"spinnerContainer": "mobile__spinner-container__2Edq0",
	"spinner": "mobile__spinner__2Hber",
	"container": "mobile__container__K1HRY",
	"box": "mobile__box__3jUP3",
	"header": "mobile__header__18TAh",
	"player-wrapper": "mobile__player-wrapper__28A-w",
	"playerWrapper": "mobile__player-wrapper__28A-w",
	"player": "mobile__player__14Am3",
	"videos-carousel": "mobile__videos-carousel__175Ms",
	"videosCarousel": "mobile__videos-carousel__175Ms",
	"footer": "mobile__footer__ygg8j",
	"explore-channel": "mobile__explore-channel__1bd8o",
	"exploreChannel": "mobile__explore-channel__1bd8o",
	"search-icon": "mobile__search-icon__2UBZF",
	"searchIcon": "mobile__search-icon__2UBZF",
	"no-player": "mobile__no-player__365Ai",
	"noPlayer": "mobile__no-player__365Ai",
	"view-mode-editor": "mobile__view-mode-editor__35bVa",
	"viewModeEditor": "mobile__view-mode-editor__35bVa",
	"no-player-play": "mobile__no-player-play__2oIoj",
	"noPlayerPlay": "mobile__no-player-play__2oIoj",
	"view-mode-preview": "mobile__view-mode-preview__LsJFU",
	"viewModePreview": "mobile__view-mode-preview__LsJFU",
	"view-mode-site": "mobile__view-mode-site__7IrSu",
	"viewModeSite": "mobile__view-mode-site__7IrSu",
	"overlay-only": "mobile__overlay-only__1R8CQ",
	"overlayOnly": "mobile__overlay-only__1R8CQ"
};

/***/ }),

/***/ 243:
/***/ (function(module, exports) {

module.exports = ReactDOM;

/***/ }),

/***/ 2460:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(872);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),

/***/ 2494:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(872);

var getVendorPrefixedEventName = __webpack_require__(2460);

var endEvents = [];

function detectEvents() {
  var animEnd = getVendorPrefixedEventName('animationend');
  var transEnd = getVendorPrefixedEventName('transitionend');

  if (animEnd) {
    endEvents.push(animEnd);
  }

  if (transEnd) {
    endEvents.push(transEnd);
  }
}

if (ExecutionEnvironment.canUseDOM) {
  detectEvents();
}

// We use the raw {add|remove}EventListener() call because EventListener
// does not know how to remove event listeners and we really should
// clean up. Also, these events are not triggered in older browsers
// so we should be A-OK here.

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var ReactTransitionEvents = {
  addEndEventListener: function (node, eventListener) {
    if (endEvents.length === 0) {
      // If CSS transitions are not supported, trigger an "end animation"
      // event immediately.
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },

  removeEndEventListener: function (node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

module.exports = ReactTransitionEvents;

/***/ }),

/***/ 2679:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1951);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./clickable.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./clickable.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2681:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1954);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./account-button-strip.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./account-button-strip.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2682:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1955);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./account-button.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./account-button.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2686:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1959);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./categories.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./categories.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2688:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1962);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./empty-search-results.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./empty-search-results.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2690:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1964);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./buttons.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./buttons.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2691:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1965);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./mobile-carousel.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./mobile-carousel.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2692:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1966);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./track.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./track.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2698:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1972);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./classic.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./classic.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2699:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1973);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./member-only.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./member-only.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2701:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1976);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./bottom-buttons.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./bottom-buttons.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2702:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1977);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./middle-buttons.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./middle-buttons.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2703:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1978);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./three-rows-widget.styl", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./three-rows-widget.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2705:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1981);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./first-time-track-animation.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./first-time-track-animation.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2707:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1984);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./classic-search-bar.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./classic-search-bar.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2708:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1985);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./strip-search-bar.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./strip-search-bar.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2709:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1986);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./share-channel.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./share-channel.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2713:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1991);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./mobile-thumb.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./mobile-thumb.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2714:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1992);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./thumbnail.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./thumbnail.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2715:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1993);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./classic.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./classic.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2716:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1994);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./nav-button.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./nav-button.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2717:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1995);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./strip.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./strip.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2718:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1996);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./thumbnail-overlay.styl", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./thumbnail-overlay.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2719:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1997);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./mobile.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./mobile.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2741:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2019);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./classic.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./classic.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2742:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2020);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./compact.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./compact.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2743:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2021);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./channel-actions.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./channel-actions.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2744:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2022);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./player.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./player.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2745:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2023);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./videos.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./videos.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2746:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2024);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./strip.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./strip.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2747:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2025);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./mobile.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./mobile.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2812:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(981);


/***/ }),

/***/ 307:
/***/ (function(module, exports) {

module.exports = _;

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OPEN_VIDEO_PAGE = exports.VISIT_CHANNEL = undefined;
exports.visitChannel = visitChannel;
exports.openVideoPage = openVideoPage;

var _reduxActions = __webpack_require__(22);

var _openOverlay = __webpack_require__(128);

var VISIT_CHANNEL = exports.VISIT_CHANNEL = 'CLIENT.VISIT-CHANNEL';
var VISIT_CHANNEL_ACTION = (0, _reduxActions.createAction)(VISIT_CHANNEL);

var OPEN_VIDEO_PAGE = exports.OPEN_VIDEO_PAGE = 'CLIENT.OPEN.VIDEO-PAGE';
var OPEN_VIDEO_PAGE_ACTION = (0, _reduxActions.createAction)(OPEN_VIDEO_PAGE);

function visitChannel() {
  return function (dispatch) {
    dispatch(VISIT_CHANNEL_ACTION());

    return (0, _openOverlay.openMobileOverlay)();
  };
}

function openVideoPage(videoId) {
  return function (dispatch) {
    dispatch(OPEN_VIDEO_PAGE_ACTION());

    return (0, _openOverlay.openMobileOverlay)('#/video/' + videoId);
  };
}

/***/ }),

/***/ 694:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = __webpack_require__(10);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _slicedToArray2 = __webpack_require__(63);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp2;

var _autobind = __webpack_require__(11);

var _autobind2 = _interopRequireDefault(_autobind);

var _measure = __webpack_require__(1311);

var _measure2 = _interopRequireDefault(_measure);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function childrenKeys(props) {
  return React.Children.map(props.children, function (child) {
    return child.key;
  });
}

var ElementSwitcher = (_class = (_temp2 = _class2 = function (_React$Component) {
  (0, _inherits3.default)(ElementSwitcher, _React$Component);

  function ElementSwitcher() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ElementSwitcher);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ElementSwitcher.__proto__ || (0, _getPrototypeOf2.default)(ElementSwitcher)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      width: null
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ElementSwitcher, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Correct solution would be to check width of prev and next children but
      // to simplify and to speed up keys are used instead
      var nextKeys = childrenKeys(nextProps).join('++');
      var prevKeys = childrenKeys(this.props).join('++');

      if (nextProps.maxWidth !== this.props.maxWidth || nextKeys !== prevKeys) {
        this.setState({ width: null });
      }
    }
  }, {
    key: 'onMeasure',
    value: function onMeasure(dimensions) {
      var width = _.get(dimensions, 'width');
      if (width !== 0 && width !== this.state.width) {
        this.setState({ width: width });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          maxWidth = _props.maxWidth,
          children = _props.children;

      var width = this.state.width;

      var _React$Children$toArr = React.Children.toArray(children),
          _React$Children$toArr2 = (0, _slicedToArray3.default)(_React$Children$toArr, 2),
          normal = _React$Children$toArr2[0],
          small = _React$Children$toArr2[1];

      return React.createElement(
        _measure2.default,
        { onMeasure: this.onMeasure,
          shouldMeasure: width === null },
        width && width > maxWidth ? small : normal
      );
    }
  }]);
  return ElementSwitcher;
}(React.Component), _class2.propTypes = {
  children: React.PropTypes.any,
  maxWidth: React.PropTypes.number
}, _temp2), (_applyDecoratedDescriptor(_class.prototype, 'onMeasure', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onMeasure'), _class.prototype)), _class);
exports.default = ElementSwitcher;

/***/ }),

/***/ 738:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = runOnce;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function runOnce(target, key, descriptor) {
  var originMethod = target[key];
  var hasBeenCalled = false;

  return (0, _extends3.default)({}, descriptor, {
    value: function value() {
      if (hasBeenCalled) {
        return;
      }
      hasBeenCalled = true;
      return originMethod.apply(this, arguments);
    }
  });
}

/***/ }),

/***/ 740:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BaseAccountButton = undefined;

var _getOwnPropertyDescriptor = __webpack_require__(10);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp, _dec, _dec2, _class3, _class4, _temp2;

var _reactIntl = __webpack_require__(5);

var _autobind = __webpack_require__(11);

var _autobind2 = _interopRequireDefault(_autobind);

var _reactRedux = __webpack_require__(12);

var _playerWidget = __webpack_require__(25);

var _wixConnect = __webpack_require__(6);

var _wixSdk = __webpack_require__(21);

var _wixSdk2 = _interopRequireDefault(_wixSdk);

var _notForPreview = __webpack_require__(221);

var _layoutHelpers = __webpack_require__(67);

var _popout = __webpack_require__(31);

var _popout2 = __webpack_require__(74);

var _button = __webpack_require__(19);

var _tooltip = __webpack_require__(73);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _tooltipPopout = __webpack_require__(110);

var _channelSubscription = __webpack_require__(751);

var _channelSubscription2 = _interopRequireDefault(_channelSubscription);

var _accountButton = __webpack_require__(2682);

var _accountButton2 = _interopRequireDefault(_accountButton);

var _translations = __webpack_require__(485);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var BaseAccountButton = exports.BaseAccountButton = (_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(BaseAccountButton, _React$Component);

  function BaseAccountButton() {
    (0, _classCallCheck3.default)(this, BaseAccountButton);
    return (0, _possibleConstructorReturn3.default)(this, (BaseAccountButton.__proto__ || (0, _getPrototypeOf2.default)(BaseAccountButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(BaseAccountButton, [{
    key: 'showLoginForm',
    value: function showLoginForm() {
      var _props = this.props,
          biEvent = _props.biEvent,
          onUserLogin = _props.onUserLogin;


      biEvent('widget.signIn.clicked');
      _wixSdk2.default.requestLogin().then(onUserLogin);
    }
  }, {
    key: 'processSubscriptionBuy',
    value: function processSubscriptionBuy() {
      var onSubscribeClick = this.props.onSubscribeClick;

      this.props.biEvent('widget.subscription.clicked');
      (0, _tooltipPopout.hideTooltip)();
      onSubscribeClick();
    }
  }, {
    key: 'processSubscriptionCancel',
    value: function processSubscriptionCancel() {
      var onSubscriptionCancelClick = this.props.onSubscriptionCancelClick;

      (0, _tooltipPopout.hideTooltip)();
      onSubscriptionCancelClick();
    }
  }, {
    key: 'logOut',
    value: function logOut() {
      var onUserLogout = this.props.onUserLogout;

      onUserLogout();
      _wixSdk2.default.logOutCurrentMember();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          currentSiteUser = _props2.currentSiteUser,
          appSettings = _props2.appSettings,
          popoutSide = _props2.popoutSide;


      if (!(0, _layoutHelpers.isSignInVisible)(appSettings)) {
        return null;
      }

      if (!currentSiteUser) {
        return React.createElement(
          _button.LinkButton,
          { className: 'qa-sign-in ' + className,
            styleName: 'account-button',
            onClick: this.showLoginForm },
          React.createElement(_reactIntl.FormattedMessage, _translations2.default.signIn)
        );
      }

      return React.createElement(
        'div',
        { className: 'qa-account ' + className,
          styleName: 'account-preview-button-wrapper' },
        React.createElement(
          _tooltip2.default,
          { preventHideOnHover: true,
            popoutSide: popoutSide,
            iconName: 'avatar',
            styleName: 'account-preview-button',
            popoutClassName: _accountButton2.default.popout,
            popoutInnerClassName: _accountButton2.default['popout-inner'],
            popoutTriangleClassName: _accountButton2.default['popout-triangle'] },
          React.createElement(
            'div',
            { styleName: 'user-email',
              className: 'qa-account-button-user-email' },
            currentSiteUser.email
          ),
          this.channelSubscription,
          React.createElement(
            'div',
            { styleName: 'logout-wrapper' },
            React.createElement(
              _button.LinkButton,
              { styleName: 'logout',
                className: 'qa-account-button-user-logout',
                onClick: this.logOut },
              React.createElement(_reactIntl.FormattedMessage, _translations2.default.logout)
            )
          )
        )
      );
    }
  }, {
    key: 'channelSubscription',
    get: function get() {
      var channelData = this.props.channelData;
      var dealInfo = channelData.dealInfo;

      dealInfo = _playerWidget.dealInfoHelpers.getSubscriptionPriceInfo(dealInfo);

      if (!dealInfo) {
        return null;
      }

      return React.createElement(_channelSubscription2.default, { styleName: 'channel-subscription',
        channelData: channelData,
        onSubscribeClick: this.processSubscriptionBuy,
        onSubscriptionCancelClick: this.processSubscriptionCancel });
    }
  }]);
  return BaseAccountButton;
}(React.Component), _class2.propTypes = {
  appSettings: React.PropTypes.object,
  onSubscribeClick: React.PropTypes.func,
  onSubscriptionCancelClick: React.PropTypes.func,
  onUserLogin: React.PropTypes.func,
  onUserLogout: React.PropTypes.func,
  channelData: React.PropTypes.object,
  className: React.PropTypes.string,
  popoutSide: _popout2.sideShape,
  currentSiteUser: React.PropTypes.object,
  biEvent: React.PropTypes.func
}, _class2.defaultProps = {
  popoutSide: _popout.sides.BOTTOM,
  onSubscribeClick: _.noop,
  onSubscriptionCancelClick: _.noop,
  onUserLogin: _.noop,
  onUserLogout: _.noop
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'showLoginForm', [_autobind2.default, _notForPreview.notForPreview], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'showLoginForm'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'processSubscriptionBuy', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'processSubscriptionBuy'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'processSubscriptionCancel', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'processSubscriptionCancel'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'logOut', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'logOut'), _class.prototype)), _class);
var AccountButton = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    appSettings: state.appSettings,
    currentSiteUser: state.currentSiteUser
  };
}), _dec2 = (0, _wixConnect.WixConnect)(_accountButton2.default), _dec(_class3 = _dec2(_class3 = (_temp2 = _class4 = function (_BaseAccountButton) {
  (0, _inherits3.default)(AccountButton, _BaseAccountButton);

  function AccountButton() {
    (0, _classCallCheck3.default)(this, AccountButton);
    return (0, _possibleConstructorReturn3.default)(this, (AccountButton.__proto__ || (0, _getPrototypeOf2.default)(AccountButton)).apply(this, arguments));
  }

  return AccountButton;
}(BaseAccountButton), _class4.displayName = 'AccountButton', _temp2)) || _class3) || _class3);
exports.default = AccountButton;

/***/ }),

/***/ 742:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = __webpack_require__(10);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _toConsumableArray2 = __webpack_require__(42);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _autobind = __webpack_require__(11);

var _autobind2 = _interopRequireDefault(_autobind);

var _reactIntl = __webpack_require__(5);

var _decorate = __webpack_require__(348);

var _decorate2 = _interopRequireDefault(_decorate);

var _wixConnect = __webpack_require__(6);

var _dropdown = __webpack_require__(72);

var _categories = __webpack_require__(2686);

var _categories2 = _interopRequireDefault(_categories);

var _translations = __webpack_require__(1384);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var Categories = (_dec = (0, _wixConnect.WixConnect)(), _dec2 = (0, _decorate2.default)(_.memoize), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  (0, _inherits3.default)(Categories, _React$Component);

  function Categories() {
    (0, _classCallCheck3.default)(this, Categories);
    return (0, _possibleConstructorReturn3.default)(this, (Categories.__proto__ || (0, _getPrototypeOf2.default)(Categories)).apply(this, arguments));
  }

  (0, _createClass3.default)(Categories, [{
    key: 'getOptions',
    value: function getOptions(list) {
      var options = _.map(list, function (value) {
        return { label: value, value: value };
      });
      return [{
        label: this.props.intl.formatMessage(_translations2.default.allVideos),
        value: null
      }].concat((0, _toConsumableArray3.default)(options));
    }
  }, {
    key: 'sendCategorySelectedBI',
    value: function sendCategorySelectedBI() {
      this.props.biEvent('widget.categories.selected');
    }
  }, {
    key: 'sendCategoriesClickedBI',
    value: function sendCategoriesClickedBI() {
      this.props.biEvent('widget.categories.clicked');
    }
  }, {
    key: 'handleChange',
    value: function handleChange(value) {
      this.sendCategorySelectedBI();
      this.props.onCategorySelect(value);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          selectedCategory = _props.selectedCategory,
          DropdownClass = _props.DropdownClass,
          height = _props.height,
          list = _props.list;


      return React.createElement(DropdownClass, { className: className + ' qa-widget-categories',
        optionsClassName: _categories2.default.options,
        optionClassName: _categories2.default.option,
        height: height,
        onChange: this.handleChange,
        onOpen: this.sendCategoriesClickedBI,
        value: selectedCategory,
        options: this.getOptions(list) });
    }
  }]);
  return Categories;
}(React.Component), _class3.propTypes = {
  className: React.PropTypes.string,
  list: React.PropTypes.arrayOf(React.PropTypes.string),
  onCategorySelect: React.PropTypes.func,
  selectedCategory: React.PropTypes.string,
  height: React.PropTypes.number,
  biEvent: React.PropTypes.func,
  intl: _reactIntl.intlShape,
  DropdownClass: React.PropTypes.func
}, _class3.defaultProps = {
  selectedCategory: null,
  DropdownClass: _dropdown.WidgetDropdown
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'getOptions', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'getOptions'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'sendCategoriesClickedBI', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'sendCategoriesClickedBI'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleChange', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleChange'), _class2.prototype)), _class2)) || _class);
exports.default = Categories;

/***/ }),

/***/ 743:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = __webpack_require__(10);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _autobind = __webpack_require__(11);

var _autobind2 = _interopRequireDefault(_autobind);

var _reactRedux = __webpack_require__(12);

var _wixConnect = __webpack_require__(6);

var _runOnce = __webpack_require__(738);

var _runOnce2 = _interopRequireDefault(_runOnce);

var _button = __webpack_require__(19);

var _icon = __webpack_require__(20);

var _icon2 = _interopRequireDefault(_icon);

var _layoutHelpers = __webpack_require__(67);

var _channelActions = __webpack_require__(968);

var _channelActions2 = _interopRequireDefault(_channelActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var ChannelInfoButton = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    isVisible: (0, _layoutHelpers.isChannelInfoVisible)(state.appSettings)
  };
}), _dec2 = (0, _wixConnect.WixConnect)(_channelActions2.default), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  (0, _inherits3.default)(ChannelInfoButton, _React$Component);

  function ChannelInfoButton() {
    (0, _classCallCheck3.default)(this, ChannelInfoButton);
    return (0, _possibleConstructorReturn3.default)(this, (ChannelInfoButton.__proto__ || (0, _getPrototypeOf2.default)(ChannelInfoButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(ChannelInfoButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.sendAboutInfoDisplayedBI();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.sendAboutInfoDisplayedBI();
    }
  }, {
    key: 'sendAboutInfoDisplayedBI',
    value: function sendAboutInfoDisplayedBI() {
      if (this.props.isVisible) {
        this.doSendAboutInfoDisplayedBI();
      }
    }
  }, {
    key: 'doSendAboutInfoDisplayedBI',
    value: function doSendAboutInfoDisplayedBI() {
      this.props.biEvent('widget.aboutCh.displayed');
    }
  }, {
    key: 'sendClickedBI',
    value: function sendClickedBI() {
      this.props.biEvent('widget.aboutCh.clicked');
    }
  }, {
    key: 'handleClick',
    value: function handleClick(event) {
      this.sendClickedBI();
      this.props.onClick(event);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          isVisible = _props.isVisible;


      if (!isVisible) {
        return null;
      }

      return React.createElement(
        _button.LinkButton,
        { className: 'qa-info-button ' + className,
          styleName: 'action info',
          onClick: this.handleClick },
        React.createElement(_icon2.default, { styleName: 'back-button',
          name: 'info-1' })
      );
    }
  }]);
  return ChannelInfoButton;
}(React.Component), _class3.propTypes = {
  isVisible: React.PropTypes.bool,
  channelData: React.PropTypes.object,
  className: React.PropTypes.string,
  onClick: React.PropTypes.func,
  biEvent: React.PropTypes.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'doSendAboutInfoDisplayedBI', [_runOnce2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'doSendAboutInfoDisplayedBI'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleClick', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleClick'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = ChannelInfoButton;

/***/ }),

/***/ 744:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _reactIntl = __webpack_require__(5);

var _playerWidget = __webpack_require__(25);

var _wixConnect = __webpack_require__(6);

var _layoutHelpers = __webpack_require__(67);

var _button = __webpack_require__(19);

var _translations = __webpack_require__(1386);

var _translations2 = _interopRequireDefault(_translations);

var _channelActions = __webpack_require__(968);

var _channelActions2 = _interopRequireDefault(_channelActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChannelSubscriptionButton = (_dec = (0, _wixConnect.WixConnect)(_channelActions2.default), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(ChannelSubscriptionButton, _React$Component);

  function ChannelSubscriptionButton() {
    (0, _classCallCheck3.default)(this, ChannelSubscriptionButton);
    return (0, _possibleConstructorReturn3.default)(this, (ChannelSubscriptionButton.__proto__ || (0, _getPrototypeOf2.default)(ChannelSubscriptionButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(ChannelSubscriptionButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          channelData = _props.channelData,
          className = _props.className,
          onClick = _props.onClick;


      if (!(0, _layoutHelpers.isSubscriptionButtonVisible)(channelData)) {
        return null;
      }

      var subscriptionPriceInfo = _playerWidget.dealInfoHelpers.getSubscriptionPriceInfo(channelData.dealInfo);

      var values = {
        price: React.createElement(_reactIntl.FormattedNumber, { value: subscriptionPriceInfo.price,
          style: 'currency',
          currency: subscriptionPriceInfo.currency })
      };

      return React.createElement(
        _button.LinkButton,
        { className: 'qa-channel-subscription ' + className,
          styleName: 'action subscribe',
          onClick: onClick },
        React.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, _translations2.default.subscribe, {
          values: values }))
      );
    }
  }]);
  return ChannelSubscriptionButton;
}(React.Component), _class2.propTypes = {
  channelData: React.PropTypes.object,
  className: React.PropTypes.string,
  onClick: React.PropTypes.func
}, _temp)) || _class);
exports.default = ChannelSubscriptionButton;

/***/ }),

/***/ 745:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _wixConnect = __webpack_require__(6);

var _reactIntl = __webpack_require__(5);

var _search = __webpack_require__(1522);

var _search2 = _interopRequireDefault(_search);

var _emptySearchResults = __webpack_require__(2688);

var _emptySearchResults2 = _interopRequireDefault(_emptySearchResults);

var _translations = __webpack_require__(276);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmptySearchResults = (_dec = (0, _wixConnect.WixConnect)(_emptySearchResults2.default), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(EmptySearchResults, _React$Component);

  function EmptySearchResults() {
    (0, _classCallCheck3.default)(this, EmptySearchResults);
    return (0, _possibleConstructorReturn3.default)(this, (EmptySearchResults.__proto__ || (0, _getPrototypeOf2.default)(EmptySearchResults)).apply(this, arguments));
  }

  (0, _createClass3.default)(EmptySearchResults, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: this.props.className,
          styleName: 'no-search-wrapper' },
        React.createElement(_search2.default, { styleName: 'no-search-icon' }),
        React.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, _translations2.default.noSearchResults, {
          styleName: 'no-search-text' }))
      );
    }
  }]);
  return EmptySearchResults;
}(React.Component), _class2.propTypes = {
  className: React.PropTypes.string
}, _temp)) || _class);
exports.default = EmptySearchResults;

/***/ }),

/***/ 747:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = __webpack_require__(10);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _autobind = __webpack_require__(11);

var _autobind2 = _interopRequireDefault(_autobind);

var _ReactTransitionEvents = __webpack_require__(2494);

var _ReactTransitionEvents2 = _interopRequireDefault(_ReactTransitionEvents);

var _wixConnect = __webpack_require__(6);

var _sizes = __webpack_require__(1388);

var _buttons = __webpack_require__(1387);

var _buttons2 = _interopRequireDefault(_buttons);

var _track = __webpack_require__(1389);

var _track2 = _interopRequireDefault(_track);

var _mobileCarousel = __webpack_require__(2691);

var _mobileCarousel2 = _interopRequireDefault(_mobileCarousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/*
 Mobile carousel is inspired by https://github.com/akiran/react-slick/tree/master/src
*/

function getTrackCSS(_ref) {
  var slideCount = _ref.slideCount,
      slidesToShow = _ref.slidesToShow,
      slideWidth = _ref.slideWidth,
      left = _ref.left;

  var trackWidth = (slideCount + 2 * slidesToShow) * slideWidth;

  return {
    opacity: 1,
    width: trackWidth,
    WebkitTransform: 'translate3d(' + left + 'px, 0px, 0px)',
    transform: 'translate3d(' + left + 'px, 0px, 0px)',
    transition: '',
    WebkitTransition: '',
    msTransform: 'translateX(' + left + 'px)'
  };
}

function getTrackAnimateCSS(spec) {
  var style = getTrackCSS(spec);
  // useCSS is true by default so it can be undefined
  style.WebkitTransition = '-webkit-transform \'' + spec.speed + 'ms ' + spec.cssEase;
  style.transition = 'transform ' + spec.speed + 'ms ' + spec.cssEase;
  return style;
}

function calcSwipeDirection(touchObject) {
  var xDist = touchObject.startX - touchObject.curX;
  var yDist = touchObject.startY - touchObject.curY;
  var r = Math.atan2(yDist, xDist);

  var swipeAngle = Math.round(r * 180 / Math.PI);
  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }
  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return 'left';
  }
  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return 'right';
  }

  return 'vertical';
}

var MobileCarousel = (_dec = (0, _wixConnect.WixConnect)(_mobileCarousel2.default), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  (0, _inherits3.default)(MobileCarousel, _React$Component);

  function MobileCarousel(props) {
    (0, _classCallCheck3.default)(this, MobileCarousel);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MobileCarousel.__proto__ || (0, _getPrototypeOf2.default)(MobileCarousel)).call(this, props));

    _this._touchObject = {
      startX: 0,
      startY: 0,
      curX: 0,
      curY: 0
    };


    _this._currentSlide = props.initialSlide;

    _this.state = {
      slideWidth: null
    };
    return _this;
  }

  (0, _createClass3.default)(MobileCarousel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.update();
      window.addEventListener('resize', this.update);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.update);
    }
  }, {
    key: 'update',
    value: function update() {
      var _this2 = this;

      if (!this.wrapper) {
        return;
      }

      var _props = this.props,
          slidesToShow = _props.slidesToShow,
          slidesPreviewWidth = _props.slidesPreviewWidth;

      var listWidth = (0, _sizes.getWidth)(this.list);
      var trackWidth = (0, _sizes.getWidth)(this.track);
      var slideWidth = (0, _sizes.getSlideWidth)(this.wrapper, slidesToShow, { slidesPreviewWidth: slidesPreviewWidth });

      this.setState({
        slideWidth: slideWidth,
        listWidth: listWidth,
        trackWidth: trackWidth
      }, function () {
        var targetLeft = _this2.getTrackLeft(_this2._currentSlide, slideWidth, slidesPreviewWidth);
        // getCSS function needs previously set state
        var trackStyle = getTrackCSS(_.assign({
          left: targetLeft,
          slideCount: _this2.getSlidesCount()
        }, _this2.props, _this2.state));

        _this2.setTrackStyle(trackStyle);
      });
    }
  }, {
    key: 'getTrackLeft',
    value: function getTrackLeft(slideIndex, slideWidth, slidesPreviewWidth) {
      return (0, _sizes.getTrackLeft)(this.getSlidesCount(), this.props.slidesToShow, slideIndex, slideWidth, slidesPreviewWidth);
    }
  }, {
    key: 'setTrackStyle',
    value: function setTrackStyle(style) {
      _.assign(this.track.style, style);
    }
  }, {
    key: 'swipeStart',
    value: function swipeStart(e) {
      var posX = _.isUndefined(e.touches) ? e.clientX : e.touches[0].pageX;
      var posY = _.isUndefined(e.touches) ? e.clientY : e.touches[0].pageY;

      this._dragging = true;
      this._animating = false;
      this._swipeStarted = false;

      this._touchObject = {
        startX: posX,
        startY: posY,
        curX: posX,
        curY: posY
      };
    }
  }, {
    key: 'getSlidesCount',
    value: function getSlidesCount() {
      return React.Children.count(this.props.children);
    }
  }, {
    key: 'swipeMove',
    value: function swipeMove(e) {
      if (!this._dragging) {
        return;
      }
      if (this._animating) {
        return;
      }

      var touchObject = _.clone(this._touchObject);
      var slideWidth = this.state.slideWidth;
      var _props2 = this.props,
          slidesToShow = _props2.slidesToShow,
          slidesPreviewWidth = _props2.slidesPreviewWidth,
          onUserStartedTracking = _props2.onUserStartedTracking;

      var currentSlide = this._currentSlide;

      var curLeft = this.getTrackLeft(currentSlide, slideWidth, slidesPreviewWidth);
      touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
      touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
      touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));

      var positionOffset = touchObject.curX > touchObject.startX ? 1 : -1;

      var slidesCount = this.getSlidesCount();
      var swipeDirection = calcSwipeDirection.call(this, touchObject);
      var touchSwipeLength = touchObject.swipeLength;

      if (currentSlide === 0 && swipeDirection === 'right' || currentSlide >= slidesCount - slidesToShow && swipeDirection === 'left') {
        touchSwipeLength = touchObject.swipeLength * this.props.edgeFriction;
      }

      var swipeLeft = curLeft + touchSwipeLength * positionOffset;
      this._touchObject = touchObject;

      var trackStyle = getTrackCSS(_.assign({
        left: swipeLeft,
        slideCount: this.getSlidesCount()
      }, this.props, this.state));

      this.setTrackStyle(trackStyle);

      if (this._swipeStarted) {
        // prevent vertical scrolling in browsers what doesn't support passive touch events
        // https://developers.google.com/web/updates/2016/06/passive-event-listeners
        e.preventDefault();
        return;
      }

      if (touchObject.swipeLength > 4) {
        this._swipeStarted = true;
        onUserStartedTracking();
      }
    }
  }, {
    key: 'calcSlidesToScroll',
    value: function calcSlidesToScroll(swipeLength) {
      var _state = this.state,
          slideWidth = _state.slideWidth,
          listWidth = _state.listWidth;
      var touchThreshold = this.props.touchThreshold;

      var minSwipe = listWidth / touchThreshold;
      var slidesCount = Math.floor(swipeLength / slideWidth);
      var lastSlideLength = swipeLength % slideWidth;
      if (lastSlideLength > minSwipe) {
        slidesCount += 1;
      }
      return slidesCount;
    }
  }, {
    key: 'swipeEnd',
    value: function swipeEnd(e) {
      if (!this._dragging) {
        return;
      }
      var touchObject = this._touchObject;
      var minSwipe = this.state.listWidth / this.props.touchThreshold;
      var swipeDirection = calcSwipeDirection.call(this, touchObject);
      var currentSlide = this._currentSlide;

      // reset the state of touch related state variables.
      this._dragging = false;
      this._touchObject = {};
      // Fix for #13
      if (!touchObject.swipeLength) {
        return;
      }
      if (touchObject.swipeLength > minSwipe) {
        var slidesToScroll = this.calcSlidesToScroll(touchObject.swipeLength);
        e.preventDefault();
        if (swipeDirection === 'left') {
          this.slideHandler(currentSlide + slidesToScroll);
        } else if (swipeDirection === 'right') {
          this.slideHandler(currentSlide - slidesToScroll);
        } else {
          this.slideHandler(currentSlide);
        }
      } else {
        // Adjust the track back to it's original position.
        var currentLeft = this.getTrackLeft(currentSlide, this.state.slideWidth, this.props.slidesPreviewWidth);

        this.setTrackStyle(getTrackAnimateCSS(_.assign({
          left: currentLeft,
          slideCount: this.getSlidesCount()
        }, this.props, this.state)));
      }
    }
  }, {
    key: 'slideHandler',
    value: function slideHandler(index) {
      var _this3 = this;

      // Functionality of animateSlide and postSlide is merged into this function

      if (this.props.waitForAnimate && this._animating) {
        return;
      }

      var currentSlide = void 0;
      var slideCount = this.getSlidesCount();
      var targetSlide = index;

      if (targetSlide < 0) {
        currentSlide = 0;
      } else if (targetSlide > slideCount - this.props.slidesToShow) {
        currentSlide = slideCount - this.props.slidesToShow;
      } else {
        currentSlide = targetSlide;
      }

      var targetLeft = this.getTrackLeft(currentSlide, this.state.slideWidth, this.props.slidesPreviewWidth);

      if (this.props.beforeChange) {
        this.props.beforeChange(this._currentSlide, currentSlide);
      }

      // Slide Transition happens here.
      // animated transition happens to target Slide and
      // non - animated transition happens to current Slide

      var nextStateChanges = {
        trackStyle: getTrackCSS((0, _extends3.default)({
          left: targetLeft,
          slideCount: this.getSlidesCount()
        }, this.props, this.state)),
        swipeLeft: null
      };

      var callback = function callback() {
        _this3._animating = false;
        _this3.setTrackStyle(nextStateChanges.trackStyle);
        _this3.props.afterChange(currentSlide);
        _ReactTransitionEvents2.default.removeEndEventListener(_this3.track, callback);
      };

      this._animating = true;
      var trackStyle = getTrackAnimateCSS(_.assign({
        left: targetLeft,
        slideCount: this.getSlidesCount()
      }, this.props, this.state));
      this.setTrackStyle(trackStyle);

      this._currentSlide = currentSlide;
      _ReactTransitionEvents2.default.addEndEventListener(this.track, callback);
    }
  }, {
    key: 'changeSlide',
    value: function changeSlide(_ref2) {
      var action = _ref2.action,
          slideIndex = _ref2.slideIndex;

      var slideOffset = void 0;
      var targetSlide = void 0;
      var slideCount = this.getSlidesCount();
      var currentSlide = this._currentSlide;
      var slidesToScroll = this.props.slidesToScroll;
      var unevenOffset = slideCount % slidesToScroll !== 0;
      var indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

      if (action === 'previous') {
        slideOffset = indexOffset === 0 ? slidesToScroll : this.props.slidesToShow - indexOffset;
        targetSlide = currentSlide - slideOffset;
      } else if (action === 'next') {
        slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
        targetSlide = currentSlide + slideOffset;
      } else if (action === 'index') {
        targetSlide = slideIndex;
        if (targetSlide === currentSlide) {
          return;
        }
      }

      this.slideHandler(targetSlide);
    }
  }, {
    key: 'handlePrevButtonClick',
    value: function handlePrevButtonClick() {
      this.changeSlide({ action: 'previous' });
    }
  }, {
    key: 'handleNextButtonClick',
    value: function handleNextButtonClick() {
      this.changeSlide({ action: 'next' });
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      var slideWidth = this.state.slideWidth;
      var _props3 = this.props,
          getHeight = _props3.getHeight,
          children = _props3.children;


      if (!slideWidth) {
        return null;
      }

      return React.Children.map(children, function (elem) {
        return React.cloneElement(elem, {
          width: slideWidth,
          height: getHeight(elem, slideWidth)
        });
      });
    }
  }, {
    key: 'getTrackRef',
    value: function getTrackRef(node) {
      this.track = node;
    }
  }, {
    key: 'setWrapper',
    value: function setWrapper(node) {
      this.wrapper = node;
      this.update();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var trackProps = {
        cssEase: this.props.cssEase,
        speed: this.props.speed,
        currentSlide: this._currentSlide,
        slideWidth: this.state.slideWidth,
        slidesToShow: this.props.slidesToShow,
        slideCount: this.getSlidesCount(),
        trackStyle: this.state.trackStyle
      };

      var _props4 = this.props,
          className = _props4.className,
          trackClassName = _props4.trackClassName;


      return React.createElement(
        'div',
        { ref: this.setWrapper,
          styleName: 'container',
          className: className },
        React.createElement(
          'div',
          { ref: function ref(node) {
              return _this4.list = node;
            },
            className: 'slick-list',
            onMouseDown: this.swipeStart,
            onMouseMove: this.swipeMove,
            onMouseUp: this.swipeEnd,
            onMouseLeave: this.swipeEnd,
            onTouchStart: this.swipeStart,
            onTouchMove: this.swipeMove,
            onTouchEnd: this.swipeEnd,
            onTouchCancel: this.swipeEnd },
          React.createElement(
            _track2.default,
            (0, _extends3.default)({ getRef: this.getTrackRef,
              className: trackClassName
            }, trackProps),
            this.renderChildren()
          )
        ),
        this.buttons
      );
    }
  }, {
    key: 'buttons',
    get: function get() {
      var _props5 = this.props,
          showButtons = _props5.showButtons,
          slidesToShow = _props5.slidesToShow;

      var currentSlide = this._currentSlide;

      if (!showButtons) {
        return null;
      }

      var slidesCount = this.getSlidesCount();

      return [React.createElement(_buttons2.default, { key: 'prev',
        direction: 'left',
        onClick: this.handlePrevButtonClick,
        isActive: currentSlide > 0 }), React.createElement(_buttons2.default, { key: 'next',
        direction: 'right',
        onClick: this.handleNextButtonClick,
        isActive: currentSlide < slidesCount - slidesToShow })];
    }
  }]);
  return MobileCarousel;
}(React.Component), _class3.propTypes = {
  totalCount: React.PropTypes.number,
  slidesToShow: React.PropTypes.number,
  afterChange: React.PropTypes.func,
  children: React.PropTypes.any,
  className: React.PropTypes.string,
  touchThreshold: React.PropTypes.number,
  slidesToScroll: React.PropTypes.number,
  initialSlide: React.PropTypes.number,
  slidesPreviewWidth: React.PropTypes.number,
  cssEase: React.PropTypes.string,
  edgeFriction: React.PropTypes.number,
  speed: React.PropTypes.number,
  getHeight: React.PropTypes.func,
  beforeChange: React.PropTypes.func,
  waitForAnimate: React.PropTypes.bool,
  showButtons: React.PropTypes.bool,
  trackClassName: React.PropTypes.string,
  onUserStartedTracking: React.PropTypes.func
}, _class3.defaultProps = {
  className: '',
  cssEase: 'ease',
  easing: 'linear',
  edgeFriction: 0.35,
  initialSlide: 0,
  slidesToScroll: 1,
  speed: 500,
  getHeight: _.constant(200),
  slidesToShow: 3,
  touchThreshold: 5,
  useCSS: true,
  waitForAnimate: true,
  afterChange: _.noop,
  beforeChange: _.noop,
  onUserStartedTracking: _.noop,
  slidesPreviewWidth: 0,
  showButtons: true
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'update', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'update'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'swipeStart', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'swipeStart'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'getSlidesCount', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'getSlidesCount'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'swipeMove', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'swipeMove'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'swipeEnd', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'swipeEnd'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handlePrevButtonClick', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handlePrevButtonClick'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleNextButtonClick', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleNextButtonClick'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'renderChildren', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'renderChildren'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'getTrackRef', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'getTrackRef'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setWrapper', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setWrapper'), _class2.prototype)), _class2)) || _class);
exports.default = MobileCarousel;

/***/ }),

/***/ 757:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(5);

exports.default = (0, _reactIntl.defineMessages)({
  viewChannel: {
    id: 'widget.mobile.overlay-button.visit-channel',
    defaultMessage: 'Visit channel'
  },
  signIn: {
    id: 'widget.mobile.overlay-button.sign-in',
    defaultMessage: 'Sign in'
  },
  subscribeShortText: {
    id: 'widget.mobile.overlay-button.subscribe.short',
    defaultMessage: 'Subscribe'
  }
});

/***/ }),

/***/ 761:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = __webpack_require__(10);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _reactRedux = __webpack_require__(12);

var _autobind = __webpack_require__(11);

var _autobind2 = _interopRequireDefault(_autobind);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _paymentPagesActions = __webpack_require__(789);

var _threeRowsWidget = __webpack_require__(1399);

var _threeRowsWidget2 = _interopRequireDefault(_threeRowsWidget);

var _channels = __webpack_require__(29);

var _playerCover = __webpack_require__(1394);

var _videoAccess = __webpack_require__(92);

var _mainOpenners = __webpack_require__(347);

var _playersListSlidable = __webpack_require__(971);

var _playersListSlidable2 = _interopRequireDefault(_playersListSlidable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var Player = (_dec = (0, _reactRedux.connect)(function (state) {
  var channelData = (0, _channels.getChannelForWidget)(state);

  return {
    channelData: channelData,
    appSettings: state.appSettings,
    currentSiteUser: state.currentSiteUser
  };
}, function (dispatch, _ref) {
  var videoItem = _ref.videoItem;
  return {
    onBuyVideoClick: function onBuyVideoClick() {
      return dispatch((0, _paymentPagesActions.openBuyVideoOverlay)(videoItem.id));
    },
    onOpenVideoClick: function onOpenVideoClick() {
      return dispatch((0, _mainOpenners.openVideoPage)(videoItem.id));
    }
  };
}), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  (0, _inherits3.default)(Player, _React$Component);

  function Player() {
    (0, _classCallCheck3.default)(this, Player);
    return (0, _possibleConstructorReturn3.default)(this, (Player.__proto__ || (0, _getPrototypeOf2.default)(Player)).apply(this, arguments));
  }

  (0, _createClass3.default)(Player, [{
    key: 'onPlayClick',
    value: function onPlayClick() {
      var _props = this.props,
          onPlayClick = _props.onPlayClick,
          channelData = _props.channelData,
          videoItem = _props.videoItem,
          currentSiteUser = _props.currentSiteUser,
          onMemberSignUp = _props.onMemberSignUp;


      var accessActionName = (0, _videoAccess.getFullAccessActionName)(channelData, videoItem, currentSiteUser);

      if (accessActionName === _videoAccess.FULL_ACCESS_ACTION_NAMES.SIGN_IN) {
        onMemberSignUp();
      } else {
        onPlayClick();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          videoItem = _props2.videoItem,
          useChannelCoverIfPossible = _props2.useChannelCoverIfPossible,
          className = _props2.className,
          itemWidth = _props2.itemWidth,
          itemHeight = _props2.itemHeight,
          paused = _props2.paused,
          onOpenVideoClick = _props2.onOpenVideoClick,
          onBuyVideoClick = _props2.onBuyVideoClick,
          channelData = _props2.channelData,
          appSettings = _props2.appSettings;


      var coverClassNames = (0, _classnames2.default)(className, { paused: paused });

      return React.createElement(
        _playerCover.PlayerCover,
        { videoItem: videoItem,
          className: coverClassNames,
          useChannelCoverIfPossible: useChannelCoverIfPossible,
          coverWidth: itemWidth,
          coverHeight: itemHeight },
        React.createElement(_threeRowsWidget2.default, { videoItem: videoItem,
          className: _playersListSlidable2.default['slidable-overlay'],
          appSettings: appSettings,
          channelData: channelData,
          showChannelCover: useChannelCoverIfPossible,
          onOpenVideoClick: onOpenVideoClick,
          onBuyVideoClick: onBuyVideoClick,
          onPlayClick: this.onPlayClick })
      );
    }
  }]);
  return Player;
}(React.Component), _class3.propTypes = {
  channelData: React.PropTypes.object,
  appSettings: React.PropTypes.object,
  canShowChannelCover: React.PropTypes.bool,
  onBuyVideoClick: React.PropTypes.func,
  onOpenVideoClick: React.PropTypes.func,

  videoItem: React.PropTypes.object,
  useChannelCoverIfPossible: React.PropTypes.bool,
  className: React.PropTypes.string,
  coverClassName: React.PropTypes.string,
  onPause: React.PropTypes.func,
  paused: React.PropTypes.bool,
  itemWidth: React.PropTypes.number,
  itemHeight: React.PropTypes.number,
  currentSiteUser: React.PropTypes.object,
  onPlayClick: React.PropTypes.func,
  onPlayStart: React.PropTypes.func,
  onFullScreenChanged: React.PropTypes.func,
  onMemberSignUp: React.PropTypes.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onPlayClick', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onPlayClick'), _class2.prototype)), _class2)) || _class);
exports.default = Player;

/***/ }),

/***/ 763:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StripSearchBar = exports.ClassicSearchBar = undefined;

var _getOwnPropertyDescriptor = __webpack_require__(10);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp;

var _autobind = __webpack_require__(11);

var _autobind2 = _interopRequireDefault(_autobind);

var _reactIntl = __webpack_require__(5);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _wixConnect = __webpack_require__(6);

var _icon = __webpack_require__(20);

var _icon2 = _interopRequireDefault(_icon);

var _button = __webpack_require__(19);

var _classicSearchBar = __webpack_require__(2707);

var _classicSearchBar2 = _interopRequireDefault(_classicSearchBar);

var _stripSearchBar = __webpack_require__(2708);

var _stripSearchBar2 = _interopRequireDefault(_stripSearchBar);

var _translations = __webpack_require__(1405);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var SearchBar = (_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(SearchBar, _React$Component);

  function SearchBar(props) {
    (0, _classCallCheck3.default)(this, SearchBar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SearchBar.__proto__ || (0, _getPrototypeOf2.default)(SearchBar)).call(this, props));

    _this.state = {
      currentValue: props.value,
      focused: false
    };
    return _this;
  }

  (0, _createClass3.default)(SearchBar, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value) {
        this.setState({ currentValue: nextProps.value });
      }
    }
  }, {
    key: 'updateValue',
    value: function updateValue() {
      var value = this.input.value;

      this.props.onChange(value);
      this.setState({ currentValue: value });
    }
  }, {
    key: 'searchOnEnter',
    value: function searchOnEnter(event) {
      var keyCode = event.nativeEvent.keyCode;
      var value = this.input.value;

      // check if Enter

      if (keyCode === 13) {
        this.sendSearchBI(value);
        this.permitSearch();
      }
    }
  }, {
    key: 'sendSearchBI',
    value: function sendSearchBI(searchQuery) {
      if (searchQuery !== '') {
        this.props.biEvent('widget.search.clicked');
      }
    }
  }, {
    key: 'setFocused',
    value: function setFocused(focused) {
      var _this2 = this;

      // Don`t hide if click outside with new value passed to props
      setTimeout(function () {
        return _this2.setState({ focused: focused });
      }, 0);
    }
  }, {
    key: 'permitSearch',
    value: function permitSearch() {
      var onSearch = this.props.onSearch;
      var value = this.input.value;

      this.setFocused(true);

      onSearch(value);
    }
  }, {
    key: 'closeSearch',
    value: function closeSearch() {
      this.input.value = '';
      this.setState({
        currentValue: '',
        focused: false
      });
      this.props.onClose('');
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus(event) {
      this.props.onFocus(event);
      this.setFocused(true);
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur(event) {
      this.props.onBlur(event);
      this.setFocused(false);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          formatMessage = _props.intl.formatMessage,
          className = _props.className;

      var placeholder = formatMessage(_translations2.default.searchVideo);

      return React.createElement(
        'div',
        { className: className,
          styleName: this.styleNames },
        React.createElement(
          'div',
          { styleName: 'background-text' },
          placeholder
        ),
        React.createElement('input', { type: 'text',
          styleName: 'input search-bar',
          className: 'qa-search-bar-input',
          value: this.state.currentValue,
          onKeyPress: this.searchOnEnter,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          onChange: this.updateValue,
          ref: function ref(node) {
            return _this3.input = node;
          },
          placeholder: placeholder }),
        React.createElement(_icon2.default, { styleName: 'search-icon',
          name: 'search-bar' }),
        React.createElement(
          _button.LinkButton,
          { styleName: 'close-search',
            onClick: this.closeSearch },
          React.createElement(_icon2.default, { name: 'clear-search' })
        ),
        React.createElement(
          _button.LinkButton,
          { styleName: 'permit-search',
            onClick: this.permitSearch },
          React.createElement(_icon2.default, { name: 'permit-search' })
        )
      );
    }
  }, {
    key: 'styleNames',
    get: function get() {
      var _state = this.state,
          currentValue = _state.currentValue,
          focused = _state.focused;
      var value = this.props.value;


      return (0, _classnames2.default)('container', {
        'has-value': currentValue,
        'has-submitted-value': value,
        changed: value !== currentValue,
        focused: focused
      });
    }
  }]);
  return SearchBar;
}(React.Component), _class2.propTypes = {
  onChange: React.PropTypes.func,
  onSearch: React.PropTypes.func,
  onClose: React.PropTypes.func,
  onFocus: React.PropTypes.func,
  onBlur: React.PropTypes.func,
  biEvent: React.PropTypes.func,
  className: React.PropTypes.string,
  value: React.PropTypes.string,
  intl: _reactIntl.intlShape
}, _class2.defaultProps = {
  value: '',
  onChange: _.noop,
  onSearch: _.noop,
  onClose: _.noop,
  onFocus: _.noop,
  onBlur: _.noop,
  onKeyPress: _.noop
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'updateValue', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateValue'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'searchOnEnter', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'searchOnEnter'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'permitSearch', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'permitSearch'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'closeSearch', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'closeSearch'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleFocus', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'handleFocus'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleBlur', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'handleBlur'), _class.prototype)), _class);
var ClassicSearchBar = exports.ClassicSearchBar = (0, _wixConnect.WixConnect)(_classicSearchBar2.default)(SearchBar);
var StripSearchBar = exports.StripSearchBar = (0, _wixConnect.WixConnect)(_stripSearchBar2.default)(SearchBar);

/***/ }),

/***/ 764:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = __webpack_require__(10);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

exports.getContentToShare = getContentToShare;

var _autobind = __webpack_require__(11);

var _autobind2 = _interopRequireDefault(_autobind);

var _playerWidget = __webpack_require__(25);

var _reactRedux = __webpack_require__(12);

var _wixConnect = __webpack_require__(6);

var _layoutHelpers = __webpack_require__(67);

var _report = __webpack_require__(508);

var _report2 = _interopRequireDefault(_report);

var _events = __webpack_require__(327);

var _events2 = _interopRequireDefault(_events);

var _previewPrompt = __webpack_require__(177);

var _icon = __webpack_require__(20);

var _icon2 = _interopRequireDefault(_icon);

var _shareChannel = __webpack_require__(2709);

var _shareChannel2 = _interopRequireDefault(_shareChannel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function getContentToShare(channelData, appSettings) {
  if (!channelData) {
    return {};
  }

  var siteUrl = appSettings.siteUrl;
  var title = channelData.title,
      description = channelData.description;

  var coverUrl = channelData.customCoverUrl || channelData.coverUrl;

  return {
    siteUrl: siteUrl,
    title: title,
    description: description,
    coverUrl: coverUrl
  };
}

var ShareChannel = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    appSettings: state.appSettings
  };
}, {
  reportStats: _report2.default
}), _dec2 = (0, _wixConnect.WixConnect)(_shareChannel2.default), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  (0, _inherits3.default)(ShareChannel, _React$Component);

  function ShareChannel() {
    (0, _classCallCheck3.default)(this, ShareChannel);
    return (0, _possibleConstructorReturn3.default)(this, (ShareChannel.__proto__ || (0, _getPrototypeOf2.default)(ShareChannel)).apply(this, arguments));
  }

  (0, _createClass3.default)(ShareChannel, [{
    key: 'sendSharedBI',
    value: function sendSharedBI(networkName) {
      this.props.biEvent('widget.share.clicked', { typeShare: networkName });
    }
  }, {
    key: 'sendStatsReport',
    value: function sendStatsReport(name) {
      var _props = this.props,
          reportStats = _props.reportStats,
          channel = _props.channelData;


      reportStats(_events2.default.CHANNEL_SHARE, {
        network: {
          name: name
        },
        channel: channel
      });
    }
  }, {
    key: 'handleAfterClicked',
    value: function handleAfterClicked(networkName) {
      this.sendSharedBI(networkName);
      this.sendStatsReport(networkName);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          appSettings = _props2.appSettings,
          className = _props2.className,
          buttonsClassName = _props2.buttonsClassName,
          channelData = _props2.channelData;


      if (!(0, _layoutHelpers.isChannelShareVisible)(appSettings)) {
        return null;
      }

      var contentToShare = getContentToShare(channelData, appSettings);
      return React.createElement(
        'section',
        { styleName: 'share-container',
          className: 'qa-share-channel ' + className },
        React.createElement(_playerWidget.SocialShare, { styleName: 'share-buttons',
          className: buttonsClassName,
          buttonClassName: _shareChannel2.default['share-button'],
          networksClassNames: this.networksClassNames,
          onAfterClicked: this.handleAfterClicked,
          networks: ['facebook', 'twitter', 'pinterest', 'tumblr'],
          content: contentToShare,
          appSettings: appSettings,
          openPreviewPrompt: _previewPrompt.openPreviewPrompt }),
        React.createElement(_icon2.default, { name: 'share',
          styleName: 'share' })
      );
    }
  }, {
    key: 'networksClassNames',
    get: function get() {
      return _.pick(_shareChannel2.default, 'facebook', 'twitter', 'pinterest', 'tumblr');
    }
  }]);
  return ShareChannel;
}(React.Component), _class3.propTypes = {
  className: React.PropTypes.string,
  buttonsClassName: React.PropTypes.string,
  channelData: React.PropTypes.object,
  appSettings: React.PropTypes.object,
  reportStats: React.PropTypes.func,
  biEvent: React.PropTypes.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'handleAfterClicked', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleAfterClicked'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = ShareChannel;

/***/ }),

/***/ 769:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = __webpack_require__(10);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp2;

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _autobind = __webpack_require__(11);

var _autobind2 = _interopRequireDefault(_autobind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var BaseVideosList = (_class = (_temp2 = _class2 = function (_React$PureComponent) {
  (0, _inherits3.default)(BaseVideosList, _React$PureComponent);

  function BaseVideosList() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, BaseVideosList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BaseVideosList.__proto__ || (0, _getPrototypeOf2.default)(BaseVideosList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currentTransition: ''
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(BaseVideosList, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(this.state.currentTransition !== '' && nextState.currentTransition === '' && this.props.channelVideoIds === nextProps.channelVideoIds);
    }
  }, {
    key: 'moveListBack',
    value: function moveListBack() {
      this.setState({ currentTransition: '' });
      this.props.goBack();
      this.currentNode.removeEventListener('animationend', this.moveListBack);
    }
  }, {
    key: 'moveListForward',
    value: function moveListForward() {
      this.setState({ currentTransition: '' });
      this.props.goForward();
      this.currentNode.removeEventListener('animationend', this.moveListForward);
    }
  }, {
    key: 'toPrevPage',
    value: function toPrevPage() {
      if (this.state.currentTransition) {
        return;
      }

      this.setState({ currentTransition: 'scroll-to-prev' });
      this.currentNode.addEventListener('animationend', this.moveListBack);
    }
  }, {
    key: 'toNextPage',
    value: function toNextPage() {
      if (this.state.currentTransition) {
        return;
      }

      this.setState({ currentTransition: 'scroll-to-next' });
      this.currentNode.addEventListener('animationend', this.moveListForward);
    }
  }, {
    key: 'toVideoThumbnail',
    value: function toVideoThumbnail() {
      return null;
    }
  }, {
    key: 'styleNames',
    get: function get() {
      var _props = this.props,
          prevPageIds = _props.prevPageIds,
          nextPageIds = _props.nextPageIds,
          videosInRow = _props.videosInRow;

      return (0, _classnames2.default)('list-wrapper', 'row-' + videosInRow, this.state.currentTransition, {
        'with-paging': prevPageIds.length || nextPageIds.length
      });
    }
  }, {
    key: 'list',
    get: function get() {
      var _this2 = this;

      var _props2 = this.props,
          prevPageIds = _props2.prevPageIds,
          nextPageIds = _props2.nextPageIds,
          channelVideoIds = _props2.channelVideoIds,
          videosInRow = _props2.videosInRow;

      var styleNames = (0, _classnames2.default)('list-wrapper', 'row-' + videosInRow, this.state.currentTransition);

      return React.createElement(
        'section',
        { styleName: styleNames },
        React.createElement(
          'div',
          { ref: function ref(node) {
              return _this2.currentNode = node;
            },
            styleName: 'list current' },
          _.map(channelVideoIds, this.toVideoThumbnail)
        ),
        React.createElement(
          'div',
          { styleName: 'list prev' },
          _.map(prevPageIds, this.toVideoThumbnail)
        ),
        React.createElement(
          'div',
          { styleName: 'list next' },
          _.map(nextPageIds, this.toVideoThumbnail)
        )
      );
    }
  }]);
  return BaseVideosList;
}(React.PureComponent), _class2.propTypes = {
  channelVideoIds: React.PropTypes.array,
  prevPageIds: React.PropTypes.array,
  nextPageIds: React.PropTypes.array,
  videoByIds: React.PropTypes.object,
  videosInRow: React.PropTypes.number,
  thumbnailSize: React.PropTypes.objectOf(React.PropTypes.number),
  className: React.PropTypes.string,
  goBack: React.PropTypes.func,
  goForward: React.PropTypes.func
}, _temp2), (_applyDecoratedDescriptor(_class.prototype, 'moveListBack', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'moveListBack'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'moveListForward', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'moveListForward'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toPrevPage', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'toPrevPage'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toNextPage', [_autobind2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'toNextPage'), _class.prototype)), _class);
exports.default = BaseVideosList;

/***/ }),

/***/ 789:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OPEN_BUY_VIDEO_OVERLAY = exports.OPEN_SUBSCRIBE_OVERLAY = undefined;
exports.openSubscribeOverlay = openSubscribeOverlay;
exports.openBuyVideoOverlay = openBuyVideoOverlay;

var _reduxActions = __webpack_require__(22);

var _openOverlay = __webpack_require__(128);

var _initiators = __webpack_require__(481);

var OPEN_SUBSCRIBE_OVERLAY = exports.OPEN_SUBSCRIBE_OVERLAY = 'OPEN.SUBSCRIBE-OVERLAY';
var OPEN_SUBSCRIBE_OVERLAY_ACTION = (0, _reduxActions.createAction)(OPEN_SUBSCRIBE_OVERLAY);

var OPEN_BUY_VIDEO_OVERLAY = exports.OPEN_BUY_VIDEO_OVERLAY = 'OPEN.BUY-VIDEO-OVERLAY';
var OPEN_BUY_VIDEO_OVERLAY_ACTION = (0, _reduxActions.createAction)(OPEN_BUY_VIDEO_OVERLAY);

function openPaymentPage(path) {
  path += '?' + (0, _initiators.makeInitiatorQueryString)(_initiators.INITIATORS.WIDGET);
  (0, _openOverlay.openMobileOverlay)(path);
}

function openSubscribeOverlay() {
  return function (dispatch) {
    dispatch(OPEN_SUBSCRIBE_OVERLAY_ACTION());

    return openPaymentPage('#/channel/subscribe');
  };
}

function openBuyVideoOverlay(videoId) {
  return function (dispatch) {
    dispatch(OPEN_BUY_VIDEO_OVERLAY_ACTION());

    return openPaymentPage('#/video/purchase/' + videoId);
  };
}

/***/ }),

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),

/***/ 968:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1960);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./channel-actions.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./channel-actions.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 971:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1982);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./players-list-slidable.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./players-list-slidable.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 981:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(279);

var _reactRouter = __webpack_require__(27);

var _reactRouterRedux = __webpack_require__(162);

var _root = __webpack_require__(263);

var _root2 = _interopRequireDefault(_root);

var _routes = __webpack_require__(1478);

var _routes2 = _interopRequireDefault(_routes);

var _configureStore = __webpack_require__(507);

var _configureStore2 = _interopRequireDefault(_configureStore);

var _setupEnv = __webpack_require__(328);

var _newRelic = __webpack_require__(120);

var _performance = __webpack_require__(129);

var _applicationNames = __webpack_require__(450);

var _applicationNames2 = _interopRequireDefault(_applicationNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _newRelic.initNewRelic)({ application: _applicationNames2.default.WIDGET });
(0, _performance.addSingleMeasurement)('appRenderStart');
(0, _setupEnv.setupEnv)();

var store = (0, _configureStore2.default)({
  configuration: {
    applicationName: _applicationNames2.default.WIDGET
  }
});
var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.hashHistory, store);

// Render the React application to the DOM
ReactDOM.render(React.createElement(_root2.default, { history: history,
  routes: _routes2.default,
  store: store }), document.getElementById('root'));

/***/ })

},[2812]);


// WEBPACK FOOTER //
// widget/widget.js